// before 20-5-2026
// import React, { useEffect, useMemo, useState, useCallback, useRef } from 'react';
// import { DesktopDateTimePicker } from '@mui/x-date-pickers/DesktopDateTimePicker';
// import { CalendarToday as CalendarTodayIcon } from '@mui/icons-material';
// import OpenInNewIcon from '@mui/icons-material/OpenInNew';
// import LinkIcon from '@mui/icons-material/Link';
// import {
//   Box,
//   Container,
//   Typography,
//   Card,
//   CardContent,
//   CardHeader,
//   Avatar,
//   IconButton,
//   Button,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   List,
//   Divider,
//   TextField,
//   Switch,
//   FormControlLabel,
//   Autocomplete,
//   Tooltip,
//   CircularProgress,
//   Chip,
//   Grid,
//   Slide,
//   AppBar,
//   Toolbar,
//   Tabs,
//   Tab,
//   useTheme,
//   styled,
//   InputAdornment,
//   Alert,
//   Paper,
//   Fade,
//   Collapse,
//   Modal,
//   Backdrop,
// } from '@mui/material';
// import { LocalizationProvider } from '@mui/x-date-pickers';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
// import {
//   Close as CloseIcon,
//   Person as PersonIcon,
//   Phone as PhoneIcon,
//   WhatsApp as WhatsAppIcon,
//   Email as EmailIcon,
//   Work as WorkIcon,
//   CalendarToday as CalendarIcon,
//   Comment as CommentIcon,
//   AddComment as AddCommentIcon,
//   Info as InfoIcon,
//   Add as AddIcon,
//   Refresh as RefreshIcon,
//   Visibility as VisibilityIcon,
//   Edit as EditIcon,
//   Send as SendIcon,
//   CheckCircle as CheckCircleIcon,
//   Warning as WarningIcon,
//   PhoneInTalk as PhoneInTalkIcon,
//   AttachMoney as AttachMoneyIcon,
//   Cancel as CancelIcon,
//   Done as DoneIcon,
//   ChangeCircle as ChangeCircleIcon,
//   Schedule as ScheduleIcon,
//   KeyboardArrowDown as KeyboardArrowDownIcon,
//   KeyboardArrowUp as KeyboardArrowUpIcon,
// } from '@mui/icons-material';
// import { Link } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import moment from 'moment';
// import dayjs from 'dayjs';
// import JSConfetti from 'js-confetti';

// // Import actions
// import {
//   GetAllcomments_Data_With_Pagination_action_advanced,
//   InsertNewAction_action,
//   Insert_Comment_Replay_Action,
// } from '../Redux/Actions/Action_action';
// import { UpdateStageToLeed } from '../Redux/Actions/UsersAction';
// import { Get_All_Lead_Assigned_Data_Action } from '../Redux/Actions/Lead_Assigned_Action';
// import { GetAll_stage_Data, GetOne_stagetogettype_Data } from '../Redux/Actions/Stage_Action';
// import { Insert_Lead_Stages_Data_Action } from '../Redux/Actions/Lead_Stages_Changed_Action';

// // Import utilities and components
// import { Notify } from '../Utility/Notify';

// // =============================================================================================
// // Styled Components
// // =============================================================================================

// const StyledCard = styled(Card)(({ theme }) => ({
//   borderRadius: 16,
//   boxShadow:
//     theme.palette.mode === 'dark'
//       ? '0 8px 32px rgba(0,0,0,0.3)'
//       : '0 8px 32px rgba(16, 45, 255, 0.08)',
//   transition: 'transform 0.3s ease, box-shadow 0.3s ease',
//   '&:hover': {
//     transform: 'translateY(-2px)',
//     boxShadow:
//       theme.palette.mode === 'dark'
//         ? '0 12px 48px rgba(0,0,0,0.4)'
//         : '0 12px 48px rgba(16, 45, 255, 0.12)',
//   },
// }));

// const GradientButton = styled(Button)(({ theme }) => ({
//   background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//   color: 'white',
//   fontWeight: 600,
//   borderRadius: 12,
//   padding: '12px 24px',
//   textTransform: 'none',
//   '&:hover': {
//     background: 'linear-gradient(135deg, #764ba2 0%, #667eea 100%)',
//     transform: 'translateY(-1px)',
//   },
// }));

// const CommentTextField = styled(TextField)(({ theme }) => ({
//   '& .MuiOutlinedInput-root': {
//     borderRadius: 12,
//     backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.02)',
//     transition: 'all 0.3s ease',
//     '&:hover': {
//       backgroundColor:
//         theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.04)',
//     },
//     '&.Mui-focused': {
//       backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'white',
//       boxShadow: `0 0 0 3px ${theme.palette.primary.main}20`,
//     },
//     '& input, & textarea': {
//       fontSize: '16px !important', // منع zoom في iOS
//     },
//   },
//   '& .MuiOutlinedInput-notchedOutline': {
//     borderColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
//   },
// }));

// const StageChip = styled(Chip)(({ theme, stagecolor }) => ({
//   borderRadius: 8,
//   fontWeight: 600,
//   backgroundColor: stagecolor || theme.palette.primary.main,
//   color: 'white',
//   '& .MuiChip-label': {
//     padding: '4px 12px',
//   },
// }));

// const StatusChip = styled(Chip)(({ theme, status }) => {
//   let color;
//   switch (status?.toLowerCase()) {
//     case 'hot':
//       color = theme.palette.error.main;
//       break;
//     case 'warm':
//       color = theme.palette.warning.main;
//       break;
//     case 'cold':
//       color = theme.palette.info.main;
//       break;
//     case 'done deal':
//       color = theme.palette.success.main;
//       break;
//     case 'eoi':
//       return {
//         backgroundColor: '#FFF3E0',
//         color: '#EF6C00',
//         fontWeight: 600,
//         border: '1px solid #FFCC80',
//       };
//     case 'reservation':
//       return {
//         backgroundColor: '#E3F2FD',
//         color: '#1565C0',
//         fontWeight: 600,
//         border: '1px solid #90CAF9',
//       };
//     default:
//       color = theme.palette.grey[600];
//   }
//   return {
//     backgroundColor: `${color}15`,
//     color: color,
//     fontWeight: 600,
//     border: `1px solid ${color}30`,
//   };
// });

// const Transition = React.forwardRef(function Transition(props, ref) {
//   return <Slide direction="up" ref={ref} {...props} />;
// });

// // Scrollable Container Styled Component
// const ScrollableContainer = styled(Box)(({ theme }) => ({
//   overflowY: 'auto',
//   maxHeight: 'calc(80vh - 200px)',
//   minHeight: '300px',
//   paddingRight: theme.spacing(1),
//   '&::-webkit-scrollbar': {
//     width: '8px',
//   },
//   '&::-webkit-scrollbar-track': {
//     background: theme.palette.mode === 'dark' ? '#2d2d2d' : '#f1f1f1',
//     borderRadius: '4px',
//   },
//   '&::-webkit-scrollbar-thumb': {
//     background: theme.palette.mode === 'dark' ? '#555' : '#888',
//     borderRadius: '4px',
//     '&:hover': {
//       background: theme.palette.mode === 'dark' ? '#777' : '#555',
//     },
//   },
//   scrollbarWidth: 'thin',
//   scrollbarColor: `${theme.palette.mode === 'dark' ? '#555 #2d2d2d' : '#888 #f1f1f1'}`,
// }));

// const FormScrollContainer = styled(Box)(({ theme }) => ({
//   overflowY: 'auto',
//   maxHeight: '500px',
//   paddingRight: theme.spacing(1),
//   '&::-webkit-scrollbar': {
//     width: '8px',
//   },
//   '&::-webkit-scrollbar-track': {
//     background: theme.palette.mode === 'dark' ? '#2d2d2d' : '#f1f1f1',
//     borderRadius: '4px',
//   },
//   '&::-webkit-scrollbar-thumb': {
//     background: theme.palette.mode === 'dark' ? '#555' : '#888',
//     borderRadius: '4px',
//     '&:hover': {
//       background: theme.palette.mode === 'dark' ? '#777' : '#555',
//     },
//   },
// }));

// // Current Stage Display Component
// const CurrentStageDisplay = styled(Box)(({ theme }) => ({
//   display: 'flex',
//   alignItems: 'center',
//   gap: theme.spacing(2),
//   padding: theme.spacing(2),
//   backgroundColor: theme.palette.primary.lighter,
//   borderRadius: theme.spacing(1),
//   border: `1px solid ${theme.palette.primary.light}`,
//   marginBottom: theme.spacing(2),
// }));

// // Helper function to get stage color
// const getStageColor = (stageName) => {
//   switch (stageName?.toLowerCase()) {
//     case 'done deal':
//       return '#4CAF50';
//     case 'hot':
//       return '#F44336';
//     case 'warm':
//       return '#FF9800';
//     case 'cold':
//       return '#2196F3';
//     case 'eoi':
//       return '#FF5722';
//     case 'reservation':
//       return '#3F51B5';
//     case 'answer':
//       return '#009688';
//     case 'no answer':
//       return '#9E9E9E';
//     case 'meeting':
//       return '#9C27B0';
//     case 'follow':
//       return '#795548';
//     default:
//       return '#757575';
//   }
// };

// // =============================================================================================
// // Tab Panel Component with Scroll
// // =============================================================================================

// function TabPanel(props) {
//   const { children, value, index, ...other } = props;

//   return (
//     <div
//       role="tabpanel"
//       hidden={value !== index}
//       id={`action-tabpanel-${index}`}
//       aria-labelledby={`action-tab-${index}`}
//       {...other}
//       style={{
//         width: '100%',
//         height: 'calc(80vh - 120px)',
//         display: 'flex',
//         flexDirection: 'column',
//       }}
//     >
//       {value === index && (
//         <ScrollableContainer>
//           <Box sx={{ p: 3 }}>{children}</Box>
//         </ScrollableContainer>
//       )}
//     </div>
//   );
// }

// // =============================================================================================
// // CommentReplies Component - NEW
// // =============================================================================================

// const CommentReplies = React.memo(({ comment, currentUserId, onReplyAdded, theme }) => {
//   const [showInput, setShowInput] = useState(false);
//   const [replyText, setReplyText] = useState('');
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [loadingreplay, setloadingreplay] = useState(true);

//   const dispatch = useDispatch();

//   const userLogin = JSON.parse(localStorage.getItem('user'))?.data || {};

//   const handleSubmitReply = async () => {
//     if (!replyText.trim() || !comment?._id || !userLogin?._id) return;

//     setIsSubmitting(true);
//     try {
//       const body = {
//         commentId: comment._id,
//         replyText: replyText.trim(),
//         userId: userLogin._id,
//       };
//       setloadingreplay(true);

//       await dispatch(Insert_Comment_Replay_Action(body));

//       setloadingreplay(false);
//     } catch (error) {
//       console.error('Error adding reply:', error);
//       Notify('error', 'Error adding reply', 'error');
//     } finally {
//       setIsSubmitting(false);
//       setloadingreplay(false);
//     }
//   };

//   const resaddreplay = useSelector((state) => state.AllActions.insrertrepaly);

//   useEffect(() => {
//     if (loadingreplay === false) {
//       if (resaddreplay?.status === 200 || resaddreplay?.success) {
//         Notify('success', 'Reply added successfully', 'success');
//         setReplyText('');
//         setShowInput(false);

//         // Callback to refresh comments
//         if (loadingreplay === false) onReplyAdded();
//       } else {
//         Notify('error', 'Failed to add reply', 'error');
//       }
//     }
//   }, [loadingreplay]);

//   const handleKeyPress = (e) => {
//     if (e.key === 'Enter' && !e.shiftKey) {
//       e.preventDefault();
//       handleSubmitReply();
//     }
//   };

//   // Check if user can reply
//   const canReply =
//     userLogin?.role === 'Sales' || userLogin?.role === 'Team Leader' || userLogin?.role === 'Admin';

//   if (!canReply && (!comment?.replies || comment.replies.length === 0)) {
//     return null;
//   }

//   return (
//     <Box sx={{ mt: 2, pl: 3, borderLeft: `2px solid ${theme.palette.divider}` }}>
//       {/* Replies List */}
//       {comment?.replies && comment.replies.length > 0 ? (
//         <Box sx={{ mb: 2 }}>
//           <Typography variant="subtitle2" fontWeight={600} gutterBottom color="text.secondary">
//             Replies ({comment.replies.length})
//           </Typography>

//           {comment.replies.map((reply, index) => (
//             <Card
//               key={reply._id || index}
//               variant="outlined"
//               sx={{
//                 mb: 1,
//                 p: 1.5,
//                 borderRadius: 1,
//                 bgcolor:
//                   theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.02)',
//                 borderColor: theme.palette.divider,
//               }}
//             >
//               <Box display="flex" gap={1}>
//                 <Avatar src={reply.user?.profileImg} sx={{ width: 28, height: 28 }}>
//                   {reply.user?.name?.charAt(0)}
//                 </Avatar>
//                 <Box flex={1}>
//                   <Box display="flex" justifyContent="space-between" alignItems="flex-start">
//                     <Box>
//                       <Typography variant="caption" fontWeight={600} color="text.primary">
//                         {reply.user?.name}
//                       </Typography>
//                       <Typography variant="caption" color="text.secondary" sx={{ ml: 1 }}>
//                         • {reply.user?.role}
//                       </Typography>
//                     </Box>
//                     <Typography variant="caption" color="text.secondary">
//                       {moment(reply.date).format('DD/MM/YYYY hh:mm A')}
//                     </Typography>
//                   </Box>
//                   <Typography variant="body2" sx={{ mt: 0.5, whiteSpace: 'pre-wrap' }}>
//                     {reply.text}
//                   </Typography>
//                 </Box>
//               </Box>
//             </Card>
//           ))}
//         </Box>
//       ) : (
//         canReply && (
//           <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic', mb: 2 }}>
//             No replies yet
//           </Typography>
//         )
//       )}

//       {/* Reply Input - Only show if user can reply */}
//       {canReply && (
//         <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>
//           <Avatar src={userLogin.profileImg} sx={{ width: 32, height: 32, mt: 0.5 }}>
//             {userLogin.name?.charAt(0)}
//           </Avatar>

//           <Box sx={{ flex: 1 }}>
//             {showInput ? (
//               <>
//                 <TextField
//                   fullWidth
//                   multiline
//                   rows={2}
//                   value={replyText}
//                   onChange={(e) => setReplyText(e.target.value)}
//                   onKeyPress={handleKeyPress}
//                   placeholder="Write your reply..."
//                   variant="outlined"
//                   size="small"
//                   disabled={isSubmitting}
//                   autoFocus
//                   sx={{
//                     '& .MuiOutlinedInput-root': {
//                       backgroundColor:
//                         theme.palette.mode === 'dark'
//                           ? 'rgba(255,255,255,0.05)'
//                           : 'rgba(0,0,0,0.02)',
//                       '& input, & textarea': {
//                         fontSize: '16px',
//                       },
//                     },
//                   }}
//                 />
//                 <Box sx={{ display: 'flex', gap: 1, mt: 1, justifyContent: 'flex-end' }}>
//                   <Button
//                     size="small"
//                     onClick={() => {
//                       setShowInput(false);
//                       setReplyText('');
//                     }}
//                     disabled={isSubmitting}
//                   >
//                     Cancel
//                   </Button>
//                   <Button
//                     variant="contained"
//                     size="small"
//                     onClick={handleSubmitReply}
//                     disabled={!replyText.trim() || isSubmitting}
//                     startIcon={isSubmitting ? <CircularProgress size={16} /> : <SendIcon />}
//                   >
//                     {isSubmitting ? 'Sending...' : 'Reply'}
//                   </Button>
//                 </Box>
//               </>
//             ) : (
//               <Button
//                 variant="outlined"
//                 size="small"
//                 startIcon={<AddCommentIcon />}
//                 onClick={() => setShowInput(true)}
//                 sx={{ width: '100%', justifyContent: 'flex-start' }}
//               >
//                 Add a reply...
//               </Button>
//             )}
//           </Box>

//           {/* Refresh button */}
//           {comment?.replies && comment.replies.length > 0 && (
//             <Tooltip title="Refresh replies">
//               <IconButton size="small" onClick={onReplyAdded} sx={{ mt: 0.5 }}>
//                 <RefreshIcon fontSize="small" />
//               </IconButton>
//             </Tooltip>
//           )}
//         </Box>
//       )}
//     </Box>
//   );
// });

// // =============================================================================================
// // Done Deal Form Component
// // =============================================================================================

// const DoneDealForm = React.memo(
//   ({
//     unitPrice,
//     unitnumber,
//     commissionRatio,
//     cashbackratio,
//     totalCommission,
//     cashbackMoney,
//     onPriceChange,
//     onUnitNumberChange,
//     onCommissionRatioChange,
//     onCashbackRatioChange,
//   }) => {
//     return (
//       <Box>
//         <Grid container spacing={2}>
//           <Grid item xs={12}>
//             <TextField
//               fullWidth
//               label="Unit Price (AED)"
//               type="text"
//               value={unitPrice}
//               onChange={onPriceChange}
//               variant="outlined"
//               margin="normal"
//               InputProps={{
//                 startAdornment: <InputAdornment position="start">AED</InputAdornment>,
//               }}
//               autoComplete="off"
//               inputProps={{
//                 inputMode: 'decimal',
//                 pattern: '[0-9]*[.]?[0-9]*',
//                 style: { fontSize: '16px' },
//               }}
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <TextField
//               fullWidth
//               label="Unit Number"
//               value={unitnumber}
//               onChange={onUnitNumberChange}
//               variant="outlined"
//               margin="normal"
//               placeholder="e.g., A101, Tower 2"
//               autoComplete="off"
//               inputProps={{
//                 style: { fontSize: '16px' },
//               }}
//             />
//           </Grid>
//           <Grid item xs={6}>
//             <TextField
//               fullWidth
//               label="Commission %"
//               type="text"
//               value={commissionRatio}
//               onChange={onCommissionRatioChange}
//               variant="outlined"
//               margin="normal"
//               helperText="Enter commission percentage"
//               InputProps={{
//                 endAdornment: <InputAdornment position="end">%</InputAdornment>,
//               }}
//               autoComplete="off"
//               inputProps={{
//                 inputMode: 'decimal',
//                 pattern: '[0-9]*[.]?[0-9]*',
//                 style: { fontSize: '16px' },
//               }}
//             />
//           </Grid>
//           <Grid item xs={6}>
//             <TextField
//               fullWidth
//               label="Total Commission (AED)"
//               value={totalCommission}
//               disabled
//               variant="outlined"
//               margin="normal"
//               helperText="Auto calculated"
//               InputProps={{
//                 startAdornment: <InputAdornment position="start">AED</InputAdornment>,
//               }}
//               sx={{
//                 '& .MuiInputBase-input.Mui-disabled': {
//                   WebkitTextFillColor: '#2E7D32',
//                   fontWeight: 600,
//                 },
//               }}
//             />
//           </Grid>
//           <Grid item xs={6}>
//             <TextField
//               fullWidth
//               label="Cashback %"
//               type="text"
//               value={cashbackratio}
//               onChange={onCashbackRatioChange}
//               variant="outlined"
//               margin="normal"
//               helperText="Enter cashback percentage (0 for no cashback)"
//               InputProps={{
//                 endAdornment: <InputAdornment position="end">%</InputAdornment>,
//               }}
//               autoComplete="off"
//               inputProps={{
//                 inputMode: 'decimal',
//                 pattern: '[0-9]*[.]?[0-9]*',
//                 style: { fontSize: '16px' },
//               }}
//             />
//           </Grid>
//           <Grid item xs={6}>
//             <TextField
//               fullWidth
//               label="Cashback Amount (AED)"
//               value={cashbackMoney}
//               disabled
//               variant="outlined"
//               margin="normal"
//               helperText="Auto calculated"
//               InputProps={{
//                 startAdornment: <InputAdornment position="start">AED</InputAdornment>,
//               }}
//               sx={{
//                 '& .MuiInputBase-input.Mui-disabled': {
//                   WebkitTextFillColor: '#1976D2',
//                 },
//               }}
//             />
//           </Grid>
//         </Grid>
//       </Box>
//     );
//   },
// );

// // =============================================================================================
// // Stage Specific Form Component
// // =============================================================================================

// const StageSpecificForm = React.memo(
//   ({
//     selectedStageName,
//     // eoiAmount,
//     reservationAmount,
//     // onEoiAmountChange,
//     onReservationAmountChange,
//     unitPrice,
//     unitnumber,
//     commissionRatio,
//     cashbackratio,
//     totalCommission,
//     cashbackMoney,
//     onPriceChange,
//     onUnitNumberChange,
//     onCommissionRatioChange,
//     onCashbackRatioChange,
//   }) => {
//     if (!selectedStageName) return null;

//     return (
//       <Box mb={3}>
//         <Typography variant="subtitle1" fontWeight={600} gutterBottom color="primary">
//           {selectedStageName} Information
//         </Typography>

//         {/* EOI Fields */}
//         {selectedStageName === 'EOI' && (
//           // <TextField
//           //   fullWidth
//           //   label="EOI Amount (AED)"
//           //   type="text"
//           //   value={eoiAmount}
//           //   onChange={onEoiAmountChange}
//           //   variant="outlined"
//           //   margin="normal"
//           //   InputProps={{
//           //     startAdornment: <InputAdornment position="start">AED</InputAdornment>,
//           //   }}
//           //   helperText="Enter the Expression of Interest amount"
//           //   autoComplete="off"
//           //   inputProps={{
//           //     inputMode: 'decimal',
//           //     pattern: '[0-9]*[.]?[0-9]*',
//           //     style: { fontSize: '16px' }
//           //   }}
//           // />
//           <DoneDealForm
//             unitPrice={unitPrice}
//             unitnumber={unitnumber}
//             commissionRatio={commissionRatio}
//             cashbackratio={cashbackratio}
//             totalCommission={totalCommission}
//             cashbackMoney={cashbackMoney}
//             onPriceChange={onPriceChange}
//             onUnitNumberChange={onUnitNumberChange}
//             onCommissionRatioChange={onCommissionRatioChange}
//             onCashbackRatioChange={onCashbackRatioChange}
//           />
//         )}

//         {/* Reservation Fields */}
//         {selectedStageName === 'Reservation' && (
//           <TextField
//             fullWidth
//             label="Reservation Amount (AED)"
//             type="text"
//             value={reservationAmount}
//             onChange={onReservationAmountChange}
//             variant="outlined"
//             margin="normal"
//             InputProps={{
//               startAdornment: <InputAdornment position="start">AED</InputAdornment>,
//             }}
//             helperText="Enter the reservation deposit amount"
//             autoComplete="off"
//             inputProps={{
//               inputMode: 'decimal',
//               pattern: '[0-9]*[.]?[0-9]*',
//               style: { fontSize: '16px' },
//             }}
//           />
//         )}

//         {/* Done Deal Fields */}
//         {selectedStageName === 'Done Deal' && (
//           <DoneDealForm
//             unitPrice={unitPrice}
//             unitnumber={unitnumber}
//             commissionRatio={commissionRatio}
//             cashbackratio={cashbackratio}
//             totalCommission={totalCommission}
//             cashbackMoney={cashbackMoney}
//             onPriceChange={onPriceChange}
//             onUnitNumberChange={onUnitNumberChange}
//             onCommissionRatioChange={onCommissionRatioChange}
//             onCashbackRatioChange={onCashbackRatioChange}
//           />
//         )}
//       </Box>
//     );
//   },
// );

// // =============================================================================================
// // Comment Inputs Component
// // =============================================================================================

// const CommentInputs = React.memo(
//   ({ firstcomment, secondcomment, onFirstCommentChange, onSecondCommentChange }) => {
//     return (
//       <Box mb={3}>
//         <Typography variant="subtitle1" fontWeight={600} gutterBottom>
//           Add Comments
//         </Typography>

//         <Grid container spacing={3}>
//           <Grid item xs={12}>
//             <CommentTextField
//               fullWidth
//               multiline
//               rows={3}
//               label="First Comment - What happened?"
//               value={firstcomment}
//               onChange={onFirstCommentChange}
//               placeholder="Describe the conversation, meeting, or interaction that just occurred..."
//               required
//             />
//           </Grid>

//           <Grid item xs={12}>
//             <CommentTextField
//               fullWidth
//               multiline
//               rows={3}
//               label="Second Comment - Next Action Plan"
//               value={secondcomment}
//               onChange={onSecondCommentChange}
//               placeholder="What's the next step? When will you follow up? What specific actions need to be taken?"
//               required
//             />
//           </Grid>
//         </Grid>
//       </Box>
//     );
//   },
// );

// // =============================================================================================
// // Current Stage Component
// // =============================================================================================

// const CurrentStageComponent = React.memo(({ user, addActionEnabled }) => {
//   if (!addActionEnabled) return null;

//   return (
//     <Fade in={addActionEnabled} timeout={500}>
//       <CurrentStageDisplay>
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: 1 }}>
//           <DoneIcon color="primary" />
//           <Typography variant="body1" fontWeight={600} color="text.primary">
//             Current Stage:
//           </Typography>
//           <StatusChip
//             label={user?.stage?.name}
//             status={user?.stage?.name}
//             size="medium"
//             sx={{
//               bgcolor: getStageColor(user?.stage?.name),
//               color: 'white',
//               fontSize: '0.875rem',
//             }}
//           />
//         </Box>
//         <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>
//           You are now in the stages component
//         </Typography>
//       </CurrentStageDisplay>
//     </Fade>
//   );
// });

// // =============================================================================================
// // Main Component
// // =============================================================================================
// const datePickerStyles = `
//   /* حل نهائي لمشكلة z-index في DateTimePicker */
//   .MuiPickersPopper-root {
//     z-index: 50001 !important;
//   }
  
//   .MuiDialog-root .MuiPickersPopper-root,
//   .MuiDialog-root .MuiPickersModal-root,
//   .MuiDialog-root .MuiModal-root {
//     z-index: 50001 !important;
//   }
  
//   .MuiPickersModal-dialog {
//     z-index: 50001 !important;
//   }
  
//   .MuiPickersCalendarHeader-root,
//   .MuiPickersCalendar-root {
//     z-index: 50001 !important;
//   }
  
//   .MuiPickersDay-root {
//     z-index: 50002 !important;
//   }
  
//   /* حل خاص للشاشات الصغيرة */
//   @media (max-width: 768px) {
//     .MuiPickersPopper-root {
//       z-index: 50001 !important;
//       position: fixed !important;
//       top: 50% !important;
//       left: 50% !important;
//       transform: translate(-50%, -50%) !important;
//     }
//   }
// `;
// export const ShowClientsActionsAdvanced = ({ user, leadid, onClose }) => {
//   const theme = useTheme();
//   const dispatch = useDispatch();
//   useEffect(() => {
//     const styleElement = document.createElement('style');
//     styleElement.innerHTML = datePickerStyles;
//     document.head.appendChild(styleElement);

//     return () => {
//       document.head.removeChild(styleElement);
//     };
//   }, []);
//   const [open, setOpen] = useState(false);
//   const [addActionEnabled, setAddActionEnabled] = useState(false);
//   const [userlogin, setUserLogin] = useState('');

//   // Tab state
//   const [tabValue, setTabValue] = useState(0);

//   // استخدام useRef للقيم التي لا تحتاج إعادة render
//   const userloginrealy = useRef(JSON.parse(localStorage.getItem('user')) || []);

//   // States الرئيسية
//   const [selectedStage, setSelectedStage] = useState(null);
//   const [showDateTimePicker, setShowDateTimePicker] = useState(false);
//   const [stageType, setStageType] = useState(null);
//   const [selectedStageId, setSelectedStageId] = useState(null);
//   const [selectedStageName, setSelectedStageName] = useState(null);
//   const [firstcomment, setFirstComment] = useState('');
//   const [secondcomment, setSecondComment] = useState('');
//   const [valuedate, setValueDate] = useState(dayjs());
//   const [loading, setLoading] = useState(true);
//   const [sendloading, setSendLoading] = useState(false);
//   const [allstagesshow, setAllStagesShow] = useState([]);

//   // States for Done Deal
//   const [unitPrice, setUnitPrice] = useState('');
//   const [isPriceValid, setIsPriceValid] = useState(false);
//   const [unitnumber, setUnitNumber] = useState('');
//   const [isunitnumberValid, setIsUnitNumberValid] = useState(false);
//   const [commissionRatio, setCommissionRatio] = useState('');
//   const [commissionratioValid, setIsCommissionRatioValid] = useState(false);
//   const [totalCommission, setTotalCommission] = useState('');
//   const [cashbackratiovalid, setIsCashbackRatioValid] = useState(false);
//   const [cashbackratio, setCashbackRatio] = useState('');
//   const [cashbackMoney, setCashbackMoney] = useState('');

//   // States for EOI and Reservation
//   const [eoiAmount, setEoiAmount] = useState('');
//   const [reservationAmount, setReservationAmount] = useState('');
//   const [isEoiAmountValid, setIsEoiAmountValid] = useState(false);
//   const [isReservationAmountValid, setIsReservationAmountValid] = useState(false);

//   // Switch state for Answer and No Answer
//   const [isNoAnswer, setIsNoAnswer] = useState(false);

//   // Comments state
//   const [comments, setComments] = useState([]);
//   const [isCommentsLoading, setIsCommentsLoading] = useState(false);
//   const [isReady, setIsReady] = useState(false);

//   // Pagination states - FIXED: يتم تحديثها من response السيرفر
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalCommentsCount, setTotalCommentsCount] = useState(0);
//   const [hasNext, setHasNext] = useState(false);
//   const [hasPrev, setHasPrev] = useState(false);

//   // Filter info
//   const [filterInfo, setFilterInfo] = useState(null);

//   // Stages that need DateTimePicker
//   const stagesWithDateTime = useMemo(
//     () => [
//       'No Answer',
//       'Answer',
//       'Meeting',
//       'Follow',
//       'Follow After Meeting',
//       'Follow Up',
//       'Transfer',
//       'Interested',
//     ],
//     [],
//   );

//   // Dialog states
//   const [openLeadPreview, setOpenLeadPreview] = useState(false);

//   // Refs for scrolling
//   const doneDealSectionRef = useRef(null);
//   const formContainerRef = useRef(null);
//   const commentsContainerRef = useRef(null);

//   // Get data from Redux
//   const resgetallassignsdata = useSelector((state) => state.AllLead_Assigned.Lead_Assigned);
//   const resaddcomment = useSelector((state) => state.AllActions.AddAction);
//   const All_stages = useSelector((state) => state.Allstages.stage);
//   const resgetonestagetype = useSelector((state) => state.Allstages.getstagetogetype);

//   // حل مشكلة الـ z-index على الموبايل
//   useEffect(() => {
//     const handleResize = () => {
//       // إعادة حساب z-index عند تغيير حجم الشاشة
//       const dialog = document.querySelector('.MuiDialog-root');
//       if (dialog && window.innerWidth < 768) {
//         dialog.style.zIndex = '50000';
//       }
//     };

//     window.addEventListener('resize', handleResize);
//     handleResize(); // استدعاء مباشر

//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   // Initialize user login
//   useEffect(() => {
//     if (JSON.parse(localStorage.getItem('user')) != null) {
//       setUserLogin(JSON.parse(localStorage.getItem('user')));
//     }
//   }, []);

//   // دالة لتحميل التعليقات باستخدام الأكشن - FIXED
//   const getallactiondata = useCallback(
//     async (page = 1) => {
//       try {
//         setIsCommentsLoading(true);

//         const userId = userloginrealy.current?.data?._id;
//         const leadId = leadid || user?._id;

//         if (!leadId || !userId) {
//           console.error('Missing leadId or userId:', { leadId, userId });
//           Notify('error', 'Cannot load comments: missing user data', 'error');
//           return;
//         }

//         console.log('Fetching comments for:', { leadId, userId, page });

//         // استدعاء الأكشن
//         const params = {
//           leadId: user?._id,
//           userId: userId,
//           page: page,
//           limit: 20,
//         };

//         const response = await dispatch(
//           GetAllcomments_Data_With_Pagination_action_advanced(params),
//         );

//         console.log('Redux action response:', response);

//         if (response?.success && response?.comments) {
//           // تحديث التعليقات مباشرة
//           setComments(response.comments);

//           // تحديث معلومات الباجينيشن من response السيرفر - FIXED
//           if (response.pagination) {
//             setCurrentPage(response.pagination.page || page);
//             setTotalPages(response.pagination.totalPages || 1);
//             setHasNext(response.pagination.hasNext || false);
//             setHasPrev(response.pagination.hasPrev || false);
//           }

//           // تحديث العدد الكلي - FIXED: استخدام totalComments من response
//           setTotalCommentsCount(response.totalComments || response.comments.length || 0);

//           // تحديث معلومات الفلتر
//           if (response.filterApplied) {
//             setFilterInfo({
//               applied: response.filterApplied,
//               assignmentInfo: response.assignmentInfo,
//             });
//           }

//           console.log('Updated pagination:', {
//             currentPage: response.pagination?.page || page,
//             totalPages: response.pagination?.totalPages || 1,
//             hasNext: response.pagination?.hasNext,
//             hasPrev: response.pagination?.hasPrev,
//             totalComments: response.totalComments,
//           });
//         }
//       } catch (error) {
//         console.error('Error fetching comments:', error);
//         Notify('error', 'Failed to load comments', 'error');
//       } finally {
//         setIsCommentsLoading(false);
//       }
//     },
//     [dispatch, leadid, user?._id],
//   );

//   // دالة لتحديث التعليقات بعد إضافة رد
//   const refreshComments = useCallback(() => {
//     getallactiondata(currentPage);
//   }, [getallactiondata, currentPage]);

//   // Get all stages
//   const getallstages = useCallback(async () => {
//     try {
//       await dispatch(GetAll_stage_Data());
//     } catch (error) {
//       console.error('Error loading stages:', error);
//     }
//   }, [dispatch]);

//   // Load data on open
//   useEffect(() => {
//     let timeout;
//     if (open) {
//       setIsReady(false);

//       timeout = setTimeout(async () => {
//         await getallstages();
//         setIsReady(true);
//       }, 500);
//     }

//     return () => clearTimeout(timeout);
//   }, [open, getallstages]);

//   // Set all stages
//   // useEffect(() => {
//   //   if (All_stages && All_stages?.data) {
//   //     setAllStagesShow(All_stages.data);
//   //   }
//   // }, [All_stages]);

//   // بعد setAllStagesShow في useEffect الخاص بتحميل الـ stages
//   useEffect(() => {
//     if (All_stages && All_stages?.data) {
//       // ترتيب الـ stages بحيث يكون "No Stage" أولًا
//       const sortedStages = [...All_stages.data].sort((a, b) => {
//         // وضع "No Stage" في البداية
//         if (a.name === 'No Stage') return -1;
//         if (b.name === 'No Stage') return 1;
//         // ترتيب باقي المراحل أبجديًا
//         return a.name.localeCompare(b.name);
//       });
//       setAllStagesShow(sortedStages);
//     }
//   }, [All_stages]);

//   // Set stage type
//   useEffect(() => {
//     if (resgetonestagetype) {
//       if (resgetonestagetype.data) {
//         setStageType(resgetonestagetype.data);
//       } else {
//         setStageType(null);
//       }
//     } else {
//       setStageType(null);
//     }
//   }, [resgetonestagetype]);

//   // Generate automatic comments
//   const generateAutoComments = useCallback((stageName) => {
//     const commentTemplates = {
//       Meeting: {
//         firstComment: '',
//         secondComment: '',
//       },
//       'Follow Up': {
//         firstComment: '',
//         secondComment: '',
//       },
//       'Follow After Meeting': {
//         firstComment: '',
//         secondComment: '',
//       },
//       Interested: {
//         firstComment: '',
//         secondComment: '',
//       },
//       'No Answer': {
//         firstComment: 'اتصلت ومفيش رد',
//         secondComment: 'هحاول تاني في وقت تاني',
//       },
//       Answer: {
//         firstComment: '',
//         secondComment: '',
//       },
//       'Done Deal': {
//         firstComment: '',
//         secondComment: '',
//       },
//       EOI: {
//         firstComment: '',
//         secondComment: '',
//       },
//       Reservation: {
//         firstComment: '',
//         secondComment: '',
//       },
//     };

//     return commentTemplates[stageName] || { firstComment: '', secondComment: '' };
//   }, []);

//   // Handle stage change
//   const handleStageChange = useCallback(
//     (event, newValue) => {
//       if (newValue) {
//         setSelectedStage(newValue);
//         const stageName = newValue.name;
//         const stageId = newValue._id;

//         setSelectedStageId(stageId);
//         setSelectedStageName(stageName);

//         if (
//           stagesWithDateTime.includes(stageName) ||
//           stageName === 'Answer' ||
//           stageName === 'No Answer'
//         ) {
//           setShowDateTimePicker(true);
//         } else {
//           setShowDateTimePicker(false);
//           setValueDate(null);
//         }

//         // Get stage type information
//         dispatch(GetOne_stagetogettype_Data(stageId))
//           .then((response) => {
//             if (response?.data) {
//               setStageType(response.data);
//             }
//           })
//           .catch((error) => {
//             console.error('Error fetching stage type:', error);
//           });

//         const autoComments = generateAutoComments(stageName);
//         setFirstComment(autoComments.firstComment);
//         setSecondComment(autoComments.secondComment);

//         if (stageName === 'No Answer') {
//           setIsNoAnswer(true);
//         } else if (stageName === 'Answer') {
//           setIsNoAnswer(false);
//         }

//         // Scroll to Done Deal section when selected
//         if (stageName === 'Done Deal' && doneDealSectionRef.current) {
//           setTimeout(() => {
//             doneDealSectionRef.current.scrollIntoView({
//               behavior: 'smooth',
//               block: 'start',
//             });
//           }, 100);
//         }
//       } else {
//         setSelectedStage(null);
//         setSelectedStageId(null);
//         setSelectedStageName(null);
//         setStageType(null);
//         setShowDateTimePicker(false);
//       }
//     },
//     [dispatch, generateAutoComments, stagesWithDateTime],
//   );

//   // Function to reset stage form
//   const resetStageForm = useCallback(() => {
//     setUnitPrice('');
//     setUnitNumber('');
//     setCommissionRatio('');
//     setCashbackRatio('');
//     setEoiAmount('');
//     setReservationAmount('');
//     setIsPriceValid(false);
//     setIsUnitNumberValid(false);
//     setIsCommissionRatioValid(false);
//     setIsCashbackRatioValid(false);
//     setIsEoiAmountValid(false);
//     setIsReservationAmountValid(false);
//     setStageType(null);
//     setSelectedStage(null);
//     setShowDateTimePicker(false);
//     setValueDate(null);
//     setIsNoAnswer(false);
//   }, []);

//   // Handle Enable Action toggle
//   const handleEnableActionToggle = useCallback(
//     (isChecked) => {
//       setAddActionEnabled(isChecked);

//       if (isChecked && user?.stage) {
//         // Set current stage as selected stage initially
//         setSelectedStage(user.stage);
//         setSelectedStageId(user.stage._id);
//         setSelectedStageName(user.stage.name);

//         // Check if DateTimePicker should be shown
//         if (stagesWithDateTime.includes(user.stage.name)) {
//           setShowDateTimePicker(true);
//         } else {
//           setShowDateTimePicker(false);
//           setValueDate(null);
//         }

//         // Get stage type information
//         dispatch(GetOne_stagetogettype_Data(user.stage._id))
//           .then((response) => {
//             if (response?.data) {
//               setStageType(response.data);
//             }
//           })
//           .catch((error) => {
//             console.error('Error fetching stage type:', error);
//           });

//         // Generate auto comments for current stage
//         const autoComments = generateAutoComments(user.stage.name);
//         setFirstComment(autoComments.firstComment);
//         setSecondComment(autoComments.secondComment);

//         // Set Answer/No Answer state
//         if (user.stage.name === 'No Answer') {
//           setIsNoAnswer(true);
//         } else if (user.stage.name === 'Answer') {
//           setIsNoAnswer(false);
//         }
//       } else {
//         resetStageForm();
//       }
//     },
//     [user?.stage, dispatch, generateAutoComments, stagesWithDateTime, resetStageForm],
//   );

//   // Handlers مع useCallback
//   const handlePriceChange = useCallback((e) => {
//     const value = e.target.value.replace(/[^0-9.]/g, '');
//     setUnitPrice(value);
//     const price = parseFloat(value);
//     setIsPriceValid(!isNaN(price) && price > 0);
//   }, []);

//   const handleUnitNumber = useCallback((e) => {
//     const value = e.target.value;
//     setUnitNumber(value);
//     setIsUnitNumberValid(value.trim() !== '');
//   }, []);

//   const handleCommissionRatioChange = useCallback((e) => {
//     const value = e.target.value.replace(/[^0-9.]/g, '');
//     setCommissionRatio(value);
//     const commissionratio = parseFloat(value);
//     setIsCommissionRatioValid(!isNaN(commissionratio) && commissionratio > 0);
//   }, []);

//   const handleCashbackRatioChange = useCallback((e) => {
//     const value = e.target.value.replace(/[^0-9.]/g, '');
//     setCashbackRatio(value);
//     const cashbackratio = parseFloat(value);
//     setIsCashbackRatioValid(!isNaN(cashbackratio) && cashbackratio >= 0);
//   }, []);

//   const handleEoiAmountChange = useCallback((e) => {
//     const value = e.target.value.replace(/[^0-9.]/g, '');
//     setEoiAmount(value);
//     const amount = parseFloat(value);
//     setIsEoiAmountValid(!isNaN(amount) && amount > 0);
//   }, []);

//   const handleReservationAmountChange = useCallback((e) => {
//     const value = e.target.value.replace(/[^0-9.]/g, '');
//     setReservationAmount(value);
//     const amount = parseFloat(value);
//     setIsReservationAmountValid(!isNaN(amount) && amount > 0);
//   }, []);

//   const handleDateTimeChange = useCallback(
//     (newValue) => {
//       if (newValue) {
//         setValueDate(newValue);

//         const formattedDateTime = moment(newValue.toDate()).format('MMMM Do YYYY, h:mm A');
//         const currentSecondComment = secondcomment || '';

//         const commentWithoutDate = currentSecondComment
//           .replace(/ - Follow up on .*$/, '')
//           .replace(/ - Scheduled for .*$/, '')
//           .replace(/ - Next action on .*$/, '');

//         const newComment = commentWithoutDate
//           ? `${commentWithoutDate} - Follow up on ${formattedDateTime}`
//           : `Follow up on ${formattedDateTime}`;

//         setSecondComment(newComment);
//       }
//     },
//     [secondcomment],
//   );

//   const onFirstCommentChange = useCallback((e) => {
//     const value = e.target.value;
//     setFirstComment(value);
//   }, []);

//   const onSecondCommentChange = useCallback((e) => {
//     const value = e.target.value;
//     setSecondComment(value);
//   }, []);

//   // Calculate commission
//   useEffect(() => {
//     const price = parseFloat(unitPrice);
//     const ratio = parseFloat(commissionRatio);

//     if (!isNaN(price) && !isNaN(ratio) && price > 0 && ratio > 0) {
//       const commission = (price * ratio) / 100;
//       setTotalCommission(commission.toFixed(2));
//     } else {
//       setTotalCommission('');
//     }
//   }, [unitPrice, commissionRatio]);

//   // Calculate cashback
//   useEffect(() => {
//     const price = parseFloat(unitPrice);
//     const ratio = parseFloat(cashbackratio);
//     const commission = parseFloat(totalCommission);

//     if (!isNaN(ratio)) {
//       if (ratio === 0) {
//         setCashbackMoney('0');
//       } else if (!isNaN(commission) && commission > 0 && ratio > 0) {
//         const cashback = (commission * ratio) / 100;
//         setCashbackMoney(cashback.toFixed(2));
//       } else {
//         setCashbackMoney('');
//       }
//     } else {
//       setCashbackMoney('');
//     }
//   }, [cashbackratio, totalCommission, unitPrice]);

//   // Confetti function for Done Deal
//   const DoneDealFun = useCallback(() => {
//     const jsConfetti = new JSConfetti();
//     jsConfetti.addConfetti({
//       confettiColors: ['#ff0a54', '#ff477e', '#ff7096', '#ff85a1', '#fbb1bd', '#f9bec7'],
//     });
//   }, []);

//   // Submit data - FIXED VERSION
//   const onsubmitdata = async (e) => {
//     e.preventDefault();

//     // ✅ Check required fields
//     if (!firstcomment.trim()) {
//       return Notify('error', 'Please enter first comment', 'error');
//     }
//     if (!secondcomment.trim()) {
//       return Notify('error', 'Please enter second comment', 'error');
//     }

//     // ✅ If stage needs DateTimePicker, check date
//     if (showDateTimePicker && !valuedate) {
//       return Notify('error', 'Please select date & time', 'error');
//     }

//     // ✅ For other stages, use current time
//     if (!showDateTimePicker && !valuedate) {
//       setValueDate(dayjs()); // Set to current time
//     }

//     // ✅ If Add Action is enabled, validate stage requirements
//     if (addActionEnabled && selectedStageId) {
//       // التحقق من صحة المبالغ في EOI و Reservation
//       // if (selectedStageName === "EOI" && (!isEoiAmountValid || eoiAmount === '')) {
//       //   return Notify("error", "Please enter a valid EOI amount", "error");
//       // }

//       if (
//         selectedStageName === 'Reservation' &&
//         (!isReservationAmountValid || reservationAmount === '')
//       ) {
//         return Notify('error', 'Please enter a valid Reservation amount', 'error');
//       }

//       if (selectedStageName === 'Done Deal' || selectedStageName === 'EOI') {
//         const price = parseFloat(unitPrice);
//         if (isNaN(price) || price <= 0) {
//           return Notify('error', 'Please enter a valid unit price (greater than zero)', 'error');
//         }
//         if (!unitnumber.trim()) {
//           return Notify('error', 'Please enter unit number', 'error');
//         }
//         if (!commissionRatio || parseFloat(commissionRatio) <= 0) {
//           return Notify('error', 'Please enter a valid commission ratio', 'error');
//         }
//         if (!cashbackratio || cashbackratio < 0) {
//           return Notify('error', 'Please enter a valid cashback ratio', 'error');
//         }
//       }
//     }

//     setLoading(true);
//     setSendLoading(true);

//     try {
//       // Determine which stage to use
//       const stageIdToUse = addActionEnabled && selectedStage ? selectedStage._id : user?.stage?._id;

//       console.log('Add Action Enabled:', addActionEnabled);
//       console.log('Selected Stage:', selectedStage);
//       console.log('Stage ID to Use:', stageIdToUse);
//       console.log('Current User Stage:', user?.stage?._id);

//       const finalStageDate = valuedate ? valuedate : dayjs();

//       // إذا كان الـ Add Action مفعل، قم بتحديث الـ stage أولاً
//       if (addActionEnabled) {
//         console.log('🔄 Updating stage to:', selectedStageName);

//         const updateData = {
//           stage: selectedStageId,
//           stagedateupdated: finalStageDate,
//           last_stage_date_updated: moment().format('YYYY-MM-DD'),
//           ...((selectedStageName === 'Done Deal' || selectedStageName === 'EOI') && {
//             unit_price: parseFloat(unitPrice),
//             review: false,
//             unitnumber: unitnumber,
//             commissionratio: parseFloat(commissionRatio),
//             commissionmoney: totalCommission,
//             cashbackratio: parseFloat(cashbackratio),
//             cashbackmoney: cashbackMoney,
//           }),
//           // ...(selectedStageName === "EOI" && {
//           //   Eoi: parseFloat(eoiAmount),
//           // }),
//           ...(selectedStageName === 'Reservation' && {
//             Reservation: parseFloat(reservationAmount),
//           }),
//         };

//         console.log('📤 Update Data:', updateData);

//         // انتظر اكتمال تحديث الـ stage أولاً
//         const updateStageResult = await dispatch(UpdateStageToLeed(user._id, updateData));

//         console.log('✅ Stage Update Result:', updateStageResult);

//         // إضافة سجل في Lead Stages
//         const leadStageData = {
//           LeadId: user._id,
//           date: moment().format('YYYY-MM-DD'),
//           stage: selectedStageId,
//           sales: userlogin.data._id,
//           dateselectedforstage: finalStageDate,
//           ...((selectedStageName === 'Done Deal' || selectedStageName === 'EOI') && {
//             unitPrice: parseFloat(unitPrice),
//           }),
//         };

//         console.log('📝 Lead Stage Data:', leadStageData);

//         await dispatch(Insert_Lead_Stages_Data_Action(leadStageData));

//         // إذا كانت Done Deal، شغل الكونفيتي
//         if (selectedStageName === 'Done Deal' || selectedStageName === 'EOI') {
//           DoneDealFun();
//         }
//       }

//       // إضافة الكومنت
//       console.log('💬 Adding comment with stage:', stageIdToUse);

//       // FIX: استخدام userlogin.data._id بدلاً من userloginrealy.current.data?._id
//       const actionResponse = await dispatch(
//         InsertNewAction_action({
//           sales: userlogin.data._id,
//           text1: firstcomment,
//           text2: secondcomment,
//           date: finalStageDate,
//           leed: user._id,
//           username: userlogin.data._id, // FIXED: استخدام userlogin.data._id مباشرة
//           commentbysales: userlogin.data.name,
//           stage: user?.stage?._id,
//         }),
//       );
//     } catch (error) {
//       console.error('❌ Error submitting data:', error);
//       Notify('error', 'Error sending data, please try again.', 'error');
//     } finally {
//       setLoading(false);
//       setSendLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (!loading) {
//       if (resaddcomment && resaddcomment?.status === 200) {
//         Notify('success', 'Comment added successfully!', 'success');
//         // Reset form
//         setFirstComment('');
//         setSecondComment('');

//         // Reset stage form إذا كان Add Action مفعل
//         if (addActionEnabled) {
//           resetStageForm();
//         }

//         // Refresh comments after adding new one
//         if (tabValue === 2) {
//           refreshComments();
//         }
//       } else {
//         Notify('error', 'Error adding comment', 'error');
//       }
//     }
//   }, [loading]);

//   // Handle tab change
//   const handleTabChange = useCallback(
//     (event, newValue) => {
//       setTabValue(newValue);

//       // Auto load comments when switching to All Comments tab
//       if (newValue === 2) {
//         console.log('Switching to All Comments tab');

//         if (leadid && userloginrealy.current?.data?._id) {
//           getallactiondata(1);
//         } else {
//           console.error('Cannot load comments: missing leadid or userId');
//           Notify('error', 'Cannot load comments: missing data', 'error');
//         }
//       }
//     },
//     [leadid, getallactiondata],
//   );

//   useEffect(() => {
//     setOpen(true);
//   }, []);

//   const handleClose = useCallback(() => {
//     if (onClose) {
//       onClose();
//     } else {
//       setOpen(false);
//       setAddActionEnabled(false);
//       resetStageForm();
//     }
//   }, [onClose, resetStageForm]);

//   return (
//     <Dialog
//       open={open}
//       onClose={handleClose}
//       maxWidth="lg"
//       fullWidth
//       TransitionComponent={Transition}
//       PaperProps={{
//         sx: {
//           borderRadius: 4,
//           height: '100vh',
//           // maxHeight: '90vh',
//           display: 'flex',
//           flexDirection: 'column',
//           // ✅ إضافة هذه الخصائص
//           position: 'relative',
//           overflow: 'visible !important',
//           zIndex: 50000,
//         },
//       }}
//       // ✅ إضافة sx جديد
//       sx={{
//         zIndex: 50000,
//         '& .MuiDialog-container': {
//           overflow: 'visible',
//           zIndex: 50000,
//           position: 'relative',
//         },
//         '& .MuiBackdrop-root': {
//           zIndex: 49999,
//         },
//         // ✅ هذا هو المفتاح لحل مشكلة الـ Picker
//         '& .MuiModal-root': {
//           zIndex: '50001 !important',
//         },
//         '& .MuiPickersPopper-root': {
//           zIndex: '50001 !important',
//           '& .MuiPaper-root': {
//             zIndex: '50001 !important',
//           },
//         },
//       }}
//       disablePortal={false}
//       keepMounted={true}
//     >
//       {/* Header */}
//       <AppBar
//         position="static"
//         elevation={0}
//         sx={{ borderTopLeftRadius: 4, borderTopRightRadius: 4, flexShrink: 0 }}
//       >
//         <Toolbar>
//           <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
//             <Avatar
//               sx={{
//                 bgcolor: getStageColor(selectedStageName || user?.stage?.name),
//                 mr: 2,
//                 fontWeight: 'bold',
//               }}
//             >
//               {user?.name?.charAt(0)}
//             </Avatar>
//             <Box>
//               <Typography variant="h6" fontWeight={600} sx={{ color: '#fff' }}>
//                 {user?.name}
//               </Typography>
//               <Typography variant="body2" sx={{ color: '#fff' }}>
//                 {user?.sales?.name} •
//                 <StatusChip
//                   label={selectedStageName || user?.stage?.name}
//                   status={selectedStageName || user?.stage?.name}
//                   size="small"
//                   sx={{ ml: 1, color: '#fff' }}
//                 />
//               </Typography>
//             </Box>
//           </Box>
//           <IconButton edge="end" color="inherit" onClick={handleClose}>
//             <CloseIcon />
//           </IconButton>
//         </Toolbar>
//       </AppBar>

//       {/* Tabs Header - Fixed */}
//       <Box sx={{ borderBottom: 1, borderColor: 'divider', px: 3, flexShrink: 0 }}>
//         <Tabs
//           value={tabValue}
//           onChange={handleTabChange}
//           variant="fullWidth"
//           textColor="primary"
//           indicatorColor="primary"
//         >
//           <Tab
//             icon={<InfoIcon />}
//             iconPosition="start"
//             label="Information"
//             id="action-tab-0"
//             aria-controls="action-tabpanel-0"
//           />
//           <Tab
//             icon={<AddCommentIcon />}
//             iconPosition="start"
//             label="Add Comment"
//             id="action-tab-1"
//             aria-controls="action-tabpanel-1"
//           />
//           <Tab
//             icon={<CommentIcon />}
//             iconPosition="start"
//             label={`All Comments`}
//             id="action-tab-2"
//             aria-controls="action-tabpanel-2"
//           />
//         </Tabs>
//       </Box>

//       {/* Tab Content - Scrollable */}
//       <DialogContent
//         dividers
//         sx={{
//           p: 0,
//           flex: 1,
//           overflow: 'hidden',
//           display: 'flex',
//           flexDirection: 'column',
//         }}
//       >
//         <Container
//           maxWidth={false}
//           sx={{
//             p: 0,
//             height: '100%',
//             display: 'flex',
//             flexDirection: 'column',
//           }}
//         >
//           {/* Tab 1: Information */}
//           <TabPanel value={tabValue} index={0}>
//             <StyledCard>
//               <CardHeader
//                 avatar={
//                   <Avatar sx={{ bgcolor: 'primary.main' }}>
//                     <PersonIcon />
//                   </Avatar>
//                 }
//                 title="Lead Information"
//                 titleTypographyProps={{ variant: 'h6', fontWeight: 600 }}
//                 action={
//                   <Box display="flex" gap={1}>
//                     <Tooltip title="Lead Preview">
//                       <IconButton onClick={() => setOpenLeadPreview(true)} size="small">
//                         <VisibilityIcon />
//                       </IconButton>
//                     </Tooltip>
//                     {userlogin?.data?.role === 'Sales' ||
//                     userlogin?.data?.role === 'Team Leader' ? null : (
//                       <Tooltip title="Edit Lead">
//                         <IconButton component={Link} to={`/updateclient/${user._id}`} size="small">
//                           <EditIcon />
//                         </IconButton>
//                       </Tooltip>
//                     )}
//                   </Box>
//                 }
//               />
//               <CardContent>
//                 <Grid container spacing={2}>
//                   <Grid item xs={12}>
//                     <Box display="flex" alignItems="center" gap={1} mb={1}>
//                       <PersonIcon fontSize="small" color="primary" />
//                       <Typography variant="body2" color="textSecondary">
//                         Lead Name:
//                       </Typography>
//                       <Typography variant="body1" fontWeight={500}>
//                         {user?.name}
//                       </Typography>
//                     </Box>
//                   </Grid>

//                   <Grid item xs={12}>
//                     <Box display="flex" alignItems="center" gap={1} mb={1}>
//                       <WorkIcon fontSize="small" color="primary" />
//                       <Typography variant="body2" color="textSecondary">
//                         Sales Person:
//                       </Typography>
//                       <Typography variant="body1" fontWeight={500}>
//                         {user?.sales?.name}
//                       </Typography>
//                     </Box>
//                   </Grid>

//                   <Grid item xs={12}>
//                     <Box display="flex" alignItems="center" gap={1} mb={1}>
//                       <PhoneIcon fontSize="small" color="primary" />
//                       <Typography variant="body2" color="textSecondary">
//                         Phone 1:
//                       </Typography>
//                       <IconButton
//                         size="small"
//                         onClick={() => window.open(`https://wa.me/${user?.phone}`, '_blank')}
//                         sx={{ p: 0, ml: 1 }}
//                       >
//                         <WhatsAppIcon fontSize="small" color="success" />
//                       </IconButton>
//                       <Typography variant="body1" fontWeight={500}>
//                         {user?.phone}
//                       </Typography>
//                     </Box>
//                   </Grid>

//                   <Grid item xs={12}>
//                     <Box display="flex" alignItems="center" gap={1} mb={1}>
//                       <PhoneIcon fontSize="small" color="primary" />
//                       <Typography variant="body2" color="textSecondary">
//                         Phone 2:
//                       </Typography>
//                       <IconButton
//                         size="small"
//                         onClick={() => window.open(`https://wa.me/${user?.phonenumber2}`, '_blank')}
//                         sx={{ p: 0, ml: 1 }}
//                       >
//                         <WhatsAppIcon fontSize="small" color="success" />
//                       </IconButton>
//                       <Typography variant="body1" fontWeight={500}>
//                         {user?.phonenumber2 || 'Not Exist'}
//                       </Typography>
//                     </Box>
//                   </Grid>

//                   <Grid item xs={12}>
//                     <Box display="flex" alignItems="center" gap={1}>
//                       <WhatsAppIcon fontSize="small" color="primary" />
//                       <Typography variant="body2" color="textSecondary">
//                         WhatsApp:
//                       </Typography>
//                       <Typography variant="body1" fontWeight={500}>
//                         {user?.whatsappnumber ? user?.whatsappnumber : user?.phone || 'Not Exist'}
//                       </Typography>
//                     </Box>
//                   </Grid>

//                   <Grid item xs={12}>
//                     <Box display="flex" alignItems="center" gap={1}>
//                       <EmailIcon fontSize="small" color="primary" />
//                       <Typography variant="body2" color="textSecondary">
//                         Email:
//                       </Typography>
//                       <Typography variant="body1" fontWeight={500}>
//                         {user?.email || 'N/A'}
//                       </Typography>
//                     </Box>
//                   </Grid>

//                   <Grid item xs={12} sx={{ mt: 2 }}>
//                     <Divider />
//                   </Grid>

//                   <Grid item xs={12}>
//                     <Box display="flex" justifyContent="space-between" alignItems="center">
//                       <Typography variant="body2" color="textSecondary">
//                         Current Stage:
//                       </Typography>
//                       <StageChip label={user?.stage?.name} size="small" />
//                     </Box>
//                   </Grid>

//                   <Grid item xs={12}>
//                     <Box display="flex" justifyContent="space-between" alignItems="center">
//                       <Typography variant="body2" color="textSecondary">
//                         Developer:
//                       </Typography>
//                       <Typography variant="body1" fontWeight={500}>
//                         {user?.project?.developer?.name}
//                       </Typography>
//                     </Box>
//                   </Grid>

//                   <Grid item xs={12}>
//                     <Box display="flex" justifyContent="space-between" alignItems="center">
//                       <Typography variant="body2" color="textSecondary">
//                         Project:
//                       </Typography>
//                       <Typography variant="body1" fontWeight={500}>
//                         {user?.project?.name}
//                       </Typography>
//                     </Box>
//                   </Grid>

//                   {/* <Grid item xs={12}>
//                     <Box display="flex" justifyContent="space-between" alignItems="center">
//                       <Typography variant="body2" color="textSecondary">
//                         Channal:
//                       </Typography>
//                       <Typography variant="body1" fontWeight={500}>
//                         {user?.chanel?.name}
//                       </Typography>
//                     </Box>
//                   </Grid> */}

//                   {userlogin?.data?.role === 'Sales' || userlogin?.data?.role === 'Team Leader' ? (
//                     // إذا كان المستخدم الحالي Sales أو Team Leader
//                     user?.resetcreationdate ===
//                     true ? // وإذا كان resetcreationdate = true نخفي التاريخ
//                     null : (
//                       // إذا كان resetcreationdate = false أو undefined نعرض التاريخ
//                       <Grid item xs={12}>
//                         <Box display="flex" justifyContent="space-between" alignItems="center">
//                           <Typography variant="body2" color="textSecondary">
//                             Created Date:
//                           </Typography>
//                           <Typography variant="body1" fontWeight={500}>
//                             {moment(user?.createdAt).format('DD/MM/YYYY')}
//                           </Typography>
//                         </Box>
//                       </Grid>
//                     )
//                   ) : (
//                     // إذا كان المستخدم الحالي ليس Sales ولا Team Leader نعرض التاريخ دائماً
//                     <Grid item xs={12}>
//                       <Box display="flex" justifyContent="space-between" alignItems="center">
//                         <Typography variant="body2" color="textSecondary">
//                           Created Date:
//                         </Typography>
//                         <Typography variant="body1" fontWeight={500}>
//                           {moment(user?.createdAt).format('DD/MM/YYYY')}
//                         </Typography>
//                       </Box>
//                     </Grid>
//                   )}

//                   {/* // <Grid item xs={12}>
//                   //   <Box display="flex" justifyContent="space-between" alignItems="center">
//                   //     <Typography variant="body2" color="textSecondary">
//                   //       Created Date:
//                   //     </Typography>
//                   //     <Typography variant="body1" fontWeight={500}>
//                   //       {moment(user?.createdAt).format('DD/MM/YYYY')}
//                   //     </Typography>
//                   //   </Box>
//                   // </Grid> */}

//                   <Grid item xs={12}>
//                     <Box display="flex" justifyContent="space-between" alignItems="center">
//                       <Typography variant="body2" color="textSecondary">
//                         Job Description:
//                       </Typography>
//                       <Typography variant="body1" fontWeight={500}>
//                         {user?.jobdescription}
//                       </Typography>
//                     </Box>
//                   </Grid>

//                   <Grid item xs={12}>
//                     <Box display="flex" justifyContent="space-between" alignItems="center">
//                       <Typography variant="body2" color="textSecondary">
//                         Notes:
//                       </Typography>
//                       <Typography variant="body1" fontWeight={500}>
//                         {user?.notes}
//                       </Typography>
//                     </Box>
//                   </Grid>

// {/* Campaign Redirect Link Section - NEW */}
// {user?.campaignRedirectLink && (
//   <>
//     <Grid item xs={12}>
//       <Divider sx={{ my: 2 }} />
//     </Grid>
//     <Grid item xs={12}>
//       <Box display="flex" alignItems="center" gap={1}>
//         <Box
//           component="span"
//           role="img"
//           aria-label="link"
//           sx={{ 
//             fontSize: '1.2rem',
//             background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//             width: 32,
//             height: 32,
//             borderRadius: '50%',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             color: 'white'
//           }}
//         >
//           🔗
//         </Box>
//         <Typography variant="subtitle1" fontWeight={600} gutterBottom sx={{ mb: 0 }}>
//           Campaign Redirect Link
//         </Typography>
//       </Box>
//     </Grid>
//     <Grid item xs={12}>
//       <Paper
//         variant="outlined"
//         sx={{
//           p: 2,
//           bgcolor: theme.palette.mode === 'dark' ? 'rgba(102, 126, 234, 0.1)' : '#f0f4ff',
//           borderRadius: 2,
//           border: '1px solid',
//           borderColor: 'primary.main',
//           display: 'flex',
//           alignItems: 'center',
//           gap: 1
//         }}
//       >
//         <Box
//           sx={{
//             bgcolor: 'primary.main',
//             borderRadius: '50%',
//             width: 32,
//             height: 32,
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             color: 'white'
//           }}
//         >
//           <LinkIcon fontSize="small" />
//         </Box>
//         <Box sx={{ flex: 1 }}>
//           <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mb: 0.5 }}>
//             Redirect URL
//           </Typography>
//           <Typography 
//             variant="body1" 
//             sx={{ 
//               wordBreak: 'break-all',
//               fontWeight: 500,
//               color: 'primary.main'
//             }}
//           >
//             <a 
//               href={user.campaignRedirectLink} 
//               target="_blank" 
//               rel="noopener noreferrer"
//               style={{ 
//                 color: 'inherit',
//                 textDecoration: 'none',
//                 '&:hover': {
//                   textDecoration: 'underline'
//                 }
//               }}
//             >
//               {user.campaignRedirectLink}
//             </a>
//           </Typography>
//         </Box>
//         <Tooltip title="Open link">
//           <IconButton
//             size="small"
//             onClick={() => window.open(user.campaignRedirectLink, '_blank')}
//             sx={{ 
//               bgcolor: 'primary.main',
//               color: 'white',
//               '&:hover': {
//                 bgcolor: 'primary.dark'
//               }
//             }}
//           >
//             <OpenInNewIcon fontSize="small" />
//           </IconButton>
//         </Tooltip>
//       </Paper>
//     </Grid>
//   </>
// )}

//                   {/* Questions & Answers Section - بتظهر لو فيه بيانات فقط */}
// {[1, 2, 3, 4, 5].some(num => user?.[`question${num}_text`] || user?.[`question${num}_answer`]) && (
//   <>
//     <Grid item xs={12}>
//       <Divider sx={{ my: 2 }} />
//     </Grid>
//     <Grid item xs={12}>
//       <Typography variant="subtitle1" fontWeight={600} gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//         <Box component="span" role="img" aria-label="qa" sx={{ fontSize: '1.2rem' }}>❓</Box>
//        Campaign Questions & Answers
//       </Typography>
//     </Grid>
    
//     {[1, 2, 3, 4, 5].map((num) => {
//       const question = user?.[`question${num}_text`];
//       const answer = user?.[`question${num}_answer`];
      
//       // لو السؤال والإجابة فاضيين متعرضش
//       if (!question && !answer) return null;
      
//       return (
//         <Grid item xs={12} key={num}>
//           <Paper
//             variant="outlined"
//             sx={{
//               p: 2,
//               bgcolor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.05)' : '#f8f9fa',
//               borderRadius: 2,
//               borderLeft: '4px solid',
//               borderLeftColor: 'primary.main',
//             }}
//           >
//             {/* السؤال */}
//             {question && (
//               <Box sx={{ mb: answer ? 1.5 : 0 }}>
//                 <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mb: 0.5 }}>
//                   Question {num}:
//                 </Typography>
//                 <Typography variant="body2" fontWeight={500}>
//                   {question}
//                 </Typography>
//               </Box>
//             )}
            
//             {/* الإجابة */}
//             {answer && (
//               <Box>
//                 <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mb: 0.5 }}>
//                   Answer:
//                 </Typography>
//                 <Typography variant="body2" color="text.primary">
//                   {answer}
//                 </Typography>
//               </Box>
//             )}
//           </Paper>
//         </Grid>
//       );
//     })}
//   </>
// )}
//                 </Grid>
//               </CardContent>
//             </StyledCard>
//           </TabPanel>

//           {/* Tab 2: Add Comment */}
//           <TabPanel value={tabValue} index={1}>
//             <FormScrollContainer ref={formContainerRef}>
//               <StyledCard>
//                 <CardHeader
//                   title="Add New Comment"
//                   titleTypographyProps={{ variant: 'h6', fontWeight: 600 }}
//                   action={
//                     <Box
//                       sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', justifyContent: 'flex-end' }}
//                     >
//                       {/* Answer/No Answer Buttons in Header */}
//                       <Box sx={{ display: 'flex', gap: 0.5 }}>
//                         <Tooltip title="Answer">
//                           <IconButton
//                             size="small"
//                             onClick={() => {
//                               setIsNoAnswer(false);
//                               setFirstComment('');
//                               setSecondComment('');
//                             }}
//                             sx={{
//                               bgcolor: !isNoAnswer ? 'primary.main' : 'transparent', // ✅ سماوي عند التحديد
//                               color: !isNoAnswer ? 'white' : 'primary.main', // ✅ لون النص
//                               border: '1px solid',
//                               borderColor: 'primary.main',
//                               borderRadius: '5px',
//                               '&:hover': {
//                                 bgcolor: !isNoAnswer ? 'primary.dark' : 'primary.light', // ✅ hover effects
//                                 color: 'white',
//                               },
//                             }}
//                           >
//                             <PhoneInTalkIcon fontSize="small" /> Answer
//                           </IconButton>
//                         </Tooltip>

//                         <Tooltip title="No Answer">
//                           <IconButton
//                             size="small"
//                             onClick={() => {
//                               setIsNoAnswer(true);
//                               setFirstComment('اتصلت ومفيش رد');
//                               setSecondComment('هحاول تاني في وقت تاني');
//                             }}
//                             sx={{
//                               bgcolor: isNoAnswer ? 'secondary.main' : 'transparent', // ✅ سماوي للثاني
//                               color: isNoAnswer ? 'white' : 'secondary.main',
//                               border: '1px solid',
//                               borderColor: 'secondary.main',
//                               borderRadius: '5px',
//                               '&:hover': {
//                                 bgcolor: isNoAnswer ? 'secondary.dark' : 'secondary.light',
//                                 color: 'white',
//                               },
//                             }}
//                           >
//                             <CancelIcon fontSize="small" /> No Answer
//                           </IconButton>
//                         </Tooltip>
//                       </Box>
//                     </Box>
//                   }
//                 />
//                 <CardContent>
//                   {/* Enable Action Switch (Top of the form) */}
//                   <Box
//                     sx={{
//                       mb: 3,
//                       display: 'flex',
//                       justifyContent: 'space-between',
//                       alignItems: 'center',
//                     }}
//                   >
//                     <Typography variant="h6" color="primary" fontWeight={600}>
//                       Stage Management
//                     </Typography>
//                     <FormControlLabel
//                       control={
//                         <Switch
//                           checked={addActionEnabled}
//                           onChange={(e) => handleEnableActionToggle(e.target.checked)}
//                           color="primary"
//                           size="medium"
//                         />
//                       }
//                       label={
//                         <Typography variant="body1" fontWeight={500}>
//                           {addActionEnabled ? '✓ Action Enabled' : 'Enable Action to change stage'}
//                         </Typography>
//                       }
//                     />
//                   </Box>

//                   {/* Current Stage Display (Only shows when Action is Enabled) */}
//                   <CurrentStageComponent user={user} addActionEnabled={addActionEnabled} />

//                   {/* Stage Management Sections (Only shows when Action is Enabled) */}
//                   <Collapse in={addActionEnabled} timeout={500}>
//                     <Box>
//                       {/* Change Stage Section */}
//                       <Box mb={3}>
//                         <Paper
//                           elevation={0}
//                           sx={{
//                             p: 2.5,
//                             border: '2px solid',
//                             borderColor: 'primary.light',
//                             borderRadius: 2,
//                             bgcolor: 'primary.lighter',
//                           }}
//                         >
//                           <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
//                             <ChangeCircleIcon color="primary" sx={{ mr: 1.5 }} />
//                             <Typography variant="h6" color="primary" fontWeight={600}>
//                               Change Stage To
//                             </Typography>
//                           </Box>

//                           <Autocomplete
//                             disablePortal
//                             options={allstagesshow}
//                             getOptionLabel={(option) => option.name || ''}
//                             value={selectedStage}
//                             onChange={handleStageChange}
//                             isOptionEqualToValue={(option, value) => option?._id === value?._id}
//                             size="medium"
//                             fullWidth
//                             // إضافة PopperProps لحل مشكلة z-index
//                             PopperProps={{
//                               style: {
//                                 zIndex: 9999,
//                                 position: 'fixed',
//                               },
//                             }}
//                             renderInput={(params) => (
//                               <TextField
//                                 {...params}
//                                 label="Choose New Stage"
//                                 variant="outlined"
//                                 helperText="Select the stage you want to move this lead to"
//                               />
//                             )}
//                           />

//                           {/* Display selected stage */}
//                           {selectedStage && (
//                             <Box
//                               sx={{
//                                 mt: 2,
//                                 p: 1.5,
//                                 bgcolor: 'primary.main',
//                                 borderRadius: 1,
//                                 textAlign: 'center',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 justifyContent: 'center',
//                                 gap: 1,
//                               }}
//                             >
//                               <CheckCircleIcon sx={{ color: 'white' }} />
//                               <Typography variant="body1" fontWeight={600} color="white">
//                                 Selected: {selectedStage.name}
//                               </Typography>
//                             </Box>
//                           )}
//                         </Paper>
//                       </Box>

//                       {/* Date Time Picker (Only shows for specific stages) */}
//                       {/* {showDateTimePicker && (
//   <Box mb={3}>
//     <Paper elevation={0} sx={{ 
//       p: 2.5, 
//       border: '2px solid', 
//       borderColor: 'warning.light', 
//       borderRadius: 2, 
//       bgcolor: 'warning.lighter',
//     }}>
//       <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
//         <ScheduleIcon color="warning" sx={{ mr: 1.5 }} />
//         <Typography variant="h6" color="warning.dark" fontWeight={600}>
//           Schedule Next Action
//         </Typography>
//       </Box>
      
//       <LocalizationProvider dateAdapter={AdapterDayjs}>
//         <DesktopDateTimePicker
//           label="Select Next Action Date & Time"
//           value={valuedate}
//           onChange={handleDateTimeChange}
//           ampm={true}
//           PopperProps={{
//             disablePortal: false,
//             sx: {
//               zIndex: 50001,
//             }
//           }}
//           slotProps={{
//             popper: {
//               sx: {
//                 zIndex: 50001,
//               }
//             },
//             desktopPaper: {
//               sx: {
//                 zIndex: 50001,
//               }
//             }
//           }}
//           renderInput={(params) => (
//             <TextField
//               {...params}
//               fullWidth
//               helperText="Set the date and time for the next follow-up action"
//             />
//           )}
//         />
//       </LocalizationProvider>
//     </Paper>
//   </Box>
// )} */}

//                       {/* Date Time Picker (Only shows for specific stages) */}
//                       {showDateTimePicker && (
//                         <Box mb={3}>
//                           <Paper
//                             elevation={0}
//                             sx={{
//                               p: 2.5,
//                               border: '2px solid',
//                               borderColor: 'warning.light',
//                               borderRadius: 2,
//                               bgcolor: 'warning.lighter',
//                             }}
//                           >
//                             <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
//                               <ScheduleIcon color="warning" sx={{ mr: 1.5 }} />
//                               <Typography variant="h6" color="warning.dark" fontWeight={600}>
//                                 Schedule Next Action
//                               </Typography>
//                             </Box>

//                             {/* ✅ إضافة الـ 3 buttons هنا فوق الـ DateTimePicker */}
//                             <Box sx={{ display: 'flex', gap: 1, mb: 2, flexWrap: 'wrap' }}>
//                               <Button
//                                 variant="outlined"
//                                 size="small"
//                                 startIcon={<AddIcon />}
//                                 onClick={() => {
//                                   const now = dayjs();
//                                   const oneHourLater = now.add(1, 'hour');
//                                   setValueDate(oneHourLater);
//                                   handleDateTimeChange(oneHourLater);
//                                 }}
//                                 sx={{
//                                   borderColor: 'primary.main',
//                                   color: 'primary.main',
//                                   '&:hover': {
//                                     borderColor: 'primary.dark',
//                                     bgcolor: 'primary.light',
//                                   },
//                                 }}
//                               >
//                                 +1 Hour
//                               </Button>

//                               <Button
//                                 variant="outlined"
//                                 size="small"
//                                 startIcon={<AddIcon />}
//                                 onClick={() => {
//                                   const now = dayjs();
//                                   const twoHoursLater = now.add(2, 'hours');
//                                   setValueDate(twoHoursLater);
//                                   handleDateTimeChange(twoHoursLater);
//                                 }}
//                                 sx={{
//                                   borderColor: 'secondary.main',
//                                   color: 'secondary.main',
//                                   '&:hover': {
//                                     borderColor: 'secondary.dark',
//                                     bgcolor: 'secondary.light',
//                                   },
//                                 }}
//                               >
//                                 +2 Hours
//                               </Button>

//                               <Button
//                                 variant="outlined"
//                                 size="small"
//                                 startIcon={<AddIcon />}
//                                 onClick={() => {
//                                   const now = dayjs();
//                                   const twoHoursLater = now.add(3, 'hours');
//                                   setValueDate(twoHoursLater);
//                                   handleDateTimeChange(twoHoursLater);
//                                 }}
//                                 sx={{
//                                   borderColor: 'secondary.main',
//                                   color: 'secondary.main',
//                                   '&:hover': {
//                                     borderColor: 'secondary.dark',
//                                     bgcolor: 'secondary.light',
//                                   },
//                                 }}
//                               >
//                                 +3 Hours
//                               </Button>

//                               <Button
//                                 variant="outlined"
//                                 size="small"
//                                 startIcon={<CalendarTodayIcon />}
//                                 onClick={() => {
//                                   const now = dayjs();
//                                   const tomorrow = now
//                                     .add(1, 'day')
//                                     .hour(11) // الساعة 10 صباحاً
//                                     .minute(0) // الدقيقة 0
//                                     .second(0); // الثانية 0

//                                   setValueDate(tomorrow);
//                                   handleDateTimeChange(tomorrow);
//                                 }}
//                                 sx={{
//                                   borderColor: 'success.main',
//                                   color: 'success.main',
//                                   '&:hover': {
//                                     borderColor: 'success.dark',
//                                     bgcolor: 'success.light',
//                                   },
//                                 }}
//                               >
//                                 Tomorrow 11 AM
//                               </Button>

//                               <Button
//                                 variant="outlined"
//                                 size="small"
//                                 startIcon={<CalendarTodayIcon />}
//                                 onClick={() => {
//                                   const now = dayjs();
//                                   const tomorrow = now
//                                     .add(2, 'day')
//                                     .hour(11) // الساعة 10 صباحاً
//                                     .minute(0) // الدقيقة 0
//                                     .second(0); // الثانية 0

//                                   setValueDate(tomorrow);
//                                   handleDateTimeChange(tomorrow);
//                                 }}
//                                 sx={{
//                                   borderColor: 'success.main',
//                                   color: 'success.main',
//                                   '&:hover': {
//                                     borderColor: 'success.dark',
//                                     bgcolor: 'success.light',
//                                   },
//                                 }}
//                               >
//                                 After Tomorrow 11 AM
//                               </Button>
//                             </Box>

//                             <LocalizationProvider dateAdapter={AdapterDayjs}>
//                               <DesktopDateTimePicker
//                                 label="Select Next Action Date & Time"
//                                 value={valuedate}
//                                 onChange={handleDateTimeChange}
//                                 ampm={true}
//                                 PopperProps={{
//                                   disablePortal: false,
//                                   sx: {
//                                     zIndex: 50001,
//                                   },
//                                 }}
//                                 slotProps={{
//                                   popper: {
//                                     sx: {
//                                       zIndex: 50001,
//                                     },
//                                   },
//                                   desktopPaper: {
//                                     sx: {
//                                       zIndex: 50001,
//                                     },
//                                   },
//                                 }}
//                                 renderInput={(params) => (
//                                   <TextField
//                                     {...params}
//                                     fullWidth
//                                     helperText="Set the date and time for the next follow-up action"
//                                   />
//                                 )}
//                               />
//                             </LocalizationProvider>
//                           </Paper>
//                         </Box>
//                       )}

//                       {/* Stage Specific Fields */}
//                       <StageSpecificForm
//                         selectedStageName={selectedStageName}
//                         eoiAmount={eoiAmount}
//                         reservationAmount={reservationAmount}
//                         onEoiAmountChange={handleEoiAmountChange}
//                         onReservationAmountChange={handleReservationAmountChange}
//                         unitPrice={unitPrice}
//                         unitnumber={unitnumber}
//                         commissionRatio={commissionRatio}
//                         cashbackratio={cashbackratio}
//                         totalCommission={totalCommission}
//                         cashbackMoney={cashbackMoney}
//                         onPriceChange={handlePriceChange}
//                         onUnitNumberChange={handleUnitNumber}
//                         onCommissionRatioChange={handleCommissionRatioChange}
//                         onCashbackRatioChange={handleCashbackRatioChange}
//                       />
//                     </Box>
//                   </Collapse>

//                   {/* Comment Inputs (Always visible) */}
//                   <Box mt={addActionEnabled ? 3 : 0}>
//                     <CommentInputs
//                       firstcomment={firstcomment}
//                       secondcomment={secondcomment}
//                       onFirstCommentChange={onFirstCommentChange}
//                       onSecondCommentChange={onSecondCommentChange}
//                     />
//                   </Box>

//                   {/* Validation Summary */}
//                   {(!firstcomment.trim() || !secondcomment.trim()) && (
//                     <Alert severity="error" sx={{ mt: 2, py: 1, mb: 2 }} icon={<WarningIcon />}>
//                       ⚠️ Please fill in both comment fields before submitting
//                     </Alert>
//                   )}

//                   {selectedStageName === 'Done Deal' &&
//                     (!unitPrice || !unitnumber || !commissionRatio) && (
//                       <Alert severity="warning" sx={{ mt: 2, py: 1, mb: 2 }} icon={<WarningIcon />}>
//                         ⚠️ Please fill all required Done Deal fields (Unit Price, Unit Number,
//                         Commission Ratio)
//                       </Alert>
//                     )}

//                   {/* Submit Button */}
//                   <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
//                     <GradientButton
//                       type="submit"
//                       disabled={sendloading}
//                       startIcon={
//                         sendloading ? null : selectedStageName === 'Done Deal' ? (
//                           <CheckCircleIcon />
//                         ) : (
//                           <SendIcon />
//                         )
//                       }
//                       endIcon={sendloading ? <CircularProgress size={20} color="inherit" /> : null}
//                       size="large"
//                       sx={{
//                         minWidth: 250,
//                         bgcolor:
//                           selectedStageName === 'Done Deal' ? 'success.main' : 'primary.main',
//                         '&:hover': {
//                           bgcolor:
//                             selectedStageName === 'Done Deal' ? 'success.dark' : 'primary.dark',
//                         },
//                       }}
//                       onClick={onsubmitdata}
//                     >
//                       {sendloading
//                         ? 'Adding...'
//                         : selectedStageName === 'Done Deal'
//                           ? '🎉 Complete Deal & Add Comment'
//                           : 'Add New Comment'}
//                     </GradientButton>
//                   </Box>
//                 </CardContent>
//               </StyledCard>
//             </FormScrollContainer>
//           </TabPanel>

//           {/* Tab 3: All Comments - مع نظام الردود الجديد */}
//           <TabPanel value={tabValue} index={2}>
//             <Box ref={commentsContainerRef} sx={{ height: '100%', overflow: 'hidden' }}>
//               <StyledCard sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
//                 <CardHeader
//                   title="All Comments"
//                   subheader={`Total: ${totalCommentsCount} comments`}
//                   titleTypographyProps={{ variant: 'h6', fontWeight: 600 }}
//                   action={
//                     <Box display="flex" gap={1}>
//                       <Tooltip title="Refresh">
//                         <IconButton
//                           size="small"
//                           onClick={() => getallactiondata(1)}
//                           disabled={isCommentsLoading}
//                         >
//                           <RefreshIcon />
//                         </IconButton>
//                       </Tooltip>
//                       <Button
//                         variant="contained"
//                         size="small"
//                         startIcon={<AddIcon />}
//                         onClick={() => setTabValue(1)}
//                       >
//                         Add Comment
//                       </Button>
//                     </Box>
//                   }
//                 />
//                 <CardContent sx={{ flex: 1, overflow: 'hidden' }}>
//                   {isCommentsLoading ? (
//                     <Box display="flex" justifyContent="center" alignItems="center" height="300px">
//                       <CircularProgress />
//                     </Box>
//                   ) : (
//                     <>
//                       {/* Filter Info Alert */}
//                       {filterInfo?.applied === 'filtered_by_date' && (
//                         <Alert severity="info" sx={{ mb: 2 }} icon={<InfoIcon />}>
//                           <Typography variant="body2">
//                             Showing comments after assignment date:{' '}
//                             {moment(filterInfo.assignmentInfo?.assignDateTime).format(
//                               'DD/MM/YYYY hh:mm A',
//                             )}
//                           </Typography>
//                         </Alert>
//                       )}

//                       {/* Comments List */}
//                       {comments && comments.length > 0 ? (
//                         <Box sx={{ height: '100%', overflow: 'auto' }}>
//                           {/* Display Comments Count */}
//                           <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
//                             Showing {comments.length} of {totalCommentsCount} comments (Page{' '}
//                             {currentPage} of {totalPages})
//                           </Typography>

//                           <List disablePadding>
//                             {comments
//                               .sort((a, b) => new Date(b.stageDate) - new Date(a.stageDate))
//                               .map((comment, index) => (
//                                 <React.Fragment key={comment._id || index}>
//                                   <Box sx={{ mb: 3 }}>
//                                     <Card variant="outlined" sx={{ borderRadius: 2 }}>
//                                       <CardContent>
//                                         {/* معلومات الـ Sales */}
//                                         {comment.sales && (
//                                           <Box display="flex" alignItems="center" gap={1} mb={2}>
//                                             <Avatar
//                                               src={comment.sales.profileImg}
//                                               sx={{ width: 32, height: 32 }}
//                                             >
//                                               {comment.sales.name?.charAt(0)}
//                                             </Avatar>
//                                             <Box>
//                                               <Typography variant="subtitle2" fontWeight={600}>
//                                                 {comment.sales.name}
//                                               </Typography>
//                                               <Typography variant="caption" color="textSecondary">
//                                                 {moment(comment.stageDate).format(
//                                                   'DD/MM/YYYY hh:mm A',
//                                                 )}
//                                               </Typography>
//                                             </Box>
//                                           </Box>
//                                         )}

//                                         {/* First Comment */}
//                                         {comment.firstcomment?.text && (
//                                           <Box mb={2}>
//                                             <Typography
//                                               variant="body2"
//                                               color="textSecondary"
//                                               gutterBottom
//                                             >
//                                               First Comment:
//                                             </Typography>
//                                             <Typography
//                                               variant="body1"
//                                               paragraph
//                                               sx={{ whiteSpace: 'pre-wrap' }}
//                                             >
//                                               {comment.firstcomment.text}
//                                             </Typography>
//                                             {comment.firstcomment.date && (
//                                               <Typography variant="caption" color="textSecondary">
//                                                 Posted:{' '}
//                                                 {moment(comment.firstcomment.date).format(
//                                                   'DD/MM/YYYY hh:mm A',
//                                                 )}
//                                               </Typography>
//                                             )}
//                                           </Box>
//                                         )}

//                                         {/* Second Comment */}
//                                         {comment.secondcomment?.text && (
//                                           <Box mb={2}>
//                                             <Typography
//                                               variant="body2"
//                                               color="textSecondary"
//                                               gutterBottom
//                                             >
//                                               Second Comment:
//                                             </Typography>
//                                             <Typography
//                                               variant="body1"
//                                               paragraph
//                                               sx={{ whiteSpace: 'pre-wrap' }}
//                                             >
//                                               {comment.secondcomment.text}
//                                             </Typography>
//                                             {comment.secondcomment.date && (
//                                               <Typography variant="caption" color="textSecondary">
//                                                 Posted:{' '}
//                                                 {moment(comment.secondcomment.date).format(
//                                                   'DD/MM/YYYY hh:mm A',
//                                                 )}
//                                               </Typography>
//                                             )}
//                                           </Box>
//                                         )}

//                                         {/* الـ Stage */}
//                                         {comment.stage && (
//                                           <Box display="flex" alignItems="center" gap={1} mb={2}>
//                                             <StageChip
//                                               label={comment.stage.name}
//                                               size="small"
//                                               stagecolor={getStageColor(comment.stage.name)}
//                                             />
//                                           </Box>
//                                         )}

//                                         {/* نظام الردود الجديد */}
//                                         <CommentReplies
//                                           comment={comment}
//                                           currentUserId={userloginrealy.current?.data?._id}
//                                           onReplyAdded={refreshComments}
//                                           theme={theme}
//                                         />
//                                       </CardContent>
//                                     </Card>
//                                   </Box>

//                                   {index < comments.length - 1 && <Divider sx={{ my: 2 }} />}
//                                 </React.Fragment>
//                               ))}
//                           </List>

//                           {/* Pagination Controls */}
//                           {totalPages > 1 && (
//                             <Box
//                               display="flex"
//                               justifyContent="center"
//                               alignItems="center"
//                               gap={2}
//                               mt={3}
//                               py={2}
//                             >
//                               <Button
//                                 variant="outlined"
//                                 size="small"
//                                 disabled={!hasPrev || isCommentsLoading}
//                                 onClick={() => getallactiondata(currentPage - 1)}
//                                 startIcon={<KeyboardArrowUpIcon />}
//                               >
//                                 Previous
//                               </Button>

//                               <Typography variant="body2" color="textSecondary">
//                                 Page {currentPage} of {totalPages}
//                               </Typography>

//                               <Button
//                                 variant="outlined"
//                                 size="small"
//                                 disabled={!hasNext || isCommentsLoading}
//                                 onClick={() => getallactiondata(currentPage + 1)}
//                                 endIcon={<KeyboardArrowDownIcon />}
//                               >
//                                 Next
//                               </Button>
//                             </Box>
//                           )}

//                           {/* إذا كان totalPages = 1 أو ليس هناك صفحات أخرى */}
//                           {totalPages <= 1 && (
//                             <Box textAlign="center" py={2}>
//                               <Typography variant="body2" color="textSecondary">
//                                 {totalCommentsCount <= 20
//                                   ? 'All comments shown'
//                                   : `Showing all ${totalCommentsCount} comments in one page`}
//                               </Typography>
//                             </Box>
//                           )}
//                         </Box>
//                       ) : (
//                         <Box textAlign="center" py={8}>
//                           <CommentIcon sx={{ fontSize: 80, color: 'text.disabled', mb: 2 }} />
//                           <Typography variant="h5" color="textSecondary" gutterBottom>
//                             No Comments Available
//                           </Typography>
//                           <Typography variant="body1" color="textSecondary" paragraph>
//                             {filterInfo?.applied === 'filtered_by_date'
//                               ? 'Only comments after assignment date are shown'
//                               : 'Start the conversation by adding the first comment'}
//                           </Typography>
//                           <Button
//                             variant="contained"
//                             startIcon={<AddIcon />}
//                             onClick={() => setTabValue(1)}
//                             sx={{ mt: 2 }}
//                           >
//                             Add First Comment
//                           </Button>
//                         </Box>
//                       )}
//                     </>
//                   )}
//                 </CardContent>
//               </StyledCard>
//             </Box>
//           </TabPanel>
//         </Container>
//       </DialogContent>

//       {/* Lead Preview Dialog */}
//       <Dialog
//         open={openLeadPreview}
//         onClose={() => setOpenLeadPreview(false)}
//         maxWidth="sm"
//         fullWidth
//         sx={{
//           zIndex: (theme) => theme.zIndex.modal + 50000, // أعلى من الديالوج الرئيسي
//         }}
//       >
//         <DialogTitle>
//           <Typography variant="h6" fontWeight={600}>
//             Lead Preview
//           </Typography>
//         </DialogTitle>
//         <DialogContent dividers>
//           <Grid container spacing={2}>
//             <Grid item xs={12}>
//               <Typography variant="h6" gutterBottom>
//                 {user?.name}
//               </Typography>
//             </Grid>
//             <Grid item xs={6}>
//               <Typography variant="body2" color="textSecondary">
//                 Phone
//               </Typography>
//               <Typography variant="body1">{user?.phone}</Typography>
//             </Grid>
//             <Grid item xs={6}>
//               <Typography variant="body2" color="textSecondary">
//                 Email
//               </Typography>
//               <Typography variant="body1">{user?.email || 'N/A'}</Typography>
//             </Grid>
//             <Grid item xs={6}>
//               <Typography variant="body2" color="textSecondary">
//                 Stage
//               </Typography>
//               <Typography variant="body1">{user?.stage?.name}</Typography>
//             </Grid>
//             <Grid item xs={6}>
//               <Typography variant="body2" color="textSecondary">
//                 Project
//               </Typography>
//               <Typography variant="body1">{user?.project?.name}</Typography>
//             </Grid>

//             {/* <Grid item xs={6}>
//               <Typography variant="body2" color="textSecondary">Stage</Typography>
//               <Typography variant="body1">{user?.stage?.name}</Typography>
//             </Grid> */}

//             {/* Done Deal Data For Admin Only */}

//             {userlogin?.data?.role === 'Admin' &&
//             (user?.stage?.name === 'Done Deal' || user?.stage?.name === 'EOI') ? (
//               <>
//                 <Grid item xs={6}>
//                   <Typography variant="body2" color="textSecondary">
//                     Unit Number
//                   </Typography>
//                   <Typography variant="body1">{user?.unitnumber}</Typography>
//                 </Grid>

//                 <Grid item xs={6}>
//                   <Typography variant="body2" color="textSecondary">
//                     Unit Price
//                   </Typography>
//                   <Typography variant="body1">{user?.unit_price}</Typography>
//                 </Grid>

//                 <Grid item xs={6}>
//                   <Typography variant="body2" color="textSecondary">
//                     Commission Ratio %
//                   </Typography>
//                   <Typography variant="body1">{user?.commissionratio}</Typography>
//                 </Grid>

//                 <Grid item xs={6}>
//                   <Typography variant="body2" color="textSecondary">
//                     Commission Money $
//                   </Typography>
//                   <Typography variant="body1">{user?.commissionmoney}</Typography>
//                 </Grid>

//                 <Grid item xs={6}>
//                   <Typography variant="body2" color="textSecondary">
//                     Cashback Ratio %
//                   </Typography>
//                   <Typography variant="body1">{user?.cashbackratio}</Typography>
//                 </Grid>

//                 <Grid item xs={6}>
//                   <Typography variant="body2" color="textSecondary">
//                     Cashback Money ${' '}
//                   </Typography>
//                   <Typography variant="body1">{user?.cashbackmoney}</Typography>
//                 </Grid>
//               </>
//             ) : null}
//           </Grid>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenLeadPreview(false)} variant="contained">
//             Close
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Dialog>
//   );
// };

























// 20-5-2026
// import React, { useEffect, useMemo, useState, useCallback, useRef } from 'react';
// import { DesktopDateTimePicker } from '@mui/x-date-pickers/DesktopDateTimePicker';
// import { CalendarToday as CalendarTodayIcon } from '@mui/icons-material';
// import OpenInNewIcon from '@mui/icons-material/OpenInNew';
// import LinkIcon from '@mui/icons-material/Link';
// import {
//   Box, Container, Typography, Card, CardContent, CardHeader, Avatar,
//   IconButton, Button, Dialog, DialogTitle, DialogContent, DialogActions,
//   List, Divider, TextField, Switch, FormControlLabel, Autocomplete,
//   Tooltip, CircularProgress, Chip, Grid, Slide, AppBar, Toolbar,
//   Tabs, Tab, useTheme, styled, InputAdornment, Alert, Paper, Fade,
//   Collapse, Modal, Backdrop, Popper,
// } from '@mui/material';
// import { LocalizationProvider } from '@mui/x-date-pickers';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
// import {
//   Close as CloseIcon, Person as PersonIcon, Phone as PhoneIcon,
//   WhatsApp as WhatsAppIcon, Email as EmailIcon, Work as WorkIcon,
//   CalendarToday as CalendarIcon, Comment as CommentIcon, AddComment as AddCommentIcon,
//   Info as InfoIcon, Add as AddIcon, Refresh as RefreshIcon, Visibility as VisibilityIcon,
//   Edit as EditIcon, Send as SendIcon, CheckCircle as CheckCircleIcon, Warning as WarningIcon,
//   PhoneInTalk as PhoneInTalkIcon, AttachMoney as AttachMoneyIcon, Cancel as CancelIcon,
//   Done as DoneIcon, ChangeCircle as ChangeCircleIcon, Schedule as ScheduleIcon,
//   KeyboardArrowDown as KeyboardArrowDownIcon, KeyboardArrowUp as KeyboardArrowUpIcon,
// } from '@mui/icons-material';
// import { Link } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import moment from 'moment';
// import dayjs from 'dayjs';
// import JSConfetti from 'js-confetti';

// import {
//   GetAllcomments_Data_With_Pagination_action_advanced,
//   InsertNewAction_action,
//   Insert_Comment_Replay_Action,
// } from '../Redux/Actions/Action_action';
// import { UpdateStageToLeed } from '../Redux/Actions/UsersAction';
// import { Get_All_Lead_Assigned_Data_Action } from '../Redux/Actions/Lead_Assigned_Action';
// import { GetAll_stage_Data, GetOne_stagetogettype_Data } from '../Redux/Actions/Stage_Action';
// import { Insert_Lead_Stages_Data_Action } from '../Redux/Actions/Lead_Stages_Changed_Action';
// import { Notify } from '../Utility/Notify';

// /* ═══════════════════════════════════════════════════════════════
//    DESIGN TOKENS  — Midnight Obsidian × Champagne Gold
// ═══════════════════════════════════════════════════════════════ */
// const T = {
//   bg0:   '#eeeef4',
//   bg1:   '#fdfdfe',
//   bg2:   '#eef0f7',
//   bg3:   '#f2f3f8',
//   bg4:   '#eeeef0',
//   gold:  '#0D47A1',
//   goldL: '#0D47A1',
//   goldD: '#9A7030',
//   goldSoft: 'rgba(201,168,76,0.10)',
//   goldGlow: 'rgba(201,168,76,0.25)',
//   txtPri: '#333',
//   txtSec: '#333',
//   txtMut: '#333',
//   success: '#34D399',
//   warning: '#0D47A1',
//   danger:  '#F87171',
//   info:    '#60A5FA',
//   bdr:  'rgba(201,168,76,0.15)',
//   bdr2: 'rgba(255,255,255,0.06)',
// };

// /* ── CSS لحل مشكلة Date Picker تظهر قدام الـ Dialog ── */
// const globalCSS = `
//   @import url('https://fonts.googleapis.com/css2?family=sans+serif:wght;600;700&family=DM+Sans:wght@300;400;500;600&display=swap');
  
//   /* حل مشكلة Date Picker يظهر ورا الـ Dialog */
//   .MuiDialog-root {
//     z-index: 50000 !important;
//   }
  
//   .MuiPickersPopper-root,
//   .MuiPopper-root {
//     z-index: 50010 !important;
//     position: fixed !important;
//   }
  
//   .MuiPickersPopper-root .MuiPaper-root {
//     z-index: 50011 !important;
//     position: relative !important;
//   }
  
//   .MuiDialog-container .MuiPickersPopper-root {
//     z-index: 50010 !important;
//   }
  
//   .modal-picker {
//     z-index: 50012 !important;
//   }
  
//   ::-webkit-scrollbar { width: 4px; height: 4px; }
//   ::-webkit-scrollbar-track  { background: transparent; }
//   ::-webkit-scrollbar-thumb  { background: ${T.bg4}; border-radius: 4px; }
//   ::-webkit-scrollbar-thumb:hover { background: ${T.goldD}; }
// `;

// /* ── Stage color map ── */
// const stageColor = (name) => {
//   const map = {
//     'done deal':   T.success,
//     'hot':         T.danger,
//     'warm':        T.warning,
//     'cold':        T.info,
//     'eoi':         '#FB923C',
//     'reservation': '#818CF8',
//     'no answer':   T.txtMut,
//     'follow up':   T.gold,
//     'follow':      T.gold,
//     'meeting':     '#A78BFA',
//     'transfer':    '#F472B6',
//     'pending':     '#94A3B8',
//     'fresh':       T.success,
//     'interested':  '#4ADE80',
//   };
//   return map[(name || '').toLowerCase()] || T.goldD;
// };

// /* ═══════════════════════════════════════════════════════════════
//    STYLED PRIMITIVES
// ═══════════════════════════════════════════════════════════════ */
// const GlassCard = styled(Box)(({ bordered }) => ({
//   background: `linear-gradient(135deg, ${T.bg2} 0%, ${T.bg3} 100%)`,
//   border: `1px solid ${bordered ? T.bdr : T.bdr2}`,
//   borderRadius: 16,
//   backdropFilter: 'blur(12px)',
//   position: 'relative',
//   overflow: 'hidden',
//   '&::before': bordered ? {
//     content: '""',
//     position: 'absolute',
//     inset: 0,
//     borderRadius: 16,
//     padding: 1,
//     background: `linear-gradient(135deg, ${T.gold}40, transparent 60%)`,
//     WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
//     WebkitMaskComposite: 'xor',
//     maskComposite: 'exclude',
//     pointerEvents: 'none',
//   } : {},
// }));

// const GoldButton = styled(Button)(() => ({
//   background: `linear-gradient(135deg, ${T.gold} 0%, ${T.goldL} 50%, ${T.gold} 100%)`,
//   backgroundSize: '200% 100%',
//   color: T.bg0,
//   fontFamily: "'DM Sans', sans-serif",
//   fontWeight: 700,
//   fontSize: 13,
//   borderRadius: 10,
//   padding: '11px 28px',
//   textTransform: 'none',
//   letterSpacing: '0.04em',
//   border: 'none',
//   transition: 'all 0.3s ease',
//   boxShadow: `0 4px 20px ${T.goldGlow}`,
//   '&:hover': {
//     backgroundPosition: '100% 0',
//     boxShadow: `0 6px 30px ${T.goldGlow}`,
//     transform: 'translateY(-1px)',
//   },
//   '&:disabled': {
//     background: T.bg4,
//     color: T.txtMut,
//     boxShadow: 'none',
//   },
// }));

// const OutlineBtn = styled(Button)(({ active, danger }) => ({
//   fontFamily: "'DM Sans', sans-serif",
//   fontWeight: 600,
//   fontSize: 12,
//   borderRadius: 8,
//   padding: '7px 16px',
//   textTransform: 'none',
//   border: `1px solid ${danger ? T.danger : active ? T.gold : T.bdr}`,
//   color: danger ? T.danger : active ? T.gold : T.txtSec,
//   background: danger ? 'rgba(248,113,113,0.08)' : active ? T.goldSoft : 'transparent',
//   transition: 'all 0.2s',
//   '&:hover': {
//     border: `1px solid ${danger ? T.danger : T.gold}`,
//     background: danger ? 'rgba(248,113,113,0.15)' : T.goldSoft,
//     color: danger ? T.danger : T.gold,
//   },
// }));

// const DarkTextField = styled(TextField)(() => ({
//   '& .MuiOutlinedInput-root': {
//     background: T.bg1,
//     borderRadius: 10,
//     fontFamily: "'DM Sans', sans-serif",
//     fontSize: 14,
//     color: T.txtPri,
//     '& fieldset': { borderColor: T.bdr2 },
//     '&:hover fieldset': { borderColor: T.bdr },
//     '&.Mui-focused fieldset': { borderColor: T.gold, borderWidth: 1 },
//     '& input, & textarea': { fontSize: '16px !important' },
//   },
//   '& .MuiInputLabel-root': { color: T.txtMut, fontFamily: "'DM Sans', sans-serif", fontSize: 13 },
//   '& .MuiInputLabel-root.Mui-focused': { color: T.gold },
//   '& .MuiFormHelperText-root': { color: T.txtMut, fontSize: 11 },
// }));

// const StagePill = ({ name, size = 'small' }) => (
//   <Box sx={{
//     display: 'inline-flex', alignItems: 'center', gap: 0.5,
//     px: size === 'small' ? '8px' : '12px',
//     py: size === 'small' ? '3px' : '5px',
//     borderRadius: 20,
//     background: `${stageColor(name)}20`,
//     border: `1px solid ${stageColor(name)}50`,
//     fontSize: size === 'small' ? 10 : 12,
//     fontWeight: 700,
//     color: stageColor(name),
//     fontFamily: "'DM Sans', sans-serif",
//     letterSpacing: '0.05em',
//     textTransform: 'uppercase',
//   }}>
//     <Box sx={{ width: 5, height: 5, borderRadius: '50%', bgcolor: stageColor(name), flexShrink: 0 }} />
//     {name}
//   </Box>
// );

// const InfoRow = ({ icon: Icon, label, value, accent }) => (
//   <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5, py: 1, borderBottom: `1px solid ${T.bdr2}` }}>
//     <Box sx={{ width: 30, height: 30, borderRadius: 8, bgcolor: T.bg1, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, mt: '2px' }}>
//       <Icon sx={{ fontSize: 14, color: T.gold }} />
//     </Box>
//     <Box>
//       <Typography sx={{ fontSize: 11, color: T.txtMut, fontFamily: "'DM Sans', sans-serif", mb: '2px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>{label}</Typography>
//       <Typography sx={{ fontSize: 14, color: accent || T.txtPri, fontFamily: "'DM Sans', sans-serif", fontWeight: 500, lineHeight: 1.4 }}>{value || '—'}</Typography>
//     </Box>
//   </Box>
// );

// const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

// /* ═══════════════════════════════════════════════════════════════
//    TAB PANEL
// ═══════════════════════════════════════════════════════════════ */
// const TabPanel = ({ children, value, index }) => (
//   <Box role="tabpanel" hidden={value !== index} sx={{ flex: 1, overflowY: 'auto', height: '100%' }}>
//     {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
//   </Box>
// );

// /* ═══════════════════════════════════════════════════════════════
//    COMMENT REPLIES
// ═══════════════════════════════════════════════════════════════ */
// const CommentReplies = React.memo(({ comment, currentUserId, onReplyAdded }) => {
//   const [showInput, setShowInput] = useState(false);
//   const [replyText, setReplyText]   = useState('');
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [loadingreplay, setloadingreplay] = useState(true);
//   const dispatch   = useDispatch();
//   const userLogin  = JSON.parse(localStorage.getItem('user'))?.data || {};
//   const resaddreplay = useSelector(s => s.AllActions.insrertrepaly);

//   const handleSubmitReply = async () => {
//     if (!replyText.trim() || !comment?._id || !userLogin?._id) return;
//     setIsSubmitting(true);
//     try {
//       setloadingreplay(true);
//       await dispatch(Insert_Comment_Replay_Action({ commentId: comment._id, replyText: replyText.trim(), userId: userLogin._id }));
//       setloadingreplay(false);
//     } catch { Notify('error', 'Error adding reply', 'error'); }
//     finally { setIsSubmitting(false); setloadingreplay(false); }
//   };

//   useEffect(() => {
//     if (loadingreplay === false) {
//       if (resaddreplay?.status === 200 || resaddreplay?.success) {
//         Notify('success', 'Reply added', 'success');
//         setReplyText(''); setShowInput(false); onReplyAdded();
//       } else { Notify('error', 'Failed to add reply', 'error'); }
//     }
//   }, [loadingreplay]);

//   const canReply = ['Sales','Team Leader','Admin'].includes(userLogin?.role);
//   if (!canReply && !comment?.replies?.length) return null;

//   return (
//     <Box sx={{ mt: 2, pl: 2, borderLeft: `2px solid ${T.bdr}` }}>
//       {comment?.replies?.length > 0 && (
//         <Box sx={{ mb: 2 }}>
//           <Typography sx={{ fontSize: 11, color: T.gold, fontFamily: "'DM Sans', sans-serif", fontWeight: 600, mb: 1, textTransform: 'uppercase', letterSpacing: '0.06em' }}>
//             {comment.replies.length} {comment.replies.length === 1 ? 'Reply' : 'Replies'}
//           </Typography>
//           {comment.replies.map((reply, i) => (
//             <Box key={reply._id || i} sx={{ display: 'flex', gap: 1.5, mb: 1.5, p: 1.5, borderRadius: 10, bgcolor: T.bg4 }}>
//               <Avatar src={reply.user?.profileImg} sx={{ width: 26, height: 26, fontSize: 11, bgcolor: T.bg3, border: `1px solid ${T.bdr}` }}>
//                 {reply.user?.name?.charAt(0)}
//               </Avatar>
//               <Box>
//                 <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', mb: 0.5 }}>
//                   <Typography sx={{ fontSize: 12, fontWeight: 600, color: T.txtPri, fontFamily: "'DM Sans', sans-serif" }}>{reply.user?.name}</Typography>
//                   <Typography sx={{ fontSize: 10, color: T.txtMut, fontFamily: "'DM Sans', sans-serif" }}>{moment(reply.date).format('DD/MM/YY hh:mm A')}</Typography>
//                 </Box>
//                 <Typography sx={{ fontSize: 13, color: T.txtSec, fontFamily: "'DM Sans', sans-serif" }}>{reply.text}</Typography>
//               </Box>
//             </Box>
//           ))}
//         </Box>
//       )}
//       {canReply && (
//         <Box>
//           {showInput ? (
//             <Box>
//               <DarkTextField fullWidth multiline rows={2} value={replyText} onChange={e => setReplyText(e.target.value)} placeholder="Write your reply..." size="small" disabled={isSubmitting} autoFocus sx={{ mb: 1 }} />
//               <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
//                 <OutlineBtn size="small" onClick={() => { setShowInput(false); setReplyText(''); }} disabled={isSubmitting}>Cancel</OutlineBtn>
//                 <GoldButton size="small" onClick={handleSubmitReply} disabled={!replyText.trim() || isSubmitting} startIcon={isSubmitting ? <CircularProgress size={13} color="inherit" /> : <SendIcon sx={{ fontSize: 14 }} />} sx={{ py: '7px', px: '16px', fontSize: 12 }}>
//                   {isSubmitting ? 'Sending…' : 'Reply'}
//                 </GoldButton>
//               </Box>
//             </Box>
//           ) : (
//             <OutlineBtn size="small" startIcon={<AddCommentIcon sx={{ fontSize: 14 }} />} onClick={() => setShowInput(true)} sx={{ width: '100%', justifyContent: 'flex-start' }}>
//               Add a reply…
//             </OutlineBtn>
//           )}
//         </Box>
//       )}
//     </Box>
//   );
// });

// /* ═══════════════════════════════════════════════════════════════
//    RESERVATION FORM
// ═══════════════════════════════════════════════════════════════ */

// // Form خاص بـ Reservation
// const ReservationForm = React.memo(({ reservationAmount, onReservationAmountChange }) => (
//   <GlassCard sx={{ p: 2.5, mb: 2 }}>
//     <Typography sx={{ fontSize: 11, color: T.info, fontFamily: "'DM Sans', sans-serif", fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em', mb: 2 }}>
//       🔒 Reservation Information
//     </Typography>
//     <DarkTextField
//       fullWidth
//       label="Reservation Amount (AED)"
//       type="text"
//       value={reservationAmount}
//       onChange={onReservationAmountChange}
//       InputProps={{
//         startAdornment: <InputAdornment position="start"><Typography sx={{ color: T.gold, fontSize: 12 }}>AED</Typography></InputAdornment>
//       }}
//       helperText="Enter the reservation deposit amount"
//       inputProps={{ inputMode: 'decimal', style: { fontSize: 16 } }}
//     />
//   </GlassCard>
// ));

// /* ═══════════════════════════════════════════════════════════════
//    STAGE SPECIFIC FORM - (العنوان يتغير حسب الـ stage)
// ═══════════════════════════════════════════════════════════════ */
// const StageSpecificForm = React.memo(({ 
//   selectedStageName, 
//   eoiAmount, 
//   reservationAmount, 
//   onEoiAmountChange, 
//   onReservationAmountChange,
//   unitPrice, 
//   unitnumber, 
//   commissionRatio, 
//   cashbackratio, 
//   totalCommission, 
//   cashbackMoney,
//   onPriceChange, 
//   onUnitNumberChange, 
//   onCommissionRatioChange, 
//   onCashbackRatioChange
// }) => {
//   if (!selectedStageName) return null;

//   // حالة Reservation
//   if (selectedStageName === 'Reservation') {
//     return (
//       <ReservationForm 
//         reservationAmount={reservationAmount} 
//         onReservationAmountChange={onReservationAmountChange} 
//       />
//     );
//   }

//   // حالة EOI - Form خاص مع EOI Amount + بيانات Done Deal
//   if (selectedStageName === 'EOI') {
//     return (
//       <GlassCard sx={{ p: 2.5, mb: 2 }}>
//         <Typography sx={{ fontSize: 11, color: T.warning, fontFamily: "'DM Sans', sans-serif", fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em', mb: 2 }}>
//           📝 EOI Information
//         </Typography>
        
//         {/* حقل EOI Amount منفصل */}
//         <DarkTextField
//           fullWidth
//           label="EOI Amount (AED)"
//           type="text"
//           value={eoiAmount}
//           onChange={onEoiAmountChange}
//           InputProps={{
//             startAdornment: <InputAdornment position="start"><Typography sx={{ color: T.gold, fontSize: 12 }}>AED</Typography></InputAdornment>
//           }}
//           helperText="Enter the Expression of Interest amount"
//           inputProps={{ inputMode: 'decimal', style: { fontSize: 16 } }}
//           sx={{ mb: 3 }}
//         />
        
//         <Typography sx={{ fontSize: 11, color: T.txtMut, fontFamily: "'DM Sans', sans-serif", fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.08em', mb: 2, mt: 1 }}>
//           ⬇️ Deal Information
//         </Typography>
        
//         {/* بيانات Done Deal كاملة */}
//         <Grid container spacing={2}>
//           <Grid item xs={12}>
//             <DarkTextField 
//               fullWidth 
//               label="Unit Price (AED)" 
//               type="text" 
//               value={unitPrice} 
//               onChange={onPriceChange} 
//               InputProps={{ 
//                 startAdornment: <InputAdornment position="start"><Typography sx={{ color: T.gold, fontSize: 12 }}>AED</Typography></InputAdornment> 
//               }} 
//               inputProps={{ inputMode: 'decimal', style: { fontSize: 16 } }} 
//               required
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <DarkTextField 
//               fullWidth 
//               label="Unit Number" 
//               value={unitnumber} 
//               onChange={onUnitNumberChange} 
//               placeholder="e.g., A101, Tower 2" 
//               inputProps={{ style: { fontSize: 16 } }} 
//               required
//             />
//           </Grid>
//           <Grid item xs={6}>
//             <DarkTextField 
//               fullWidth 
//               label="Commission %" 
//               type="text" 
//               value={commissionRatio} 
//               onChange={onCommissionRatioChange} 
//               helperText="Commission percentage" 
//               InputProps={{ 
//                 endAdornment: <InputAdornment position="end"><Typography sx={{ color: T.gold, fontSize: 12 }}>%</Typography></InputAdornment> 
//               }} 
//               inputProps={{ inputMode: 'decimal', style: { fontSize: 16 } }} 
//               required
//             />
//           </Grid>
//           <Grid item xs={6}>
//             <DarkTextField 
//               fullWidth 
//               label="Total Commission (AED)" 
//               value={totalCommission} 
//               disabled 
//               helperText="Auto calculated" 
//               InputProps={{ 
//                 startAdornment: <InputAdornment position="start"><Typography sx={{ color: T.success, fontSize: 12 }}>AED</Typography></InputAdornment> 
//               }} 
//               sx={{ '& .MuiInputBase-input.Mui-disabled': { WebkitTextFillColor: T.success, fontWeight: 600 } }} 
//             />
//           </Grid>
//           <Grid item xs={6}>
//             <DarkTextField 
//               fullWidth 
//               label="Cashback %" 
//               type="text" 
//               value={cashbackratio} 
//               onChange={onCashbackRatioChange} 
//               helperText="0 for no cashback" 
//               InputProps={{ 
//                 endAdornment: <InputAdornment position="end"><Typography sx={{ color: T.info, fontSize: 12 }}>%</Typography></InputAdornment> 
//               }} 
//               inputProps={{ inputMode: 'decimal', style: { fontSize: 16 } }} 
//             />
//           </Grid>
//           <Grid item xs={6}>
//             <DarkTextField 
//               fullWidth 
//               label="Cashback Amount (AED)" 
//               value={cashbackMoney} 
//               disabled 
//               helperText="Auto calculated" 
//               InputProps={{ 
//                 startAdornment: <InputAdornment position="start"><Typography sx={{ color: T.info, fontSize: 12 }}>AED</Typography></InputAdornment> 
//               }} 
//               sx={{ '& .MuiInputBase-input.Mui-disabled': { WebkitTextFillColor: T.info } }} 
//             />
//           </Grid>
//         </Grid>
//       </GlassCard>
//     );
//   }

//   // حالة Done Deal - فقط بيانات Done Deal بدون EOI Amount
//   if (selectedStageName === 'Done Deal') {
//     return (
//       <GlassCard sx={{ p: 2.5, mb: 2 }}>
//         <Typography sx={{ fontSize: 11, color: T.success, fontFamily: "'DM Sans', sans-serif", fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em', mb: 2 }}>
//           🎉 Done Deal Information
//         </Typography>
//         <Grid container spacing={2}>
//           <Grid item xs={12}>
//             <DarkTextField 
//               fullWidth 
//               label="Unit Price (AED)" 
//               type="text" 
//               value={unitPrice} 
//               onChange={onPriceChange} 
//               InputProps={{ 
//                 startAdornment: <InputAdornment position="start"><Typography sx={{ color: T.gold, fontSize: 12 }}>AED</Typography></InputAdornment> 
//               }} 
//               inputProps={{ inputMode: 'decimal', style: { fontSize: 16 } }} 
//               required
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <DarkTextField 
//               fullWidth 
//               label="Unit Number" 
//               value={unitnumber} 
//               onChange={onUnitNumberChange} 
//               placeholder="e.g., A101, Tower 2" 
//               inputProps={{ style: { fontSize: 16 } }} 
//               required
//             />
//           </Grid>
//           <Grid item xs={6}>
//             <DarkTextField 
//               fullWidth 
//               label="Commission %" 
//               type="text" 
//               value={commissionRatio} 
//               onChange={onCommissionRatioChange} 
//               helperText="Commission percentage" 
//               InputProps={{ 
//                 endAdornment: <InputAdornment position="end"><Typography sx={{ color: T.gold, fontSize: 12 }}>%</Typography></InputAdornment> 
//               }} 
//               inputProps={{ inputMode: 'decimal', style: { fontSize: 16 } }} 
//               required
//             />
//           </Grid>
//           <Grid item xs={6}>
//             <DarkTextField 
//               fullWidth 
//               label="Total Commission (AED)" 
//               value={totalCommission} 
//               disabled 
//               helperText="Auto calculated" 
//               InputProps={{ 
//                 startAdornment: <InputAdornment position="start"><Typography sx={{ color: T.success, fontSize: 12 }}>AED</Typography></InputAdornment> 
//               }} 
//               sx={{ '& .MuiInputBase-input.Mui-disabled': { WebkitTextFillColor: T.success, fontWeight: 600 } }} 
//             />
//           </Grid>
//           <Grid item xs={6}>
//             <DarkTextField 
//               fullWidth 
//               label="Cashback %" 
//               type="text" 
//               value={cashbackratio} 
//               onChange={onCashbackRatioChange} 
//               helperText="0 for no cashback" 
//               InputProps={{ 
//                 endAdornment: <InputAdornment position="end"><Typography sx={{ color: T.info, fontSize: 12 }}>%</Typography></InputAdornment> 
//               }} 
//               inputProps={{ inputMode: 'decimal', style: { fontSize: 16 } }} 
//             />
//           </Grid>
//           <Grid item xs={6}>
//             <DarkTextField 
//               fullWidth 
//               label="Cashback Amount (AED)" 
//               value={cashbackMoney} 
//               disabled 
//               helperText="Auto calculated" 
//               InputProps={{ 
//                 startAdornment: <InputAdornment position="start"><Typography sx={{ color: T.info, fontSize: 12 }}>AED</Typography></InputAdornment> 
//               }} 
//               sx={{ '& .MuiInputBase-input.Mui-disabled': { WebkitTextFillColor: T.info } }} 
//             />
//           </Grid>
//         </Grid>
//       </GlassCard>
//     );
//   }

//   return null;
// });

// /* ═══════════════════════════════════════════════════════════════
//    MAIN COMPONENT
// ═══════════════════════════════════════════════════════════════ */
// export const ShowClientsActionsAdvanced = ({ user, leadid, onClose,onLeadUpdated  }) => {
//   const dispatch = useDispatch();

//   /* inject global CSS once */
//   useEffect(() => {
//     const el = document.createElement('style');
//     el.innerHTML = globalCSS;
//     document.head.appendChild(el);
//     return () => document.head.removeChild(el);
//   }, []);

//   const [open,            setOpen]            = useState(true);
//   const [tabValue,        setTabValue]        = useState(0);
//   const [addActionEnabled,setAddActionEnabled]= useState(false);
//   const [userlogin,       setUserLogin]       = useState('');
//   const userloginrealy = useRef(JSON.parse(localStorage.getItem('user')) || []);

//   /* stage states */
//   const [selectedStage,    setSelectedStage]    = useState(null);
//   const [showDateTime,     setShowDateTime]     = useState(false);
//   const [stageType,        setStageType]        = useState(null);
//   const [selectedStageId,  setSelectedStageId]  = useState(null);
//   const [selectedStageName,setSelectedStageName]= useState(null);
//   const [allstagesshow,    setAllStagesShow]    = useState([]);

//   /* comment states */
//   const [firstcomment,  setFirstComment]  = useState('');
//   const [secondcomment, setSecondComment] = useState('');
//   const [valuedate,     setValueDate]     = useState(dayjs());
//   const [loading,       setLoading]       = useState(true);
//   const [sendloading,   setSendLoading]   = useState(false);

//   /* done deal & eoi & reservation */
//   const [unitPrice,       setUnitPrice]       = useState('');
//   const [unitnumber,      setUnitNumber]      = useState('');
//   const [commissionRatio, setCommissionRatio] = useState('');
//   const [totalCommission, setTotalCommission] = useState('');
//   const [cashbackratio,   setCashbackRatio]   = useState('');
//   const [cashbackMoney,   setCashbackMoney]   = useState('');
//   const [eoiAmount,       setEoiAmount]       = useState('');
//   const [reservationAmount,setReservationAmount]=useState('');
//   const [isNoAnswer,      setIsNoAnswer]      = useState(false);

//   /* comments pagination */
//   const [comments,          setComments]          = useState([]);
//   const [isCommentsLoading, setIsCommentsLoading] = useState(false);
//   const [isReady,           setIsReady]           = useState(false);
//   const [currentPage,       setCurrentPage]       = useState(1);
//   const [totalPages,        setTotalPages]        = useState(1);
//   const [totalCommentsCount,setTotalCommentsCount]= useState(0);
//   const [hasNext,           setHasNext]           = useState(false);
//   const [hasPrev,           setHasPrev]           = useState(false);
//   const [filterInfo,        setFilterInfo]        = useState(null);
//   const [openLeadPreview,   setOpenLeadPreview]   = useState(false);

//   const stagesWithDateTime = useMemo(() =>
//     ['No Answer','Answer','Meeting','Follow','Follow After Meeting','Follow Up','Transfer','Interested'], []);

//   const resaddcomment   = useSelector(s => s.AllActions.AddAction);
//   const All_stages      = useSelector(s => s.Allstages.stage);
//   const resgetonestagetype = useSelector(s => s.Allstages.getstagetogetype);

//   useEffect(() => { if (JSON.parse(localStorage.getItem('user'))) setUserLogin(JSON.parse(localStorage.getItem('user'))); }, []);

//   /* ── fetch comments ── */
//   const getallactiondata = useCallback(async (page = 1) => {
//     try {
//       setIsCommentsLoading(true);
//       const userId = userloginrealy.current?.data?._id;
//       const leadId = leadid || user?._id;
//       if (!leadId || !userId) return;
//       const response = await dispatch(GetAllcomments_Data_With_Pagination_action_advanced({ leadId: user?._id, userId, page, limit: 20 }));
//       if (response?.success && response?.comments) {
//         setComments(response.comments);
//         if (response.pagination) {
//           setCurrentPage(response.pagination.page || page);
//           setTotalPages(response.pagination.totalPages || 1);
//           setHasNext(response.pagination.hasNext || false);
//           setHasPrev(response.pagination.hasPrev || false);
//         }
//         setTotalCommentsCount(response.totalComments || response.comments.length || 0);
//         if (response.filterApplied) setFilterInfo({ applied: response.filterApplied, assignmentInfo: response.assignmentInfo });
//       }
//     } catch { Notify('error', 'Failed to load comments', 'error'); }
//     finally { setIsCommentsLoading(false); }
//   }, [dispatch, leadid, user?._id]);

//   const refreshComments = useCallback(() => getallactiondata(currentPage), [getallactiondata, currentPage]);

//   /* ── fetch stages ── */
//   const getallstages = useCallback(async () => {
//     try { await dispatch(GetAll_stage_Data()); } catch {}
//   }, [dispatch]);

//   useEffect(() => {
//     let t;
//     if (open) { setIsReady(false); t = setTimeout(async () => { await getallstages(); setIsReady(true); }, 500); }
//     return () => clearTimeout(t);
//   }, [open, getallstages]);

//   /* إزالة الـ Stage اللي اسمها "Fresh" من القائمة */
//   useEffect(() => {
//     if (All_stages?.data) {
//       const filtered = All_stages.data.filter(stage => stage.name !== 'Fresh');
//       const sorted = [...filtered].sort((a, b) => a.name === 'No Stage' ? -1 : b.name === 'No Stage' ? 1 : a.name.localeCompare(b.name));
//       setAllStagesShow(sorted);
//     }
//   }, [All_stages]);

//   useEffect(() => { if (resgetonestagetype?.data) setStageType(resgetonestagetype.data); else setStageType(null); }, [resgetonestagetype]);

//   const generateAutoComments = useCallback((stageName) => {
//     const map = { 'No Answer': { firstComment: 'اتصلت ومفيش رد', secondComment: 'هحاول تاني في وقت تاني' } };
//     return map[stageName] || { firstComment: '', secondComment: '' };
//   }, []);

//   // const handleStageChange = useCallback((e, newValue) => {
//   //   if (newValue) {
//   //     setSelectedStage(newValue);
//   //     setSelectedStageId(newValue._id);
//   //     setSelectedStageName(newValue.name);
//   //     setShowDateTime(stagesWithDateTime.includes(newValue.name) || newValue.name === 'Answer' || newValue.name === 'No Answer');
//   //     if (!stagesWithDateTime.includes(newValue.name)) setValueDate(null);
//   //     dispatch(GetOne_stagetogettype_Data(newValue._id)).then(r => { if (r?.data) setStageType(r.data); }).catch(() => {});
//   //     const ac = generateAutoComments(newValue.name);
//   //     setFirstComment(ac.firstComment);
//   //     setSecondComment(ac.secondComment);
//   //     setIsNoAnswer(newValue.name === 'No Answer');
//   //   } else { setSelectedStage(null); setSelectedStageId(null); setSelectedStageName(null); setStageType(null); setShowDateTime(false); }
//   // }, [dispatch, generateAutoComments, stagesWithDateTime]);
// const handleStageChange = useCallback((e, newValue) => {
//   if (newValue) {
//     setSelectedStage(newValue);
//     setSelectedStageId(newValue._id);
//     setSelectedStageName(newValue.name);
//     setShowDateTime(stagesWithDateTime.includes(newValue.name) || newValue.name === 'Answer' || newValue.name === 'No Answer');
//     if (!stagesWithDateTime.includes(newValue.name)) setValueDate(null);
//     dispatch(GetOne_stagetogettype_Data(newValue._id)).then(r => { if (r?.data) setStageType(r.data); }).catch(() => {});
    
//     // ✅ بس لو الحقول فاضية، اعمل auto fill
//     // لو فيه حاجة مكتوبة متمسحش
//     if (!firstcomment.trim() && !secondcomment.trim()) {
//       const ac = generateAutoComments(newValue.name);
//       setFirstComment(ac.firstComment);
//       setSecondComment(ac.secondComment);
//     }
    
//     setIsNoAnswer(newValue.name === 'No Answer');
//   } else { 
//     setSelectedStage(null); 
//     setSelectedStageId(null); 
//     setSelectedStageName(null); 
//     setStageType(null); 
//     setShowDateTime(false); 
//   }
// }, [dispatch, generateAutoComments, stagesWithDateTime, firstcomment, secondcomment]);


//   const resetStageForm = useCallback(() => {
//     setUnitPrice(''); setUnitNumber(''); setCommissionRatio(''); setCashbackRatio('');
//     setEoiAmount(''); setReservationAmount(''); setStageType(null); setSelectedStage(null);
//     setShowDateTime(false); setValueDate(null); setIsNoAnswer(false);
//   }, []);

//   // const handleEnableActionToggle = useCallback((checked) => {
//   //   setAddActionEnabled(checked);
//   //   if (checked && user?.stage) {
//   //     setSelectedStage(user.stage); setSelectedStageId(user.stage._id); setSelectedStageName(user.stage.name);
//   //     setShowDateTime(stagesWithDateTime.includes(user.stage.name));
//   //     if (!stagesWithDateTime.includes(user.stage.name)) setValueDate(null);
//   //     dispatch(GetOne_stagetogettype_Data(user.stage._id)).then(r => { if (r?.data) setStageType(r.data); }).catch(() => {});
//   //     const ac = generateAutoComments(user.stage.name);
//   //     setFirstComment(ac.firstComment); setSecondComment(ac.secondComment);
//   //     setIsNoAnswer(user.stage.name === 'No Answer');
//   //   } else resetStageForm();
//   // }, [user?.stage, dispatch, generateAutoComments, stagesWithDateTime, resetStageForm]);
// const handleEnableActionToggle = useCallback((checked) => {
//   setAddActionEnabled(checked);
//   if (checked && user?.stage) {
//     setSelectedStage(user.stage); 
//     setSelectedStageId(user.stage._id); 
//     setSelectedStageName(user.stage.name);
//     setShowDateTime(stagesWithDateTime.includes(user.stage.name));
//     if (!stagesWithDateTime.includes(user.stage.name)) setValueDate(null);
//     dispatch(GetOne_stagetogettype_Data(user.stage._id)).then(r => { if (r?.data) setStageType(r.data); }).catch(() => {});
    
//     // ✅ بس لو الحقول فاضية، اعمل auto fill
//     if (!firstcomment.trim() && !secondcomment.trim()) {
//       const ac = generateAutoComments(user.stage.name);
//       setFirstComment(ac.firstComment); 
//       setSecondComment(ac.secondComment);
//     }
    
//     setIsNoAnswer(user.stage.name === 'No Answer');
//   } else resetStageForm();
// }, [user?.stage, dispatch, generateAutoComments, stagesWithDateTime, resetStageForm, firstcomment, secondcomment]);
//   /* ── price handlers ── */
//   const handlePriceChange = useCallback(e => { const v = e.target.value.replace(/[^0-9.]/g,''); setUnitPrice(v); }, []);
//   const handleUnitNumber  = useCallback(e => setUnitNumber(e.target.value), []);
//   const handleCommissionRatioChange = useCallback(e => { const v = e.target.value.replace(/[^0-9.]/g,''); setCommissionRatio(v); }, []);
//   const handleCashbackRatioChange   = useCallback(e => { const v = e.target.value.replace(/[^0-9.]/g,''); setCashbackRatio(v); }, []);
//   const handleReservationAmountChange = useCallback(e => { const v = e.target.value.replace(/[^0-9.]/g,''); setReservationAmount(v); }, []);
//   const handleEoiAmountChange = useCallback(e => { const v = e.target.value.replace(/[^0-9.]/g,''); setEoiAmount(v); }, []);

//   const handleDateTimeChange = useCallback((newValue) => {
//     if (newValue) {
//       setValueDate(newValue);
//       const fmt = moment(newValue.toDate()).format('MMMM Do YYYY, h:mm A');
//       const base = secondcomment.replace(/ - Follow up on .*$/, '').replace(/ - Scheduled for .*$/, '');
//       setSecondComment(base ? `${base} - Follow up on ${fmt}` : `Follow up on ${fmt}`);
//     }
//   }, [secondcomment]);

//   /* ── calc commission ── */
//   useEffect(() => {
//     const p = parseFloat(unitPrice), r = parseFloat(commissionRatio);
//     if (!isNaN(p) && !isNaN(r) && p > 0 && r > 0) setTotalCommission(((p * r) / 100).toFixed(2));
//     else setTotalCommission('');
//   }, [unitPrice, commissionRatio]);

//   useEffect(() => {
//     const r = parseFloat(cashbackratio), c = parseFloat(totalCommission);
//     if (!isNaN(r)) { if (r === 0) setCashbackMoney('0'); else if (!isNaN(c) && c > 0) setCashbackMoney(((c * r) / 100).toFixed(2)); else setCashbackMoney(''); }
//     else setCashbackMoney('');
//   }, [cashbackratio, totalCommission]);

//   const DoneDealFun = useCallback(() => {
//     const j = new JSConfetti();
//     j.addConfetti({ confettiColors: ['#C9A84C','#E8C97A','#34D399','#60A5FA','#F87171'] });
//   }, []);

//   /* ── submit ── */
//   const onsubmitdata = async (e) => {
//     e.preventDefault();
//     if (!firstcomment.trim()) return Notify('error', 'Please enter first comment', 'error');
//     if (!secondcomment.trim()) return Notify('error', 'Please enter second comment', 'error');
//     if (showDateTime && !valuedate) return Notify('error', 'Please select date & time', 'error');
//     if (!showDateTime && !valuedate) setValueDate(dayjs());
//     if (addActionEnabled && selectedStageId) {
//       if (selectedStageName === 'Reservation' && !reservationAmount) return Notify('error', 'Please enter Reservation amount', 'error');
//       if (selectedStageName === 'EOI') {
//         if (!eoiAmount || parseFloat(eoiAmount) <= 0) return Notify('error', 'Please enter a valid EOI amount', 'error');
//         if (!unitPrice || parseFloat(unitPrice) <= 0) return Notify('error', 'Please enter a valid unit price', 'error');
//         if (!unitnumber.trim()) return Notify('error', 'Please enter unit number', 'error');
//         if (!commissionRatio || parseFloat(commissionRatio) <= 0) return Notify('error', 'Please enter commission ratio', 'error');
//         if (cashbackratio === '' || cashbackratio < 0) return Notify('error', 'Please enter cashback ratio', 'error');
//       }
//       if (selectedStageName === 'Done Deal') {
//         if (!unitPrice || parseFloat(unitPrice) <= 0) return Notify('error', 'Please enter a valid unit price', 'error');
//         if (!unitnumber.trim()) return Notify('error', 'Please enter unit number', 'error');
//         if (!commissionRatio || parseFloat(commissionRatio) <= 0) return Notify('error', 'Please enter commission ratio', 'error');
//         if (cashbackratio === '' || cashbackratio < 0) return Notify('error', 'Please enter cashback ratio', 'error');
//       }
//     }
//     setLoading(true); setSendLoading(true);
//     try {
//       const finalDate = valuedate || dayjs();
//       if (addActionEnabled) {
//         const updateData = {
//           stage: selectedStageId, stagedateupdated: finalDate, last_stage_date_updated: moment().format('YYYY-MM-DD'),
//           ...((selectedStageName === 'Done Deal') && {
//             unit_price: parseFloat(unitPrice), review: false, unitnumber,
//             commissionratio: parseFloat(commissionRatio), commissionmoney: totalCommission,
//             cashbackratio: parseFloat(cashbackratio), cashbackmoney: cashbackMoney,
//           }),
//           ...((selectedStageName === 'EOI') && {
//             unit_price: parseFloat(unitPrice), review: false, unitnumber,
//             commissionratio: parseFloat(commissionRatio), commissionmoney: totalCommission,
//             cashbackratio: parseFloat(cashbackratio), cashbackmoney: cashbackMoney,
//             Eoi: parseFloat(eoiAmount),
//           }),
//           ...(selectedStageName === 'Reservation' && { Reservation: parseFloat(reservationAmount) }),
//         };
//         await dispatch(UpdateStageToLeed(user._id, updateData));
//         await dispatch(Insert_Lead_Stages_Data_Action({ LeadId: user._id, date: moment().format('YYYY-MM-DD'), stage: selectedStageId, sales: userlogin.data._id, dateselectedforstage: finalDate, ...((selectedStageName === 'Done Deal' || selectedStageName === 'EOI') && { unitPrice: parseFloat(unitPrice) }) }));
//         if (selectedStageName === 'Done Deal' || selectedStageName === 'EOI') DoneDealFun();
//       }
//       await dispatch(InsertNewAction_action({ sales: userlogin.data._id, text1: firstcomment, text2: secondcomment, date: finalDate, leed: user._id, username: userlogin.data._id, commentbysales: userlogin.data.name, stage: user?.stage?._id }));
//     } catch { Notify('error', 'Error sending data, please try again.', 'error'); }
//     finally { setLoading(false); setSendLoading(false); }
//   };

//   useEffect(() => {
//     if (!loading) {
//       if (resaddcomment?.status === 200) {
//         Notify('success', 'Comment added successfully!', 'success');
//         setFirstComment(''); setSecondComment('');
//         if (addActionEnabled) resetStageForm();
//         if (tabValue === 2) refreshComments();
//               if (onLeadUpdated) onLeadUpdated();

//       } else { Notify('error', 'Error adding comment', 'error'); }
//     }
//   }, [loading]);

//   const handleTabChange = useCallback((e, v) => {
//     setTabValue(v);
//     if (v === 2 && leadid && userloginrealy.current?.data?._id) getallactiondata(1);
//   }, [leadid, getallactiondata]);

//   const handleClose = useCallback(() => { if (onClose) onClose(); else { setOpen(false); setAddActionEnabled(false); resetStageForm(); } }, [onClose, resetStageForm]);

//   /* ════════════════════════════════════════════════════
//      RENDER
//   ════════════════════════════════════════════════════ */
//   return (
//     <Dialog
//       open={open}
//       onClose={handleClose}
//       maxWidth="lg"
//       fullWidth
//       className="mca-dialog"
//       TransitionComponent={Transition}
//       PaperProps={{
//         sx: {
//           background: T.bg1,
//           borderRadius: 3,
//           border: `1px solid ${T.bdr}`,
//           height: '95vh',
//           display: 'flex',
//           flexDirection: 'column',
//           overflow: 'hidden',
//           boxShadow: `0 32px 80px rgba(0,0,0,0.7), 0 0 0 1px ${T.bdr}`,
//         },
//       }}
//       sx={{ zIndex: 50000 }}
//     >
//       {/* ── HEADER ── */}
//       <Box sx={{
//         px: 3, py: 2,
//         background: `linear-gradient(135deg, ${T.bg2} 0%, ${T.bg3} 100%)`,
//         borderBottom: `1px solid ${T.bdr}`,
//         display: 'flex', alignItems: 'center', justifyContent: 'space-between',
//         flexShrink: 0,
//       }}>
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//           <Box sx={{ position: 'relative' }}>
//             <Box sx={{
//               position: 'absolute', inset: -2,
//               borderRadius: '50%',
//               background: `conic-gradient(from 0deg, ${T.gold}, ${T.goldL}, ${T.gold})`,
//               animation: 'spin 6s linear infinite',
//               '@keyframes spin': { '100%': { transform: 'rotate(360deg)' } },
//             }} />
//             <Avatar sx={{ width: 44, height: 44, fontSize: 16, fontWeight: 700, bgcolor: T.bg4, border: `2px solid ${T.bg1}`, color: T.gold, fontFamily: "'DM Sans', sans-serif", position: 'relative', zIndex: 1 }}>
//               {user?.name?.charAt(0)?.toUpperCase()}
//             </Avatar>
//           </Box>
//           <Box>
//             <Typography sx={{ fontSize: 16, fontWeight: 600, color: T.txtPri, fontFamily: "'DM Sans', sans-serif", letterSpacing: '0.03em', lineHeight: 1.2 }}>{user?.name}</Typography>
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
//               <Typography sx={{ fontSize: 11, color: T.txtMut, fontFamily: "'DM Sans', sans-serif" }}>{user?.sales?.name}</Typography>
//               <Box sx={{ width: 3, height: 3, borderRadius: '50%', bgcolor: T.txtMut }} />
//               <StagePill name={selectedStageName || user?.stage?.name} />
//             </Box>
//           </Box>
//         </Box>
//         <IconButton onClick={handleClose} sx={{ color: T.txtSec, bgcolor: T.bg4, borderRadius: 2, '&:hover': { bgcolor: T.bg3, color: T.txtPri } }}>
//           <CloseIcon sx={{ fontSize: 18 }} />
//         </IconButton>
//       </Box>

//       {/* ── TABS ── */}
//       <Box sx={{ px: 3, pt: 0.5, borderBottom: `1px solid ${T.bdr2}`, bgcolor: T.bg1, flexShrink: 0 }}>
//         <Tabs
//           value={tabValue}
//           onChange={handleTabChange}
//           sx={{
//             minHeight: 44,
//             '& .MuiTabs-indicator': { background: `linear-gradient(90deg, ${T.gold}, ${T.goldL})`, height: 2, borderRadius: 1 },
//             '& .MuiTab-root': { color: T.txtMut, fontFamily: "'DM Sans', sans-serif", fontSize: 12, fontWeight: 500, textTransform: 'none', minHeight: 44, letterSpacing: '0.03em', transition: 'color 0.2s', '&.Mui-selected': { color: T.gold, fontWeight: 700 } },
//           }}
//         >
//           <Tab icon={<InfoIcon sx={{ fontSize: 14 }} />} iconPosition="start" label="Information" />
//           <Tab icon={<AddCommentIcon sx={{ fontSize: 14 }} />} iconPosition="start" label="Add Comment" />
//           <Tab icon={<CommentIcon sx={{ fontSize: 14 }} />} iconPosition="start" label={`Comments${totalCommentsCount > 0 ? ` (${totalCommentsCount})` : ''}`} />
//         </Tabs>
//       </Box>

//       {/* ── CONTENT ── */}
//       <Box sx={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column', bgcolor: T.bg1 }}>

//         {/* ════ TAB 0: INFORMATION ════ */}
//         <TabPanel value={tabValue} index={0}>
//           <Grid container spacing={3}>
//             <Grid item xs={12} md={6}>
//               <GlassCard bordered sx={{ p: 2.5, height: '100%' }}>
//                 <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
//                   <Typography sx={{ fontSize: 11, color: T.txtPri, fontFamily: "'DM Sans', sans-serif", fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em' }}>Lead Details</Typography>
//                   <Box sx={{ display: 'flex', gap: 0.5 }}>
//                     <Tooltip title="Preview">
//                       <IconButton size="small" onClick={() => setOpenLeadPreview(true)} sx={{ color: T.txtSec, bgcolor: T.bg1, borderRadius: 1.5, width: 28, height: 28, '&:hover': { color: T.gold } }}>
//                         <VisibilityIcon sx={{ fontSize: 14 }} />
//                       </IconButton>
//                     </Tooltip>
//                     {!['Sales','Team Leader'].includes(userlogin?.data?.role) && (
//                       <Tooltip title="Edit Lead">
//                         <IconButton size="small" component={Link} to={`/updateclient/${user._id}`} sx={{ color: T.txtSec, bgcolor: T.bg1, borderRadius: 1.5, width: 28, height: 28, '&:hover': { color: T.gold } }}>
//                           <EditIcon sx={{ fontSize: 14 }} />
//                         </IconButton>
//                       </Tooltip>
//                     )}
//                   </Box>
//                 </Box>
//                 <InfoRow icon={PersonIcon} label="Lead Name" value={user?.name} />
//                 <InfoRow icon={WorkIcon} label="Sales Person" value={user?.sales?.name} accent={T.gold} />
//                 <InfoRow icon={PhoneIcon} label="Phone" value={
//                   <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                     <Typography sx={{ fontSize: 14, color: T.txtPri, fontFamily: "'DM Sans', sans-serif" }}>{user?.phone}</Typography>
//                     <IconButton size="small" onClick={() => window.open(`https://wa.me/${user?.phone}`, '_blank')} sx={{ color: T.success, p: 0.3, bgcolor: 'rgba(52,211,153,0.08)', borderRadius: 1 }}>
//                       <WhatsAppIcon sx={{ fontSize: 14 }} />
//                     </IconButton>
//                   </Box>
//                 } />
//                 {user?.phonenumber2 && <InfoRow icon={PhoneIcon} label="Phone 2" value={user.phonenumber2} />}
//                 <InfoRow icon={EmailIcon} label="Email" value={user?.email} />
//                 <InfoRow icon={WorkIcon} label="Developer" value={user?.project?.developer?.name} />
//                 <InfoRow icon={InfoIcon} label="Project" value={user?.project?.name} accent={T.info} />
//                 {user?.notes && <InfoRow icon={EditIcon} label="Notes" value={user.notes} />}
//                 {(userlogin?.data?.role !== 'Sales' && userlogin?.data?.role !== 'Team Leader') || !user?.resetcreationdate ? (
//                   <InfoRow icon={CalendarIcon} label="Created" value={moment(user?.createdAt).format('DD MMM YYYY')} />
//                 ) : null}
//               </GlassCard>
//             </Grid>

//             <Grid item xs={12} md={6}>
//               <GlassCard sx={{ p: 2.5, mb: 2 }}>
//                 <Typography sx={{ fontSize: 11, color: T.txtPri, fontFamily: "'DM Sans', sans-serif", fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em', mb: 2 }}>Current Stage</Typography>
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//                   <Box sx={{ width: 50, height: 50, borderRadius: 12, bgcolor: `${stageColor(user?.stage?.name)}15`, border: `1px solid ${stageColor(user?.stage?.name)}40`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                     <Box sx={{ width: 14, height: 14, borderRadius: '50%', bgcolor: stageColor(user?.stage?.name), boxShadow: `0 0 8px ${stageColor(user?.stage?.name)}` }} />
//                   </Box>
//                   <Box>
//                     <StagePill name={user?.stage?.name} size="large" />
//                     {user?.stagedateupdated && <Typography sx={{ fontSize: 11, color: T.txtMut, fontFamily: "'DM Sans', sans-serif", mt: 0.5 }}>{moment(user.stagedateupdated).format('DD MMM YYYY, HH:mm')}</Typography>}
//                   </Box>
//                 </Box>
//               </GlassCard>

//               {user?.campaignRedirectLink && (
//                 <GlassCard sx={{ p: 2.5, mb: 2 }}>
//                   <Typography sx={{ fontSize: 11, color: T.gold, fontFamily: "'DM Sans', sans-serif", fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em', mb: 1.5 }}>Campaign Link</Typography>
//                   <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, p: 1.5, borderRadius: 2, bgcolor: T.bg4, border: `1px solid ${T.bdr2}` }}>
//                     <Box sx={{ width: 32, height: 32, borderRadius: 8, bgcolor: T.goldSoft, border: `1px solid ${T.bdr}`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
//                       <LinkIcon sx={{ fontSize: 14, color: T.gold }} />
//                     </Box>
//                     <Typography sx={{ flex: 1, fontSize: 12, color: T.info, fontFamily: "'DM Sans', sans-serif", wordBreak: 'break-all', lineHeight: 1.4 }}>
//                       <a href={user.campaignRedirectLink} target="_blank" rel="noopener noreferrer" style={{ color: 'inherit' }}>{user.campaignRedirectLink}</a>
//                     </Typography>
//                     <IconButton size="small" onClick={() => window.open(user.campaignRedirectLink, '_blank')} sx={{ color: T.gold, bgcolor: T.goldSoft, borderRadius: 1.5, width: 28, height: 28, flexShrink: 0 }}>
//                       <OpenInNewIcon sx={{ fontSize: 13 }} />
//                     </IconButton>
//                   </Box>
//                 </GlassCard>
//               )}

//               {[1,2,3,4,5].some(n => user?.[`question${n}_text`] || user?.[`question${n}_answer`]) && (
//                 <GlassCard sx={{ p: 2.5 }}>
//                   <Typography sx={{ fontSize: 11, color: T.gold, fontFamily: "'DM Sans', sans-serif", fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em', mb: 2 }}>Campaign Q&A</Typography>
//                   {[1,2,3,4,5].map(num => {
//                     const q = user?.[`question${num}_text`], a = user?.[`question${num}_answer`];
//                     if (!q && !a) return null;
//                     return (
//                       <Box key={num} sx={{ mb: 1.5, p: 1.5, borderRadius: 2, bgcolor: T.bg4, borderLeft: `3px solid ${T.gold}` }}>
//                         {q && <Typography sx={{ fontSize: 12, color: T.txtSec, fontFamily: "'DM Sans', sans-serif", mb: 0.5, fontStyle: 'italic' }}>{q}</Typography>}
//                         {a && <Typography sx={{ fontSize: 13, color: T.txtPri, fontFamily: "'DM Sans', sans-serif", fontWeight: 500 }}>{a}</Typography>}
//                       </Box>
//                     );
//                   })}
//                 </GlassCard>
//               )}
//             </Grid>
//           </Grid>
//         </TabPanel>

//         {/* ════ TAB 1: ADD COMMENT ════ */}
//         <TabPanel value={tabValue} index={1}>
//           <Box sx={{ display: 'flex', gap: 1.5, mb: 3 }}>
//             <OutlineBtn size="small" active={!isNoAnswer} startIcon={<PhoneInTalkIcon sx={{ fontSize: 14 }} />} onClick={() => { setIsNoAnswer(false); setFirstComment(''); setSecondComment(''); }}>
//               Answer
//             </OutlineBtn>
//             <OutlineBtn size="small" danger active={isNoAnswer} startIcon={<CancelIcon sx={{ fontSize: 14 }} />} onClick={() => { setIsNoAnswer(true); setFirstComment('اتصلت ومفيش رد'); setSecondComment('هحاول تاني في وقت تاني'); }}>
//               No Answer
//             </OutlineBtn>
//           </Box>

//           <GlassCard bordered sx={{ p: 2.5, mb: 3 }}>
//             <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//               <Box>
//                 <Typography sx={{ fontSize: 13, fontWeight: 600, color: T.txtPri, fontFamily: "'DM Sans', sans-serif" }}>Stage Management</Typography>
//                 <Typography sx={{ fontSize: 11, color: T.txtMut, fontFamily: "'DM Sans', sans-serif", mt: 0.3 }}>Enable to change the lead stage</Typography>
//               </Box>
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
//                 {addActionEnabled && <Typography sx={{ fontSize: 11, color: T.success, fontFamily: "'DM Sans', sans-serif", fontWeight: 600 }}>✓ Active</Typography>}
//                 <Switch
//                   checked={addActionEnabled}
//                   onChange={e => handleEnableActionToggle(e.target.checked)}
//                   sx={{ '& .MuiSwitch-switchBase.Mui-checked': { color: T.gold }, '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { bgcolor: T.goldD } }}
//                 />
//               </Box>
//             </Box>

//             {addActionEnabled && (
//               <Box sx={{ mt: 2, pt: 2, borderTop: `1px solid ${T.bdr2}`, display: 'flex', alignItems: 'center', gap: 1.5 }}>
//                 <Typography sx={{ fontSize: 11, color: T.txtMut, fontFamily: "'DM Sans', sans-serif" }}>Current:</Typography>
//                 <StagePill name={user?.stage?.name} />
//                 <Box sx={{ fontSize: 18, lineHeight: 1 }}>→</Box>
//                 <Typography sx={{ fontSize: 11, color: T.txtMut, fontFamily: "'DM Sans', sans-serif" }}>Change to:</Typography>
//               </Box>
//             )}
//           </GlassCard>

//           <Collapse in={addActionEnabled} timeout={400}>
//             <Box sx={{ mb: 3 }}>
//               <Box sx={{ mb: 2 }}>
//                 <Autocomplete
//                   disablePortal
//                   options={allstagesshow}
//                   getOptionLabel={o => o.name || ''}
//                   value={selectedStage}
//                   onChange={handleStageChange}
//                   isOptionEqualToValue={(o, v) => o?._id === v?._id}
//                   PopperProps={{ 
//                     style: { zIndex: 60000 },
//                     modifiers: [
//                       {
//                         name: 'flip',
//                         enabled: true,
//                         options: {
//                           altBoundary: true,
//                           rootBoundary: 'document',
//                           padding: 8,
//                         },
//                       },
//                       {
//                         name: 'preventOverflow',
//                         enabled: true,
//                         options: {
//                           altAxis: true,
//                           altBoundary: true,
//                           tether: true,
//                           rootBoundary: 'document',
//                           padding: 8,
//                         },
//                       },
//                     ],
//                   }}
//                   renderInput={params => (
//                     <DarkTextField {...params} label="Select New Stage" helperText="Choose the stage you want to move this lead to" />
//                   )}
//                   renderOption={(props, option) => (
//                     <Box component="li" {...props} sx={{ fontFamily: "'DM Sans', sans-serif", fontSize: 13, color: T.txtPri, bgcolor: T.bg3, '&:hover': { bgcolor: T.bg4 }, display: 'flex', alignItems: 'center', gap: 1.5, px: 2, py: 1 }}>
//                       <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: stageColor(option.name), flexShrink: 0 }} />
//                       {option.name}
//                     </Box>
//                   )}
//                 />

//                 {selectedStage && selectedStage.Comment && (
//                   <Box sx={{ mt: 1.5, p: 1.5, borderRadius: 2, bgcolor: T.goldSoft, border: `1px solid ${T.bdr}`, display: 'flex', alignItems: 'flex-start', gap: 1 }}>
//                     <InfoIcon sx={{ fontSize: 14, color: T.gold, mt: 0.2 }} />
//                     <Box>
//                       <Typography sx={{ fontSize: 10, color: T.gold, fontFamily: "'DM Sans', sans-serif", fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em' }}>
//                         Stage Note
//                       </Typography>
//                       <Typography sx={{ fontSize: 12, color: T.txtPri, fontFamily: "'DM Sans', sans-serif" }}>
//                         {selectedStage.Comment}
//                       </Typography>
//                     </Box>
//                   </Box>
//                 )}
//               </Box>

//               {/* DateTime picker - مع تعديلات z-index عالية جداً */}
//               {showDateTime && (
//                 <GlassCard sx={{ p: 2.5, mb: 2 }}>
//                   <Typography sx={{ fontSize: 11, color: T.warning, fontFamily: "'DM Sans', sans-serif", fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em', mb: 2, display: 'flex', alignItems: 'center', gap: 0.8 }}>
//                     <ScheduleIcon sx={{ fontSize: 13 }} /> Schedule Next Action
//                   </Typography>
//                   <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 2 }}>
//                     {[
//                       { label: '+1h',   fn: () => { const t = dayjs().add(1,'hour'); setValueDate(t); handleDateTimeChange(t); } },
//                       { label: '+2h',   fn: () => { const t = dayjs().add(2,'hour'); setValueDate(t); handleDateTimeChange(t); } },
//                       { label: '+3h',   fn: () => { const t = dayjs().add(3,'hour'); setValueDate(t); handleDateTimeChange(t); } },
//                       { label: 'Tom 11AM', fn: () => { const t = dayjs().add(1,'day').hour(11).minute(0).second(0); setValueDate(t); handleDateTimeChange(t); } },
//                       { label: 'In 2 days', fn: () => { const t = dayjs().add(2,'day').hour(11).minute(0).second(0); setValueDate(t); handleDateTimeChange(t); } },
//                     ].map(btn => (
//                       <Box key={btn.label} onClick={btn.fn} sx={{ px: 1.5, py: 0.8, borderRadius: 8, border: `1px solid ${T.bdr}`, fontSize: 11, color: T.txtSec, fontFamily: "'DM Sans', sans-serif", cursor: 'pointer', transition: 'all 0.15s', bgcolor: T.bg4, '&:hover': { border: `1px solid ${T.gold}`, color: T.gold, bgcolor: T.goldSoft } }}>
//                         {btn.label}
//                       </Box>
//                     ))}
//                   </Box>
//                   <LocalizationProvider dateAdapter={AdapterDayjs}>
//                     <DesktopDateTimePicker
//                       label="Select Date & Time"
//                       value={valuedate}
//                       onChange={handleDateTimeChange}
//                       ampm={true}
//                       slotProps={{
//                         textField: { fullWidth: true, sx: { '& .MuiOutlinedInput-root': { background: T.bg1, color: T.txtPri, borderRadius: 2, fontFamily: "'DM Sans', sans-serif", '& fieldset': { borderColor: T.bdr2 }, '&:hover fieldset': { borderColor: T.bdr }, '&.Mui-focused fieldset': { borderColor: T.gold, borderWidth: 1 } }, '& .MuiInputLabel-root': { color: T.txtMut }, '& .MuiInputLabel-root.Mui-focused': { color: T.gold }, '& .MuiSvgIcon-root': { color: T.txtSec } } },
//                         popper: { 
//                           sx: { 
//                             zIndex: 50010,
//                             '& .MuiPaper-root': {
//                               zIndex: 50011,
//                             }
//                           } 
//                         },
//                         desktopPaper: { 
//                           sx: { 
//                             zIndex: 50011, 
//                             background: T.bg2, 
//                             border: `1px solid ${T.bdr}`, 
//                             borderRadius: 2, 
//                             color: T.txtPri 
//                           } 
//                         },
//                       }}
//                     />
//                   </LocalizationProvider>
//                 </GlassCard>
//               )}

//               {/* Stage-specific fields - الـ Forms الجديدة */}
//               <StageSpecificForm
//                 selectedStageName={selectedStageName}
//                 eoiAmount={eoiAmount}
//                 reservationAmount={reservationAmount}
//                 onEoiAmountChange={handleEoiAmountChange}
//                 onReservationAmountChange={handleReservationAmountChange}
//                 unitPrice={unitPrice}
//                 unitnumber={unitnumber}
//                 commissionRatio={commissionRatio}
//                 cashbackratio={cashbackratio}
//                 totalCommission={totalCommission}
//                 cashbackMoney={cashbackMoney}
//                 onPriceChange={handlePriceChange}
//                 onUnitNumberChange={handleUnitNumber}
//                 onCommissionRatioChange={handleCommissionRatioChange}
//                 onCashbackRatioChange={handleCashbackRatioChange}
//               />
//             </Box>
//           </Collapse>

//           <GlassCard sx={{ p: 2.5, mb: 3 }}>
//             <Typography sx={{ fontSize: 11, color: T.txtPri, fontFamily: "'DM Sans', sans-serif", fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em', mb: 2 }}>Comments</Typography>
//             <Grid container spacing={2}>
//               <Grid item xs={12}>
//                 <DarkTextField fullWidth multiline rows={3} label="What happened? (First comment)" value={firstcomment} onChange={e => setFirstComment(e.target.value)} placeholder="Describe the conversation, meeting, or interaction…" required />
//               </Grid>
//               <Grid item xs={12}>
//                 <DarkTextField fullWidth multiline rows={3} label="Next Action Plan (Second comment)" value={secondcomment} onChange={e => setSecondComment(e.target.value)} placeholder="What's the next step? When will you follow up?" required />
//               </Grid>
//             </Grid>
//           </GlassCard>

//           {(!firstcomment.trim() || !secondcomment.trim()) && (
//             <Box sx={{ mb: 2, p: 1.5, borderRadius: 2, bgcolor: 'rgba(251,191,36,0.08)', border: `1px solid rgba(251,191,36,0.3)`, display: 'flex', alignItems: 'center', gap: 1 }}>
//               <WarningIcon sx={{ fontSize: 14, color: T.warning }} />
//               <Typography sx={{ fontSize: 12, color: T.warning, fontFamily: "'DM Sans', sans-serif" }}>Please fill in both comment fields before submitting</Typography>
//             </Box>
//           )}

//           <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
//             <GoldButton onClick={onsubmitdata} disabled={sendloading} startIcon={sendloading ? null : (selectedStageName === 'Done Deal' || selectedStageName === 'EOI') ? <CheckCircleIcon sx={{ fontSize: 16 }} /> : <SendIcon sx={{ fontSize: 16 }} />} endIcon={sendloading ? <CircularProgress size={14} color="inherit" /> : null}>
//               {sendloading ? 'Submitting…' : selectedStageName === 'Done Deal' ? '🎉 Complete Deal & Add Comment' : selectedStageName === 'EOI' ? '📝 Add EOI & Comment' : 'Add Comment'}
//             </GoldButton>
//           </Box>
//         </TabPanel>

//         {/* ════ TAB 2: ALL COMMENTS ════ */}
//         <TabPanel value={tabValue} index={2}>
//           <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3 }}>
//             <Box>
//               <Typography sx={{ fontSize: 14, fontWeight: 600, color: T.txtPri, fontFamily: "'DM Sans', sans-serif" }}>All Comments</Typography>
//               <Typography sx={{ fontSize: 11, color: T.txtMut, fontFamily: "'DM Sans', sans-serif" }}>{totalCommentsCount} total · Page {currentPage} of {totalPages}</Typography>
//             </Box>
//             <Box sx={{ display: 'flex', gap: 1 }}>
//               <Tooltip title="Refresh">
//                 <IconButton size="small" onClick={() => getallactiondata(1)} disabled={isCommentsLoading} sx={{ color: T.txtSec, bgcolor: T.bg4, borderRadius: 1.5, width: 32, height: 32, '&:hover': { color: T.gold } }}>
//                   {isCommentsLoading ? <CircularProgress size={14} sx={{ color: T.gold }} /> : <RefreshIcon sx={{ fontSize: 16 }} />}
//                 </IconButton>
//               </Tooltip>
//               <OutlineBtn size="small" startIcon={<AddIcon sx={{ fontSize: 13 }} />} onClick={() => setTabValue(1)}>New Comment</OutlineBtn>
//             </Box>
//           </Box>

//           {filterInfo?.applied === 'filtered_by_date' && (
//             <Box sx={{ mb: 2, p: 1.5, borderRadius: 2, bgcolor: 'rgba(96,165,250,0.08)', border: `1px solid rgba(96,165,250,0.2)`, display: 'flex', alignItems: 'center', gap: 1 }}>
//               <InfoIcon sx={{ fontSize: 14, color: T.info }} />
//               <Typography sx={{ fontSize: 12, color: T.info, fontFamily: "'DM Sans', sans-serif" }}>
//                 Showing comments after assignment: {moment(filterInfo.assignmentInfo?.assignDateTime).format('DD/MM/YYYY hh:mm A')}
//               </Typography>
//             </Box>
//           )}

//           {isCommentsLoading ? (
//             <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 10 }}>
//               <Box sx={{ textAlign: 'center' }}>
//                 <CircularProgress sx={{ color: T.gold }} size={32} />
//                 <Typography sx={{ fontSize: 12, color: T.txtMut, fontFamily: "'DM Sans', sans-serif", mt: 1.5 }}>Loading comments…</Typography>
//               </Box>
//             </Box>
//           ) : comments?.length > 0 ? (
//             <Box>
//               {[...comments].sort((a, b) => new Date(b.stageDate) - new Date(a.stageDate)).map((comment, idx) => (
//                 <GlassCard key={comment._id || idx} sx={{ p: 0, mb: 2, overflow: 'hidden' }}>
//                   <Box sx={{ px: 2.5, py: 1.5, display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: `1px solid ${T.bdr2}`, bgcolor: T.bg3 }}>
//                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
//                       <Avatar src={comment.sales?.profileImg} sx={{ width: 30, height: 30, fontSize: 12, bgcolor: T.bg4, border: `1px solid ${T.bdr}`, color: T.gold }}>
//                         {comment.sales?.name?.charAt(0)}
//                       </Avatar>
//                       <Box>
//                         <Typography sx={{ fontSize: 13, fontWeight: 600, color: T.txtPri, fontFamily: "'DM Sans', sans-serif", lineHeight: 1.2 }}>{comment.sales?.name}</Typography>
//                         <Typography sx={{ fontSize: 10, color: T.txtMut, fontFamily: "'DM Sans', sans-serif" }}>{moment(comment.stageDate).format('DD MMM YYYY, HH:mm')}</Typography>
//                       </Box>
//                     </Box>
//                     {comment.stage && <StagePill name={comment.stage.name} />}
//                   </Box>

//                   <Box sx={{ px: 2.5, py: 2 }}>
//                     {comment.firstcomment?.text && (
//                       <Box sx={{ mb: 2 }}>
//                         <Typography sx={{ fontSize: 10, color: T.gold, fontFamily: "'DM Sans', sans-serif", fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', mb: 0.8 }}>Comment</Typography>
//                         <Box sx={{ p: 1.5, borderRadius: 2, bgcolor: T.bg1, borderLeft: `2px solid ${T.gold}` }}>
//                           <Typography sx={{ fontSize: 13, color: T.txtPri, fontFamily: "'DM Sans', sans-serif", lineHeight: 1.6, whiteSpace: 'pre-wrap' }}>{comment.firstcomment.text}</Typography>
//                         </Box>
//                       </Box>
//                     )}
//                     {comment.secondcomment?.text && (
//                       <Box>
//                         <Typography sx={{ fontSize: 10, color: T.info, fontFamily: "'DM Sans', sans-serif", fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', mb: 0.8 }}>Next Plan</Typography>
//                         <Box sx={{ p: 1.5, borderRadius: 2, bgcolor: T.bg1, borderLeft: `2px solid ${T.info}` }}>
//                           <Typography sx={{ fontSize: 13, color: T.txtSec, fontFamily: "'DM Sans', sans-serif", lineHeight: 1.6, whiteSpace: 'pre-wrap' }}>{comment.secondcomment.text}</Typography>
//                         </Box>
//                       </Box>
//                     )}
//                     <CommentReplies comment={comment} currentUserId={userloginrealy.current?.data?._id} onReplyAdded={refreshComments} />
//                   </Box>
//                 </GlassCard>
//               ))}

//               {totalPages > 1 && (
//                 <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2, mt: 3 }}>
//                   <OutlineBtn size="small" disabled={!hasPrev || isCommentsLoading} onClick={() => getallactiondata(currentPage - 1)} startIcon={<KeyboardArrowUpIcon sx={{ fontSize: 14 }} />}>
//                     Prev
//                   </OutlineBtn>
//                   <Typography sx={{ fontSize: 12, color: T.txtSec, fontFamily: "'DM Sans', sans-serif" }}>
//                     {currentPage} / {totalPages}
//                   </Typography>
//                   <OutlineBtn size="small" disabled={!hasNext || isCommentsLoading} onClick={() => getallactiondata(currentPage + 1)} endIcon={<KeyboardArrowDownIcon sx={{ fontSize: 14 }} />}>
//                     Next
//                   </OutlineBtn>
//                 </Box>
//               )}
//             </Box>
//           ) : (
//             <Box sx={{ textAlign: 'center', py: 10 }}>
//               <Box sx={{ width: 60, height: 60, borderRadius: '50%', bgcolor: T.bg4, border: `1px solid ${T.bdr}`, display: 'flex', alignItems: 'center', justifyContent: 'center', mx: 'auto', mb: 2 }}>
//                 <CommentIcon sx={{ fontSize: 24, color: T.txtMut }} />
//               </Box>
//               <Typography sx={{ fontSize: 15, fontWeight: 600, color: T.txtSec, fontFamily: "'DM Sans', sans-serif", mb: 1 }}>No Comments Yet</Typography>
//               <Typography sx={{ fontSize: 12, color: T.txtMut, fontFamily: "'DM Sans', sans-serif", mb: 3 }}>
//                 {filterInfo?.applied === 'filtered_by_date' ? 'Only comments after assignment date are shown' : 'Start by adding the first comment'}
//               </Typography>
//               <GoldButton size="small" startIcon={<AddIcon sx={{ fontSize: 14 }} />} onClick={() => setTabValue(1)} sx={{ fontSize: 12, py: '8px', px: '18px' }}>
//                 Add First Comment
//               </GoldButton>
//             </Box>
//           )}
//         </TabPanel>
//       </Box>

//       {/* ── LEAD PREVIEW DIALOG ── */}
//       <Dialog open={openLeadPreview} onClose={() => setOpenLeadPreview(false)} maxWidth="sm" fullWidth sx={{ zIndex: 60000 }}
//         PaperProps={{ sx: { background: T.bg1, border: `1px solid ${T.bdr}`, borderRadius: 3 } }}>
//         <DialogTitle sx={{ pb: 1 }}>
//           <Typography sx={{ fontSize: 15, fontWeight: 600, color: T.txtPri, fontFamily: "'DM Sans', sans-serif" }}>Lead Preview</Typography>
//         </DialogTitle>
//         <DialogContent>
//           <Grid container spacing={2}>
//             {[
//               ['Name', user?.name],
//               ['Phone', user?.phone],
//               ['Email', user?.email || 'N/A'],
//               ['Stage', null, <StagePill name={user?.stage?.name} />],
//               ['Project', user?.project?.name],
//             ].map(([label, value, custom]) => (
//               <Grid item xs={6} key={label}>
//                 <Typography sx={{ fontSize: 10, color: T.txtMut, fontFamily: "'DM Sans', sans-serif", textTransform: 'uppercase', letterSpacing: '0.06em', mb: 0.5 }}>{label}</Typography>
//                 {custom || <Typography sx={{ fontSize: 13, color: T.txtPri, fontFamily: "'DM Sans', sans-serif", fontWeight: 500 }}>{value}</Typography>}
//               </Grid>
//             ))}
//             {userlogin?.data?.role === 'Admin' && ['Done Deal','EOI'].includes(user?.stage?.name) && (
//               <>
//                 {[['Unit #',user?.unitnumber],['Unit Price',user?.unit_price],['Commission %',user?.commissionratio],['Commission AED',user?.commissionmoney],['Cashback %',user?.cashbackratio],['Cashback AED',user?.cashbackmoney]].map(([l,v]) => (
//                   <Grid item xs={6} key={l}>
//                     <Typography sx={{ fontSize: 10, color: T.txtMut, fontFamily: "'DM Sans', sans-serif", textTransform: 'uppercase', letterSpacing: '0.06em', mb: 0.5 }}>{l}</Typography>
//                     <Typography sx={{ fontSize: 13, color: T.gold, fontFamily: "'DM Sans', sans-serif", fontWeight: 600 }}>{v}</Typography>
//                   </Grid>
//                 ))}
//               </>
//             )}
//           </Grid>
//         </DialogContent>
//         <DialogActions sx={{ px: 3, pb: 2 }}>
//           <GoldButton size="small" onClick={() => setOpenLeadPreview(false)} sx={{ fontSize: 12, py: '7px', px: '18px' }}>Close</GoldButton>
//         </DialogActions>
//       </Dialog>
//     </Dialog>
//   );
// };













// import React, { useEffect, useMemo, useState, useCallback, useRef } from 'react';
// import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';
// import { CalendarToday as CalendarTodayIcon } from '@mui/icons-material';
// import OpenInNewIcon from '@mui/icons-material/OpenInNew';
// import LinkIcon from '@mui/icons-material/Link';
// import {
//   Box, Container, Typography, Card, CardContent, CardHeader, Avatar,
//   IconButton, Button, Dialog, DialogTitle, DialogContent, DialogActions,
//   List, Divider, TextField, Switch, FormControlLabel, Autocomplete,
//   Tooltip, CircularProgress, Chip, Grid, Slide, AppBar, Toolbar,
//   Tabs, Tab, useTheme, styled, InputAdornment, Alert, Paper, Fade,
//   Collapse, Modal, Backdrop, Popper, Drawer, Radio, RadioGroup,
// } from '@mui/material';
// import { LocalizationProvider } from '@mui/x-date-pickers';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
// import {
//   Close as CloseIcon, Person as PersonIcon, Phone as PhoneIcon,
//   WhatsApp as WhatsAppIcon, Email as EmailIcon, Work as WorkIcon,
//   CalendarToday as CalendarIcon, Comment as CommentIcon, AddComment as AddCommentIcon,
//   Info as InfoIcon, Add as AddIcon, Refresh as RefreshIcon, Visibility as VisibilityIcon,
//   Edit as EditIcon, Send as SendIcon, CheckCircle as CheckCircleIcon, Warning as WarningIcon,
//   PhoneInTalk as PhoneInTalkIcon, AttachMoney as AttachMoneyIcon, Cancel as CancelIcon,
//   Done as DoneIcon, ChangeCircle as ChangeCircleIcon, Schedule as ScheduleIcon,
//   KeyboardArrowDown as KeyboardArrowDownIcon, KeyboardArrowUp as KeyboardArrowUpIcon,
//   Search as SearchIcon, ChevronRight as ChevronRightIcon,
// } from '@mui/icons-material';
// import { Link } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import moment from 'moment';
// import dayjs from 'dayjs';
// import JSConfetti from 'js-confetti';

// import {
//   GetAllcomments_Data_With_Pagination_action_advanced,
//   InsertNewAction_action,
//   Insert_Comment_Replay_Action,
// } from '../Redux/Actions/Action_action';
// import { UpdateStageToLeed } from '../Redux/Actions/UsersAction';
// import { Get_All_Lead_Assigned_Data_Action } from '../Redux/Actions/Lead_Assigned_Action';
// import { GetAll_stage_Data, GetOne_stagetogettype_Data } from '../Redux/Actions/Stage_Action';
// import { Insert_Lead_Stages_Data_Action } from '../Redux/Actions/Lead_Stages_Changed_Action';
// import { Notify } from '../Utility/Notify';

// /* ═══════════════════════════════════════════════════════════════
//    DESIGN TOKENS
// ═══════════════════════════════════════════════════════════════ */
// const T = {
//   bg0:   '#eeeef4',
//   bg1:   '#fdfdfe',
//   bg2:   '#eef0f7',
//   bg3:   '#f2f3f8',
//   bg4:   '#eeeef0',
//   gold:  '#0D47A1',
//   goldL: '#0D47A1',
//   goldD: '#9A7030',
//   goldSoft: 'rgba(201,168,76,0.10)',
//   goldGlow: 'rgba(201,168,76,0.25)',
//   txtPri: '#333',
//   txtSec: '#333',
//   txtMut: '#333',
//   success: '#34D399',
//   warning: '#0D47A1',
//   danger:  '#F87171',
//   info:    '#60A5FA',
//   bdr:  'rgba(201,168,76,0.15)',
//   bdr2: 'rgba(255,255,255,0.06)',
// };

// const globalCSS = `
//   @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&display=swap');
//   ::-webkit-scrollbar { width: 4px; height: 4px; }
//   ::-webkit-scrollbar-track  { background: transparent; }
//   ::-webkit-scrollbar-thumb  { background: ${T.bg4}; border-radius: 4px; }
//   ::-webkit-scrollbar-thumb:hover { background: ${T.goldD}; }
// `;

// /* ── Stage color map ── */
// const stageColor = (name) => {
//   const map = {
//     'done deal':   T.success,
//     'hot':         T.danger,
//     'warm':        T.warning,
//     'cold':        T.info,
//     'eoi':         '#FB923C',
//     'reservation': '#818CF8',
//     'no answer':   '#94A3B8',
//     'follow up':   T.gold,
//     'follow':      T.gold,
//     'meeting':     '#A78BFA',
//     'transfer':    '#F472B6',
//     'pending':     '#94A3B8',
//     'fresh':       T.success,
//     'interested':  '#4ADE80',
//     'not interested': T.danger,
//   };
//   return map[(name || '').toLowerCase()] || T.goldD;
// };

// /* ── Avatar initials color ── */
// const avatarColor = (name) => {
//   const colors = ['#6366F1','#8B5CF6','#EC4899','#F59E0B','#10B981','#3B82F6','#EF4444','#14B8A6'];
//   if (!name) return colors[0];
//   return colors[name.charCodeAt(0) % colors.length];
// };

// /* ═══════════════════════════════════════════════════════════════
//    STYLED PRIMITIVES
// ═══════════════════════════════════════════════════════════════ */
// const GlassCard = styled(Box)(({ bordered }) => ({
//   background: `linear-gradient(135deg, ${T.bg2} 0%, ${T.bg3} 100%)`,
//   border: `1px solid ${bordered ? T.bdr : T.bdr2}`,
//   borderRadius: 16,
//   backdropFilter: 'blur(12px)',
//   position: 'relative',
//   overflow: 'hidden',
//   '&::before': bordered ? {
//     content: '""', position: 'absolute', inset: 0, borderRadius: 16, padding: 1,
//     background: `linear-gradient(135deg, ${T.gold}40, transparent 60%)`,
//     WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
//     WebkitMaskComposite: 'xor', maskComposite: 'exclude', pointerEvents: 'none',
//   } : {},
// }));

// const GoldButton = styled(Button)(() => ({
//   background: `linear-gradient(135deg, ${T.gold} 0%, ${T.goldL} 50%, ${T.gold} 100%)`,
//   backgroundSize: '200% 100%',
//   color: '#fff',
//   fontFamily: "'DM Sans', sans-serif",
//   fontWeight: 700, fontSize: 13, borderRadius: 10, padding: '11px 28px',
//   textTransform: 'none', letterSpacing: '0.04em', border: 'none',
//   transition: 'all 0.3s ease',
//   boxShadow: `0 4px 20px ${T.goldGlow}`,
//   '&:hover': { backgroundPosition: '100% 0', boxShadow: `0 6px 30px ${T.goldGlow}`, transform: 'translateY(-1px)' },
//   '&:disabled': { background: T.bg4, color: T.txtMut, boxShadow: 'none' },
// }));

// const OutlineBtn = styled(Button)(({ active, danger }) => ({
//   fontFamily: "'DM Sans', sans-serif", fontWeight: 600, fontSize: 12,
//   borderRadius: 8, padding: '7px 16px', textTransform: 'none',
//   border: `1px solid ${danger ? T.danger : active ? T.gold : T.bdr}`,
//   color: danger ? T.danger : active ? T.gold : T.txtSec,
//   background: danger ? 'rgba(248,113,113,0.08)' : active ? T.goldSoft : 'transparent',
//   transition: 'all 0.2s',
//   '&:hover': {
//     border: `1px solid ${danger ? T.danger : T.gold}`,
//     background: danger ? 'rgba(248,113,113,0.15)' : T.goldSoft,
//     color: danger ? T.danger : T.gold,
//   },
// }));

// const DarkTextField = styled(TextField)(() => ({
//   '& .MuiOutlinedInput-root': {
//     background: T.bg1, borderRadius: 10,
//     fontFamily: "'DM Sans', sans-serif", fontSize: 14, color: T.txtPri,
//     '& fieldset': { borderColor: T.bdr2 },
//     '&:hover fieldset': { borderColor: T.bdr },
//     '&.Mui-focused fieldset': { borderColor: T.gold, borderWidth: 1 },
//     '& input, & textarea': { fontSize: '16px !important' },
//   },
//   '& .MuiInputLabel-root': { color: T.txtMut, fontFamily: "'DM Sans', sans-serif", fontSize: 13 },
//   '& .MuiInputLabel-root.Mui-focused': { color: T.gold },
//   '& .MuiFormHelperText-root': { color: T.txtMut, fontSize: 11 },
// }));

// const StagePill = ({ name, size = 'small' }) => (
//   <Box sx={{
//     display: 'inline-flex', alignItems: 'center', gap: 0.5,
//     px: size === 'small' ? '8px' : '12px',
//     py: size === 'small' ? '3px' : '5px',
//     borderRadius: 20,
//     background: `${stageColor(name)}20`,
//     border: `1px solid ${stageColor(name)}50`,
//     fontSize: size === 'small' ? 10 : 12, fontWeight: 700,
//     color: stageColor(name), fontFamily: "'DM Sans', sans-serif",
//     letterSpacing: '0.05em', textTransform: 'uppercase',
//   }}>
//     <Box sx={{ width: 5, height: 5, borderRadius: '50%', bgcolor: stageColor(name), flexShrink: 0 }} />
//     {name}
//   </Box>
// );

// const InfoRow = ({ icon: Icon, label, value, accent }) => (
//   <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5, py: 1, borderBottom: `1px solid ${T.bdr2}` }}>
//     <Box sx={{ width: 30, height: 30, borderRadius: 8, bgcolor: T.bg1, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, mt: '2px' }}>
//       <Icon sx={{ fontSize: 14, color: T.gold }} />
//     </Box>
//     <Box>
//       <Typography sx={{ fontSize: 11, color: T.txtMut, fontFamily: "'DM Sans', sans-serif", mb: '2px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>{label}</Typography>
//       <Typography sx={{ fontSize: 14, color: accent || T.txtPri, fontFamily: "'DM Sans', sans-serif", fontWeight: 500, lineHeight: 1.4 }}>{value || '—'}</Typography>
//     </Box>
//   </Box>
// );

// const Transition = React.forwardRef((props, ref) => <Slide direction="left" ref={ref} {...props} />);

// /* ═══════════════════════════════════════════════════════════════
//    TAB PANEL
// ═══════════════════════════════════════════════════════════════ */
// const TabPanel = ({ children, value, index }) => (
//   <Box role="tabpanel" hidden={value !== index} sx={{ flex: 1, overflowY: 'auto', height: '100%' }}>
//     {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
//   </Box>
// );

// /* ═══════════════════════════════════════════════════════════════
//    STAGE DROPDOWN  (بيظهر تحت الزرار مباشرة — مش drawer)
// ═══════════════════════════════════════════════════════════════ */
// const StageDropdown = React.memo(({ open, onClose, stages, selectedStage, onSelect }) => {
//   const [search, setSearch] = useState('');

//   const filtered = useMemo(() => {
//     if (!search.trim()) return stages;
//     return stages.filter(s => s.name.toLowerCase().includes(search.toLowerCase()));
//   }, [stages, search]);

//   const handleSelect = (stage) => {
//     onSelect(null, stage);
//     onClose();
//   };

//   if (!open) return null;

//   return (
//     <>
//       {/* backdrop شفاف يقفل الـ dropdown لما تضغط برا */}
//       <Box
//         onClick={onClose}
//         sx={{ position: 'fixed', inset: 0, zIndex: 59999 }}
//       />

//       <Paper
//         elevation={0}
//         sx={{
//           position: 'absolute',
//           top: 'calc(100% + 6px)',
//           left: 0,
//           right: 0,
//           zIndex: 60000,
//           border: `1px solid #E2E8F0`,
//           borderRadius: '12px',
//           overflow: 'hidden',
//           bgcolor: '#fff',
//           boxShadow: '0 12px 40px rgba(0,0,0,0.14)',
//           maxHeight: 320,
//           display: 'flex',
//           flexDirection: 'column',
//         }}
//       >
//         {/* Search */}
//         <Box sx={{
//           px: 1.5, py: 1.2,
//           borderBottom: `1px solid #F1F5F9`,
//           bgcolor: '#FAFBFC',
//           flexShrink: 0,
//         }}>
//           <Box sx={{
//             display: 'flex', alignItems: 'center', gap: 1,
//             bgcolor: '#F1F5F9', borderRadius: 8, px: 1.2, py: 0.8,
//           }}>
//             <SearchIcon sx={{ fontSize: 14, color: '#94A3B8', flexShrink: 0 }} />
//             <input
//               value={search}
//               onChange={e => setSearch(e.target.value)}
//               placeholder="Search stages..."
//               style={{
//                 border: 'none', outline: 'none', background: 'transparent',
//                 fontFamily: "'DM Sans', sans-serif", fontSize: 13,
//                 color: '#334155', width: '100%',
//               }}
//               autoFocus
//             />
//             {search && (
//               <IconButton size="small" onClick={() => setSearch('')} sx={{ p: 0.2 }}>
//                 <CloseIcon sx={{ fontSize: 12, color: '#94A3B8' }} />
//               </IconButton>
//             )}
//           </Box>
//         </Box>

//         {/* Stage List */}
//         <Box sx={{ overflowY: 'auto', flex: 1 }}>
//           {filtered.length === 0 ? (
//             <Box sx={{ py: 4, textAlign: 'center' }}>
//               <Typography sx={{ fontSize: 12, color: '#94A3B8', fontFamily: "'DM Sans', sans-serif" }}>
//                 No stages found
//               </Typography>
//             </Box>
//           ) : (
//             filtered.map((stage, idx) => {
//               const isSelected = selectedStage?._id === stage._id;
//               const color = stageColor(stage.name);

//               return (
//                 <Box
//                   key={stage._id || idx}
//                   onClick={() => handleSelect(stage)}
//                   sx={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: 1.5,
//                     px: 2,
//                     py: 1.1,
//                     cursor: 'pointer',
//                     borderBottom: '1px solid #F8FAFC',
//                     bgcolor: isSelected ? '#EFF6FF' : 'transparent',
//                     transition: 'background 0.12s',
//                     '&:hover': { bgcolor: isSelected ? '#EFF6FF' : '#F8FAFC' },
//                   }}
//                 >
//                   {/* Color dot */}
//                   <Box sx={{
//                     width: 8, height: 8, borderRadius: '50%',
//                     bgcolor: color, flexShrink: 0,
//                     boxShadow: `0 0 0 3px ${color}22`,
//                   }} />

//                   <Typography sx={{
//                     flex: 1,
//                     fontSize: 13,
//                     fontWeight: isSelected ? 700 : 500,
//                     color: isSelected ? T.gold : '#1E293B',
//                     fontFamily: "'DM Sans', sans-serif",
//                   }}>
//                     {stage.name}
//                   </Typography>

//                   {/* Stage color pill */}
//                   <Box sx={{
//                     px: '8px', py: '2px', borderRadius: 20,
//                     bgcolor: `${color}15`,
//                     border: `1px solid ${color}40`,
//                     fontSize: 10, fontWeight: 700, color: color,
//                     fontFamily: "'DM Sans', sans-serif",
//                     letterSpacing: '0.04em', textTransform: 'uppercase',
//                     flexShrink: 0,
//                   }}>
//                     stage
//                   </Box>

//                   {/* Check لو selected */}
//                   {isSelected && (
//                     <CheckCircleIcon sx={{ fontSize: 15, color: T.gold, flexShrink: 0 }} />
//                   )}
//                 </Box>
//               );
//             })
//           )}
//         </Box>
//       </Paper>
//     </>
//   );
// });

// /* ═══════════════════════════════════════════════════════════════
//    COMMENT REPLIES
// ═══════════════════════════════════════════════════════════════ */
// const CommentReplies = React.memo(({ comment, currentUserId, onReplyAdded }) => {
//   const [showInput, setShowInput] = useState(false);
//   const [replyText, setReplyText] = useState('');
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [loadingreplay, setloadingreplay] = useState(true);
//   const dispatch = useDispatch();
//   const userLogin = JSON.parse(localStorage.getItem('user'))?.data || {};
//   const resaddreplay = useSelector(s => s.AllActions.insrertrepaly);

//   const handleSubmitReply = async () => {
//     if (!replyText.trim() || !comment?._id || !userLogin?._id) return;
//     setIsSubmitting(true);
//     try {
//       setloadingreplay(true);
//       await dispatch(Insert_Comment_Replay_Action({ commentId: comment._id, replyText: replyText.trim(), userId: userLogin._id }));
//       setloadingreplay(false);
//     } catch { Notify('error', 'Error adding reply', 'error'); }
//     finally { setIsSubmitting(false); setloadingreplay(false); }
//   };

//   useEffect(() => {
//     if (loadingreplay === false) {
//       if (resaddreplay?.status === 200 || resaddreplay?.success) {
//         Notify('success', 'Reply added', 'success');
//         setReplyText(''); setShowInput(false); onReplyAdded();
//       } else { Notify('error', 'Failed to add reply', 'error'); }
//     }
//   }, [loadingreplay]);

//   const canReply = ['Sales', 'Team Leader', 'Admin'].includes(userLogin?.role);
//   if (!canReply && !comment?.replies?.length) return null;

//   return (
//     <Box sx={{ mt: 2, pl: 2, borderLeft: `2px solid ${T.bdr}` }}>
//       {comment?.replies?.length > 0 && (
//         <Box sx={{ mb: 2 }}>
//           <Typography sx={{ fontSize: 11, color: T.gold, fontFamily: "'DM Sans', sans-serif", fontWeight: 600, mb: 1, textTransform: 'uppercase', letterSpacing: '0.06em' }}>
//             {comment.replies.length} {comment.replies.length === 1 ? 'Reply' : 'Replies'}
//           </Typography>
//           {comment.replies.map((reply, i) => (
//             <Box key={reply._id || i} sx={{ display: 'flex', gap: 1.5, mb: 1.5, p: 1.5, borderRadius: 10, bgcolor: T.bg4 }}>
//               <Avatar src={reply.user?.profileImg} sx={{ width: 26, height: 26, fontSize: 11, bgcolor: T.bg3, border: `1px solid ${T.bdr}`, color: T.gold }}>
//                 {reply.user?.name?.charAt(0)}
//               </Avatar>
//               <Box>
//                 <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', mb: 0.5 }}>
//                   <Typography sx={{ fontSize: 12, fontWeight: 600, color: T.txtPri, fontFamily: "'DM Sans', sans-serif" }}>{reply.user?.name}</Typography>
//                   <Typography sx={{ fontSize: 10, color: T.txtMut, fontFamily: "'DM Sans', sans-serif" }}>{moment(reply.date).format('DD/MM/YY hh:mm A')}</Typography>
//                 </Box>
//                 <Typography sx={{ fontSize: 13, color: T.txtSec, fontFamily: "'DM Sans', sans-serif" }}>{reply.text}</Typography>
//               </Box>
//             </Box>
//           ))}
//         </Box>
//       )}
//       {canReply && (
//         <Box>
//           {showInput ? (
//             <Box>
//               <DarkTextField fullWidth multiline rows={2} value={replyText} onChange={e => setReplyText(e.target.value)} placeholder="Write your reply..." size="small" disabled={isSubmitting} autoFocus sx={{ mb: 1 }} />
//               <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
//                 <OutlineBtn size="small" onClick={() => { setShowInput(false); setReplyText(''); }} disabled={isSubmitting}>Cancel</OutlineBtn>
//                 <GoldButton size="small" onClick={handleSubmitReply} disabled={!replyText.trim() || isSubmitting} startIcon={isSubmitting ? <CircularProgress size={13} color="inherit" /> : <SendIcon sx={{ fontSize: 14 }} />} sx={{ py: '7px', px: '16px', fontSize: 12 }}>
//                   {isSubmitting ? 'Sending…' : 'Reply'}
//                 </GoldButton>
//               </Box>
//             </Box>
//           ) : (
//             <OutlineBtn size="small" startIcon={<AddCommentIcon sx={{ fontSize: 14 }} />} onClick={() => setShowInput(true)} sx={{ width: '100%', justifyContent: 'flex-start' }}>
//               Add a reply…
//             </OutlineBtn>
//           )}
//         </Box>
//       )}
//     </Box>
//   );
// });

// /* ═══════════════════════════════════════════════════════════════
//    RESERVATION FORM
// ═══════════════════════════════════════════════════════════════ */
// const ReservationForm = React.memo(({ reservationAmount, onReservationAmountChange }) => (
//   <GlassCard sx={{ p: 2.5, mb: 2 }}>
//     <Typography sx={{ fontSize: 11, color: T.info, fontFamily: "'DM Sans', sans-serif", fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em', mb: 2 }}>
//       🔒 Reservation Information
//     </Typography>
//     <DarkTextField
//       fullWidth label="Reservation Amount (AED)" type="text"
//       value={reservationAmount} onChange={onReservationAmountChange}
//       InputProps={{ startAdornment: <InputAdornment position="start"><Typography sx={{ color: T.gold, fontSize: 12 }}>AED</Typography></InputAdornment> }}
//       helperText="Enter the reservation deposit amount"
//       inputProps={{ inputMode: 'decimal', style: { fontSize: 16 } }}
//     />
//   </GlassCard>
// ));

// /* ═══════════════════════════════════════════════════════════════
//    STAGE SPECIFIC FORM
// ═══════════════════════════════════════════════════════════════ */
// const StageSpecificForm = React.memo(({
//   selectedStageName, eoiAmount, reservationAmount,
//   onEoiAmountChange, onReservationAmountChange,
//   unitPrice, unitnumber, commissionRatio, cashbackratio,
//   totalCommission, cashbackMoney,
//   onPriceChange, onUnitNumberChange, onCommissionRatioChange, onCashbackRatioChange
// }) => {
//   if (!selectedStageName) return null;

//   if (selectedStageName === 'Reservation') {
//     return <ReservationForm reservationAmount={reservationAmount} onReservationAmountChange={onReservationAmountChange} />;
//   }

//   const DealFields = () => (
//     <Grid container spacing={2}>
//       <Grid item xs={12}>
//         <DarkTextField fullWidth label="Unit Price (AED)" type="text" value={unitPrice} onChange={onPriceChange}
//           InputProps={{ startAdornment: <InputAdornment position="start"><Typography sx={{ color: T.gold, fontSize: 12 }}>AED</Typography></InputAdornment> }}
//           inputProps={{ inputMode: 'decimal', style: { fontSize: 16 } }} required />
//       </Grid>
//       <Grid item xs={12}>
//         <DarkTextField fullWidth label="Unit Number" value={unitnumber} onChange={onUnitNumberChange}
//           placeholder="e.g., A101, Tower 2" inputProps={{ style: { fontSize: 16 } }} required />
//       </Grid>
//       <Grid item xs={6}>
//         <DarkTextField fullWidth label="Commission %" type="text" value={commissionRatio} onChange={onCommissionRatioChange}
//           helperText="Commission percentage"
//           InputProps={{ endAdornment: <InputAdornment position="end"><Typography sx={{ color: T.gold, fontSize: 12 }}>%</Typography></InputAdornment> }}
//           inputProps={{ inputMode: 'decimal', style: { fontSize: 16 } }} required />
//       </Grid>
//       <Grid item xs={6}>
//         <DarkTextField fullWidth label="Total Commission (AED)" value={totalCommission} disabled helperText="Auto calculated"
//           InputProps={{ startAdornment: <InputAdornment position="start"><Typography sx={{ color: T.success, fontSize: 12 }}>AED</Typography></InputAdornment> }}
//           sx={{ '& .MuiInputBase-input.Mui-disabled': { WebkitTextFillColor: T.success, fontWeight: 600 } }} />
//       </Grid>
//       <Grid item xs={6}>
//         <DarkTextField fullWidth label="Cashback %" type="text" value={cashbackratio} onChange={onCashbackRatioChange}
//           helperText="0 for no cashback"
//           InputProps={{ endAdornment: <InputAdornment position="end"><Typography sx={{ color: T.info, fontSize: 12 }}>%</Typography></InputAdornment> }}
//           inputProps={{ inputMode: 'decimal', style: { fontSize: 16 } }} />
//       </Grid>
//       <Grid item xs={6}>
//         <DarkTextField fullWidth label="Cashback Amount (AED)" value={cashbackMoney} disabled helperText="Auto calculated"
//           InputProps={{ startAdornment: <InputAdornment position="start"><Typography sx={{ color: T.info, fontSize: 12 }}>AED</Typography></InputAdornment> }}
//           sx={{ '& .MuiInputBase-input.Mui-disabled': { WebkitTextFillColor: T.info } }} />
//       </Grid>
//     </Grid>
//   );

//   if (selectedStageName === 'EOI') {
//     return (
//       <GlassCard sx={{ p: 2.5, mb: 2 }}>
//         <Typography sx={{ fontSize: 11, color: T.warning, fontFamily: "'DM Sans', sans-serif", fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em', mb: 2 }}>
//           📝 EOI Information
//         </Typography>
//         <DarkTextField fullWidth label="EOI Amount (AED)" type="text" value={eoiAmount} onChange={onEoiAmountChange}
//           InputProps={{ startAdornment: <InputAdornment position="start"><Typography sx={{ color: T.gold, fontSize: 12 }}>AED</Typography></InputAdornment> }}
//           helperText="Enter the Expression of Interest amount"
//           inputProps={{ inputMode: 'decimal', style: { fontSize: 16 } }} sx={{ mb: 3 }} />
//         <Typography sx={{ fontSize: 11, color: T.txtMut, fontFamily: "'DM Sans', sans-serif", fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.08em', mb: 2, mt: 1 }}>
//           ⬇️ Deal Information
//         </Typography>
//         <DealFields />
//       </GlassCard>
//     );
//   }

//   if (selectedStageName === 'Done Deal') {
//     return (
//       <GlassCard sx={{ p: 2.5, mb: 2 }}>
//         <Typography sx={{ fontSize: 11, color: T.success, fontFamily: "'DM Sans', sans-serif", fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em', mb: 2 }}>
//           🎉 Done Deal Information
//         </Typography>
//         <DealFields />
//       </GlassCard>
//     );
//   }

//   return null;
// });

// /* ═══════════════════════════════════════════════════════════════
//    MAIN COMPONENT
// ═══════════════════════════════════════════════════════════════ */
// export const ShowClientsActionsAdvanced = ({ user, leadid, onClose, onLeadUpdated }) => {

//   const dispatch = useDispatch();

//   useEffect(() => {
//     const el = document.createElement('style');
//     el.innerHTML = globalCSS;
//     document.head.appendChild(el);
//     return () => document.head.removeChild(el);
//   }, []);

//   const [open, setOpen] = useState(true);
//   const [tabValue, setTabValue] = useState(0);
//   const [addActionEnabled, setAddActionEnabled] = useState(false);
//   const [userlogin, setUserLogin] = useState('');
//   const userloginrealy = useRef(JSON.parse(localStorage.getItem('user')) || []);

//   /* stage states */
//   const [selectedStage, setSelectedStage] = useState(null);
//   const [showDateTime, setShowDateTime] = useState(false);
//   const [stageType, setStageType] = useState(null);
//   const [selectedStageId, setSelectedStageId] = useState(null);
//   const [selectedStageName, setSelectedStageName] = useState(null);
//   const [allstagesshow, setAllStagesShow] = useState([]);
//   const [stageDropdownOpen, setStageDropdownOpen] = useState(false);  // ← غيّرنا الاسم

//   /* comment states */
//   const [firstcomment, setFirstComment] = useState('');
//   const [secondcomment, setSecondComment] = useState('');
//   const [valuedate, setValueDate] = useState(dayjs());
//   const [loading, setLoading] = useState(true);
//   const [sendloading, setSendLoading] = useState(false);

//   /* done deal & eoi & reservation */
//   const [unitPrice, setUnitPrice] = useState('');
//   const [unitnumber, setUnitNumber] = useState('');
//   const [commissionRatio, setCommissionRatio] = useState('');
//   const [totalCommission, setTotalCommission] = useState('');
//   const [cashbackratio, setCashbackRatio] = useState('');
//   const [cashbackMoney, setCashbackMoney] = useState('');
//   const [eoiAmount, setEoiAmount] = useState('');
//   const [reservationAmount, setReservationAmount] = useState('');
//   const [isNoAnswer, setIsNoAnswer] = useState(false);

//   /* comments pagination */
//   const [comments, setComments] = useState([]);
//   const [isCommentsLoading, setIsCommentsLoading] = useState(false);
//   const [isReady, setIsReady] = useState(false);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalCommentsCount, setTotalCommentsCount] = useState(0);
//   const [hasNext, setHasNext] = useState(false);
//   const [hasPrev, setHasPrev] = useState(false);
//   const [filterInfo, setFilterInfo] = useState(null);
//   const [openLeadPreview, setOpenLeadPreview] = useState(false);

//   const stagesWithDateTime = useMemo(() =>
//     ['No Answer', 'Answer', 'Meeting', 'Follow', 'Follow After Meeting', 'Follow Up', 'Transfer', 'Interested'], []);

//   const resaddcomment = useSelector(s => s.AllActions.AddAction);
//   const All_stages = useSelector(s => s.Allstages.stage);
//   const resgetonestagetype = useSelector(s => s.Allstages.getstagetogetype);

//   useEffect(() => {
//     if (JSON.parse(localStorage.getItem('user'))) setUserLogin(JSON.parse(localStorage.getItem('user')));
//   }, []);

//   /* ── fetch comments ── */
//   const getallactiondata = useCallback(async (page = 1) => {
//     try {
//       setIsCommentsLoading(true);
//       const userId = userloginrealy.current?.data?._id;
//       const leadId = leadid || user?._id;
//       if (!leadId || !userId) return;
//       const response = await dispatch(GetAllcomments_Data_With_Pagination_action_advanced({ leadId: user?._id, userId, page, limit: 20 }));
//       if (response?.success && response?.comments) {
//         setComments(response.comments);
//         if (response.pagination) {
//           setCurrentPage(response.pagination.page || page);
//           setTotalPages(response.pagination.totalPages || 1);
//           setHasNext(response.pagination.hasNext || false);
//           setHasPrev(response.pagination.hasPrev || false);
//         }
//         setTotalCommentsCount(response.totalComments || response.comments.length || 0);
//         if (response.filterApplied) setFilterInfo({ applied: response.filterApplied, assignmentInfo: response.assignmentInfo });
//       }
//     } catch { Notify('error', 'Failed to load comments', 'error'); }
//     finally { setIsCommentsLoading(false); }
//   }, [dispatch, leadid, user?._id]);

//   const refreshComments = useCallback(() => getallactiondata(currentPage), [getallactiondata, currentPage]);

//   const getallstages = useCallback(async () => {
//     try { await dispatch(GetAll_stage_Data()); } catch {}
//   }, [dispatch]);

//   useEffect(() => {
//     let t;
//     if (open) { setIsReady(false); t = setTimeout(async () => { await getallstages(); setIsReady(true); }, 500); }
//     return () => clearTimeout(t);
//   }, [open, getallstages]);

//   useEffect(() => {
//     if (All_stages?.data) {
//       const filtered = All_stages.data.filter(stage => stage.name !== 'Fresh');
//       const sorted = [...filtered].sort((a, b) => a.name === 'No Stage' ? -1 : b.name === 'No Stage' ? 1 : a.name.localeCompare(b.name));
//       setAllStagesShow(sorted);
//     }
//   }, [All_stages]);

//   useEffect(() => {
//     if (resgetonestagetype?.data) setStageType(resgetonestagetype.data);
//     else setStageType(null);
//   }, [resgetonestagetype]);

//   const generateAutoComments = useCallback((stageName) => {
//     const map = { 'No Answer': { firstComment: 'اتصلت ومفيش رد', secondComment: 'هحاول تاني في وقت تاني' } };
//     return map[stageName] || { firstComment: '', secondComment: '' };
//   }, []);

//   const handleStageChange = useCallback((e, newValue) => {
//     if (newValue) {
//       setSelectedStage(newValue);
//       setSelectedStageId(newValue._id);
//       setSelectedStageName(newValue.name);
//       setShowDateTime(stagesWithDateTime.includes(newValue.name) || newValue.name === 'Answer' || newValue.name === 'No Answer');
//       if (!stagesWithDateTime.includes(newValue.name)) setValueDate(null);
//       dispatch(GetOne_stagetogettype_Data(newValue._id)).then(r => { if (r?.data) setStageType(r.data); }).catch(() => {});
//       if (!firstcomment.trim() && !secondcomment.trim()) {
//         const ac = generateAutoComments(newValue.name);
//         setFirstComment(ac.firstComment);
//         setSecondComment(ac.secondComment);
//       }
//       setIsNoAnswer(newValue.name === 'No Answer');
//     } else {
//       setSelectedStage(null); setSelectedStageId(null); setSelectedStageName(null);
//       setStageType(null); setShowDateTime(false);
//     }
//   }, [dispatch, generateAutoComments, stagesWithDateTime, firstcomment, secondcomment]);

//   const resetStageForm = useCallback(() => {
//     setUnitPrice(''); setUnitNumber(''); setCommissionRatio(''); setCashbackRatio('');
//     setEoiAmount(''); setReservationAmount(''); setStageType(null); setSelectedStage(null);
//     setShowDateTime(false); setValueDate(null); setIsNoAnswer(false);
//   }, []);

//   const handleEnableActionToggle = useCallback((checked) => {
//     setAddActionEnabled(checked);
//     if (checked && user?.stage) {
//       setSelectedStage(user.stage); setSelectedStageId(user.stage._id); setSelectedStageName(user.stage.name);
//       setShowDateTime(stagesWithDateTime.includes(user.stage.name));
//       if (!stagesWithDateTime.includes(user.stage.name)) setValueDate(null);
//       dispatch(GetOne_stagetogettype_Data(user.stage._id)).then(r => { if (r?.data) setStageType(r.data); }).catch(() => {});
//       if (!firstcomment.trim() && !secondcomment.trim()) {
//         const ac = generateAutoComments(user.stage.name);
//         setFirstComment(ac.firstComment); setSecondComment(ac.secondComment);
//       }
//       setIsNoAnswer(user.stage.name === 'No Answer');
//     } else resetStageForm();
//   }, [user?.stage, dispatch, generateAutoComments, stagesWithDateTime, resetStageForm, firstcomment, secondcomment]);

//   const handlePriceChange = useCallback(e => { const v = e.target.value.replace(/[^0-9.]/g, ''); setUnitPrice(v); }, []);
//   const handleUnitNumber = useCallback(e => setUnitNumber(e.target.value), []);
//   const handleCommissionRatioChange = useCallback(e => { const v = e.target.value.replace(/[^0-9.]/g, ''); setCommissionRatio(v); }, []);
//   const handleCashbackRatioChange = useCallback(e => { const v = e.target.value.replace(/[^0-9.]/g, ''); setCashbackRatio(v); }, []);
//   const handleReservationAmountChange = useCallback(e => { const v = e.target.value.replace(/[^0-9.]/g, ''); setReservationAmount(v); }, []);
//   const handleEoiAmountChange = useCallback(e => { const v = e.target.value.replace(/[^0-9.]/g, ''); setEoiAmount(v); }, []);

//   const handleDateTimeChange = useCallback((newValue) => {
//     if (newValue) {
//       setValueDate(newValue);
//       const fmt = moment(newValue.toDate()).format('MMMM Do YYYY, h:mm A');
//       const base = secondcomment.replace(/ - Follow up on .*$/, '').replace(/ - Scheduled for .*$/, '');
//       setSecondComment(base ? `${base} - Follow up on ${fmt}` : `Follow up on ${fmt}`);
//     }
//   }, [secondcomment]);

//   useEffect(() => {
//     const p = parseFloat(unitPrice), r = parseFloat(commissionRatio);
//     if (!isNaN(p) && !isNaN(r) && p > 0 && r > 0) setTotalCommission(((p * r) / 100).toFixed(2));
//     else setTotalCommission('');
//   }, [unitPrice, commissionRatio]);

//   useEffect(() => {
//     const r = parseFloat(cashbackratio), c = parseFloat(totalCommission);
//     if (!isNaN(r)) {
//       if (r === 0) setCashbackMoney('0');
//       else if (!isNaN(c) && c > 0) setCashbackMoney(((c * r) / 100).toFixed(2));
//       else setCashbackMoney('');
//     } else setCashbackMoney('');
//   }, [cashbackratio, totalCommission]);

//   const DoneDealFun = useCallback(() => {
//     const j = new JSConfetti();
//     j.addConfetti({ confettiColors: ['#C9A84C', '#E8C97A', '#34D399', '#60A5FA', '#F87171'] });
//   }, []);

//   const onsubmitdata = async (e) => {
//     e.preventDefault();
//     if (!firstcomment.trim()) return Notify('error', 'Please enter first comment', 'error');
//     if (!secondcomment.trim()) return Notify('error', 'Please enter second comment', 'error');
//     if (showDateTime && !valuedate) return Notify('error', 'Please select date & time', 'error');
//     if (!showDateTime && !valuedate) setValueDate(dayjs());
//     if (addActionEnabled && selectedStageId) {
//       if (selectedStageName === 'Reservation' && !reservationAmount) return Notify('error', 'Please enter Reservation amount', 'error');
//       if (selectedStageName === 'EOI') {
//         if (!eoiAmount || parseFloat(eoiAmount) <= 0) return Notify('error', 'Please enter a valid EOI amount', 'error');
//         if (!unitPrice || parseFloat(unitPrice) <= 0) return Notify('error', 'Please enter a valid unit price', 'error');
//         if (!unitnumber.trim()) return Notify('error', 'Please enter unit number', 'error');
//         if (!commissionRatio || parseFloat(commissionRatio) <= 0) return Notify('error', 'Please enter commission ratio', 'error');
//         if (cashbackratio === '' || cashbackratio < 0) return Notify('error', 'Please enter cashback ratio', 'error');
//       }
//       if (selectedStageName === 'Done Deal') {
//         if (!unitPrice || parseFloat(unitPrice) <= 0) return Notify('error', 'Please enter a valid unit price', 'error');
//         if (!unitnumber.trim()) return Notify('error', 'Please enter unit number', 'error');
//         if (!commissionRatio || parseFloat(commissionRatio) <= 0) return Notify('error', 'Please enter commission ratio', 'error');
//         if (cashbackratio === '' || cashbackratio < 0) return Notify('error', 'Please enter cashback ratio', 'error');
//       }
//     }
//     setLoading(true); setSendLoading(true);
//     try {
//       const finalDate = valuedate || dayjs();
//       if (addActionEnabled) {
//         const updateData = {
//           stage: selectedStageId, stagedateupdated: finalDate, last_stage_date_updated: moment().format('YYYY-MM-DD'),
//           ...((selectedStageName === 'Done Deal') && {
//             unit_price: parseFloat(unitPrice), review: false, unitnumber,
//             commissionratio: parseFloat(commissionRatio), commissionmoney: totalCommission,
//             cashbackratio: parseFloat(cashbackratio), cashbackmoney: cashbackMoney,
//           }),
//           ...((selectedStageName === 'EOI') && {
//             unit_price: parseFloat(unitPrice), review: false, unitnumber,
//             commissionratio: parseFloat(commissionRatio), commissionmoney: totalCommission,
//             cashbackratio: parseFloat(cashbackratio), cashbackmoney: cashbackMoney,
//             Eoi: parseFloat(eoiAmount),
//           }),
//           ...(selectedStageName === 'Reservation' && { Reservation: parseFloat(reservationAmount) }),
//         };
//         await dispatch(UpdateStageToLeed(user._id, updateData));
//         await dispatch(Insert_Lead_Stages_Data_Action({ LeadId: user._id, date: moment().format('YYYY-MM-DD'), stage: selectedStageId, sales: userlogin.data._id, dateselectedforstage: finalDate, ...((selectedStageName === 'Done Deal' || selectedStageName === 'EOI') && { unitPrice: parseFloat(unitPrice) }) }));
//         if (selectedStageName === 'Done Deal' || selectedStageName === 'EOI') DoneDealFun();
//       }
//       await dispatch(InsertNewAction_action({ sales: userlogin.data._id, text1: firstcomment, text2: secondcomment, date: finalDate, leed: user._id, username: userlogin.data._id, commentbysales: userlogin.data.name, stage: user?.stage?._id }));
//     } catch { Notify('error', 'Error sending data, please try again.', 'error'); }
//     finally { setLoading(false); setSendLoading(false); }
//   };

//   useEffect(() => {
//     if (!loading) {
//       if (resaddcomment?.status === 200) {
//         Notify('success', 'Comment added successfully!', 'success');
//         setFirstComment(''); setSecondComment('');
//         if (addActionEnabled) resetStageForm();
//         if (tabValue === 2) refreshComments();
//         if (onLeadUpdated) onLeadUpdated();
//       } else { Notify('error', 'Error adding comment', 'error'); }
//     }
//   }, [loading]);

//   const handleTabChange = useCallback((e, v) => {
//     setTabValue(v);
//     if (v === 2 && leadid && userloginrealy.current?.data?._id) getallactiondata(1);
//   }, [leadid, getallactiondata]);

//   const handleClose = useCallback(() => {
//     if (onClose) onClose();
//     else { setOpen(false); setAddActionEnabled(false); resetStageForm(); }
//   }, [onClose, resetStageForm]);

//   /* ════════════════════════════════════════════════════
//      RENDER
//   ════════════════════════════════════════════════════ */
//   return (
//     <>
//       <Dialog
//         open={open}
//         onClose={handleClose}
//         maxWidth={false}
//         fullWidth
//         sx={{
//           zIndex: 50000,
//           '& .MuiDialog-paper': {
//             width: { xs: '100vw', sm: '92vw', md: '88vw', lg: 1100 },
//             maxWidth: '96vw',
//             maxHeight: '92vh',
//             background: T.bg1,
//             display: 'flex',
//             flexDirection: 'column',
//             overflow: 'hidden',
//             borderRadius: 3,
//             boxShadow: '0 24px 80px rgba(0,0,0,0.25)',
//             m: { xs: 1, sm: 2 },
//           },
//           '& .MuiBackdrop-root': {
//             background: 'rgba(0,0,0,0.4)',
//             backdropFilter: 'blur(3px)',
//           },
//         }}
//       >
//         {/* ── HEADER ── */}
//         <Box sx={{
//           px: 3, py: 2,
//           background: `linear-gradient(135deg, ${T.bg2} 0%, ${T.bg3} 100%)`,
//           borderBottom: `1px solid ${T.bdr}`,
//           display: 'flex', alignItems: 'center', justifyContent: 'space-between',
//           flexShrink: 0,
//         }}>
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//             <Box sx={{ position: 'relative' }}>
//               <Box sx={{
//                 position: 'absolute', inset: -2, borderRadius: '50%',
//                 background: `conic-gradient(from 0deg, ${T.gold}, ${T.goldL}, ${T.gold})`,
//                 animation: 'spin 6s linear infinite',
//                 '@keyframes spin': { '100%': { transform: 'rotate(360deg)' } },
//               }} />
//               <Avatar sx={{ width: 44, height: 44, fontSize: 16, fontWeight: 700, bgcolor: T.bg4, border: `2px solid ${T.bg1}`, color: T.gold, fontFamily: "'DM Sans', sans-serif", position: 'relative', zIndex: 1 }}>
//                 {user?.name?.charAt(0)?.toUpperCase()}
//               </Avatar>
//             </Box>
//             <Box>
//               <Typography sx={{ fontSize: 16, fontWeight: 600, color: T.txtPri, fontFamily: "'DM Sans', sans-serif", letterSpacing: '0.03em', lineHeight: 1.2 }}>{user?.name}</Typography>
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
//                 <Typography sx={{ fontSize: 11, color: T.txtMut, fontFamily: "'DM Sans', sans-serif" }}>{user?.sales?.name}</Typography>
//                 <Box sx={{ width: 3, height: 3, borderRadius: '50%', bgcolor: T.txtMut }} />
//                 <StagePill name={selectedStageName || user?.stage?.name} />
//               </Box>
//             </Box>
//           </Box>
//           <IconButton onClick={handleClose} sx={{ color: T.txtSec, bgcolor: T.bg4, borderRadius: 2, '&:hover': { bgcolor: T.bg3, color: T.txtPri } }}>
//             <CloseIcon sx={{ fontSize: 18 }} />
//           </IconButton>
//         </Box>

//         {/* ── TABS ── */}
//         <Box sx={{ px: 3, pt: 0.5, borderBottom: `1px solid ${T.bdr2}`, bgcolor: T.bg1, flexShrink: 0 }}>
//           <Tabs
//             value={tabValue} onChange={handleTabChange}
//             sx={{
//               minHeight: 44,
//               '& .MuiTabs-indicator': { background: `linear-gradient(90deg, ${T.gold}, ${T.goldL})`, height: 2, borderRadius: 1 },
//               '& .MuiTab-root': { color: T.txtMut, fontFamily: "'DM Sans', sans-serif", fontSize: 12, fontWeight: 500, textTransform: 'none', minHeight: 44, letterSpacing: '0.03em', transition: 'color 0.2s', '&.Mui-selected': { color: T.gold, fontWeight: 700 } },
//             }}
//           >
//             <Tab icon={<InfoIcon sx={{ fontSize: 14 }} />} iconPosition="start" label="Information" />
//             <Tab icon={<AddCommentIcon sx={{ fontSize: 14 }} />} iconPosition="start" label="Add Comment" />
//             <Tab icon={<CommentIcon sx={{ fontSize: 14 }} />} iconPosition="start" label={`Comments${totalCommentsCount > 0 ? ` (${totalCommentsCount})` : ''}`} />
//           </Tabs>
//         </Box>

//         {/* ── CONTENT ── */}
//         <Box sx={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column', bgcolor: T.bg1 }}>

//           {/* ════ TAB 0: INFORMATION ════ */}
//           <TabPanel value={tabValue} index={0}>
//             <Grid container spacing={3}>
//               <Grid item xs={12} md={6}>
//                 <GlassCard bordered sx={{ p: 2.5, height: '100%' }}>
//                   <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
//                     <Typography sx={{ fontSize: 11, color: T.txtPri, fontFamily: "'DM Sans', sans-serif", fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em' }}>Lead Details</Typography>
//                     <Box sx={{ display: 'flex', gap: 0.5 }}>
//                       <Tooltip title="Preview">
//                         <IconButton size="small" onClick={() => setOpenLeadPreview(true)} sx={{ color: T.txtSec, bgcolor: T.bg1, borderRadius: 1.5, width: 28, height: 28, '&:hover': { color: T.gold } }}>
//                           <VisibilityIcon sx={{ fontSize: 14 }} />
//                         </IconButton>
//                       </Tooltip>
//                       {!['Sales', 'Team Leader'].includes(userlogin?.data?.role) && (
//                         <Tooltip title="Edit Lead">
//                           <IconButton size="small" component={Link} to={`/updateclient/${user._id}`} sx={{ color: T.txtSec, bgcolor: T.bg1, borderRadius: 1.5, width: 28, height: 28, '&:hover': { color: T.gold } }}>
//                             <EditIcon sx={{ fontSize: 14 }} />
//                           </IconButton>
//                         </Tooltip>
//                       )}
//                     </Box>
//                   </Box>
//                   <InfoRow icon={PersonIcon} label="Lead Name" value={user?.name} />
//                   <InfoRow icon={WorkIcon} label="Sales Person" value={user?.sales?.name} accent={T.gold} />
//                   <InfoRow icon={PhoneIcon} label="Phone" value={
//                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                       <Typography sx={{ fontSize: 14, color: T.txtPri, fontFamily: "'DM Sans', sans-serif" }}>{user?.phone}</Typography>
//                       <IconButton size="small" onClick={() => window.open(`https://wa.me/${user?.phone}`, '_blank')} sx={{ color: T.success, p: 0.3, bgcolor: 'rgba(52,211,153,0.08)', borderRadius: 1 }}>
//                         <WhatsAppIcon sx={{ fontSize: 14 }} />
//                       </IconButton>
//                     </Box>
//                   } />
//                   {user?.phonenumber2 && <InfoRow icon={PhoneIcon} label="Phone 2" value={user.phonenumber2} />}
//                   <InfoRow icon={EmailIcon} label="Email" value={user?.email} />
//                   <InfoRow icon={WorkIcon} label="Developer" value={user?.project?.developer?.name} />
//                   <InfoRow icon={InfoIcon} label="Project" value={user?.project?.name} accent={T.info} />
//                   {user?.notes && <InfoRow icon={EditIcon} label="Notes" value={user.notes} />}
//                   {(userlogin?.data?.role !== 'Sales' && userlogin?.data?.role !== 'Team Leader') || !user?.resetcreationdate ? (
//                     <InfoRow icon={CalendarIcon} label="Created" value={moment(user?.createdAt).format('DD MMM YYYY')} />
//                   ) : null}
//                 </GlassCard>
//               </Grid>

//               <Grid item xs={12} md={6}>
//                 <GlassCard sx={{ p: 2.5, mb: 2 }}>
//                   <Typography sx={{ fontSize: 11, color: T.txtPri, fontFamily: "'DM Sans', sans-serif", fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em', mb: 2 }}>Current Stage</Typography>
//                   <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//                     <Box sx={{ width: 50, height: 50, borderRadius: 12, bgcolor: `${stageColor(user?.stage?.name)}15`, border: `1px solid ${stageColor(user?.stage?.name)}40`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                       <Box sx={{ width: 14, height: 14, borderRadius: '50%', bgcolor: stageColor(user?.stage?.name), boxShadow: `0 0 8px ${stageColor(user?.stage?.name)}` }} />
//                     </Box>
//                     <Box>
//                       <StagePill name={user?.stage?.name} size="large" />
//                       {user?.stagedateupdated && <Typography sx={{ fontSize: 11, color: T.txtMut, fontFamily: "'DM Sans', sans-serif", mt: 0.5 }}>{moment(user.stagedateupdated).format('DD MMM YYYY, HH:mm')}</Typography>}
//                     </Box>
//                   </Box>
//                 </GlassCard>

//                 {user?.campaignRedirectLink && (
//                   <GlassCard sx={{ p: 2.5, mb: 2 }}>
//                     <Typography sx={{ fontSize: 11, color: T.gold, fontFamily: "'DM Sans', sans-serif", fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em', mb: 1.5 }}>Campaign Link</Typography>
//                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, p: 1.5, borderRadius: 2, bgcolor: T.bg4, border: `1px solid ${T.bdr2}` }}>
//                       <Box sx={{ width: 32, height: 32, borderRadius: 8, bgcolor: T.goldSoft, border: `1px solid ${T.bdr}`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
//                         <LinkIcon sx={{ fontSize: 14, color: T.gold }} />
//                       </Box>
//                       <Typography sx={{ flex: 1, fontSize: 12, color: T.info, fontFamily: "'DM Sans', sans-serif", wordBreak: 'break-all', lineHeight: 1.4 }}>
//                         <a href={user.campaignRedirectLink} target="_blank" rel="noopener noreferrer" style={{ color: 'inherit' }}>{user.campaignRedirectLink}</a>
//                       </Typography>
//                       <IconButton size="small" onClick={() => window.open(user.campaignRedirectLink, '_blank')} sx={{ color: T.gold, bgcolor: T.goldSoft, borderRadius: 1.5, width: 28, height: 28, flexShrink: 0 }}>
//                         <OpenInNewIcon sx={{ fontSize: 13 }} />
//                       </IconButton>
//                     </Box>
//                   </GlassCard>
//                 )}

//                 {[1, 2, 3, 4, 5].some(n => user?.[`question${n}_text`] || user?.[`question${n}_answer`]) && (
//                   <GlassCard sx={{ p: 2.5 }}>
//                     <Typography sx={{ fontSize: 11, color: T.gold, fontFamily: "'DM Sans', sans-serif", fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em', mb: 2 }}>Campaign Q&A</Typography>
//                     {[1, 2, 3, 4, 5].map(num => {
//                       const q = user?.[`question${num}_text`], a = user?.[`question${num}_answer`];
//                       if (!q && !a) return null;
//                       return (
//                         <Box key={num} sx={{ mb: 1.5, p: 1.5, borderRadius: 2, bgcolor: T.bg4, borderLeft: `3px solid ${T.gold}` }}>
//                           {q && <Typography sx={{ fontSize: 12, color: T.txtSec, fontFamily: "'DM Sans', sans-serif", mb: 0.5, fontStyle: 'italic' }}>{q}</Typography>}
//                           {a && <Typography sx={{ fontSize: 13, color: T.txtPri, fontFamily: "'DM Sans', sans-serif", fontWeight: 500 }}>{a}</Typography>}
//                         </Box>
//                       );
//                     })}
//                   </GlassCard>
//                 )}
//               </Grid>
//             </Grid>
//           </TabPanel>

//           {/* ════ TAB 1: ADD COMMENT ════ */}
//           <TabPanel value={tabValue} index={1}>
//             <Box sx={{ display: 'flex', gap: 1.5, mb: 3 }}>
//               <OutlineBtn size="small" active={!isNoAnswer} startIcon={<PhoneInTalkIcon sx={{ fontSize: 14 }} />} onClick={() => { setIsNoAnswer(false); setFirstComment(''); setSecondComment(''); }}>
//                 Answer
//               </OutlineBtn>
//               <OutlineBtn size="small" danger active={isNoAnswer} startIcon={<CancelIcon sx={{ fontSize: 14 }} />} onClick={() => { setIsNoAnswer(true); setFirstComment('اتصلت ومفيش رد'); setSecondComment('هحاول تاني في وقت تاني'); }}>
//                 No Answer
//               </OutlineBtn>
//             </Box>

//             <GlassCard bordered sx={{ p: 2.5, mb: 3 }}>
//               <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//                 <Box>
//                   <Typography sx={{ fontSize: 13, fontWeight: 600, color: T.txtPri, fontFamily: "'DM Sans', sans-serif" }}>Stage Management</Typography>
//                   <Typography sx={{ fontSize: 11, color: T.txtMut, fontFamily: "'DM Sans', sans-serif", mt: 0.3 }}>Enable to change the lead stage</Typography>
//                 </Box>
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
//                   {addActionEnabled && <Typography sx={{ fontSize: 11, color: T.success, fontFamily: "'DM Sans', sans-serif", fontWeight: 600 }}>✓ Active</Typography>}
//                   <Switch
//                     checked={addActionEnabled}
//                     onChange={e => handleEnableActionToggle(e.target.checked)}
//                     sx={{ '& .MuiSwitch-switchBase.Mui-checked': { color: T.gold }, '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { bgcolor: T.goldD } }}
//                   />
//                 </Box>
//               </Box>

//               {addActionEnabled && (
//                 <Box sx={{ mt: 2, pt: 2, borderTop: `1px solid ${T.bdr2}`, display: 'flex', alignItems: 'center', gap: 1.5 }}>
//                   <Typography sx={{ fontSize: 11, color: T.txtMut, fontFamily: "'DM Sans', sans-serif" }}>Current:</Typography>
//                   <StagePill name={user?.stage?.name} />
//                   <Box sx={{ fontSize: 18, lineHeight: 1 }}>→</Box>
//                   <Typography sx={{ fontSize: 11, color: T.txtMut, fontFamily: "'DM Sans', sans-serif" }}>Change to:</Typography>
//                 </Box>
//               )}
//             </GlassCard>

//             <Collapse in={addActionEnabled} timeout={400}>
//               <Box sx={{ mb: 3 }}>

//                 {/* ══ Stage Selector — dropdown يفتح تحته مباشرة ══ */}
//                 <Box sx={{ position: 'relative', mb: 2 }}>
//                   {/* الزرار اللي بيفتح الـ dropdown */}
//                   <Box
//                     onClick={() => setStageDropdownOpen(prev => !prev)}
//                     sx={{
//                       display: 'flex', alignItems: 'center', justifyContent: 'space-between',
//                       p: 1.8,
//                       borderRadius: stageDropdownOpen ? '12px 12px 0 0' : '12px',
//                       border: `1px solid ${selectedStage ? T.gold : stageDropdownOpen ? T.gold : T.bdr2}`,
//                       borderBottom: stageDropdownOpen ? `1px solid transparent` : undefined,
//                       background: selectedStage ? T.goldSoft : T.bg1,
//                       cursor: 'pointer',
//                       transition: 'all 0.2s',
//                       userSelect: 'none',
//                       '&:hover': {
//                         border: `1px solid ${T.gold}`,
//                         borderBottom: stageDropdownOpen ? `1px solid transparent` : undefined,
//                         background: T.goldSoft,
//                       },
//                     }}
//                   >
//                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
//                       {selectedStage ? (
//                         <>
//                           <Box sx={{
//                             width: 32, height: 32, borderRadius: '50%',
//                             bgcolor: avatarColor(selectedStage.name),
//                             display: 'flex', alignItems: 'center', justifyContent: 'center',
//                             fontSize: 12, fontWeight: 700, color: '#fff',
//                             fontFamily: "'DM Sans', sans-serif", flexShrink: 0,
//                           }}>
//                             {selectedStage.name.slice(0, 2).toUpperCase()}
//                           </Box>
//                           <Box>
//                             <Typography sx={{ fontSize: 14, fontWeight: 600, color: T.txtPri, fontFamily: "'DM Sans', sans-serif", lineHeight: 1.2 }}>
//                               {selectedStage.name}
//                             </Typography>
//                             <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.2 }}>
//                               <Box sx={{ width: 5, height: 5, borderRadius: '50%', bgcolor: stageColor(selectedStage.name) }} />
//                               <Typography sx={{ fontSize: 10, color: stageColor(selectedStage.name), fontWeight: 600, fontFamily: "'DM Sans', sans-serif", textTransform: 'uppercase', letterSpacing: '0.04em' }}>
//                                 STAGE
//                               </Typography>
//                             </Box>
//                           </Box>
//                         </>
//                       ) : (
//                         <>
//                           <Box sx={{ width: 32, height: 32, borderRadius: '50%', bgcolor: T.bg4, border: `1px dashed ${T.bdr}`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                             <ChangeCircleIcon sx={{ fontSize: 16, color: T.txtMut }} />
//                           </Box>
//                           <Box>
//                             <Typography sx={{ fontSize: 14, color: T.txtMut, fontFamily: "'DM Sans', sans-serif" }}>Select New Stage</Typography>
//                             <Typography sx={{ fontSize: 11, color: T.txtMut, fontFamily: "'DM Sans', sans-serif", opacity: 0.7 }}>Tap to choose</Typography>
//                           </Box>
//                         </>
//                       )}
//                     </Box>

//                     {/* السهم يتقلب لما الـ dropdown يفتح */}
//                     <KeyboardArrowDownIcon sx={{
//                       fontSize: 20,
//                       color: selectedStage ? T.gold : T.txtMut,
//                       transition: 'transform 0.2s',
//                       transform: stageDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)',
//                     }} />
//                   </Box>

//                   {/* الـ Dropdown نفسه */}
//                   <StageDropdown
//                     open={stageDropdownOpen}
//                     onClose={() => setStageDropdownOpen(false)}
//                     stages={allstagesshow}
//                     selectedStage={selectedStage}
//                     onSelect={handleStageChange}
//                   />
//                 </Box>
//                 {/* ══ نهاية Stage Selector ══ */}

//                 {selectedStage?.Comment && (
//                   <Box sx={{ mb: 2, p: 1.5, borderRadius: 2, bgcolor: T.goldSoft, border: `1px solid ${T.bdr}`, display: 'flex', alignItems: 'flex-start', gap: 1 }}>
//                     <InfoIcon sx={{ fontSize: 14, color: T.gold, mt: 0.2 }} />
//                     <Box>
//                       <Typography sx={{ fontSize: 10, color: T.gold, fontFamily: "'DM Sans', sans-serif", fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em' }}>Stage Note</Typography>
//                       <Typography sx={{ fontSize: 12, color: T.txtPri, fontFamily: "'DM Sans', sans-serif" }}>{selectedStage.Comment}</Typography>
//                     </Box>
//                   </Box>
//                 )}

//                 {/* DateTime picker */}
//                 {showDateTime && (
//                   <GlassCard sx={{ p: 2.5, mb: 2 }}>
//                     <Typography sx={{ fontSize: 11, color: T.warning, fontFamily: "'DM Sans', sans-serif", fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em', mb: 2, display: 'flex', alignItems: 'center', gap: 0.8 }}>
//                       <ScheduleIcon sx={{ fontSize: 13 }} /> Schedule Next Action
//                     </Typography>
//                     <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 2 }}>
//                       {[
//                         { label: '+1h', fn: () => { const t = dayjs().add(1, 'hour'); setValueDate(t); handleDateTimeChange(t); } },
//                         { label: '+2h', fn: () => { const t = dayjs().add(2, 'hour'); setValueDate(t); handleDateTimeChange(t); } },
//                         { label: '+3h', fn: () => { const t = dayjs().add(3, 'hour'); setValueDate(t); handleDateTimeChange(t); } },
//                         { label: 'Tom 11AM', fn: () => { const t = dayjs().add(1, 'day').hour(11).minute(0).second(0); setValueDate(t); handleDateTimeChange(t); } },
//                         { label: 'In 2 days', fn: () => { const t = dayjs().add(2, 'day').hour(11).minute(0).second(0); setValueDate(t); handleDateTimeChange(t); } },
//                       ].map(btn => (
//                         <Box key={btn.label} onClick={btn.fn} sx={{ px: 1.5, py: 0.8, borderRadius: 8, border: `1px solid ${T.bdr}`, fontSize: 11, color: T.txtSec, fontFamily: "'DM Sans', sans-serif", cursor: 'pointer', transition: 'all 0.15s', bgcolor: T.bg4, '&:hover': { border: `1px solid ${T.gold}`, color: T.gold, bgcolor: T.goldSoft } }}>
//                           {btn.label}
//                         </Box>
//                       ))}
//                     </Box>
//                     <LocalizationProvider dateAdapter={AdapterDayjs}>
//                       <MobileDateTimePicker
//                         label="Select Date & Time"
//                         value={valuedate}
//                         onChange={handleDateTimeChange}
//                         ampm={true}
//                         slotProps={{
//                           textField: {
//                             fullWidth: true,
//                             sx: {
//                               '& .MuiOutlinedInput-root': { background: T.bg1, color: T.txtPri, borderRadius: 2, fontFamily: "'DM Sans', sans-serif", '& fieldset': { borderColor: T.bdr2 }, '&:hover fieldset': { borderColor: T.bdr }, '&.Mui-focused fieldset': { borderColor: T.gold, borderWidth: 1 } },
//                               '& .MuiInputLabel-root': { color: T.txtMut },
//                               '& .MuiInputLabel-root.Mui-focused': { color: T.gold },
//                               '& .MuiSvgIcon-root': { color: T.txtSec },
//                             },
//                           },
//                           dialog: {
//                             sx: { zIndex: 70000 },
//                           },
//                           mobilePaper: {
//                             sx: { background: T.bg2, border: `1px solid ${T.bdr}`, borderRadius: 3 },
//                           },
//                         }}
//                       />
//                     </LocalizationProvider>
//                   </GlassCard>
//                 )}

//                 <StageSpecificForm
//                   selectedStageName={selectedStageName}
//                   eoiAmount={eoiAmount} reservationAmount={reservationAmount}
//                   onEoiAmountChange={handleEoiAmountChange} onReservationAmountChange={handleReservationAmountChange}
//                   unitPrice={unitPrice} unitnumber={unitnumber}
//                   commissionRatio={commissionRatio} cashbackratio={cashbackratio}
//                   totalCommission={totalCommission} cashbackMoney={cashbackMoney}
//                   onPriceChange={handlePriceChange} onUnitNumberChange={handleUnitNumber}
//                   onCommissionRatioChange={handleCommissionRatioChange} onCashbackRatioChange={handleCashbackRatioChange}
//                 />
//               </Box>
//             </Collapse>

//             <GlassCard sx={{ p: 2.5, mb: 3 }}>
//               <Typography sx={{ fontSize: 11, color: T.txtPri, fontFamily: "'DM Sans', sans-serif", fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em', mb: 2 }}>Comments</Typography>
//               <Grid container spacing={2}>
//                 <Grid item xs={12}>
//                   <DarkTextField fullWidth multiline rows={3} label="What happened? (First comment)" value={firstcomment} onChange={e => setFirstComment(e.target.value)} placeholder="Describe the conversation, meeting, or interaction…" required />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <DarkTextField fullWidth multiline rows={3} label="Next Action Plan (Second comment)" value={secondcomment} onChange={e => setSecondComment(e.target.value)} placeholder="What's the next step? When will you follow up?" required />
//                 </Grid>
//               </Grid>
//             </GlassCard>

//             {(!firstcomment.trim() || !secondcomment.trim()) && (
//               <Box sx={{ mb: 2, p: 1.5, borderRadius: 2, bgcolor: 'rgba(251,191,36,0.08)', border: `1px solid rgba(251,191,36,0.3)`, display: 'flex', alignItems: 'center', gap: 1 }}>
//                 <WarningIcon sx={{ fontSize: 14, color: T.warning }} />
//                 <Typography sx={{ fontSize: 12, color: T.warning, fontFamily: "'DM Sans', sans-serif" }}>Please fill in both comment fields before submitting</Typography>
//               </Box>
//             )}

//             <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
//               <GoldButton onClick={onsubmitdata} disabled={sendloading}
//                 startIcon={sendloading ? null : (selectedStageName === 'Done Deal' || selectedStageName === 'EOI') ? <CheckCircleIcon sx={{ fontSize: 16 }} /> : <SendIcon sx={{ fontSize: 16 }} />}
//                 endIcon={sendloading ? <CircularProgress size={14} color="inherit" /> : null}>
//                 {sendloading ? 'Submitting…' : selectedStageName === 'Done Deal' ? '🎉 Complete Deal & Add Comment' : selectedStageName === 'EOI' ? '📝 Add EOI & Comment' : 'Add Comment'}
//               </GoldButton>
//             </Box>
//           </TabPanel>

//           {/* ════ TAB 2: ALL COMMENTS ════ */}
//           <TabPanel value={tabValue} index={2}>
//             <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3 }}>
//               <Box>
//                 <Typography sx={{ fontSize: 14, fontWeight: 600, color: T.txtPri, fontFamily: "'DM Sans', sans-serif" }}>All Comments</Typography>
//                 <Typography sx={{ fontSize: 11, color: T.txtMut, fontFamily: "'DM Sans', sans-serif" }}>{totalCommentsCount} total · Page {currentPage} of {totalPages}</Typography>
//               </Box>
//               <Box sx={{ display: 'flex', gap: 1 }}>
//                 <Tooltip title="Refresh">
//                   <IconButton size="small" onClick={() => getallactiondata(1)} disabled={isCommentsLoading} sx={{ color: T.txtSec, bgcolor: T.bg4, borderRadius: 1.5, width: 32, height: 32, '&:hover': { color: T.gold } }}>
//                     {isCommentsLoading ? <CircularProgress size={14} sx={{ color: T.gold }} /> : <RefreshIcon sx={{ fontSize: 16 }} />}
//                   </IconButton>
//                 </Tooltip>
//                 <OutlineBtn size="small" startIcon={<AddIcon sx={{ fontSize: 13 }} />} onClick={() => setTabValue(1)}>New Comment</OutlineBtn>
//               </Box>
//             </Box>

//             {filterInfo?.applied === 'filtered_by_date' && (
//               <Box sx={{ mb: 2, p: 1.5, borderRadius: 2, bgcolor: 'rgba(96,165,250,0.08)', border: `1px solid rgba(96,165,250,0.2)`, display: 'flex', alignItems: 'center', gap: 1 }}>
//                 <InfoIcon sx={{ fontSize: 14, color: T.info }} />
//                 <Typography sx={{ fontSize: 12, color: T.info, fontFamily: "'DM Sans', sans-serif" }}>
//                   Showing comments after assignment: {moment(filterInfo.assignmentInfo?.assignDateTime).format('DD/MM/YYYY hh:mm A')}
//                 </Typography>
//               </Box>
//             )}

//             {isCommentsLoading ? (
//               <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 10 }}>
//                 <Box sx={{ textAlign: 'center' }}>
//                   <CircularProgress sx={{ color: T.gold }} size={32} />
//                   <Typography sx={{ fontSize: 12, color: T.txtMut, fontFamily: "'DM Sans', sans-serif", mt: 1.5 }}>Loading comments…</Typography>
//                 </Box>
//               </Box>
//             ) : comments?.length > 0 ? (
//               <Box>
//                 {[...comments].sort((a, b) => new Date(b.stageDate) - new Date(a.stageDate)).map((comment, idx) => (
//                   <GlassCard key={comment._id || idx} sx={{ p: 0, mb: 2, overflow: 'hidden' }}>
//                     <Box sx={{ px: 2.5, py: 1.5, display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: `1px solid ${T.bdr2}`, bgcolor: T.bg3 }}>
//                       <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
//                         <Avatar src={comment.sales?.profileImg} sx={{ width: 30, height: 30, fontSize: 12, bgcolor: T.bg4, border: `1px solid ${T.bdr}`, color: T.gold }}>
//                           {comment.sales?.name?.charAt(0)}
//                         </Avatar>
//                         <Box>
//                           <Typography sx={{ fontSize: 13, fontWeight: 600, color: T.txtPri, fontFamily: "'DM Sans', sans-serif", lineHeight: 1.2 }}>{comment.sales?.name}</Typography>
//                           <Typography sx={{ fontSize: 10, color: T.txtMut, fontFamily: "'DM Sans', sans-serif" }}>{moment(comment.stageDate).format('DD MMM YYYY, HH:mm')}</Typography>
//                         </Box>
//                       </Box>
//                       {comment.stage && <StagePill name={comment.stage.name} />}
//                     </Box>
//                     <Box sx={{ px: 2.5, py: 2 }}>
//                       {comment.firstcomment?.text && (
//                         <Box sx={{ mb: 2 }}>
//                           <Typography sx={{ fontSize: 10, color: T.gold, fontFamily: "'DM Sans', sans-serif", fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', mb: 0.8 }}>Comment</Typography>
//                           <Box sx={{ p: 1.5, borderRadius: 2, bgcolor: T.bg1, borderLeft: `2px solid ${T.gold}` }}>
//                             <Typography sx={{ fontSize: 13, color: T.txtPri, fontFamily: "'DM Sans', sans-serif", lineHeight: 1.6, whiteSpace: 'pre-wrap' }}>{comment.firstcomment.text}</Typography>
//                           </Box>
//                         </Box>
//                       )}
//                       {comment.secondcomment?.text && (
//                         <Box>
//                           <Typography sx={{ fontSize: 10, color: T.info, fontFamily: "'DM Sans', sans-serif", fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', mb: 0.8 }}>Next Plan</Typography>
//                           <Box sx={{ p: 1.5, borderRadius: 2, bgcolor: T.bg1, borderLeft: `2px solid ${T.info}` }}>
//                             <Typography sx={{ fontSize: 13, color: T.txtSec, fontFamily: "'DM Sans', sans-serif", lineHeight: 1.6, whiteSpace: 'pre-wrap' }}>{comment.secondcomment.text}</Typography>
//                           </Box>
//                         </Box>
//                       )}
//                       <CommentReplies comment={comment} currentUserId={userloginrealy.current?.data?._id} onReplyAdded={refreshComments} />
//                     </Box>
//                   </GlassCard>
//                 ))}

//                 {totalPages > 1 && (
//                   <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2, mt: 3 }}>
//                     <OutlineBtn size="small" disabled={!hasPrev || isCommentsLoading} onClick={() => getallactiondata(currentPage - 1)} startIcon={<KeyboardArrowUpIcon sx={{ fontSize: 14 }} />}>Prev</OutlineBtn>
//                     <Typography sx={{ fontSize: 12, color: T.txtSec, fontFamily: "'DM Sans', sans-serif" }}>{currentPage} / {totalPages}</Typography>
//                     <OutlineBtn size="small" disabled={!hasNext || isCommentsLoading} onClick={() => getallactiondata(currentPage + 1)} endIcon={<KeyboardArrowDownIcon sx={{ fontSize: 14 }} />}>Next</OutlineBtn>
//                   </Box>
//                 )}
//               </Box>
//             ) : (
//               <Box sx={{ textAlign: 'center', py: 10 }}>
//                 <Box sx={{ width: 60, height: 60, borderRadius: '50%', bgcolor: T.bg4, border: `1px solid ${T.bdr}`, display: 'flex', alignItems: 'center', justifyContent: 'center', mx: 'auto', mb: 2 }}>
//                   <CommentIcon sx={{ fontSize: 24, color: T.txtMut }} />
//                 </Box>
//                 <Typography sx={{ fontSize: 15, fontWeight: 600, color: T.txtSec, fontFamily: "'DM Sans', sans-serif", mb: 1 }}>No Comments Yet</Typography>
//                 <Typography sx={{ fontSize: 12, color: T.txtMut, fontFamily: "'DM Sans', sans-serif", mb: 3 }}>
//                   {filterInfo?.applied === 'filtered_by_date' ? 'Only comments after assignment date are shown' : 'Start by adding the first comment'}
//                 </Typography>
//                 <GoldButton size="small" startIcon={<AddIcon sx={{ fontSize: 14 }} />} onClick={() => setTabValue(1)} sx={{ fontSize: 12, py: '8px', px: '18px' }}>
//                   Add First Comment
//                 </GoldButton>
//               </Box>
//             )}
//           </TabPanel>
//         </Box>
//       </Dialog>

//       {/* ── LEAD PREVIEW DIALOG ── */}
//       <Dialog open={openLeadPreview} onClose={() => setOpenLeadPreview(false)} maxWidth="sm" fullWidth sx={{ zIndex: 65000 }}
//         PaperProps={{ sx: { background: T.bg1, border: `1px solid ${T.bdr}`, borderRadius: 3 } }}>
//         <DialogTitle sx={{ pb: 1 }}>
//           <Typography sx={{ fontSize: 15, fontWeight: 600, color: T.txtPri, fontFamily: "'DM Sans', sans-serif" }}>Lead Preview</Typography>
//         </DialogTitle>
//         <DialogContent>
//           <Grid container spacing={2}>
//             {[['Name', user?.name], ['Phone', user?.phone], ['Email', user?.email || 'N/A'], ['Stage', null, <StagePill name={user?.stage?.name} />], ['Project', user?.project?.name]].map(([label, value, custom]) => (
//               <Grid item xs={6} key={label}>
//                 <Typography sx={{ fontSize: 10, color: T.txtMut, fontFamily: "'DM Sans', sans-serif", textTransform: 'uppercase', letterSpacing: '0.06em', mb: 0.5 }}>{label}</Typography>
//                 {custom || <Typography sx={{ fontSize: 13, color: T.txtPri, fontFamily: "'DM Sans', sans-serif", fontWeight: 500 }}>{value}</Typography>}
//               </Grid>
//             ))}
//             {userlogin?.data?.role === 'Admin' && ['Done Deal', 'EOI'].includes(user?.stage?.name) && (
//               [['Unit #', user?.unitnumber], ['Unit Price', user?.unit_price], ['Commission %', user?.commissionratio], ['Commission AED', user?.commissionmoney], ['Cashback %', user?.cashbackratio], ['Cashback AED', user?.cashbackmoney]].map(([l, v]) => (
//                 <Grid item xs={6} key={l}>
//                   <Typography sx={{ fontSize: 10, color: T.txtMut, fontFamily: "'DM Sans', sans-serif", textTransform: 'uppercase', letterSpacing: '0.06em', mb: 0.5 }}>{l}</Typography>
//                   <Typography sx={{ fontSize: 13, color: T.gold, fontFamily: "'DM Sans', sans-serif", fontWeight: 600 }}>{v}</Typography>
//                 </Grid>
//               ))
//             )}
//           </Grid>
//         </DialogContent>
//         <DialogActions sx={{ px: 3, pb: 2 }}>
//           <GoldButton size="small" onClick={() => setOpenLeadPreview(false)} sx={{ fontSize: 12, py: '7px', px: '18px' }}>Close</GoldButton>
//         </DialogActions>
//       </Dialog>
//     </>
//   );
// };












import React, { useEffect, useMemo, useState, useCallback, useRef } from 'react';
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import LinkIcon from '@mui/icons-material/Link';
import {
  Box, Typography, Avatar,
  IconButton, Button, Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Switch,
  Tooltip, CircularProgress, Grid,
  Tabs, Tab, styled, InputAdornment, Paper, Fade,
  Collapse, LinearProgress,
} from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import {
  Close as CloseIcon, Person as PersonIcon, Phone as PhoneIcon,
  WhatsApp as WhatsAppIcon, Email as EmailIcon, Work as WorkIcon,
  CalendarToday as CalendarIcon, Comment as CommentIcon, AddComment as AddCommentIcon,
  Info as InfoIcon, Add as AddIcon, Refresh as RefreshIcon, Visibility as VisibilityIcon,
  Edit as EditIcon, Send as SendIcon, CheckCircle as CheckCircleIcon, Warning as WarningIcon,
  PhoneInTalk as PhoneInTalkIcon, AttachMoney as AttachMoneyIcon, Cancel as CancelIcon,
  ChangeCircle as ChangeCircleIcon, Schedule as ScheduleIcon,
  KeyboardArrowDown as KeyboardArrowDownIcon, KeyboardArrowUp as KeyboardArrowUpIcon,
  Search as SearchIcon, FilterList as FilterListIcon, Assessment as AssessmentIcon,
} from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import dayjs from 'dayjs';
import JSConfetti from 'js-confetti';

import {
  GetAllcomments_Data_With_Pagination_action_advanced,
  InsertNewAction_action,
  Insert_Comment_Replay_Action,
} from '../Redux/Actions/Action_action';
import { UpdateStageToLeed } from '../Redux/Actions/UsersAction';
import { GetAll_stage_Data, GetOne_stagetogettype_Data } from '../Redux/Actions/Stage_Action';
import { Insert_Lead_Stages_Data_Action } from '../Redux/Actions/Lead_Stages_Changed_Action';
import { Notify } from '../Utility/Notify';

/* ═══════════════════════════════════════════════════════════════
   Z-INDEX NOTE
   ─────────────────────────────────────────────────────────────
   هذا الـ component ممكن يفتح من جوه modal تاني (زي LeadDuplicationModal
   اللي الـ overlay بتاعه z-index: 99999). عشان كذا رفعنا كل الـ z-index
   هنا فوق 100000 بدل القيم القديمة (50000 / 59999 / 60000 / 65000 / 70000)
   عشان يفضل دايمًا ظاهر فوق أي modal تاني بيفتحه.
═══════════════════════════════════════════════════════════════ */
const Z = {
  dialog:        100001,
  dropdownMask:  100002,
  dropdownPanel: 100003,
  datePicker:    100004,
  preview:       100005,
};

/* ═══════════════════════════════════════════════════════════════
   DESIGN TOKENS
═══════════════════════════════════════════════════════════════ */
const T = {
  blue:      '#1d4ed8',
  blueDark:  '#1e3a8a',
  blueLight: '#2563eb',
  blueAlpha: 'rgba(29,78,216,0.08)',
  blueGlow:  'rgba(29,78,216,0.25)',
  bg:     '#f0f2f7',
  card:   '#ffffff',
  panel:  '#f8fafc',
  border: '#e2e8f0',
  txtPri: '#0f172a',
  txtSec: '#64748b',
  txtMut: '#94a3b8',
  success: '#16a34a',
  warning: '#f97316',
  danger:  '#ef4444',
  info:    '#0ea5e9',
  purple:  '#7c3aed',
  teal:    '#0f766e',
  header:  'linear-gradient(135deg, #1e3a8a 0%, #1d4ed8 100%)',
};

const globalCSS = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700;800&display=swap');
  ::-webkit-scrollbar { width: 4px; height: 4px; }
  ::-webkit-scrollbar-track  { background: transparent; }
  ::-webkit-scrollbar-thumb  { background: #e2e8f0; border-radius: 4px; }
  ::-webkit-scrollbar-thumb:hover { background: #1d4ed8; }
`;

const stageColor = (name) => {
  const map = {
    'done deal':      '#16a34a',
    'hot':            '#ef4444',
    'warm':           '#f97316',
    'cold':           '#0ea5e9',
    'eoi':            '#1d4ed8',
    'reservation':    '#7c3aed',
    'no answer':      '#94a3b8',
    'follow up':      '#f97316',
    'follow':         '#f97316',
    'meeting':        '#f97316',
        'Schedule Meeting':        '#f97316',

    'transfer':       '#ec4899',
    'pending':        '#94a3b8',
    'fresh':          '#16a34a',
    'interested':     '#16a34a',
    'not interested': '#ef4444',
  };
  return map[(name || '').toLowerCase()] || '#64748b';
};

/* ═══════════════════════════════════════════════════════════════
   STYLED COMPONENTS
═══════════════════════════════════════════════════════════════ */
const PanelHeader = styled(Box)(() => ({
  background: T.header,
  padding: '20px 28px',
  display: 'flex', alignItems: 'center', justifyContent: 'space-between',
  flexShrink: 0, position: 'relative', overflow: 'hidden',
  '&::after':  { content: '""', position: 'absolute', top: '-40px',  right: '-40px',  width: 180, height: 180, borderRadius: '50%', background: 'rgba(255,255,255,0.05)' },
  '&::before': { content: '""', position: 'absolute', bottom: '-60px', right: '120px', width: 140, height: 140, borderRadius: '50%', background: 'rgba(255,255,255,0.04)' },
}));

const BlueButton = styled(Button)(() => ({
  background: `linear-gradient(135deg, ${T.blueDark}, ${T.blue})`,
  color: '#fff',
  fontFamily: "'DM Sans', sans-serif",
  fontWeight: 700, fontSize: 13, borderRadius: 8, padding: '10px 24px',
  textTransform: 'none', border: 'none', transition: 'all 0.2s ease',
  boxShadow: `0 2px 10px ${T.blueGlow}`,
  '&:hover': { background: `linear-gradient(135deg, ${T.blueDark}, ${T.blueLight})`, boxShadow: `0 4px 16px ${T.blueGlow}`, transform: 'translateY(-1px)' },
  '&:disabled': { background: '#e2e8f0', color: T.txtMut, boxShadow: 'none', transform: 'none' },
}));

const OutlineBtn = styled(Button)(({ active, danger }) => ({
  fontFamily: "'DM Sans', sans-serif", fontWeight: 600, fontSize: 12,
  borderRadius: 8, padding: '7px 14px', textTransform: 'none',
  border: `1px solid ${danger ? T.danger : active ? T.blue : T.border}`,
  color: danger ? T.danger : active ? T.blue : T.txtSec,
  background: danger ? 'rgba(239,68,68,0.06)' : active ? T.blueAlpha : 'transparent',
  transition: 'all 0.15s',
  '&:hover': {
    border: `1px solid ${danger ? T.danger : T.blue}`,
    background: danger ? 'rgba(239,68,68,0.1)' : T.blueAlpha,
    color: danger ? T.danger : T.blue,
  },
}));

const HeaderIconBtn = styled(IconButton)(() => ({
  width: 34, height: 34, borderRadius: 8,
  background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.18)', color: '#fff',
  '&:hover': { background: 'rgba(255,255,255,0.22)' },
}));

const SurfaceCard = styled(Box)(({ bordered }) => ({
  background: T.card,
  border: `1px solid ${bordered ? T.blue + '50' : T.border}`,
  borderRadius: 12,
  position: 'relative',
  overflow: 'hidden',
}));

const FilterPanel = styled(Box)(() => ({
  background: T.panel,
  borderRadius: 12,
  border: `1px solid ${T.border}`,
  padding: '20px',
  marginBottom: 16,
}));

const NavBtn = styled(IconButton)(() => ({
  width: 32, height: 32, borderRadius: 6,
  border: `1px solid ${T.border}`,
  background: T.card, color: T.txtSec,
  '&:hover': { background: T.blue, borderColor: T.blue, color: '#ffffff' },
  '&.Mui-disabled': { opacity: 0.35 },
  transition: 'all 0.15s ease',
}));

/*
 * BlueTextField — ملاحظة مهمة:
 * لازم يكون defined برة أي component عشان مايتعملش re-create كل render
 * وده هو السبب الأساسي لمشكلة فقدان الـ focus
 */
const BlueTextField = styled(TextField)(() => ({
  '& .MuiOutlinedInput-root': {
    background: T.card, borderRadius: 8,
    fontFamily: "'DM Sans', sans-serif", fontSize: 14, color: T.txtPri,
    '& fieldset': { borderColor: T.border },
    '&:hover fieldset': { borderColor: T.blue },
    '&.Mui-focused fieldset': { borderColor: T.blue, borderWidth: 2 },
    '& input, & textarea': { fontSize: '16px !important' },
  },
  '& .MuiInputLabel-root': { color: T.txtMut, fontFamily: "'DM Sans', sans-serif", fontSize: 13 },
  '& .MuiInputLabel-root.Mui-focused': { color: T.blue },
  '& .MuiFormHelperText-root': { color: T.txtMut, fontSize: 11 },
}));

/* ═══════════════════════════════════════════════════════════════
   SMALL REUSABLE UI COMPONENTS — كلها TOP-LEVEL (مش جوا component)
═══════════════════════════════════════════════════════════════ */

const StageTag = React.memo(({ name }) => {
  const color = stageColor(name);
  return (
    <Box sx={{
      display: 'inline-flex', alignItems: 'center', gap: '4px',
      px: '10px', py: '2px', borderRadius: 20,
      bgcolor: color + '18', color, border: `1px solid ${color}35`,
      fontSize: 11, fontWeight: 700, letterSpacing: 0.4, whiteSpace: 'nowrap',
      fontFamily: "'DM Sans', sans-serif",
    }}>
      <Box sx={{ width: 5, height: 5, borderRadius: '50%', bgcolor: color, flexShrink: 0 }} />
      {name}
    </Box>
  );
});

const InfoRow = React.memo(({ icon: Icon, label, value, accent }) => (
  <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5, py: 1.2, borderBottom: `1px solid ${T.border}` }}>
    <Box sx={{ width: 32, height: 32, borderRadius: 8, bgcolor: T.blueAlpha, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, mt: '2px' }}>
      <Icon sx={{ fontSize: 15, color: T.blue }} />
    </Box>
    <Box>
      <Typography sx={{ fontSize: 10, color: T.txtMut, fontFamily: "'DM Sans', sans-serif", mb: '2px', textTransform: 'uppercase', letterSpacing: '0.06em', fontWeight: 600 }}>{label}</Typography>
      <Typography sx={{ fontSize: 13, color: accent || T.txtPri, fontFamily: "'DM Sans', sans-serif", fontWeight: 500, lineHeight: 1.4 }}>{value || '—'}</Typography>
    </Box>
  </Box>
));

const TabPanel = React.memo(({ children, value, index }) => (
  <Box role="tabpanel" hidden={value !== index} sx={{ flex: 1, overflowY: 'auto', height: '100%' }}>
    {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
  </Box>
));

/* ═══════════════════════════════════════════════════════════════
   DEAL FIELDS — TOP-LEVEL COMPONENT
   ⚠️ ده الإصلاح الجوهري: كانت DealFields معرّفة جوا StageSpecificForm
   فكانت بتتعمل component جديدة كل render → unmount/mount → فقدان الـ focus
═══════════════════════════════════════════════════════════════ */
const DealFields = React.memo(({
  unitPrice, unitnumber, commissionRatio, cashbackratio,
  totalCommission, cashbackMoney,
  onPriceChange, onUnitNumberChange, onCommissionRatioChange, onCashbackRatioChange,
}) => (
  <Grid container spacing={2}>
    <Grid item xs={12}>
      <BlueTextField
        fullWidth label="Unit Price (AED)" type="text"
        value={unitPrice} onChange={onPriceChange}
        InputProps={{ startAdornment: <InputAdornment position="start"><Typography sx={{ color: T.blue, fontSize: 12, fontWeight: 600 }}>AED</Typography></InputAdornment> }}
        inputProps={{ inputMode: 'decimal' }}
        required
      />
    </Grid>
    <Grid item xs={12}>
      <BlueTextField
        fullWidth label="Unit Number"
        value={unitnumber} onChange={onUnitNumberChange}
        placeholder="e.g., A101, Tower 2"
        required
      />
    </Grid>
    <Grid item xs={6}>
      <BlueTextField
        fullWidth label="Commission %" type="text"
        value={commissionRatio} onChange={onCommissionRatioChange}
        helperText="Commission percentage"
        InputProps={{ endAdornment: <InputAdornment position="end"><Typography sx={{ color: T.blue, fontSize: 12 }}>%</Typography></InputAdornment> }}
        inputProps={{ inputMode: 'decimal' }}
        required
      />
    </Grid>
    <Grid item xs={6}>
      <BlueTextField
        fullWidth label="Total Commission (AED)"
        value={totalCommission} disabled helperText="Auto calculated"
        InputProps={{ startAdornment: <InputAdornment position="start"><Typography sx={{ color: T.success, fontSize: 12 }}>AED</Typography></InputAdornment> }}
        sx={{ '& .MuiInputBase-input.Mui-disabled': { WebkitTextFillColor: T.success, fontWeight: 700 } }}
      />
    </Grid>
    <Grid item xs={6}>
      <BlueTextField
        fullWidth label="Cashback %" type="text"
        value={cashbackratio} onChange={onCashbackRatioChange}
        helperText="0 for no cashback"
        InputProps={{ endAdornment: <InputAdornment position="end"><Typography sx={{ color: T.info, fontSize: 12 }}>%</Typography></InputAdornment> }}
        inputProps={{ inputMode: 'decimal' }}
      />
    </Grid>
    <Grid item xs={6}>
      <BlueTextField
        fullWidth label="Cashback Amount (AED)"
        value={cashbackMoney} disabled helperText="Auto calculated"
        InputProps={{ startAdornment: <InputAdornment position="start"><Typography sx={{ color: T.info, fontSize: 12 }}>AED</Typography></InputAdornment> }}
        sx={{ '& .MuiInputBase-input.Mui-disabled': { WebkitTextFillColor: T.info } }}
      />
    </Grid>
  </Grid>
));

/* ═══════════════════════════════════════════════════════════════
   STAGE DROPDOWN
═══════════════════════════════════════════════════════════════ */
const StageDropdown = React.memo(({ open, onClose, stages, selectedStage, onSelect }) => {
  const [search, setSearch] = useState('');

  const filtered = useMemo(() => {
    if (!search.trim()) return stages;
    return stages.filter(s => s.name.toLowerCase().includes(search.toLowerCase()));
  }, [stages, search]);

  const handleSelect = useCallback((stage) => {
    onSelect(null, stage);
    onClose();
  }, [onSelect, onClose]);

  if (!open) return null;

  return (
    <>
      <Box onClick={onClose} sx={{ position: 'fixed', inset: 0, zIndex: Z.dropdownMask }} />
      <Paper elevation={0} sx={{
        position: 'absolute', top: 'calc(100% + 6px)', left: 0, right: 0, zIndex: Z.dropdownPanel,
        border: `1px solid ${T.border}`, borderRadius: '12px', overflow: 'hidden',
        bgcolor: T.card, boxShadow: '0 12px 40px rgba(0,0,0,0.12)', maxHeight: 320,
        display: 'flex', flexDirection: 'column',
      }}>
        <Box sx={{ px: 1.5, py: 1.2, borderBottom: `1px solid ${T.border}`, bgcolor: T.panel, flexShrink: 0 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, bgcolor: '#f1f5f9', borderRadius: 8, px: 1.2, py: 0.8 }}>
            <SearchIcon sx={{ fontSize: 14, color: T.txtMut, flexShrink: 0 }} />
            <input
              value={search}
              onChange={e => setSearch(e.target.value)}
              placeholder="Search stages..."
              style={{ border: 'none', outline: 'none', background: 'transparent', fontFamily: "'DM Sans', sans-serif", fontSize: 13, color: T.txtPri, width: '100%' }}
              autoFocus
            />
            {search && (
              <IconButton size="small" onClick={() => setSearch('')} sx={{ p: 0.2 }}>
                <CloseIcon sx={{ fontSize: 12, color: T.txtMut }} />
              </IconButton>
            )}
          </Box>
        </Box>
        <Box sx={{ overflowY: 'auto', flex: 1 }}>
          {filtered.length === 0 ? (
            <Box sx={{ py: 4, textAlign: 'center' }}>
              <Typography sx={{ fontSize: 12, color: T.txtMut, fontFamily: "'DM Sans', sans-serif" }}>No stages found</Typography>
            </Box>
          ) : filtered.map((stage, idx) => {
            const isSelected = selectedStage?._id === stage._id;
            const color = stageColor(stage.name);
            return (
              <Box key={stage._id || idx} onClick={() => handleSelect(stage)} sx={{
                display: 'flex', alignItems: 'center', gap: 1.5, px: 2, py: 1.2,
                cursor: 'pointer', borderBottom: `1px solid #f8fafc`,
                bgcolor: isSelected ? T.blueAlpha : 'transparent',
                transition: 'background 0.12s',
                '&:hover': { bgcolor: isSelected ? T.blueAlpha : '#f8fafc' },
              }}>
                <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: color, flexShrink: 0, boxShadow: `0 0 0 3px ${color}22` }} />
                <Typography sx={{ flex: 1, fontSize: 13, fontWeight: isSelected ? 700 : 500, color: isSelected ? T.blue : T.txtPri, fontFamily: "'DM Sans', sans-serif" }}>
                  {stage.name}
                </Typography>
                <Box sx={{ px: '8px', py: '2px', borderRadius: 20, bgcolor: `${color}15`, border: `1px solid ${color}40`, fontSize: 10, fontWeight: 700, color, fontFamily: "'DM Sans', sans-serif", textTransform: 'uppercase', flexShrink: 0 }}>
                  stage
                </Box>
                {isSelected && <CheckCircleIcon sx={{ fontSize: 15, color: T.blue, flexShrink: 0 }} />}
              </Box>
            );
          })}
        </Box>
      </Paper>
    </>
  );
});

/* ═══════════════════════════════════════════════════════════════
   COMMENT REPLIES
═══════════════════════════════════════════════════════════════ */
const CommentReplies = React.memo(({ comment, onReplyAdded }) => {
  const [showInput, setShowInput] = useState(false);
  const [replyText, setReplyText] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loadingreplay, setloadingreplay] = useState(true);
  const dispatch = useDispatch();
  const userLogin = JSON.parse(localStorage.getItem('user'))?.data || {};
  const resaddreplay = useSelector(s => s.AllActions.insrertrepaly);

  const handleSubmitReply = useCallback(async () => {
    if (!replyText.trim() || !comment?._id || !userLogin?._id) return;
    setIsSubmitting(true);
    setloadingreplay(true);
    try {
      await dispatch(Insert_Comment_Replay_Action({ commentId: comment._id, replyText: replyText.trim(), userId: userLogin._id }));
    } catch { Notify('error', 'Error adding reply', 'error'); }
    finally { setIsSubmitting(false); setloadingreplay(false); }
  }, [replyText, comment?._id, userLogin?._id, dispatch]);

  useEffect(() => {
    if (loadingreplay === false) {
      if (resaddreplay?.status === 200 || resaddreplay?.success) {
        Notify('success', 'Reply added', 'success');
        setReplyText(''); setShowInput(false); onReplyAdded();
      } else { Notify('error', 'Failed to add reply', 'error'); }
    }
  }, [loadingreplay]);

  const canReply = ['Sales', 'Team Leader', 'Admin'].includes(userLogin?.role);
  if (!canReply && !comment?.replies?.length) return null;

  return (
    <Box sx={{ mt: 2, pl: 2, borderLeft: `2px solid ${T.blue}30` }}>
      {comment?.replies?.length > 0 && (
        <Box sx={{ mb: 2 }}>
          <Typography sx={{ fontSize: 11, color: T.blue, fontFamily: "'DM Sans', sans-serif", fontWeight: 700, mb: 1, textTransform: 'uppercase', letterSpacing: '0.06em' }}>
            {comment.replies.length} {comment.replies.length === 1 ? 'Reply' : 'Replies'}
          </Typography>
          {comment.replies.map((reply, i) => (
            <Box key={reply._id || i} sx={{ display: 'flex', gap: 1.5, mb: 1.5, p: 1.5, borderRadius: 10, bgcolor: T.panel, border: `1px solid ${T.border}` }}>
              <Avatar src={reply.user?.profileImg} sx={{ width: 26, height: 26, fontSize: 11, bgcolor: T.blueAlpha, border: `1px solid ${T.border}`, color: T.blue }}>
                {reply.user?.name?.charAt(0)}
              </Avatar>
              <Box>
                <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', mb: 0.5 }}>
                  <Typography sx={{ fontSize: 12, fontWeight: 700, color: T.txtPri, fontFamily: "'DM Sans', sans-serif" }}>{reply.user?.name}</Typography>
                  <Typography sx={{ fontSize: 10, color: T.txtMut, fontFamily: "'DM Sans', sans-serif" }}>{moment(reply.date).format('DD/MM/YY hh:mm A')}</Typography>
                </Box>
                <Typography sx={{ fontSize: 13, color: T.txtSec, fontFamily: "'DM Sans', sans-serif" }}>{reply.text}</Typography>
              </Box>
            </Box>
          ))}
        </Box>
      )}
      {canReply && (
        showInput ? (
          <Box>
            <BlueTextField
              fullWidth multiline rows={2}
              value={replyText} onChange={e => setReplyText(e.target.value)}
              placeholder="Write your reply..." size="small"
              disabled={isSubmitting} autoFocus sx={{ mb: 1 }}
            />
            <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
              <OutlineBtn size="small" onClick={() => { setShowInput(false); setReplyText(''); }} disabled={isSubmitting}>Cancel</OutlineBtn>
              <BlueButton size="small" onClick={handleSubmitReply} disabled={!replyText.trim() || isSubmitting}
                startIcon={isSubmitting ? <CircularProgress size={13} color="inherit" /> : <SendIcon sx={{ fontSize: 14 }} />}
                sx={{ py: '7px', px: '16px', fontSize: 12 }}>
                {isSubmitting ? 'Sending…' : 'Reply'}
              </BlueButton>
            </Box>
          </Box>
        ) : (
          <OutlineBtn size="small" startIcon={<AddCommentIcon sx={{ fontSize: 14 }} />} onClick={() => setShowInput(true)} sx={{ width: '100%', justifyContent: 'flex-start' }}>
            Add a reply…
          </OutlineBtn>
        )
      )}
    </Box>
  );
});

/* ═══════════════════════════════════════════════════════════════
   STAGE SPECIFIC FORM
   ⚠️ لاحظ: DealFields بقت top-level component → props بتتمرر ليها مباشرة
═══════════════════════════════════════════════════════════════ */
const StageSpecificForm = React.memo(({
  selectedStageName,
  eoiAmount, reservationAmount,
  onEoiAmountChange, onReservationAmountChange,
  unitPrice, unitnumber, commissionRatio, cashbackratio,
  totalCommission, cashbackMoney,
  onPriceChange, onUnitNumberChange, onCommissionRatioChange, onCashbackRatioChange,
}) => {
  if (!selectedStageName) return null;

  const dealFieldsProps = { unitPrice, unitnumber, commissionRatio, cashbackratio, totalCommission, cashbackMoney, onPriceChange, onUnitNumberChange, onCommissionRatioChange, onCashbackRatioChange };

  if (selectedStageName === 'Reservation') {
    return (
      <SurfaceCard sx={{ p: 2.5, mb: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
          <Box sx={{ width: 28, height: 28, borderRadius: 1.5, bgcolor: `${T.purple}15`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <AttachMoneyIcon sx={{ fontSize: 15, color: T.purple }} />
          </Box>
          <Typography sx={{ fontSize: 11, color: T.purple, fontFamily: "'DM Sans', sans-serif", fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.1em' }}>
            Reservation Information
          </Typography>
        </Box>
        <BlueTextField
          fullWidth label="Reservation Amount (AED)" type="text"
          value={reservationAmount} onChange={onReservationAmountChange}
          InputProps={{ startAdornment: <InputAdornment position="start"><Typography sx={{ color: T.blue, fontSize: 12, fontWeight: 600 }}>AED</Typography></InputAdornment> }}
          helperText="Enter the reservation deposit amount"
          inputProps={{ inputMode: 'decimal' }}
        />
      </SurfaceCard>
    );
  }

  if (selectedStageName === 'EOI') {
    return (
      <SurfaceCard sx={{ p: 2.5, mb: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
          <Box sx={{ width: 28, height: 28, borderRadius: 1.5, bgcolor: `${T.blue}15`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <EditIcon sx={{ fontSize: 15, color: T.blue }} />
          </Box>
          <Typography sx={{ fontSize: 11, color: T.blue, fontFamily: "'DM Sans', sans-serif", fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.1em' }}>
            EOI Information
          </Typography>
        </Box>
        <BlueTextField
          fullWidth label="EOI Amount (AED)" type="text"
          value={eoiAmount} onChange={onEoiAmountChange}
          InputProps={{ startAdornment: <InputAdornment position="start"><Typography sx={{ color: T.blue, fontSize: 12, fontWeight: 600 }}>AED</Typography></InputAdornment> }}
          helperText="Enter the Expression of Interest amount"
          inputProps={{ inputMode: 'decimal' }}
          sx={{ mb: 3 }}
        />
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
          <Box sx={{ flex: 1, height: '1px', bgcolor: T.border }} />
          <Typography sx={{ fontSize: 11, color: T.txtMut, fontFamily: "'DM Sans', sans-serif", fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.08em' }}>Deal Information</Typography>
          <Box sx={{ flex: 1, height: '1px', bgcolor: T.border }} />
        </Box>
        <DealFields {...dealFieldsProps} />
      </SurfaceCard>
    );
  }

  if (selectedStageName === 'Done Deal') {
    return (
      <SurfaceCard sx={{ p: 2.5, mb: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
          <Box sx={{ width: 28, height: 28, borderRadius: 1.5, bgcolor: `${T.success}15`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <CheckCircleIcon sx={{ fontSize: 15, color: T.success }} />
          </Box>
          <Typography sx={{ fontSize: 11, color: T.success, fontFamily: "'DM Sans', sans-serif", fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.1em' }}>
            Done Deal Information
          </Typography>
        </Box>
        <DealFields {...dealFieldsProps} />
      </SurfaceCard>
    );
  }

  return null;
});

/* ═══════════════════════════════════════════════════════════════
   MAIN COMPONENT
═══════════════════════════════════════════════════════════════ */
export const ShowClientsActionsAdvanced = ({ user, leadid, onClose, onLeadUpdated }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const el = document.createElement('style');
    el.innerHTML = globalCSS;
    document.head.appendChild(el);
    return () => document.head.removeChild(el);
  }, []);

  const [open, setOpen]                       = useState(true);
  const [tabValue, setTabValue]               = useState(0);
  const [addActionEnabled, setAddActionEnabled] = useState(false);
  const [userlogin, setUserLogin]             = useState('');
  const userloginrealy                        = useRef(JSON.parse(localStorage.getItem('user')) || []);

  const [selectedStage, setSelectedStage]       = useState(null);
  const [showDateTime, setShowDateTime]         = useState(false);
  const [stageType, setStageType]               = useState(null);
  const [selectedStageId, setSelectedStageId]   = useState(null);
  const [selectedStageName, setSelectedStageName] = useState(null);
  const [allstagesshow, setAllStagesShow]       = useState([]);
  const [stageDropdownOpen, setStageDropdownOpen] = useState(false);

  const [firstcomment, setFirstComment]   = useState('');
  const [secondcomment, setSecondComment] = useState('');
  const [valuedate, setValueDate]         = useState(dayjs());
  const [loading, setLoading]             = useState(true);
  const [sendloading, setSendLoading]     = useState(false);

  const [unitPrice, setUnitPrice]           = useState('');
  const [unitnumber, setUnitNumber]         = useState('');
  const [commissionRatio, setCommissionRatio] = useState('');
  const [totalCommission, setTotalCommission] = useState('');
  const [cashbackratio, setCashbackRatio]   = useState('');
  const [cashbackMoney, setCashbackMoney]   = useState('');
  const [eoiAmount, setEoiAmount]           = useState('');
  const [reservationAmount, setReservationAmount] = useState('');
  const [isNoAnswer, setIsNoAnswer]         = useState(false);

  const [comments, setComments]                   = useState([]);
  const [isCommentsLoading, setIsCommentsLoading] = useState(false);
  const [currentPage, setCurrentPage]             = useState(1);
  const [totalPages, setTotalPages]               = useState(1);
  const [totalCommentsCount, setTotalCommentsCount] = useState(0);
  const [hasNext, setHasNext]                     = useState(false);
  const [hasPrev, setHasPrev]                     = useState(false);
  const [filterInfo, setFilterInfo]               = useState(null);
  const [openLeadPreview, setOpenLeadPreview]     = useState(false);

  const stagesWithDateTime = useMemo(() =>
    ['No Answer','Schedule Meeting' ,'Answer', 'Meeting', 'Follow', 'Follow After Meeting', 'Follow Up', 'Transfer', 'Interested'], []);

  const resaddcomment     = useSelector(s => s.AllActions.AddAction);
  const All_stages        = useSelector(s => s.Allstages.stage);
  const resgetonestagetype = useSelector(s => s.Allstages.getstagetogetype);

  useEffect(() => {
    const u = JSON.parse(localStorage.getItem('user'));
    if (u) setUserLogin(u);
  }, []);

  /* ── Fetch comments ── */
  const getallactiondata = useCallback(async (page = 1) => {
    const userId = userloginrealy.current?.data?._id;
    if (!user?._id || !userId) return;
    setIsCommentsLoading(true);
    try {
      const response = await dispatch(GetAllcomments_Data_With_Pagination_action_advanced({ leadId: user._id, userId, page, limit: 20 }));
      if (response?.success && response?.comments) {
        setComments(response.comments);
        if (response.pagination) {
          setCurrentPage(response.pagination.page || page);
          setTotalPages(response.pagination.totalPages || 1);
          setHasNext(response.pagination.hasNext || false);
          setHasPrev(response.pagination.hasPrev || false);
        }
        setTotalCommentsCount(response.totalComments || response.comments.length || 0);
        if (response.filterApplied) setFilterInfo({ applied: response.filterApplied, assignmentInfo: response.assignmentInfo });
      }
    } catch { Notify('error', 'Failed to load comments', 'error'); }
    finally { setIsCommentsLoading(false); }
  }, [dispatch, user?._id]);

  const refreshComments = useCallback(() => getallactiondata(currentPage), [getallactiondata, currentPage]);

  /* ── Load stages ── */
  const getallstages = useCallback(async () => {
    try { await dispatch(GetAll_stage_Data()); } catch {}
  }, [dispatch]);

  useEffect(() => {
    if (!open) return;
    const t = setTimeout(() => getallstages(), 500);
    return () => clearTimeout(t);
  }, [open, getallstages]);

  useEffect(() => {
    if (All_stages?.data) {
      const filtered = All_stages.data.filter(s => s.name !== 'Fresh');
      const sorted = [...filtered].sort((a, b) =>
        a.name === 'No Stage' ? -1 : b.name === 'No Stage' ? 1 : a.name.localeCompare(b.name));
      setAllStagesShow(sorted);
    }
  }, [All_stages]);

  useEffect(() => {
    setStageType(resgetonestagetype?.data || null);
  }, [resgetonestagetype]);

  /* ── Auto comments ── */
  const generateAutoComments = useCallback((stageName) => {
    const map = { 'No Answer': { firstComment: 'اتصلت ومفيش رد', secondComment: 'هحاول تاني في وقت تاني' } };
    return map[stageName] || { firstComment: '', secondComment: '' };
  }, []);

  /* ── Stage change ── */
  const handleStageChange = useCallback((_, newValue) => {
    if (!newValue) {
      setSelectedStage(null); setSelectedStageId(null); setSelectedStageName(null);
      setStageType(null); setShowDateTime(false);
      return;
    }
    setSelectedStage(newValue);
    setSelectedStageId(newValue._id);
    setSelectedStageName(newValue.name);
    const needsDT = stagesWithDateTime.includes(newValue.name) || newValue.name === 'Answer' || newValue.name === 'No Answer';
    setShowDateTime(needsDT);
    if (!needsDT) setValueDate(null);
    dispatch(GetOne_stagetogettype_Data(newValue._id)).then(r => { if (r?.data) setStageType(r.data); }).catch(() => {});
    if (!firstcomment.trim() && !secondcomment.trim()) {
      const ac = generateAutoComments(newValue.name);
      setFirstComment(ac.firstComment);
      setSecondComment(ac.secondComment);
    }
    setIsNoAnswer(newValue.name === 'No Answer');
  }, [dispatch, generateAutoComments, stagesWithDateTime, firstcomment, secondcomment]);

  const resetStageForm = useCallback(() => {
    setUnitPrice(''); setUnitNumber(''); setCommissionRatio(''); setCashbackRatio('');
    setEoiAmount(''); setReservationAmount(''); setStageType(null); setSelectedStage(null);
    setSelectedStageId(null); setSelectedStageName(null); setShowDateTime(false); setValueDate(null); setIsNoAnswer(false);
  }, []);

  const handleEnableActionToggle = useCallback((checked) => {
    setAddActionEnabled(checked);
    if (!checked) { resetStageForm(); return; }
    if (!user?.stage) return;
    setSelectedStage(user.stage); setSelectedStageId(user.stage._id); setSelectedStageName(user.stage.name);
    const needsDT = stagesWithDateTime.includes(user.stage.name);
    setShowDateTime(needsDT);
    if (!needsDT) setValueDate(null);
    dispatch(GetOne_stagetogettype_Data(user.stage._id)).then(r => { if (r?.data) setStageType(r.data); }).catch(() => {});
    if (!firstcomment.trim() && !secondcomment.trim()) {
      const ac = generateAutoComments(user.stage.name);
      setFirstComment(ac.firstComment); setSecondComment(ac.secondComment);
    }
    setIsNoAnswer(user.stage.name === 'No Answer');
  }, [user?.stage, dispatch, generateAutoComments, stagesWithDateTime, resetStageForm, firstcomment, secondcomment]);

  /* ── Input handlers — stable references ── */
  const handlePriceChange            = useCallback(e => setUnitPrice(e.target.value.replace(/[^0-9.]/g, '')), []);
  const handleUnitNumber             = useCallback(e => setUnitNumber(e.target.value), []);
  const handleCommissionRatioChange  = useCallback(e => setCommissionRatio(e.target.value.replace(/[^0-9.]/g, '')), []);
  const handleCashbackRatioChange    = useCallback(e => setCashbackRatio(e.target.value.replace(/[^0-9.]/g, '')), []);
  const handleReservationAmountChange = useCallback(e => setReservationAmount(e.target.value.replace(/[^0-9.]/g, '')), []);
  const handleEoiAmountChange        = useCallback(e => setEoiAmount(e.target.value.replace(/[^0-9.]/g, '')), []);
  const handleFirstComment           = useCallback(e => setFirstComment(e.target.value), []);
  const handleSecondComment          = useCallback(e => setSecondComment(e.target.value), []);

  const handleDateTimeChange = useCallback((newValue) => {
    if (!newValue) return;
    setValueDate(newValue);
    const fmt = moment(newValue.toDate()).format('MMMM Do YYYY, h:mm A');
    setSecondComment(prev => {
      const base = prev.replace(/ - Follow up on .*$/, '').replace(/ - Scheduled for .*$/, '');
      return base ? `${base} - Follow up on ${fmt}` : `Follow up on ${fmt}`;
    });
  }, []);

  /* ── Auto-calculate commission & cashback ── */
  useEffect(() => {
    const p = parseFloat(unitPrice), r = parseFloat(commissionRatio);
    setTotalCommission((!isNaN(p) && !isNaN(r) && p > 0 && r > 0) ? ((p * r) / 100).toFixed(2) : '');
  }, [unitPrice, commissionRatio]);

  useEffect(() => {
    const r = parseFloat(cashbackratio), c = parseFloat(totalCommission);
    if (isNaN(r)) { setCashbackMoney(''); return; }
    if (r === 0) { setCashbackMoney('0'); return; }
    setCashbackMoney((!isNaN(c) && c > 0) ? ((c * r) / 100).toFixed(2) : '');
  }, [cashbackratio, totalCommission]);

  /* ── Confetti ── */
  const DoneDealFun = useCallback(() => {
    new JSConfetti().addConfetti({ confettiColors: ['#1d4ed8', '#16a34a', '#f97316', '#ec4899', '#7c3aed'] });
  }, []);

  /* ── Submit ── */
  const onsubmitdata = useCallback(async (e) => {
    e.preventDefault();
    if (!firstcomment.trim()) return Notify('error', 'Please enter first comment', 'error');
    if (!secondcomment.trim()) return Notify('error', 'Please enter second comment', 'error');
    if (showDateTime && !valuedate) return Notify('error', 'Please select date & time', 'error');

    if (addActionEnabled && selectedStageId) {
      if (selectedStageName === 'Reservation' && !reservationAmount) return Notify('error', 'Please enter Reservation amount', 'error');
      if (selectedStageName === 'EOI') {
        if (!eoiAmount || parseFloat(eoiAmount) <= 0) return Notify('error', 'Please enter a valid EOI amount', 'error');
        if (!unitPrice || parseFloat(unitPrice) <= 0) return Notify('error', 'Please enter a valid unit price', 'error');
        if (!unitnumber.trim()) return Notify('error', 'Please enter unit number', 'error');
        if (!commissionRatio || parseFloat(commissionRatio) <= 0) return Notify('error', 'Please enter commission ratio', 'error');
        if (cashbackratio === '' || cashbackratio < 0) return Notify('error', 'Please enter cashback ratio', 'error');
      }
      if (selectedStageName === 'Done Deal') {
        if (!unitPrice || parseFloat(unitPrice) <= 0) return Notify('error', 'Please enter a valid unit price', 'error');
        if (!unitnumber.trim()) return Notify('error', 'Please enter unit number', 'error');
        if (!commissionRatio || parseFloat(commissionRatio) <= 0) return Notify('error', 'Please enter commission ratio', 'error');
        if (cashbackratio === '' || cashbackratio < 0) return Notify('error', 'Please enter cashback ratio', 'error');
      }
    }

    setLoading(true); setSendLoading(true);
    try {
      const finalDate = valuedate || dayjs();
      if (addActionEnabled) {
        const updateData = {
          stage: selectedStageId, stagedateupdated: finalDate, last_stage_date_updated: moment().format('YYYY-MM-DD'),
          ...((selectedStageName === 'Done Deal') && { unit_price: parseFloat(unitPrice), review: false, unitnumber, commissionratio: parseFloat(commissionRatio), commissionmoney: totalCommission, cashbackratio: parseFloat(cashbackratio), cashbackmoney: cashbackMoney }),
          ...((selectedStageName === 'EOI') && { unit_price: parseFloat(unitPrice), review: false, unitnumber, commissionratio: parseFloat(commissionRatio), commissionmoney: totalCommission, cashbackratio: parseFloat(cashbackratio), cashbackmoney: cashbackMoney, Eoi: parseFloat(eoiAmount) }),
          ...(selectedStageName === 'Reservation' && { Reservation: parseFloat(reservationAmount) }),
        };
        await dispatch(UpdateStageToLeed(user._id, updateData));
        await dispatch(Insert_Lead_Stages_Data_Action({
          LeadId: user._id, date: moment().format('YYYY-MM-DD'), stage: selectedStageId,
          sales: userlogin.data._id, dateselectedforstage: finalDate,
          ...((selectedStageName === 'Done Deal' || selectedStageName === 'EOI') && { unitPrice: parseFloat(unitPrice) }),
        }));
        if (selectedStageName === 'Done Deal' || selectedStageName === 'EOI') DoneDealFun();
      }
      await dispatch(InsertNewAction_action({
        sales: userlogin.data._id, text1: firstcomment, text2: secondcomment,
        date: finalDate, leed: user._id, username: userlogin.data._id,
        commentbysales: userlogin.data.name, stage: user?.stage?._id,
      }));
    } catch { Notify('error', 'Error sending data, please try again.', 'error'); }
    finally { setLoading(false); setSendLoading(false); }
  }, [firstcomment, secondcomment, showDateTime, valuedate, addActionEnabled, selectedStageId, selectedStageName, reservationAmount, eoiAmount, unitPrice, unitnumber, commissionRatio, cashbackratio, totalCommission, cashbackMoney, dispatch, user, userlogin, DoneDealFun]);

  useEffect(() => {
    if (!loading) {
      if (resaddcomment?.status === 200) {
        Notify('success', 'Comment added successfully!', 'success');
        setFirstComment(''); setSecondComment('');
        if (addActionEnabled) resetStageForm();
        if (tabValue === 2) refreshComments();
        if (onLeadUpdated) onLeadUpdated();
      } else { Notify('error', 'Error adding comment', 'error'); }
    }
  }, [loading]);

  const handleTabChange = useCallback((_, v) => {
    setTabValue(v);
    if (v === 2 && user?._id && userloginrealy.current?.data?._id) getallactiondata(1);
  }, [user?._id, getallactiondata]);

  const handleClose = useCallback(() => {
    if (onClose) onClose();
    else { setOpen(false); setAddActionEnabled(false); resetStageForm(); }
  }, [onClose, resetStageForm]);

  const closeDropdown = useCallback(() => setStageDropdownOpen(false), []);
  const toggleDropdown = useCallback(() => setStageDropdownOpen(p => !p), []);

  /* ─── Quick-date buttons ─── */
  const quickDates = useMemo(() => [
    { label: '+1h',      fn: () => { const t = dayjs().add(1, 'hour'); setValueDate(t); handleDateTimeChange(t); } },
    { label: '+2h',      fn: () => { const t = dayjs().add(2, 'hour'); setValueDate(t); handleDateTimeChange(t); } },
    { label: '+3h',      fn: () => { const t = dayjs().add(3, 'hour'); setValueDate(t); handleDateTimeChange(t); } },
    { label: 'Tom 11AM', fn: () => { const t = dayjs().add(1, 'day').hour(11).minute(0).second(0); setValueDate(t); handleDateTimeChange(t); } },
    { label: 'In 2 days',fn: () => { const t = dayjs().add(2, 'day').hour(11).minute(0).second(0); setValueDate(t); handleDateTimeChange(t); } },
  ], [handleDateTimeChange]);

  /* ═════════════════════ RENDER ═════════════════════ */
  return (
    <>
      <Dialog
        open={open} onClose={handleClose} maxWidth={false} fullWidth
        sx={{
          zIndex: Z.dialog,
          '& .MuiDialog-paper': {
            width: { xs: '100vw', sm: '92vw', md: '88vw', lg: 1100 },
            maxWidth: '96vw', maxHeight: '92vh',
            background: T.bg, display: 'flex', flexDirection: 'column',
            overflow: 'hidden', borderRadius: 3,
            boxShadow: '0 24px 80px rgba(0,0,0,0.2)',
            m: { xs: 1, sm: 2 },
          },
          '& .MuiBackdrop-root': { background: 'rgba(0,0,0,0.45)', backdropFilter: 'blur(3px)' },
        }}
      >
        {/* ── HEADER ── */}
        <PanelHeader>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, position: 'relative', zIndex: 1 }}>
            <Box sx={{ width: 46, height: 46, borderRadius: 3, background: 'rgba(255,255,255,0.12)', border: '1px solid rgba(255,255,255,0.18)', display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(8px)' }}>
              <Typography sx={{ fontSize: 18, fontWeight: 800, color: '#fff', fontFamily: "'DM Sans', sans-serif" }}>
                {user?.name?.charAt(0)?.toUpperCase()}
              </Typography>
            </Box>
            <Box>
              <Typography sx={{ fontSize: 18, fontWeight: 800, color: '#fff', letterSpacing: -0.4, lineHeight: 1.2, fontFamily: "'DM Sans', sans-serif" }}>
                {user?.name}
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mt: 0.4 }}>
                <Typography sx={{ fontSize: 12, color: 'rgba(255,255,255,0.65)', fontFamily: "'DM Sans', sans-serif" }}>{user?.sales?.name}</Typography>
                {(selectedStageName || user?.stage?.name) && (
                  <Box sx={{ px: 1, py: 0.2, borderRadius: 10, background: 'rgba(255,255,255,0.15)', fontSize: 11, color: '#fff', fontWeight: 600, fontFamily: "'DM Sans', sans-serif" }}>
                    {selectedStageName || user?.stage?.name}
                  </Box>
                )}
              </Box>
            </Box>
          </Box>
          <Box sx={{ display: 'flex', gap: 1, position: 'relative', zIndex: 1 }}>
            <HeaderIconBtn onClick={handleClose} sx={{ '&:hover': { background: 'rgba(220,38,38,0.5)', borderColor: 'transparent' } }}>
              <CloseIcon sx={{ fontSize: 16 }} />
            </HeaderIconBtn>
          </Box>
        </PanelHeader>

        {/* ── TABS ── */}
        <Box sx={{ px: 3, borderBottom: `1px solid ${T.border}`, bgcolor: T.card, flexShrink: 0 }}>
          <Tabs value={tabValue} onChange={handleTabChange} sx={{
            minHeight: 46,
            '& .MuiTabs-indicator': { background: `linear-gradient(90deg, ${T.blueDark}, ${T.blue})`, height: 2, borderRadius: 1 },
            '& .MuiTab-root': { color: T.txtMut, fontFamily: "'DM Sans', sans-serif", fontSize: 12, fontWeight: 600, textTransform: 'none', minHeight: 46, '&.Mui-selected': { color: T.blue, fontWeight: 800 } },
          }}>
            <Tab icon={<InfoIcon sx={{ fontSize: 14 }} />} iconPosition="start" label="Information" />
            <Tab icon={<AddCommentIcon sx={{ fontSize: 14 }} />} iconPosition="start" label="Add Comment" />
            <Tab icon={<CommentIcon sx={{ fontSize: 14 }} />} iconPosition="start" label={`Comments${totalCommentsCount > 0 ? ` (${totalCommentsCount})` : ''}`} />
          </Tabs>
        </Box>

        {/* ── CONTENT ── */}
        <Box sx={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column', bgcolor: T.bg }}>

          {/* ════ TAB 0: INFORMATION ════ */}
          <TabPanel value={tabValue} index={0}>
            <Grid container spacing={2.5}>
              <Grid item xs={12} md={6}>
                <SurfaceCard bordered sx={{ p: 2.5, height: '100%' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Box sx={{ width: 28, height: 28, borderRadius: 1.5, bgcolor: T.blueAlpha, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <InfoIcon sx={{ fontSize: 15, color: T.blue }} />
                      </Box>
                      <Typography sx={{ fontSize: 11, color: T.txtPri, fontFamily: "'DM Sans', sans-serif", fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.1em' }}>Lead Details</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', gap: 0.5 }}>
                      <Tooltip title="Preview">
                        <NavBtn size="small" onClick={() => setOpenLeadPreview(true)}><VisibilityIcon sx={{ fontSize: 14 }} /></NavBtn>
                      </Tooltip>
                      {!['Sales', 'Team Leader'].includes(userlogin?.data?.role) && (
                        <Tooltip title="Edit Lead">
                          <NavBtn size="small" component={Link} to={`/updateclient/${user._id}`}><EditIcon sx={{ fontSize: 14 }} /></NavBtn>
                        </Tooltip>
                      )}
                    </Box>
                  </Box>
                  <InfoRow icon={PersonIcon} label="Lead Name" value={user?.name} />
                  <InfoRow icon={WorkIcon} label="Sales Person" value={user?.sales?.name} accent={T.blue} />
                  <InfoRow icon={PhoneIcon} label="Phone" value={
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Typography sx={{ fontSize: 13, color: T.txtPri, fontFamily: "'DM Sans', sans-serif" }}>{user?.phone}</Typography>
                      <IconButton size="small" onClick={() => window.open(`https://wa.me/${user?.phone}`, '_blank')} sx={{ color: T.success, p: 0.3, bgcolor: `${T.success}12`, borderRadius: 1 }}>
                        <WhatsAppIcon sx={{ fontSize: 14 }} />
                      </IconButton>
                    </Box>
                  } />
                  {user?.phonenumber2 && <InfoRow icon={PhoneIcon} label="Phone 2" value={user.phonenumber2} />}
                  <InfoRow icon={EmailIcon} label="Email" value={user?.email} />
                  <InfoRow icon={WorkIcon} label="Developer" value={user?.project?.developer?.name} />
                  <InfoRow icon={InfoIcon} label="Project" value={user?.project?.name} accent={T.blue} />
                  {user?.notes && <InfoRow icon={EditIcon} label="Notes" value={user.notes} />}
                  {(userlogin?.data?.role !== 'Sales' && userlogin?.data?.role !== 'Team Leader') || !user?.resetcreationdate
                    ? <InfoRow icon={CalendarIcon} label="Created" value={moment(user?.createdAt).format('DD MMM YYYY')} />
                    : null}
                </SurfaceCard>
              </Grid>

              <Grid item xs={12} md={6}>
                <SurfaceCard sx={{ p: 2.5, mb: 2 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                    <Box sx={{ width: 28, height: 28, borderRadius: 1.5, bgcolor: T.blueAlpha, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <AssessmentIcon sx={{ fontSize: 15, color: T.blue }} />
                    </Box>
                    <Typography sx={{ fontSize: 11, color: T.txtPri, fontFamily: "'DM Sans', sans-serif", fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.1em' }}>Current Stage</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Box sx={{ width: 50, height: 50, borderRadius: 12, bgcolor: `${stageColor(user?.stage?.name)}15`, border: `1px solid ${stageColor(user?.stage?.name)}40`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <Box sx={{ width: 14, height: 14, borderRadius: '50%', bgcolor: stageColor(user?.stage?.name), boxShadow: `0 0 8px ${stageColor(user?.stage?.name)}` }} />
                    </Box>
                    <Box>
                      <StageTag name={user?.stage?.name} />
                      {user?.stagedateupdated && <Typography sx={{ fontSize: 11, color: T.txtMut, fontFamily: "'DM Sans', sans-serif", mt: 0.5 }}>{moment(user.stagedateupdated).format('DD MMM YYYY, HH:mm')}</Typography>}
                    </Box>
                  </Box>
                </SurfaceCard>

                {user?.campaignRedirectLink && (
                  <SurfaceCard sx={{ p: 2.5, mb: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
                      <Box sx={{ width: 28, height: 28, borderRadius: 1.5, bgcolor: T.blueAlpha, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <LinkIcon sx={{ fontSize: 14, color: T.blue }} />
                      </Box>
                      <Typography sx={{ fontSize: 11, color: T.blue, fontFamily: "'DM Sans', sans-serif", fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.1em' }}>Campaign Link</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, p: 1.5, borderRadius: 2, bgcolor: T.panel, border: `1px solid ${T.border}` }}>
                      <Typography sx={{ flex: 1, fontSize: 12, color: T.blue, fontFamily: "'DM Sans', sans-serif", wordBreak: 'break-all', lineHeight: 1.4 }}>
                        <a href={user.campaignRedirectLink} target="_blank" rel="noopener noreferrer" style={{ color: 'inherit' }}>{user.campaignRedirectLink}</a>
                      </Typography>
                      <NavBtn size="small" onClick={() => window.open(user.campaignRedirectLink, '_blank')}><OpenInNewIcon sx={{ fontSize: 13 }} /></NavBtn>
                    </Box>
                  </SurfaceCard>
                )}

                {[1,2,3,4,5].some(n => user?.[`question${n}_text`] || user?.[`question${n}_answer`]) && (
                  <SurfaceCard sx={{ p: 2.5 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                      <Box sx={{ width: 28, height: 28, borderRadius: 1.5, bgcolor: T.blueAlpha, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <CommentIcon sx={{ fontSize: 14, color: T.blue }} />
                      </Box>
                      <Typography sx={{ fontSize: 11, color: T.blue, fontFamily: "'DM Sans', sans-serif", fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.1em' }}>Campaign Q&A</Typography>
                    </Box>
                    {[1,2,3,4,5].map(num => {
                      const q = user?.[`question${num}_text`], a = user?.[`question${num}_answer`];
                      if (!q && !a) return null;
                      return (
                        <Box key={num} sx={{ mb: 1.5, p: 1.5, borderRadius: 2, bgcolor: T.panel, borderLeft: `3px solid ${T.blue}`, border: `1px solid ${T.border}`, borderLeftWidth: 3, borderLeftColor: T.blue }}>
                          {q && <Typography sx={{ fontSize: 12, color: T.txtSec, fontFamily: "'DM Sans', sans-serif", mb: 0.5, fontStyle: 'italic' }}>{q}</Typography>}
                          {a && <Typography sx={{ fontSize: 13, color: T.txtPri, fontFamily: "'DM Sans', sans-serif", fontWeight: 600 }}>{a}</Typography>}
                        </Box>
                      );
                    })}
                  </SurfaceCard>
                )}
              </Grid>
            </Grid>
          </TabPanel>

          {/* ════ TAB 1: ADD COMMENT ════ */}
          <TabPanel value={tabValue} index={1}>
            {/* Answer / No Answer */}
            <Box sx={{ display: 'flex', gap: 1.5, mb: 3 }}>
              <OutlineBtn size="small" active={!isNoAnswer} startIcon={<PhoneInTalkIcon sx={{ fontSize: 14 }} />}
                onClick={() => { setIsNoAnswer(false); setFirstComment(''); setSecondComment(''); }}>
                Answer
              </OutlineBtn>
              <OutlineBtn size="small" danger active={isNoAnswer} startIcon={<CancelIcon sx={{ fontSize: 14 }} />}
                onClick={() => { setIsNoAnswer(true); setFirstComment('اتصلت ومفيش رد'); setSecondComment('هحاول تاني في وقت تاني'); }}>
                No Answer
              </OutlineBtn>
            </Box>

            {/* Stage Management */}
            <FilterPanel sx={{ mb: 3 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                  <Box sx={{ width: 28, height: 28, borderRadius: 1.5, bgcolor: T.blueAlpha, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <FilterListIcon sx={{ fontSize: 15, color: T.blue }} />
                  </Box>
                  <Box>
                    <Typography sx={{ fontSize: 14, fontWeight: 700, color: T.txtPri, fontFamily: "'DM Sans', sans-serif" }}>Stage Management</Typography>
                    <Typography sx={{ fontSize: 11, color: T.txtMut, fontFamily: "'DM Sans', sans-serif" }}>Enable to change the lead stage</Typography>
                  </Box>
                  {addActionEnabled && (
                    <Box sx={{ px: 1, py: 0.2, borderRadius: 10, background: T.blue, fontSize: 11, color: '#fff', fontWeight: 700, fontFamily: "'DM Sans', sans-serif" }}>Active</Box>
                  )}
                </Box>
                <Switch checked={addActionEnabled} onChange={e => handleEnableActionToggle(e.target.checked)}
                  sx={{ '& .MuiSwitch-switchBase.Mui-checked': { color: T.blue }, '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { bgcolor: T.blue } }} />
              </Box>
              {addActionEnabled && (
                <Box sx={{ mt: 2, pt: 2, borderTop: `1px solid ${T.border}`, display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
                  <Typography sx={{ fontSize: 11, color: T.txtMut, fontFamily: "'DM Sans', sans-serif" }}>Current:</Typography>
                  <StageTag name={user?.stage?.name} />
                  <Box sx={{ fontSize: 18, color: T.txtMut, lineHeight: 1 }}>→</Box>
                  <Typography sx={{ fontSize: 11, color: T.txtMut, fontFamily: "'DM Sans', sans-serif" }}>Change to:</Typography>
                </Box>
              )}
            </FilterPanel>

            <Collapse in={addActionEnabled} timeout={300}>
              <Box sx={{ mb: 3 }}>
                {/* Stage Selector */}
                <Box sx={{ position: 'relative', mb: 2 }}>
                  <Box onClick={toggleDropdown} sx={{
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    p: 1.8, borderRadius: stageDropdownOpen ? '10px 10px 0 0' : '10px',
                    border: `1px solid ${selectedStage ? T.blue : stageDropdownOpen ? T.blue : T.border}`,
                    borderBottom: stageDropdownOpen ? `1px solid transparent` : undefined,
                    background: selectedStage ? T.blueAlpha : T.card,
                    cursor: 'pointer', transition: 'all 0.15s', userSelect: 'none',
                    '&:hover': { border: `1px solid ${T.blue}`, borderBottom: stageDropdownOpen ? `1px solid transparent` : undefined, background: T.blueAlpha },
                  }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                      {selectedStage ? (
                        <>
                          <Avatar sx={{ width: 34, height: 34, fontSize: 12, fontWeight: 800, background: `linear-gradient(135deg, ${T.blueDark}, ${T.blue})` }}>
                            {selectedStage.name.slice(0, 2).toUpperCase()}
                          </Avatar>
                          <Box>
                            <Typography sx={{ fontSize: 14, fontWeight: 700, color: T.txtPri, fontFamily: "'DM Sans', sans-serif", lineHeight: 1.2 }}>{selectedStage.name}</Typography>
                            <StageTag name={selectedStage.name} />
                          </Box>
                        </>
                      ) : (
                        <>
                          <Box sx={{ width: 34, height: 34, borderRadius: '50%', bgcolor: T.panel, border: `1px dashed ${T.border}`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <ChangeCircleIcon sx={{ fontSize: 16, color: T.txtMut }} />
                          </Box>
                          <Box>
                            <Typography sx={{ fontSize: 14, color: T.txtMut, fontFamily: "'DM Sans', sans-serif", fontWeight: 500 }}>Select New Stage</Typography>
                            <Typography sx={{ fontSize: 11, color: T.txtMut, fontFamily: "'DM Sans', sans-serif", opacity: 0.7 }}>Tap to choose</Typography>
                          </Box>
                        </>
                      )}
                    </Box>
                    <KeyboardArrowDownIcon sx={{ fontSize: 20, color: selectedStage ? T.blue : T.txtMut, transition: 'transform 0.2s', transform: stageDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)' }} />
                  </Box>
                  <StageDropdown open={stageDropdownOpen} onClose={closeDropdown} stages={allstagesshow} selectedStage={selectedStage} onSelect={handleStageChange} />
                </Box>

                {selectedStage?.Comment && (
                  <Box sx={{ mb: 2, p: 1.5, borderRadius: 2, bgcolor: T.blueAlpha, border: `1px solid ${T.blue}30`, display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                    <InfoIcon sx={{ fontSize: 14, color: T.blue, mt: 0.2 }} />
                    <Box>
                      <Typography sx={{ fontSize: 10, color: T.blue, fontFamily: "'DM Sans', sans-serif", fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.06em' }}>Stage Note</Typography>
                      <Typography sx={{ fontSize: 12, color: T.txtPri, fontFamily: "'DM Sans', sans-serif" }}>{selectedStage.Comment}</Typography>
                    </Box>
                  </Box>
                )}

                {/* DateTime Picker */}
                {showDateTime && (
                  <SurfaceCard sx={{ p: 2.5, mb: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                      <Box sx={{ width: 28, height: 28, borderRadius: 1.5, bgcolor: `${T.warning}15`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <ScheduleIcon sx={{ fontSize: 15, color: T.warning }} />
                      </Box>
                      <Typography sx={{ fontSize: 11, color: T.warning, fontFamily: "'DM Sans', sans-serif", fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.1em' }}>
                        Schedule Next Action
                      </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 2 }}>
                      {quickDates.map(btn => (
                        <Box key={btn.label} onClick={btn.fn} sx={{ px: 1.5, py: 0.8, borderRadius: 8, border: `1px solid ${T.border}`, fontSize: 11, color: T.txtSec, fontFamily: "'DM Sans', sans-serif", cursor: 'pointer', transition: 'all 0.15s', bgcolor: T.panel, '&:hover': { border: `1px solid ${T.blue}`, color: T.blue, bgcolor: T.blueAlpha } }}>
                          {btn.label}
                        </Box>
                      ))}
                    </Box>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <MobileDateTimePicker
                        label="Select Date & Time" value={valuedate} onChange={handleDateTimeChange} ampm
                        slotProps={{
                          textField: { fullWidth: true, sx: { '& .MuiOutlinedInput-root': { background: T.card, color: T.txtPri, borderRadius: 2, fontFamily: "'DM Sans', sans-serif", '& fieldset': { borderColor: T.border }, '&:hover fieldset': { borderColor: T.blue }, '&.Mui-focused fieldset': { borderColor: T.blue, borderWidth: 2 } }, '& .MuiInputLabel-root': { color: T.txtMut }, '& .MuiInputLabel-root.Mui-focused': { color: T.blue } } },
                          dialog: { sx: { zIndex: Z.datePicker } },
                          mobilePaper: { sx: { border: `1px solid ${T.border}`, borderRadius: 3 } },
                        }}
                      />
                    </LocalizationProvider>
                  </SurfaceCard>
                )}

                <StageSpecificForm
                  selectedStageName={selectedStageName}
                  eoiAmount={eoiAmount} reservationAmount={reservationAmount}
                  onEoiAmountChange={handleEoiAmountChange} onReservationAmountChange={handleReservationAmountChange}
                  unitPrice={unitPrice} unitnumber={unitnumber}
                  commissionRatio={commissionRatio} cashbackratio={cashbackratio}
                  totalCommission={totalCommission} cashbackMoney={cashbackMoney}
                  onPriceChange={handlePriceChange} onUnitNumberChange={handleUnitNumber}
                  onCommissionRatioChange={handleCommissionRatioChange} onCashbackRatioChange={handleCashbackRatioChange}
                />
              </Box>
            </Collapse>

            {/* Comment inputs */}
            <SurfaceCard sx={{ p: 2.5, mb: 3 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                <Box sx={{ width: 28, height: 28, borderRadius: 1.5, bgcolor: T.blueAlpha, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <CommentIcon sx={{ fontSize: 14, color: T.blue }} />
                </Box>
                <Typography sx={{ fontSize: 11, color: T.txtPri, fontFamily: "'DM Sans', sans-serif", fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.1em' }}>Comments</Typography>
              </Box>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <BlueTextField fullWidth multiline rows={3} label="What happened? (First comment)" value={firstcomment} onChange={handleFirstComment} placeholder="Describe the conversation, meeting, or interaction…" required />
                </Grid>
                <Grid item xs={12}>
                  <BlueTextField fullWidth multiline rows={3} label="Next Action Plan (Second comment)" value={secondcomment} onChange={handleSecondComment} placeholder="What's the next step? When will you follow up?" required />
                </Grid>
              </Grid>
            </SurfaceCard>

            {(!firstcomment.trim() || !secondcomment.trim()) && (
              <Box sx={{ mb: 2, p: 1.5, borderRadius: 2, bgcolor: 'rgba(249,115,22,0.06)', border: `1px solid rgba(249,115,22,0.25)`, display: 'flex', alignItems: 'center', gap: 1 }}>
                <WarningIcon sx={{ fontSize: 14, color: T.warning }} />
                <Typography sx={{ fontSize: 12, color: T.warning, fontFamily: "'DM Sans', sans-serif", fontWeight: 500 }}>Please fill in both comment fields before submitting</Typography>
              </Box>
            )}

            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
              <BlueButton onClick={onsubmitdata} disabled={sendloading}
                startIcon={sendloading ? null : (selectedStageName === 'Done Deal' || selectedStageName === 'EOI') ? <CheckCircleIcon sx={{ fontSize: 16 }} /> : <SendIcon sx={{ fontSize: 16 }} />}
                endIcon={sendloading ? <CircularProgress size={14} color="inherit" /> : null}>
                {sendloading ? 'Submitting…' : selectedStageName === 'Done Deal' ? '🎉 Complete Deal & Add Comment' : selectedStageName === 'EOI' ? '📝 Add EOI & Comment' : 'Add Comment'}
              </BlueButton>
            </Box>
          </TabPanel>

          {/* ════ TAB 2: ALL COMMENTS ════ */}
          <TabPanel value={tabValue} index={2}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
              <Box>
                <Typography sx={{ fontSize: 15, fontWeight: 700, color: T.txtPri, fontFamily: "'DM Sans', sans-serif" }}>All Comments</Typography>
                <Typography sx={{ fontSize: 12, color: T.txtSec, fontFamily: "'DM Sans', sans-serif" }}>
                  <Box component="span" sx={{ fontWeight: 700, color: T.txtPri }}>{totalCommentsCount}</Box> total · Page{' '}
                  <Box component="span" sx={{ fontWeight: 700, color: T.txtPri }}>{currentPage}</Box> of {totalPages}
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <NavBtn onClick={() => getallactiondata(1)} disabled={isCommentsLoading}>
                  {isCommentsLoading ? <CircularProgress size={14} sx={{ color: T.blue }} /> : <RefreshIcon sx={{ fontSize: 16 }} />}
                </NavBtn>
                <OutlineBtn size="small" startIcon={<AddIcon sx={{ fontSize: 13 }} />} onClick={() => setTabValue(1)}>New Comment</OutlineBtn>
              </Box>
            </Box>

            {filterInfo?.applied === 'filtered_by_date' && (
              <Box sx={{ mb: 2, p: 1.5, borderRadius: 2, bgcolor: `${T.info}10`, border: `1px solid ${T.info}30`, display: 'flex', alignItems: 'center', gap: 1 }}>
                <InfoIcon sx={{ fontSize: 14, color: T.info }} />
                <Typography sx={{ fontSize: 12, color: T.info, fontFamily: "'DM Sans', sans-serif" }}>
                  Showing comments after assignment: {moment(filterInfo.assignmentInfo?.assignDateTime).format('DD/MM/YYYY hh:mm A')}
                </Typography>
              </Box>
            )}

            {isCommentsLoading && <LinearProgress sx={{ mb: 2, borderRadius: 1, height: 2, '& .MuiLinearProgress-bar': { background: `linear-gradient(90deg, ${T.blueDark}, ${T.blue})` } }} />}

            {!isCommentsLoading && comments?.length > 0 ? (
              <Box>
                {[...comments].sort((a, b) => new Date(b.stageDate) - new Date(a.stageDate)).map((comment, idx) => (
                  <SurfaceCard key={comment._id || idx} sx={{ mb: 2, overflow: 'hidden' }}>
                    <Box sx={{ px: 2.5, py: 1.5, display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: `1px solid ${T.border}`, bgcolor: T.panel }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        <Avatar src={comment.sales?.profileImg} sx={{ width: 32, height: 32, fontSize: 12, fontWeight: 800, background: `linear-gradient(135deg, ${T.blueDark}, ${T.blue})` }}>
                          {comment.sales?.name?.charAt(0)}
                        </Avatar>
                        <Box>
                          <Typography sx={{ fontSize: 13, fontWeight: 700, color: T.txtPri, fontFamily: "'DM Sans', sans-serif", lineHeight: 1.2 }}>{comment.sales?.name}</Typography>
                          <Typography sx={{ fontSize: 10, color: T.txtMut, fontFamily: "'DM Sans', sans-serif" }}>{moment(comment.stageDate).format('DD MMM YYYY, HH:mm')}</Typography>
                        </Box>
                      </Box>
                      {comment.stage && <StageTag name={comment.stage.name} />}
                    </Box>
                    <Box sx={{ px: 2.5, py: 2 }}>
                      {comment.firstcomment?.text && (
                        <Box sx={{ mb: 2 }}>
                          <Typography sx={{ fontSize: 10, color: T.blue, fontFamily: "'DM Sans', sans-serif", fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.08em', mb: 0.8 }}>Comment</Typography>
                          <Box sx={{ p: 1.5, borderRadius: 2, bgcolor: T.panel, borderLeft: `3px solid ${T.blue}`, border: `1px solid ${T.border}`, borderLeftWidth: 3, borderLeftColor: T.blue }}>
                            <Typography sx={{ fontSize: 13, color: T.txtPri, fontFamily: "'DM Sans', sans-serif", lineHeight: 1.6, whiteSpace: 'pre-wrap' }}>{comment.firstcomment.text}</Typography>
                          </Box>
                        </Box>
                      )}
                      {comment.secondcomment?.text && (
                        <Box>
                          <Typography sx={{ fontSize: 10, color: T.info, fontFamily: "'DM Sans', sans-serif", fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.08em', mb: 0.8 }}>Next Plan</Typography>
                          <Box sx={{ p: 1.5, borderRadius: 2, bgcolor: T.panel, borderLeft: `3px solid ${T.info}`, border: `1px solid ${T.border}`, borderLeftWidth: 3, borderLeftColor: T.info }}>
                            <Typography sx={{ fontSize: 13, color: T.txtSec, fontFamily: "'DM Sans', sans-serif", lineHeight: 1.6, whiteSpace: 'pre-wrap' }}>{comment.secondcomment.text}</Typography>
                          </Box>
                        </Box>
                      )}
                      <CommentReplies comment={comment} onReplyAdded={refreshComments} />
                    </Box>
                  </SurfaceCard>
                ))}
                {totalPages > 1 && (
                  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1, mt: 3, pt: 2, borderTop: `1px solid ${T.border}` }}>
                    <NavBtn disabled={!hasPrev || isCommentsLoading} onClick={() => getallactiondata(currentPage - 1)}>
                      <KeyboardArrowUpIcon sx={{ fontSize: 14 }} />
                    </NavBtn>
                    <Typography sx={{ fontSize: 12, color: T.txtSec, fontFamily: "'DM Sans', sans-serif", px: 1 }}>
                      <Box component="span" sx={{ fontWeight: 700, color: T.txtPri }}>{currentPage}</Box> / {totalPages}
                    </Typography>
                    <NavBtn disabled={!hasNext || isCommentsLoading} onClick={() => getallactiondata(currentPage + 1)}>
                      <KeyboardArrowDownIcon sx={{ fontSize: 14 }} />
                    </NavBtn>
                  </Box>
                )}
              </Box>
            ) : !isCommentsLoading && (
              <Box sx={{ textAlign: 'center', py: 10 }}>
                <Box sx={{ width: 64, height: 64, borderRadius: '50%', bgcolor: T.panel, border: `1px solid ${T.border}`, display: 'flex', alignItems: 'center', justifyContent: 'center', mx: 'auto', mb: 2 }}>
                  <CommentIcon sx={{ fontSize: 28, color: T.txtMut }} />
                </Box>
                <Typography sx={{ fontSize: 15, fontWeight: 700, color: T.txtPri, fontFamily: "'DM Sans', sans-serif", mb: 1 }}>No Comments Yet</Typography>
                <Typography sx={{ fontSize: 13, color: T.txtSec, fontFamily: "'DM Sans', sans-serif", mb: 3 }}>
                  {filterInfo?.applied === 'filtered_by_date' ? 'Only comments after assignment date are shown' : 'Start by adding the first comment'}
                </Typography>
                <BlueButton size="small" startIcon={<AddIcon sx={{ fontSize: 14 }} />} onClick={() => setTabValue(1)} sx={{ fontSize: 12, py: '8px', px: '18px' }}>
                  Add First Comment
                </BlueButton>
              </Box>
            )}
          </TabPanel>
        </Box>
      </Dialog>

      {/* ── LEAD PREVIEW ── */}
      <Dialog open={openLeadPreview} onClose={() => setOpenLeadPreview(false)} maxWidth="sm" fullWidth sx={{ zIndex: Z.preview }}
        PaperProps={{ sx: { background: T.card, border: `1px solid ${T.border}`, borderRadius: 3 } }}>
        <DialogTitle sx={{ pb: 1, background: T.header, position: 'relative', overflow: 'hidden' }}>
          <Typography sx={{ fontSize: 15, fontWeight: 700, color: '#fff', fontFamily: "'DM Sans', sans-serif" }}>Lead Preview</Typography>
        </DialogTitle>
        <DialogContent sx={{ pt: 2.5 }}>
          <Grid container spacing={2}>
            {[['Name', user?.name], ['Phone', user?.phone], ['Email', user?.email || 'N/A'], ['Stage', null, <StageTag key="stage" name={user?.stage?.name} />], ['Project', user?.project?.name]].map(([label, value, custom]) => (
              <Grid item xs={6} key={label}>
                <Typography sx={{ fontSize: 10, color: T.txtMut, fontFamily: "'DM Sans', sans-serif", textTransform: 'uppercase', letterSpacing: '0.06em', mb: 0.5, fontWeight: 600 }}>{label}</Typography>
                {custom || <Typography sx={{ fontSize: 13, color: T.txtPri, fontFamily: "'DM Sans', sans-serif", fontWeight: 600 }}>{value}</Typography>}
              </Grid>
            ))}
            {userlogin?.data?.role === 'Admin' && ['Done Deal', 'EOI'].includes(user?.stage?.name) && (
              [['Unit #', user?.unitnumber], ['Unit Price', user?.unit_price], ['Commission %', user?.commissionratio], ['Commission AED', user?.commissionmoney], ['Cashback %', user?.cashbackratio], ['Cashback AED', user?.cashbackmoney]].map(([l, v]) => (
                <Grid item xs={6} key={l}>
                  <Typography sx={{ fontSize: 10, color: T.txtMut, fontFamily: "'DM Sans', sans-serif", textTransform: 'uppercase', letterSpacing: '0.06em', mb: 0.5, fontWeight: 600 }}>{l}</Typography>
                  <Typography sx={{ fontSize: 13, color: T.blue, fontFamily: "'DM Sans', sans-serif", fontWeight: 700 }}>{v}</Typography>
                </Grid>
              ))
            )}
          </Grid>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <BlueButton size="small" onClick={() => setOpenLeadPreview(false)} sx={{ fontSize: 12, py: '7px', px: '18px' }}>Close</BlueButton>
        </DialogActions>
      </Dialog>
    </>
  );
};



// ===============================================================================
// quality score

// import React, { useEffect, useMemo, useState, useCallback, useRef } from 'react';
// import { DesktopDateTimePicker } from '@mui/x-date-pickers/DesktopDateTimePicker';

// import {
//   Box,
//   Container,
//   Typography,
//   Card,
//   CardContent,
//   CardHeader,
//   Avatar,
//   IconButton,
//   Button,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   List,
//   Divider,
//   TextField,
//   Switch,
//   FormControlLabel,
//   Autocomplete,
//   Tooltip,
//   CircularProgress,
//   Chip,
//   Grid,
//   Slide,
//   AppBar,
//   Toolbar,
//   Tabs,
//   Tab,
//   useTheme,
//   styled,
//   InputAdornment,
//   Alert,
//   Paper,
//   Fade,
//   Collapse,
//   Modal,
//   Backdrop,
//   LinearProgress
// } from '@mui/material';
// import { LocalizationProvider } from '@mui/x-date-pickers';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
// import {
//   Close as CloseIcon,
//   Person as PersonIcon,
//   Phone as PhoneIcon,
//   WhatsApp as WhatsAppIcon,
//   Email as EmailIcon,
//   Work as WorkIcon,
//   CalendarToday as CalendarIcon,
//   Comment as CommentIcon,
//   AddComment as AddCommentIcon,
//   Info as InfoIcon,
//   Add as AddIcon,
//   Refresh as RefreshIcon,
//   Visibility as VisibilityIcon,
//   Edit as EditIcon,
//   Send as SendIcon,
//   CheckCircle as CheckCircleIcon,
//   Warning as WarningIcon,
//   PhoneInTalk as PhoneInTalkIcon,
//   AttachMoney as AttachMoneyIcon,
//   Cancel as CancelIcon,
//   Done as DoneIcon,
//   ChangeCircle as ChangeCircleIcon,
//   Schedule as ScheduleIcon,
//   KeyboardArrowDown as KeyboardArrowDownIcon,
//   KeyboardArrowUp as KeyboardArrowUpIcon,
//   AssignmentTurnedIn as AssignmentTurnedInIcon
// } from '@mui/icons-material';
// import { Link } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import moment from 'moment';
// import dayjs from 'dayjs';
// import JSConfetti from 'js-confetti';

// // Import actions
// import {
//   GetAllcomments_Data_With_Pagination_action_advanced,
//   InsertNewAction_action,
//   Insert_Comment_Replay_Action
// } from '../Redux/Actions/Action_action';
// import { UpdateStageToLeed } from '../Redux/Actions/UsersAction';
// import { Get_All_Lead_Assigned_Data_Action } from '../Redux/Actions/Lead_Assigned_Action';
// import { GetAll_stage_Data, GetOne_stagetogettype_Data } from '../Redux/Actions/Stage_Action';
// import { Insert_Lead_Stages_Data_Action } from '../Redux/Actions/Lead_Stages_Changed_Action';

// // Import utilities and components
// import { Notify } from '../Utility/Notify';

// // =============================================================================================
// // Styled Components
// // =============================================================================================

// const StyledCard = styled(Card)(({ theme }) => ({
//   borderRadius: 16,
//   boxShadow: theme.palette.mode === 'dark'
//     ? '0 8px 32px rgba(0,0,0,0.3)'
//     : '0 8px 32px rgba(16, 45, 255, 0.08)',
//   transition: 'transform 0.3s ease, box-shadow 0.3s ease',
//   '&:hover': {
//     transform: 'translateY(-2px)',
//     boxShadow: theme.palette.mode === 'dark'
//       ? '0 12px 48px rgba(0,0,0,0.4)'
//       : '0 12px 48px rgba(16, 45, 255, 0.12)'
//   }
// }));

// const GradientButton = styled(Button)(({ theme }) => ({
//   background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//   color: 'white',
//   fontWeight: 600,
//   borderRadius: 12,
//   padding: '12px 24px',
//   textTransform: 'none',
//   '&:hover': {
//     background: 'linear-gradient(135deg, #764ba2 0%, #667eea 100%)',
//     transform: 'translateY(-1px)'
//   }
// }));

// const CommentTextField = styled(TextField)(({ theme }) => ({
//   '& .MuiOutlinedInput-root': {
//     borderRadius: 12,
//     backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.02)',
//     transition: 'all 0.3s ease',
//     '&:hover': {
//       backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.04)'
//     },
//     '&.Mui-focused': {
//       backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'white',
//       boxShadow: `0 0 0 3px ${theme.palette.primary.main}20`
//     },
//     '& input, & textarea': {
//       fontSize: '16px !important', // منع zoom في iOS
//     }
//   },
//   '& .MuiOutlinedInput-notchedOutline': {
//     borderColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'
//   }
// }));

// const StageChip = styled(Chip)(({ theme, stagecolor }) => ({
//   borderRadius: 8,
//   fontWeight: 600,
//   backgroundColor: stagecolor || theme.palette.primary.main,
//   color: 'white',
//   '& .MuiChip-label': {
//     padding: '4px 12px'
//   }
// }));

// const StatusChip = styled(Chip)(({ theme, status }) => {
//   let color;
//   switch (status?.toLowerCase()) {
//     case 'hot':
//       color = theme.palette.error.main;
//       break;
//     case 'warm':
//       color = theme.palette.warning.main;
//       break;
//     case 'cold':
//       color = theme.palette.info.main;
//       break;
//     case 'done deal':
//       color = theme.palette.success.main;
//       break;
//     case 'eoi':
//       return {
//         backgroundColor: '#FFF3E0',
//         color: '#EF6C00',
//         fontWeight: 600,
//         border: '1px solid #FFCC80',
//       };
//     case 'reservation':
//       return {
//         backgroundColor: '#E3F2FD',
//         color: '#1565C0',
//         fontWeight: 600,
//         border: '1px solid #90CAF9',
//       };
//     default:
//       color = theme.palette.grey[600];
//   }
//   return {
//     backgroundColor: `${color}15`,
//     color: color,
//     fontWeight: 600,
//     border: `1px solid ${color}30`,
//   };
// });

// const Transition = React.forwardRef(function Transition(props, ref) {
//   return <Slide direction="up" ref={ref} {...props} />;
// });

// // Scrollable Container Styled Component
// const ScrollableContainer = styled(Box)(({ theme }) => ({
//   overflowY: 'auto',
//   maxHeight: 'calc(80vh - 200px)',
//   minHeight: '300px',
//   paddingRight: theme.spacing(1),
//   '&::-webkit-scrollbar': {
//     width: '8px',
//   },
//   '&::-webkit-scrollbar-track': {
//     background: theme.palette.mode === 'dark' ? '#2d2d2d' : '#f1f1f1',
//     borderRadius: '4px',
//   },
//   '&::-webkit-scrollbar-thumb': {
//     background: theme.palette.mode === 'dark' ? '#555' : '#888',
//     borderRadius: '4px',
//     '&:hover': {
//       background: theme.palette.mode === 'dark' ? '#777' : '#555',
//     }
//   },
//   scrollbarWidth: 'thin',
//   scrollbarColor: `${theme.palette.mode === 'dark' ? '#555 #2d2d2d' : '#888 #f1f1f1'}`,
// }));

// const FormScrollContainer = styled(Box)(({ theme }) => ({
//   overflowY: 'auto',
//   maxHeight: '500px',
//   paddingRight: theme.spacing(1),
//   '&::-webkit-scrollbar': {
//     width: '8px',
//   },
//   '&::-webkit-scrollbar-track': {
//     background: theme.palette.mode === 'dark' ? '#2d2d2d' : '#f1f1f1',
//     borderRadius: '4px',
//   },
//   '&::-webkit-scrollbar-thumb': {
//     background: theme.palette.mode === 'dark' ? '#555' : '#888',
//     borderRadius: '4px',
//     '&:hover': {
//       background: theme.palette.mode === 'dark' ? '#777' : '#555',
//     }
//   },
// }));

// // Current Stage Display Component
// const CurrentStageDisplay = styled(Box)(({ theme }) => ({
//   display: 'flex',
//   alignItems: 'center',
//   gap: theme.spacing(2),
//   padding: theme.spacing(2),
//   backgroundColor: theme.palette.primary.lighter,
//   borderRadius: theme.spacing(1),
//   border: `1px solid ${theme.palette.primary.light}`,
//   marginBottom: theme.spacing(2),
// }));

// // Helper function to get stage color
// const getStageColor = (stageName) => {
//   switch (stageName?.toLowerCase()) {
//     case 'done deal':
//       return '#4CAF50';
//     case 'hot':
//       return '#F44336';
//     case 'warm':
//       return '#FF9800';
//     case 'cold':
//       return '#2196F3';
//     case 'eoi':
//       return '#FF5722';
//     case 'reservation':
//       return '#3F51B5';
//     case 'answer':
//       return '#009688';
//     case 'no answer':
//       return '#9E9E9E';
//     case 'meeting':
//       return '#9C27B0';
//     case 'follow':
//       return '#795548';
//     default:
//       return '#757575';
//   }
// };

// // =============================================================================================
// // Tab Panel Component with Scroll
// // =============================================================================================

// function TabPanel(props) {
//   const { children, value, index, ...other } = props;

//   return (
//     <div
//       role="tabpanel"
//       hidden={value !== index}
//       id={`action-tabpanel-${index}`}
//       aria-labelledby={`action-tab-${index}`}
//       {...other}
//       style={{
//         width: '100%',
//         height: 'calc(80vh - 120px)',
//         display: 'flex',
//         flexDirection: 'column'
//       }}
//     >
//       {value === index && (
//         <ScrollableContainer>
//           <Box sx={{ p: 3 }}>
//             {children}
//           </Box>
//         </ScrollableContainer>
//       )}
//     </div>
//   );
// }

// // =============================================================================================
// // Budget Input Component with Step of 50000
// // =============================================================================================

// const BudgetInput = React.memo(({ budget, onBudgetChange }) => {
//   const handleIncrement = () => {
//     const currentValue = parseFloat(budget) || 0;
//     const newValue = currentValue + 50000;
//     onBudgetChange({ target: { value: newValue.toString() } });
//   };

//   const handleDecrement = () => {
//     const currentValue = parseFloat(budget) || 0;
//     const newValue = Math.max(0, currentValue - 50000);
//     onBudgetChange({ target: { value: newValue.toString() } });
//   };

//   return (
//     <Box>
//       <TextField
//         fullWidth
//         label="Budget Amount (AED)"
//         type="number"
//         value={budget || ''}
//         onChange={onBudgetChange}
//         variant="outlined"
//         size="small"
//         InputProps={{
//           startAdornment: <InputAdornment position="start">AED</InputAdornment>,
//           endAdornment: (
//             <Box sx={{ display: 'flex', gap: 0.5 }}>
//               <IconButton
//                 size="small"
//                 onClick={handleDecrement}
//                 sx={{ border: '1px solid', borderColor: 'grey.400' }}
//               >
//                 <Typography variant="body2">-50K</Typography>
//               </IconButton>
//               <IconButton
//                 size="small"
//                 onClick={handleIncrement}
//                 sx={{ border: '1px solid', borderColor: 'grey.400' }}
//               >
//                 <Typography variant="body2">+50K</Typography>
//               </IconButton>
//             </Box>
//           ),
//         }}
//         helperText="Use +/- 50K buttons or type manually"
//         inputProps={{
//           style: { fontSize: '16px' }
//         }}
//       />
//     </Box>
//   );
// });

// // =============================================================================================
// // Timeline Component
// // =============================================================================================

// const TimelineSection = React.memo(({ timeline, onTimelineChange, disabled }) => {
//   return (
//     <Box>
//       <Typography variant="subtitle1" fontWeight={600} gutterBottom>
//         Timeline
//       </Typography>
//       <Grid container spacing={1}>
//         <Grid item xs={12}>
//           <Button
//             fullWidth
//             variant={timeline === "within_week_to_month" ? "contained" : "outlined"}
//             color={timeline === "within_week_to_month" ? "primary" : "inherit"}
//             onClick={() => onTimelineChange("within_week_to_month")}
//             disabled={disabled}
//             sx={{
//               py: 1.5,
//               mb: 1,
//               justifyContent: 'flex-start',
//               textAlign: 'left'
//             }}
//             startIcon={<CalendarIcon />}
//           >
//             <Box>
//               <Typography variant="body1" fontWeight={600}>
//                 Within Week to 1 Month
//               </Typography>
//               <Typography variant="caption" color="textSecondary">
//                 2 Degrees - Ready to move quickly
//               </Typography>
//             </Box>
//           </Button>
//         </Grid>

//         <Grid item xs={12}>
//           <Button
//             fullWidth
//             variant={timeline === "within_1_to_3_months" ? "contained" : "outlined"}
//             color={timeline === "within_1_to_3_months" ? "primary" : "inherit"}
//             onClick={() => onTimelineChange("within_1_to_3_months")}
//             disabled={disabled}
//             sx={{
//               py: 1.5,
//               mb: 1,
//               justifyContent: 'flex-start',
//               textAlign: 'left'
//             }}
//             startIcon={<CalendarIcon />}
//           >
//             <Box>
//               <Typography variant="body1" fontWeight={600}>
//                 Within 1 Month to 3 Months
//               </Typography>
//               <Typography variant="caption" color="textSecondary">
//                 1 Degree - Planning phase
//               </Typography>
//             </Box>
//           </Button>
//         </Grid>

//         <Grid item xs={12}>
//           <Button
//             fullWidth
//             variant={timeline === "more_than_3_months" ? "contained" : "outlined"}
//             color={timeline === "more_than_3_months" ? "error" : "inherit"}
//             onClick={() => onTimelineChange("more_than_3_months")}
//             disabled={disabled}
//             sx={{
//               py: 1.5,
//               justifyContent: 'flex-start',
//               textAlign: 'left',
//               borderColor: timeline === "more_than_3_months" ? 'error.main' : 'grey.400',
//               color: timeline === "more_than_3_months" ? 'white' : 'inherit',
//               bgcolor: timeline === "more_than_3_months" ? 'error.main' : 'transparent',
//               '&:hover': {
//                 bgcolor: timeline === "more_than_3_months" ? 'error.dark' : 'grey.100',
//                 borderColor: timeline === "more_than_3_months" ? 'error.dark' : 'grey.500'
//               }
//             }}
//             startIcon={<CalendarIcon />}
//           >
//             <Box>
//               <Typography variant="body1" fontWeight={600}>
//                 More than 3 Months
//               </Typography>
//               <Typography variant="caption" color="textSecondary">
//                 0 Degrees - Long term planning
//               </Typography>
//             </Box>
//           </Button>
//         </Grid>
//       </Grid>

//       {timeline && (
//         <Alert
//           severity={
//             timeline === "within_week_to_month" ? "success" :
//             timeline === "within_1_to_3_months" ? "info" : "warning"
//           }
//           sx={{ mt: 1, py: 0.5 }}
//         >
//           <Typography variant="body2">
//             {timeline === "within_week_to_month" ? "Ready within month (2 Degrees)" :
//              timeline === "within_1_to_3_months" ? "1-3 months plan (1 Degree)" :
//              "Long term (0 Degrees)"}
//           </Typography>
//         </Alert>
//       )}
//     </Box>
//   );
// });

// // =============================================================================================
// // Bunt Scoring Form Component
// // =============================================================================================

// const BuntScoringForm = React.memo(({
//   disabled,
//   onBudgetChange,
//   onAuthorityChange,
//   onSignInterestedChange,
//   onNeedChange,
//   onTypeChange,
//   onTimelineChange,
//   budget,
//   authority,
//   signInterested,
//   need,
//   type,
//   timeline,
//   totalScore,
//   isMeetingStage,
//   user
// }) => {
//   // Calculate lead status based on total score
// const getLeadStatus = (score) => {
//   if (score >= 8) return { status: "Hot", color: "#F44336", emoji: "🔥" };
//   if (score >= 5) return { status: "Warm", color: "#FF9800", emoji: "⚡" };
//   if (score >= 2) return { status: "Cold", color: "#2196F3", emoji: "❄️" };
//   return { status: "Not Qualified", color: "#757575", emoji: "📝" };
// };

//   const leadStatus = getLeadStatus(totalScore);

//   // Calculate budget score with project comparison - حسب الشرح الجديد
//   const calculateBudgetScore = (budgetValue, projectStartPrice) => {
//     if (!budgetValue) return { score: 0, label: "No budget" };

//     const budgetNum = parseFloat(budgetValue);

//     if (projectStartPrice) {
//       const projectPrice = parseFloat(projectStartPrice);

//       // حسب الشرح الجديد:
//       // 1. إذا كان Budget = أو > Project Price => 3 درجات
//       // 2. إذا كان Budget < Project Price => 2 درجات
//       // 3. إذا كان Budget = 500,000 => 1 درجة
//       // 4. إذا كان Budget < 500,000 => 0 درجات

//       if (budgetNum >= projectPrice) {
//         return {
//           score: 3,
//           label: "Same/Above Project Price",
//           description: `Budget (${budgetNum.toLocaleString()}) ≥ Project Price (${projectPrice.toLocaleString()})`
//         };
//       } else if (budgetNum < projectPrice) {
//         // التحقق من حالة 500,000
//         if (budgetNum === 500000) {
//           return {
//             score: 1,
//             label: "Exactly 500K",
//             description: `Budget (${budgetNum.toLocaleString()}) = 500,000 (less than project price)`
//           };
//         } else if (budgetNum < 500000) {
//           return {
//             score: 0,
//             label: "Below 500K",
//             description: `Budget (${budgetNum.toLocaleString()}) < 500,000`
//           };
//         } else {
//           // بين 500,000 و Project Price
//           return {
//             score: 2,
//             label: "Less than Project Price",
//             description: `Budget (${budgetNum.toLocaleString()}) < Project Price (${projectPrice.toLocaleString()})`
//           };
//         }
//       }
//     } else {
//       // Fallback logic if no project price
//       if (budgetNum >= 1000000) {
//         return { score: 3, label: "High (1M+)" };
//       } else if (budgetNum >= 500000) {
//         return { score: 2, label: "Medium (500K-1M)" };
//       } else if (budgetNum < 500000) {
//         return { score: 0, label: "Low (<500K)" };
//       } else if (budgetNum === 500000) {
//         return { score: 1, label: "Exactly 500K" };
//       }
//     }

//     return { score: 0, label: "No budget" };
//   };

//   const budgetScore = calculateBudgetScore(budget, user?.project?.startprice);

//   // Calculate timeline score
//   const calculateTimelineScore = (timelineValue) => {
//     switch(timelineValue) {
//       case "within_week_to_month":
//         return { score: 2, label: "Within Week to 1 Month" };
//       case "within_1_to_3_months":
//         return { score: 1, label: "1-3 Months" };
//       case "more_than_3_months":
//         return { score: 0, label: "More than 3 Months" };
//       default:
//         return { score: 0, label: "Not selected" };
//     }
//   };

//   const timelineScore = calculateTimelineScore(timeline);

//   return (
//     <Paper
//       elevation={0}
//       sx={{
//         p: 3,
//         border: '2px solid',
//         borderColor: disabled ? 'grey.400' : 'primary.main',
//         borderRadius: 2,
//         bgcolor: disabled ? 'grey.100' : 'primary.lighter',
//         opacity: disabled ? 0.7 : 1,
//         transition: 'all 0.3s ease',
//         mb: 3
//       }}
//     >
//       <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
//         <AttachMoneyIcon color={disabled ? "disabled" : "primary"} sx={{ mr: 1.5 }} />
//         <Typography variant="h6" color={disabled ? "text.disabled" : "primary"} fontWeight={600}>
//           Bunt Scoring
//           {disabled && (
//             <Chip
//               label="Disabled"
//               size="small"
//               sx={{ ml: 2, fontSize: '0.7rem' }}
//               color="default"
//             />
//           )}
//         </Typography>
//       </Box>

//       {disabled ? (
//         <Alert severity="info" sx={{ mt: 2 }}>
//           <Typography variant="body2">
//             Scoring is disabled because the lead is in a non-active stage.
//             Scoring is only available for active leads.
//           </Typography>
//         </Alert>
//       ) : (
//         <Grid container spacing={3}>

//           {/* Sign & Interested Section */}
//           <Grid item xs={12}>
//             <Typography variant="subtitle1" fontWeight={600} gutterBottom>
//               Sign & Interested
//             </Typography>
//             <FormControlLabel
//               control={
//                 <Switch
//                   checked={signInterested === true}
//                   onChange={onSignInterestedChange}
//                   color="secondary"
//                   disabled={disabled}
//                 />
//               }
//               label={
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                   <AssignmentTurnedInIcon color={signInterested ? "secondary" : "disabled"} />
//                   <Typography variant="body1">
//                     Signed & Interested
//                   </Typography>
//                   {signInterested === true && (
//                     <Chip
//                       label="1 Degree"
//                       size="small"
//                       color="secondary"
//                       variant="outlined"
//                     />
//                   )}
//                 </Box>
//               }
//             />
//             {signInterested === true && (
//               <Alert severity="secondary" sx={{ mt: 1, py: 0.5, bgcolor: 'secondary.light', color: 'secondary.contrastText' }}>
//                 <Typography variant="body2">
//                   Lead is signed & interested → <strong>1 Degree</strong>
//                 </Typography>
//               </Alert>
//             )}
//           </Grid>

//           {/* Budget Section */}
//           <Grid item xs={12}>
//             <Typography variant="subtitle1" fontWeight={600} gutterBottom>
//               Budget {user?.project?.startprice && (
//                 <Chip
//                   label={`Project: ${parseFloat(user.project.startprice).toLocaleString()} AED`}
//                   size="small"
//                   color="info"
//                   variant="outlined"
//                   sx={{ ml: 1 }}
//                 />
//               )}
//             </Typography>
//             <Grid container spacing={2}>
//               <Grid item xs={12} md={6}>
//                 <BudgetInput
//                   budget={budget}
//                   onBudgetChange={onBudgetChange}
//                 />
//                 {user?.project?.startprice && (
//                   <Typography variant="caption" color="textSecondary" sx={{ mt: 1, display: 'block' }}>
//                     Project starting price: {parseFloat(user.project.startprice).toLocaleString()} AED
//                   </Typography>
//                 )}
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <Box sx={{
//                   p: 2,
//                   bgcolor: budget ? 'primary.lighter' : 'grey.50',
//                   borderRadius: 1,
//                   border: '1px solid',
//                   borderColor: budget ? 'primary.main' : 'grey.400',
//                   height: '100%',
//                   display: 'flex',
//                   flexDirection: 'column',
//                   justifyContent: 'center'
//                 }}>
//                   <Typography variant="body2" color="textSecondary">
//                     Budget Score:
//                   </Typography>
//                   <Typography variant="h4" color={budget ? "primary.main" : "text.disabled"}>
//                     {budgetScore.score}
//                   </Typography>
//                   <Typography variant="caption" color="textSecondary">
//                     {budgetScore.label} - {budgetScore.score} Degree{budgetScore.score !== 1 ? 's' : ''}
//                   </Typography>
//                   {budgetScore.description && (
//                     <Typography variant="caption" color="primary" sx={{ mt: 0.5 }}>
//                       {budgetScore.description}
//                     </Typography>
//                   )}
//                   {budget && (
//                     <Typography variant="caption" color="primary" sx={{ mt: 0.5 }}>
//                       AED {parseFloat(budget).toLocaleString()}
//                     </Typography>
//                   )}
//                 </Box>
//               </Grid>
//             </Grid>
//           </Grid>

//           {/* Authority Section */}
//           <Grid item xs={12}>
//             <Typography variant="subtitle1" fontWeight={600} gutterBottom>
//               Authority
//             </Typography>
//             <FormControlLabel
//               control={
//                 <Switch
//                   checked={authority === true}
//                   onChange={onAuthorityChange}
//                   color="primary"
//                   disabled={disabled}
//                 />
//               }
//               label={
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                   <Typography variant="body1">
//                     Has Decision Making Authority
//                   </Typography>
//                   {authority === true && (
//                     <Chip
//                       label="1 Degree"
//                       size="small"
//                       color="success"
//                       variant="outlined"
//                     />
//                   )}
//                 </Box>
//               }
//             />
//             {authority === true && (
//               <Alert severity="success" sx={{ mt: 1, py: 0.5 }}>
//                 <Typography variant="body2">
//                   Lead has authority → <strong>1 Degree</strong>
//                 </Typography>
//               </Alert>
//             )}
//           </Grid>

//           {/* Need Section */}
//           <Grid item xs={12}>
//             <Typography variant="subtitle1" fontWeight={600} gutterBottom>
//               Need
//             </Typography>
//             <Grid container spacing={1}>
//               <Grid item xs={4}>
//                 <Button
//                   fullWidth
//                   variant={need === "residential" ? "contained" : "outlined"}
//                   color={need === "residential" ? "primary" : "inherit"}
//                   onClick={() => onNeedChange("residential")}
//                   sx={{ py: 1.5 }}
//                   disabled={disabled}
//                 >
//                   Residential
//                 </Button>
//               </Grid>
//               <Grid item xs={4}>
//                 <Button
//                   fullWidth
//                   variant={need === "investor" ? "contained" : "outlined"}
//                   color={need === "investor" ? "primary" : "inherit"}
//                   onClick={() => onNeedChange("investor")}
//                   sx={{ py: 1.5 }}
//                   disabled={disabled}
//                 >
//                   Investor
//                 </Button>
//               </Grid>
//               <Grid item xs={4}>
//                 <Button
//                   fullWidth
//                   variant={need === "none" ? "contained" : "outlined"}
//                   color={need === "none" ? "error" : "inherit"}
//                   onClick={() => onNeedChange("none")}
//                   disabled={disabled}
//                   sx={{
//                     py: 1.5,
//                     borderColor: need === "none" ? 'error.main' : 'grey.400',
//                     color: need === "none" ? 'white' : 'inherit',
//                     bgcolor: need === "none" ? 'error.main' : 'transparent',
//                     '&:hover': {
//                       bgcolor: need === "none" ? 'error.dark' : 'grey.100',
//                       borderColor: need === "none" ? 'error.dark' : 'grey.500'
//                     }
//                   }}
//                 >
//                   Not Clear
//                 </Button>
//               </Grid>
//             </Grid>
//             {need && (
//               <Alert
//                 severity={need === "none" ? "warning" : "info"}
//                 sx={{ mt: 1, py: 0.5,
//                   bgcolor: need === "none" ? '#FFF8E1' : '#E3F2FD'
//                 }}
//               >
//                 <Typography variant="body2">
//                   {need === "residential" ? "Residential Need" :
//                    need === "investor" ? "Investor Need" :
//                    "No Need"} → <strong>{need === "none" ? "0" : "1"} Degree</strong>
//                 </Typography>
//               </Alert>
//             )}
//           </Grid>

//           {/* Type Section */}
//           <Grid item xs={12}>
//             <Typography variant="subtitle1" fontWeight={600} gutterBottom>
//               Property Type
//             </Typography>
//             <Grid container spacing={1}>
//               {['studio', '1Bhk', '2Bhk', '3Bhk', '4Bhk', 'villa'].map((propertyType) => (
//                 <Grid item xs={6} sm={4} key={propertyType}>
//                   <Button
//                     fullWidth
//                     variant={type === propertyType ? "contained" : "outlined"}
//                     color={type === propertyType ? "primary" : "inherit"}
//                     onClick={() => onTypeChange(propertyType)}
//                     sx={{ py: 1 }}
//                     disabled={disabled}
//                   >
//                     {propertyType.charAt(0).toUpperCase() + propertyType.slice(1)}
//                   </Button>
//                 </Grid>
//               ))}
//               <Grid item xs={6} sm={4}>
//                 <Button
//                   fullWidth
//                   variant={type === "none" ? "contained" : "outlined"}
//                   color={type === "none" ? "error" : "inherit"}
//                   onClick={() => onTypeChange("none")}
//                   disabled={disabled}
//                   sx={{
//                     py: 1,
//                     borderColor: type === "none" ? 'error.main' : 'grey.400',
//                     color: type === "none" ? 'white' : 'inherit',
//                     bgcolor: type === "none" ? 'error.main' : 'transparent',
//                     '&:hover': {
//                       bgcolor: type === "none" ? 'error.dark' : 'grey.100',
//                       borderColor: type === "none" ? 'error.dark' : 'grey.500'
//                     }
//                   }}
//                 >
//                   Not Clear
//                 </Button>
//               </Grid>
//             </Grid>
//             {type && (
//               <Alert
//                 severity={type === "none" ? "warning" : "success"}
//                 sx={{ mt: 1, py: 0.5,
//                   bgcolor: type === "none" ? '#FFF8E1' : '#E8F5E9'
//                 }}
//               >
//                 <Typography variant="body2">
//                   {type === "none" ? "No Type" :
//                    type.charAt(0).toUpperCase() + type.slice(1) + " Type"} →
//                   <strong> {type === "none" ? "0" : "1"} Degree</strong>
//                 </Typography>
//               </Alert>
//             )}
//           </Grid>

//           {/* Timeline Section */}
//           <Grid item xs={12}>
//             <TimelineSection
//               timeline={timeline}
//               onTimelineChange={onTimelineChange}
//               disabled={disabled}
//             />
//           </Grid>

//           {/* Meeting Stage Bonus */}
//         {isMeetingStage && (
//   <Grid item xs={12}>
//     <Alert
//       severity="success"
//       icon={<CheckCircleIcon />}
//       sx={{
//         py: 1,
//         bgcolor: '#4CAF50',
//         color: 'white',
//         '& .MuiAlert-icon': {
//           color: 'white'
//         }
//       }}
//     >
//       <Typography variant="body1" fontWeight={600}>
//         🎉 Meeting/Follow After Meeting Bonus: +1 Degree
//       </Typography>
//       <Typography variant="body2">
//         Lead is in {isMeetingStage} stage, added 1 extra degree!
//       </Typography>
//     </Alert>
//   </Grid>
// )}

//           {/* Total Score Display - ALWAYS VISIBLE */}
//           <Grid item xs={12}>
//             <Box sx={{
//               mt: 2,
//               p: 3,
//               bgcolor: leadStatus.color,
//               borderRadius: 2,
//               textAlign: 'center',
//               color: 'white'
//             }}>
//               <Typography variant="h4" fontWeight={600} gutterBottom>
//                 {leadStatus.emoji} Total Bunt Score: {totalScore}/10 {leadStatus.emoji}
//               </Typography>
//               <Typography variant="h5" fontWeight={600} gutterBottom>
//                 Lead Status: {leadStatus.status}
//               </Typography>
//               <LinearProgress
//                 variant="determinate"
//                 value={(totalScore / 10) * 100}
//                 sx={{
//                   mt: 2,
//                   height: 12,
//                   borderRadius: 6,
//                   bgcolor: 'rgba(255,255,255,0.3)',
//                   '& .MuiLinearProgress-bar': {
//                     bgcolor: 'white'
//                   }
//                 }}
//               />

//               {/* Score Breakdown */}
//               <Grid container spacing={1} sx={{ mt: 2 }}>
//                 <Grid item xs={2}>
//                   <Box sx={{ p: 1, bgcolor: 'rgba(255,255,255,0.2)', borderRadius: 1 }}>
//                     <Typography variant="body2">Budget</Typography>
//                     <Typography variant="h6">{budgetScore.score}</Typography>
//                   </Box>
//                 </Grid>
//                 <Grid item xs={1}>
//                   <Box sx={{ p: 1, bgcolor: 'rgba(255,255,255,0.2)', borderRadius: 1 }}>
//                     <Typography variant="body2">Auth</Typography>
//                     <Typography variant="h6">{authority === true ? "1" : "0"}</Typography>
//                   </Box>
//                 </Grid>
//                 <Grid item xs={1}>
//                   <Box sx={{ p: 1, bgcolor: 'rgba(255,255,255,0.2)', borderRadius: 1 }}>
//                     <Typography variant="body2">Sign</Typography>
//                     <Typography variant="h6">{signInterested === true ? "1" : "0"}</Typography>
//                   </Box>
//                 </Grid>
//                 <Grid item xs={1}>
//                   <Box sx={{ p: 1, bgcolor: 'rgba(255,255,255,0.2)', borderRadius: 1 }}>
//                     <Typography variant="body2">Need</Typography>
//                     <Typography variant="h6">
//                       {need === "none" ? "0" : need ? "1" : "0"}
//                     </Typography>
//                   </Box>
//                 </Grid>
//                 <Grid item xs={1}>
//                   <Box sx={{ p: 1, bgcolor: 'rgba(255,255,255,0.2)', borderRadius: 1 }}>
//                     <Typography variant="body2">Type</Typography>
//                     <Typography variant="h6">
//                       {type === "none" ? "0" : type ? "1" : "0"}
//                     </Typography>
//                   </Box>
//                 </Grid>
//                 <Grid item xs={2}>
//                   <Box sx={{ p: 1, bgcolor: 'rgba(255,255,255,0.2)', borderRadius: 1 }}>
//                     <Typography variant="body2">Timeline</Typography>
//                     <Typography variant="h6">
//                       {timelineScore.score}
//                     </Typography>
//                   </Box>
//                 </Grid>
//           <Grid item xs={2}>
//   <Box sx={{ p: 1, bgcolor: 'rgba(255,255,255,0.2)', borderRadius: 1 }}>
//     <Typography variant="body2">Meeting/Follow</Typography>
//     <Typography variant="h6">
//       {(isMeetingStage === "Meeting" || isMeetingStage === "Follow After Meeting") ? "1" : "0"}
//     </Typography>
//   </Box>
// </Grid>
//                 <Grid item xs={2}>
//                   <Box sx={{ p: 1, bgcolor: 'rgba(255,255,255,0.3)', borderRadius: 1, border: '2px solid white' }}>
//                     <Typography variant="body2">Total</Typography>
//                     <Typography variant="h6">{totalScore}</Typography>
//                   </Box>
//                 </Grid>
//               </Grid>

//               {/* Lead Quality Message */}
//             <Box sx={{ mt: 2, p: 1.5, bgcolor: 'rgba(0,0,0,0.2)', borderRadius: 1 }}>
//   <Typography variant="body2">
//     {totalScore >= 8 ? "🔥 Hot Lead: High conversion potential!" :
//      totalScore >= 5 ? "⚡ Warm Lead: Good potential, needs follow-up" :
//      totalScore >= 2 ? "❄️ Cold Lead: Needs more qualification" :
//      "📝 Not Qualified: Needs initial qualification"}
//   </Typography>
// </Box>
//             </Box>
//           </Grid>
//         </Grid>
//       )}
//     </Paper>
//   );
// });

// // =============================================================================================
// // CommentReplies Component
// // =============================================================================================

// const CommentReplies = React.memo(({ comment, currentUserId, onReplyAdded, theme }) => {
//   const [showInput, setShowInput] = useState(false);
//   const [replyText, setReplyText] = useState('');
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [loadingreplay, setloadingreplay] = useState(true);

//   const dispatch = useDispatch();

//   const userLogin = JSON.parse(localStorage.getItem('user'))?.data || {};

//   const handleSubmitReply = async () => {
//     if (!replyText.trim() || !comment?._id || !userLogin?._id) return;

//     setIsSubmitting(true);
//     try {
//       const body = {
//         commentId: comment._id,
//         replyText: replyText.trim(),
//         userId: userLogin._id,
//       };
//       setloadingreplay(true)

//       await dispatch(Insert_Comment_Replay_Action(body));

//       setloadingreplay(false)

//     } catch (error) {
//       console.error('Error adding reply:', error);
//       Notify('error', 'Error adding reply', 'error');
//     } finally {
//       setIsSubmitting(false);
//       setloadingreplay(false)

//     }
//   };

//   const resaddreplay = useSelector(state => state.AllActions.insrertrepaly)

//   useEffect(() => {
//     if (loadingreplay === false) {
//       if (resaddreplay?.status === 200 || resaddreplay?.success) {
//         Notify('success', 'Reply added successfully', 'success');
//         setReplyText('');
//         setShowInput(false);

//         // Callback to refresh comments
//         if (loadingreplay === false) onReplyAdded();
//       } else {
//         Notify('error', 'Failed to add reply', 'error');
//       }
//     }
//   }, [loadingreplay])

//   const handleKeyPress = (e) => {
//     if (e.key === 'Enter' && !e.shiftKey) {
//       e.preventDefault();
//       handleSubmitReply();
//     }
//   };

//   // Check if user can reply
//   const canReply = userLogin?.role === 'Sales' ||
//                    userLogin?.role === 'Team Leader' ||
//                    userLogin?.role === 'Admin';

//   if (!canReply && (!comment?.replies || comment.replies.length === 0)) {
//     return null;
//   }

//   return (
//     <Box sx={{ mt: 2, pl: 3, borderLeft: `2px solid ${theme.palette.divider}` }}>
//       {/* Replies List */}
//       {comment?.replies && comment.replies.length > 0 ? (
//         <Box sx={{ mb: 2 }}>
//           <Typography variant="subtitle2" fontWeight={600} gutterBottom color="text.secondary">
//             Replies ({comment.replies.length})
//           </Typography>

//           {comment.replies.map((reply, index) => (
//             <Card
//               key={reply._id || index}
//               variant="outlined"
//               sx={{
//                 mb: 1,
//                 p: 1.5,
//                 borderRadius: 1,
//                 bgcolor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.02)',
//                 borderColor: theme.palette.divider
//               }}
//             >
//               <Box display="flex" gap={1}>
//                 <Avatar
//                   src={reply.user?.profileImg}
//                   sx={{ width: 28, height: 28 }}
//                 >
//                   {reply.user?.name?.charAt(0)}
//                 </Avatar>
//                 <Box flex={1}>
//                   <Box display="flex" justifyContent="space-between" alignItems="flex-start">
//                     <Box>
//                       <Typography variant="caption" fontWeight={600} color="text.primary">
//                         {reply.user?.name}
//                       </Typography>
//                       <Typography variant="caption" color="text.secondary" sx={{ ml: 1 }}>
//                         • {reply.user?.role}
//                       </Typography>
//                     </Box>
//                     <Typography variant="caption" color="text.secondary">
//                       {moment(reply.date).format('DD/MM/YYYY hh:mm A')}
//                     </Typography>
//                   </Box>
//                   <Typography variant="body2" sx={{ mt: 0.5, whiteSpace: 'pre-wrap' }}>
//                     {reply.text}
//                   </Typography>
//                 </Box>
//               </Box>
//             </Card>
//           ))}
//         </Box>
//       ) : (
//         canReply && (
//           <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic', mb: 2 }}>
//             No replies yet
//           </Typography>
//         )
//       )}

//       {/* Reply Input - Only show if user can reply */}
//       {canReply && (
//         <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>
//           <Avatar
//             src={userLogin.profileImg}
//             sx={{ width: 32, height: 32, mt: 0.5 }}
//           >
//             {userLogin.name?.charAt(0)}
//           </Avatar>

//           <Box sx={{ flex: 1 }}>
//             {showInput ? (
//               <>
//                 <TextField
//                   fullWidth
//                   multiline
//                   rows={2}
//                   value={replyText}
//                   onChange={(e) => setReplyText(e.target.value)}
//                   onKeyPress={handleKeyPress}
//                   placeholder="Write your reply..."
//                   variant="outlined"
//                   size="small"
//                   disabled={isSubmitting}
//                   autoFocus
//                   sx={{
//                     '& .MuiOutlinedInput-root': {
//                       backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.02)',
//                       '& input, & textarea': {
//                         fontSize: '16px',
//                       }
//                     }
//                   }}
//                 />
//                 <Box sx={{ display: 'flex', gap: 1, mt: 1, justifyContent: 'flex-end' }}>
//                   <Button
//                     size="small"
//                     onClick={() => {
//                       setShowInput(false);
//                       setReplyText('');
//                     }}
//                     disabled={isSubmitting}
//                   >
//                     Cancel
//                   </Button>
//                   <Button
//                     variant="contained"
//                     size="small"
//                     onClick={handleSubmitReply}
//                     disabled={!replyText.trim() || isSubmitting}
//                     startIcon={isSubmitting ? <CircularProgress size={16} /> : <SendIcon />}
//                   >
//                     {isSubmitting ? 'Sending...' : 'Reply'}
//                   </Button>
//                 </Box>
//               </>
//             ) : (
//               <Button
//                 variant="outlined"
//                 size="small"
//                 startIcon={<AddCommentIcon />}
//                 onClick={() => setShowInput(true)}
//                 sx={{ width: '100%', justifyContent: 'flex-start' }}
//               >
//                 Add a reply...
//               </Button>
//             )}
//           </Box>

//           {/* Refresh button */}
//           {comment?.replies && comment.replies.length > 0 && (
//             <Tooltip title="Refresh replies">
//               <IconButton
//                 size="small"
//                 onClick={onReplyAdded}
//                 sx={{ mt: 0.5 }}
//               >
//                 <RefreshIcon fontSize="small" />
//               </IconButton>
//             </Tooltip>
//           )}
//         </Box>
//       )}
//     </Box>
//   );
// });

// // =============================================================================================
// // Done Deal Form Component
// // =============================================================================================

// const DoneDealForm = React.memo(({
//   unitPrice,
//   unitnumber,
//   commissionRatio,
//   cashbackratio,
//   totalCommission,
//   cashbackMoney,
//   onPriceChange,
//   onUnitNumberChange,
//   onCommissionRatioChange,
//   onCashbackRatioChange
// }) => {
//   return (
//     <Box>
//       <Grid container spacing={2}>
//         <Grid item xs={12}>
//           <TextField
//             fullWidth
//             label="Unit Price (AED)"
//             type="text"
//             value={unitPrice}
//             onChange={onPriceChange}
//             variant="outlined"
//             margin="normal"
//             InputProps={{
//               startAdornment: <InputAdornment position="start">AED</InputAdornment>,
//             }}
//             autoComplete="off"
//             inputProps={{
//               inputMode: 'decimal',
//               pattern: '[0-9]*[.]?[0-9]*',
//               style: { fontSize: '16px' }
//             }}
//           />
//         </Grid>
//         <Grid item xs={12}>
//           <TextField
//             fullWidth
//             label="Unit Number"
//             value={unitnumber}
//             onChange={onUnitNumberChange}
//             variant="outlined"
//             margin="normal"
//             placeholder="e.g., A101, Tower 2"
//             autoComplete="off"
//             inputProps={{
//               style: { fontSize: '16px' }
//             }}
//           />
//         </Grid>
//         <Grid item xs={6}>
//           <TextField
//             fullWidth
//             label="Commission %"
//             type="text"
//             value={commissionRatio}
//             onChange={onCommissionRatioChange}
//             variant="outlined"
//             margin="normal"
//             helperText="Enter commission percentage"
//             InputProps={{
//               endAdornment: <InputAdornment position="end">%</InputAdornment>,
//             }}
//             autoComplete="off"
//             inputProps={{
//               inputMode: 'decimal',
//               pattern: '[0-9]*[.]?[0-9]*',
//               style: { fontSize: '16px' }
//             }}
//           />
//         </Grid>
//         <Grid item xs={6}>
//           <TextField
//             fullWidth
//             label="Total Commission (AED)"
//             value={totalCommission}
//             disabled
//             variant="outlined"
//             margin="normal"
//             helperText="Auto calculated"
//             InputProps={{
//               startAdornment: <InputAdornment position="start">AED</InputAdornment>,
//             }}
//             sx={{
//               '& .MuiInputBase-input.Mui-disabled': {
//                 WebkitTextFillColor: '#2E7D32',
//                 fontWeight: 600
//               }
//             }}
//           />
//         </Grid>
//         <Grid item xs={6}>
//           <TextField
//             fullWidth
//             label="Cashback %"
//             type="text"
//             value={cashbackratio}
//             onChange={onCashbackRatioChange}
//             variant="outlined"
//             margin="normal"
//             helperText="Enter cashback percentage (0 for no cashback)"
//             InputProps={{
//               endAdornment: <InputAdornment position="end">%</InputAdornment>,
//             }}
//             autoComplete="off"
//             inputProps={{
//               inputMode: 'decimal',
//               pattern: '[0-9]*[.]?[0-9]*',
//               style: { fontSize: '16px' }
//             }}
//           />
//         </Grid>
//         <Grid item xs={6}>
//           <TextField
//             fullWidth
//             label="Cashback Amount (AED)"
//             value={cashbackMoney}
//             disabled
//             variant="outlined"
//             margin="normal"
//             helperText="Auto calculated"
//             InputProps={{
//               startAdornment: <InputAdornment position="start">AED</InputAdornment>,
//             }}
//             sx={{
//               '& .MuiInputBase-input.Mui-disabled': {
//                 WebkitTextFillColor: '#1976D2'
//               }
//             }}
//           />
//         </Grid>
//       </Grid>
//     </Box>
//   );
// });

// // =============================================================================================
// // Stage Specific Form Component
// // =============================================================================================

// const StageSpecificForm = React.memo(({
//   selectedStageName,
//   eoiAmount,
//   reservationAmount,
//   onEoiAmountChange,
//   onReservationAmountChange,
//   unitPrice,
//   unitnumber,
//   commissionRatio,
//   cashbackratio,
//   totalCommission,
//   cashbackMoney,
//   onPriceChange,
//   onUnitNumberChange,
//   onCommissionRatioChange,
//   onCashbackRatioChange
// }) => {
//   if (!selectedStageName) return null;

//   return (
//     <Box mb={3}>
//       <Typography variant="subtitle1" fontWeight={600} gutterBottom color="primary">
//         {selectedStageName} Information
//       </Typography>

//       {/* EOI Fields */}
//       {selectedStageName === "EOI" && (
//         <TextField
//           fullWidth
//           label="EOI Amount (AED)"
//           type="text"
//           value={eoiAmount}
//           onChange={onEoiAmountChange}
//           variant="outlined"
//           margin="normal"
//           InputProps={{
//             startAdornment: <InputAdornment position="start">AED</InputAdornment>,
//           }}
//           helperText="Enter the Expression of Interest amount"
//           autoComplete="off"
//           inputProps={{
//             inputMode: 'decimal',
//             pattern: '[0-9]*[.]?[0-9]*',
//             style: { fontSize: '16px' }
//           }}
//         />
//       )}

//       {/* Reservation Fields */}
//       {selectedStageName === "Reservation" && (
//         <TextField
//           fullWidth
//           label="Reservation Amount (AED)"
//           type="text"
//           value={reservationAmount}
//           onChange={onReservationAmountChange}
//           variant="outlined"
//           margin="normal"
//           InputProps={{
//             startAdornment: <InputAdornment position="start">AED</InputAdornment>,
//           }}
//           helperText="Enter the reservation deposit amount"
//           autoComplete="off"
//           inputProps={{
//             inputMode: 'decimal',
//             pattern: '[0-9]*[.]?[0-9]*',
//             style: { fontSize: '16px' }
//           }}
//         />
//       )}

//       {/* Done Deal Fields */}
//       {selectedStageName === "Done Deal" && (
//         <DoneDealForm
//           unitPrice={unitPrice}
//           unitnumber={unitnumber}
//           commissionRatio={commissionRatio}
//           cashbackratio={cashbackratio}
//           totalCommission={totalCommission}
//           cashbackMoney={cashbackMoney}
//           onPriceChange={onPriceChange}
//           onUnitNumberChange={onUnitNumberChange}
//           onCommissionRatioChange={onCommissionRatioChange}
//           onCashbackRatioChange={onCashbackRatioChange}
//         />
//       )}
//     </Box>
//   );
// });

// // =============================================================================================
// // Comment Inputs Component
// // =============================================================================================

// const CommentInputs = React.memo(({
//   firstcomment,
//   secondcomment,
//   onFirstCommentChange,
//   onSecondCommentChange
// }) => {
//   return (
//     <Box mb={3}>
//       <Typography variant="subtitle1" fontWeight={600} gutterBottom>
//         Add Comments
//       </Typography>

//       <Grid container spacing={3}>
//         <Grid item xs={12}>
//           <CommentTextField
//             fullWidth
//             multiline
//             rows={3}
//             label="First Comment - What happened?"
//             value={firstcomment}
//             onChange={onFirstCommentChange}
//             placeholder="Describe the conversation, meeting, or interaction that just occurred..."
//             required
//           />
//         </Grid>

//         <Grid item xs={12}>
//           <CommentTextField
//             fullWidth
//             multiline
//             rows={3}
//             label="Second Comment - Next Action Plan"
//             value={secondcomment}
//             onChange={onSecondCommentChange}
//             placeholder="What's the next step? When will you follow up? What specific actions need to be taken?"
//             required
//           />
//         </Grid>
//       </Grid>
//     </Box>
//   );
// });

// // =============================================================================================
// // Current Stage Component
// // =============================================================================================

// const CurrentStageComponent = React.memo(({ user, addActionEnabled }) => {
//   if (!addActionEnabled) return null;

//   return (
//     <Fade in={addActionEnabled} timeout={500}>
//       <CurrentStageDisplay>
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: 1 }}>
//           <DoneIcon color="primary" />
//           <Typography variant="body1" fontWeight={600} color="text.primary">
//             Current Stage:
//           </Typography>
//           <StatusChip
//             label={user?.stage?.name}
//             status={user?.stage?.name}
//             size="medium"
//             sx={{
//               bgcolor: getStageColor(user?.stage?.name),
//               color: 'white',
//               fontSize: '0.875rem'
//             }}
//           />
//         </Box>
//         <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>
//           You are now in the stages component
//         </Typography>
//       </CurrentStageDisplay>
//     </Fade>
//   );
// });

// // =============================================================================================
// // Main Component
// // =============================================================================================
// const datePickerStyles = `
//   /* حل نهائي لمشكلة z-index في DateTimePicker */
//   .MuiPickersPopper-root {
//     z-index: 50001 !important;
//   }

//   .MuiDialog-root .MuiPickersPopper-root,
//   .MuiDialog-root .MuiPickersModal-root,
//   .MuiDialog-root .MuiModal-root {
//     z-index: 50001 !important;
//   }

//   .MuiPickersModal-dialog {
//     z-index: 50001 !important;
//   }

//   .MuiPickersCalendarHeader-root,
//   .MuiPickersCalendar-root {
//     z-index: 50001 !important;
//   }

//   .MuiPickersDay-root {
//     z-index: 50002 !important;
//   }

//   /* حل خاص للشاشات الصغيرة */
//   @media (max-width: 768px) {
//     .MuiPickersPopper-root {
//       z-index: 50001 !important;
//       position: fixed !important;
//       top: 50% !important;
//       left: 50% !important;
//       transform: translate(-50%, -50%) !important;
//     }
//   }
// `;
// export const ShowClientsActionsAdvanced = ({ user, leadid, onClose }) => {
//   const theme = useTheme();
//   const dispatch = useDispatch();
//  useEffect(() => {
//     const styleElement = document.createElement('style');
//     styleElement.innerHTML = datePickerStyles;
//     document.head.appendChild(styleElement);

//     return () => {
//       document.head.removeChild(styleElement);
//     };
//   }, []);
//   const [open, setOpen] = useState(false);
//   const [addActionEnabled, setAddActionEnabled] = useState(false);
//   const [userlogin, setUserLogin] = useState('');

//   // Tab state
//   const [tabValue, setTabValue] = useState(0);

//   // استخدام useRef للقيم التي لا تحتاج إعادة render
//   const userloginrealy = useRef(JSON.parse(localStorage.getItem('user')) || []);

//   // States الرئيسية
//   const [selectedStage, setSelectedStage] = useState(null);
//   const [showDateTimePicker, setShowDateTimePicker] = useState(false);
//   const [stageType, setStageType] = useState(null);
//   const [selectedStageId, setSelectedStageId] = useState(null);
//   const [selectedStageName, setSelectedStageName] = useState(null);
//   const [firstcomment, setFirstComment] = useState('');
//   const [secondcomment, setSecondComment] = useState('');
//   const [valuedate, setValueDate] = useState(dayjs());
//   const [loading, setLoading] = useState(true);
//   const [sendloading, setSendLoading] = useState(false);
//   const [allstagesshow, setAllStagesShow] = useState([]);

//   // States for Done Deal
//   const [unitPrice, setUnitPrice] = useState('');
//   const [isPriceValid, setIsPriceValid] = useState(false);
//   const [unitnumber, setUnitNumber] = useState('');
//   const [isunitnumberValid, setIsUnitNumberValid] = useState(false);
//   const [commissionRatio, setCommissionRatio] = useState('');
//   const [commissionratioValid, setIsCommissionRatioValid] = useState(false);
//   const [totalCommission, setTotalCommission] = useState('');
//   const [cashbackratiovalid, setIsCashbackRatioValid] = useState(false);
//   const [cashbackratio, setCashbackRatio] = useState('');
//   const [cashbackMoney, setCashbackMoney] = useState('');

//   // States for EOI and Reservation
//   const [eoiAmount, setEoiAmount] = useState('');
//   const [reservationAmount, setReservationAmount] = useState('');
//   const [isEoiAmountValid, setIsEoiAmountValid] = useState(false);
//   const [isReservationAmountValid, setIsReservationAmountValid] = useState(false);

//   // Switch state for Answer and No Answer
//   const [isNoAnswer, setIsNoAnswer] = useState(false);

//   // Comments state
//   const [comments, setComments] = useState([]);
//   const [isCommentsLoading, setIsCommentsLoading] = useState(false);
//   const [isReady, setIsReady] = useState(false);

//   // Pagination states - FIXED: يتم تحديثها من response السيرفر
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalCommentsCount, setTotalCommentsCount] = useState(0);
//   const [hasNext, setHasNext] = useState(false);
//   const [hasPrev, setHasPrev] = useState(false);

//   // Filter info
//   const [filterInfo, setFilterInfo] = useState(null);

//   // Bunt Scoring States
//   const [budget, setBudget] = useState('');
//   const [authority, setAuthority] = useState(false);
//   const [signInterested, setSignInterested] = useState(false); // إضافة Sign & Interested
//   const [need, setNeed] = useState('');
//   const [type, setType] = useState('');
//   const [timeline, setTimeline] = useState(''); // إضافة Timeline
//   const [buntScore, setBuntScore] = useState(0);

//   // Stages that need DateTimePicker
//   const stagesWithDateTime = useMemo(() => [
//     'No Answer',
//     'Answer',
//     'Meeting',
//     'Follow',
//     'Follow After Meeting',
//     'Follow Up',
//     'Transfer',
//     'Interested'
//   ], []);

//   // Dialog states
//   const [openLeadPreview, setOpenLeadPreview] = useState(false);

//   // Refs for scrolling
//   const doneDealSectionRef = useRef(null);
//   const formContainerRef = useRef(null);
//   const commentsContainerRef = useRef(null);

//   // Get data from Redux
//   const resgetallassignsdata = useSelector(state => state.AllLead_Assigned.Lead_Assigned);
//   const resaddcomment = useSelector(state => state.AllActions.AddAction);
//   const All_stages = useSelector(state => state.Allstages.stage);
//   const resgetonestagetype = useSelector(state => state.Allstages.getstagetogetype);

//   // حل مشكلة الـ z-index على الموبايل
//   useEffect(() => {
//     const handleResize = () => {
//       // إعادة حساب z-index عند تغيير حجم الشاشة
//       const dialog = document.querySelector('.MuiDialog-root');
//       if (dialog && window.innerWidth < 768) {
//         dialog.style.zIndex = '50000';
//       }
//     };

//     window.addEventListener('resize', handleResize);
//     handleResize(); // استدعاء مباشر

//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   // Initialize user login
//   useEffect(() => {
//     if (JSON.parse(localStorage.getItem("user")) != null) {
//       setUserLogin(JSON.parse(localStorage.getItem("user")));
//     }
//   }, []);

//   // Calculate Bunt Score whenever inputs change
//   useEffect(() => {
//     let score = 0;

//     // Budget score - مقارنة مع سعر المشروع حسب الشرح الجديد
//     if (budget && user?.project?.startprice) {
//       const budgetNum = parseFloat(budget);
//       const projectPrice = parseFloat(user.project.startprice);

//       // الشرح الجديد:
//       // 1. إذا كان Budget = أو > Project Price => 3 درجات
//       // 2. إذا كان Budget < Project Price => 2 درجات
//       // 3. إذا كان Budget = 500,000 => 1 درجة
//       // 4. إذا كان Budget < 500,000 => 0 درجات

//       if (budgetNum >= projectPrice) {
//         score += 3; // نفس سعر المشروع أو أعلى
//       } else if (budgetNum < projectPrice) {
//         // التحقق من حالة 500,000
//         if (budgetNum === 500000) {
//           score += 1; // بالضبط 500,000
//         } else if (budgetNum < 500000) {
//           score += 0; // أقل من 500,000
//         } else {
//           score += 2; // بين 500,000 و Project Price
//         }
//       }
//     } else if (budget) {
//       // إذا لم يكن هناك سعر مشروع، نستخدم المنطق القديم
//       const budgetNum = parseFloat(budget);
//       if (budgetNum >= 1000000) {
//         score += 3;
//       } else if (budgetNum >= 500000) {
//         score += 2;
//       } else if (budgetNum < 500000) {
//         score += 0;
//       } else if (budgetNum === 500000) {
//         score += 1;
//       }
//     }

//     // Authority score
//     if (authority === true) {
//       score += 1;
//     }

//     // Sign & Interested score
//     if (signInterested === true) {
//       score += 1;
//     }

//     // Need score
//     if (need && need !== "none") {
//       score += 1;
//     }

//     // Type score
//     if (type && type !== "none") {
//       score += 1;
//     }

//     // Timeline score
//     if (timeline === "within_week_to_month") {
//       score += 2;
//     } else if (timeline === "within_1_to_3_months") {
//       score += 1;
//     } else if (timeline === "more_than_3_months") {
//       score += 0;
//     }

//     // Meeting stage bonus
//     if (selectedStageName === "Meeting" || selectedStageName === "Follow After Meeting") {
//   score += 1;
// }

//     setBuntScore(score);
//   }, [budget, authority, signInterested, need, type, timeline, selectedStageName, user?.project?.startprice]);

//   // دالة لتحميل التعليقات باستخدام الأكشن - FIXED
//   const getallactiondata = useCallback(async (page = 1) => {
//     try {
//       setIsCommentsLoading(true);

//       const userId = userloginrealy.current?.data?._id;
//       const leadId = leadid || user?._id;

//       if (!leadId || !userId) {
//         console.error('Missing leadId or userId:', { leadId, userId });
//         Notify('error', 'Cannot load comments: missing user data', 'error');
//         return;
//       }

//       console.log('Fetching comments for:', { leadId, userId, page });

//       // استدعاء الأكشن
//       const params = {
//         leadId: user?._id,
//         userId: userId,
//         page: page,
//         limit: 20
//       };

//       const response = await dispatch(GetAllcomments_Data_With_Pagination_action_advanced(params));

//       console.log('Redux action response:', response);

//       if (response?.success && response?.comments) {
//         // تحديث التعليقات مباشرة
//         setComments(response.comments);

//         // تحديث معلومات الباجينيشن من response السيرفر - FIXED
//         if (response.pagination) {
//           setCurrentPage(response.pagination.page || page);
//           setTotalPages(response.pagination.totalPages || 1);
//           setHasNext(response.pagination.hasNext || false);
//           setHasPrev(response.pagination.hasPrev || false);
//         }

//         // تحديث العدد الكلي - FIXED: استخدام totalComments من response
//         setTotalCommentsCount(response.totalComments || response.comments.length || 0);

//         // تحديث معلومات الفلتر
//         if (response.filterApplied) {
//           setFilterInfo({
//             applied: response.filterApplied,
//             assignmentInfo: response.assignmentInfo
//           });
//         }

//         console.log('Updated pagination:', {
//           currentPage: response.pagination?.page || page,
//           totalPages: response.pagination?.totalPages || 1,
//           hasNext: response.pagination?.hasNext,
//           hasPrev: response.pagination?.hasPrev,
//           totalComments: response.totalComments
//         });
//       }

//     } catch (error) {
//       console.error('Error fetching comments:', error);
//       Notify('error', 'Failed to load comments', 'error');
//     } finally {
//       setIsCommentsLoading(false);
//     }
//   }, [dispatch, leadid, user?._id]);

//   // دالة لتحديث التعليقات بعد إضافة رد
//   const refreshComments = useCallback(() => {
//     getallactiondata(currentPage);
//   }, [getallactiondata, currentPage]);

//   // Get all stages
//   const getallstages = useCallback(async () => {
//     try {
//       await dispatch(GetAll_stage_Data());
//     } catch (error) {
//       console.error('Error loading stages:', error);
//     }
//   }, [dispatch]);

//   // Load data on open
//   useEffect(() => {
//     let timeout;
//     if (open) {
//       setIsReady(false);

//       timeout = setTimeout(async () => {
//         await getallstages();
//         setIsReady(true);
//       }, 500);
//     }

//     return () => clearTimeout(timeout);
//   }, [open, getallstages]);

//   // Set all stages
//   useEffect(() => {
//     if (All_stages && All_stages?.data) {
//       setAllStagesShow(All_stages.data);
//     }
//   }, [All_stages]);

//   // Set stage type
//   useEffect(() => {
//     if (resgetonestagetype) {
//       if (resgetonestagetype.data) {
//         setStageType(resgetonestagetype.data);
//       } else {
//         setStageType(null);
//       }
//     } else {
//       setStageType(null);
//     }
//   }, [resgetonestagetype]);

//   // Generate automatic comments
//   const generateAutoComments = useCallback((stageName) => {
//     const commentTemplates = {
//       'Meeting': {
//         firstComment: 'تم تحديد موعد للقاء',
//         secondComment: 'سيتم مناقشة التفاصيل أثناء اللقاء'
//       },
//       'Follow Up': {
//         firstComment: '',
//         secondComment: ''
//       },
//       'Follow After Meeting': {
//         firstComment: '',
//         secondComment: ''
//       },
//       'Interested': {
//         firstComment: '',
//         secondComment: ''
//       },
//       'No Answer': {
//         firstComment: 'اتصلت ومفيش رد',
//         secondComment: 'هحاول تاني في وقت تاني'
//       },
//       'Answer': {
//         firstComment: 'رد عليا',
//         secondComment: 'هكتب اللي قاله وهشوف هعمل ايه بعد كده'
//       },
//       'Done Deal': {
//         firstComment: 'تم إتمام الصفقة بنجاح',
//         secondComment: 'سيتم متابعة التسليم والإجراءات'
//       },
//       'EOI': {
//         firstComment: 'تم تقديم عرض النوايا',
//         secondComment: 'بانتظار موافقة العميل'
//       },
//       'Reservation': {
//         firstComment: 'تم حجز الوحدة',
//         secondComment: 'سيتم متابعة الدفعات'
//       }
//     };

//     return commentTemplates[stageName] || { firstComment: '', secondComment: '' };
//   }, []);

//   // Handle stage change
//   const handleStageChange = useCallback((event, newValue) => {
//     if (newValue) {
//       setSelectedStage(newValue);
//       const stageName = newValue.name;
//       const stageId = newValue._id;

//       setSelectedStageId(stageId);
//       setSelectedStageName(stageName);

//       if (stagesWithDateTime.includes(stageName) || stageName === "Answer" || stageName === "No Answer") {
//         setShowDateTimePicker(true);
//       } else {
//         setShowDateTimePicker(false);
//         setValueDate(null);
//       }

//       // Get stage type information
//       dispatch(GetOne_stagetogettype_Data(stageId))
//         .then(response => {
//           if (response?.data) {
//             setStageType(response.data);
//           }
//         })
//         .catch(error => {
//           console.error('Error fetching stage type:', error);
//         });

//       const autoComments = generateAutoComments(stageName);
//       setFirstComment(autoComments.firstComment);
//       setSecondComment(autoComments.secondComment);

//       if (stageName === 'No Answer') {
//         setIsNoAnswer(true);
//       } else if (stageName === 'Answer') {
//         setIsNoAnswer(false);
//       }

//       // Scroll to Done Deal section when selected
//       if (stageName === "Done Deal" && doneDealSectionRef.current) {
//         setTimeout(() => {
//           doneDealSectionRef.current.scrollIntoView({
//             behavior: 'smooth',
//             block: 'start'
//           });
//         }, 100);
//       }
//     } else {
//       setSelectedStage(null);
//       setSelectedStageId(null);
//       setSelectedStageName(null);
//       setStageType(null);
//       setShowDateTimePicker(false);
//     }
//   }, [dispatch, generateAutoComments, stagesWithDateTime]);

//   // Function to reset stage form
//   const resetStageForm = useCallback(() => {
//     setUnitPrice('');
//     setUnitNumber('');
//     setCommissionRatio('');
//     setCashbackRatio('');
//     setEoiAmount('');
//     setReservationAmount('');
//     setIsPriceValid(false);
//     setIsUnitNumberValid(false);
//     setIsCommissionRatioValid(false);
//     setIsCashbackRatioValid(false);
//     setIsEoiAmountValid(false);
//     setIsReservationAmountValid(false);
//     setStageType(null);
//     setSelectedStage(null);
//     setShowDateTimePicker(false);
//     setValueDate(null);
//     setIsNoAnswer(false);
//   }, []);

//   // Handle Enable Action toggle
//   const handleEnableActionToggle = useCallback((isChecked) => {
//     setAddActionEnabled(isChecked);

//     if (isChecked && user?.stage) {
//       // Set current stage as selected stage initially
//       setSelectedStage(user.stage);
//       setSelectedStageId(user.stage._id);
//       setSelectedStageName(user.stage.name);

//       // Check if DateTimePicker should be shown
//       if (stagesWithDateTime.includes(user.stage.name)) {
//         setShowDateTimePicker(true);
//       } else {
//         setShowDateTimePicker(false);
//         setValueDate(null);
//       }

//       // Get stage type information
//       dispatch(GetOne_stagetogettype_Data(user.stage._id))
//         .then(response => {
//           if (response?.data) {
//             setStageType(response.data);
//           }
//         })
//         .catch(error => {
//           console.error('Error fetching stage type:', error);
//         });

//       // Generate auto comments for current stage
//       const autoComments = generateAutoComments(user.stage.name);
//       setFirstComment(autoComments.firstComment);
//       setSecondComment(autoComments.secondComment);

//       // Set Answer/No Answer state
//       if (user.stage.name === 'No Answer') {
//         setIsNoAnswer(true);
//       } else if (user.stage.name === 'Answer') {
//         setIsNoAnswer(false);
//       }
//     } else {
//       resetStageForm();
//     }
//   }, [user?.stage, dispatch, generateAutoComments, stagesWithDateTime, resetStageForm]);

//   // Handlers مع useCallback
//   const handlePriceChange = useCallback((e) => {
//     const value = e.target.value.replace(/[^0-9.]/g, '');
//     setUnitPrice(value);
//     const price = parseFloat(value);
//     setIsPriceValid(!isNaN(price) && price > 0);
//   }, []);

//   const handleUnitNumber = useCallback((e) => {
//     const value = e.target.value;
//     setUnitNumber(value);
//     setIsUnitNumberValid(value.trim() !== '');
//   }, []);

//   const handleCommissionRatioChange = useCallback((e) => {
//     const value = e.target.value.replace(/[^0-9.]/g, '');
//     setCommissionRatio(value);
//     const commissionratio = parseFloat(value);
//     setIsCommissionRatioValid(!isNaN(commissionratio) && commissionratio > 0);
//   }, []);

//   const handleCashbackRatioChange = useCallback((e) => {
//     const value = e.target.value.replace(/[^0-9.]/g, '');
//     setCashbackRatio(value);
//     const cashbackratio = parseFloat(value);
//     setIsCashbackRatioValid(!isNaN(cashbackratio) && cashbackratio >= 0);
//   }, []);

//   const handleEoiAmountChange = useCallback((e) => {
//     const value = e.target.value.replace(/[^0-9.]/g, '');
//     setEoiAmount(value);
//     const amount = parseFloat(value);
//     setIsEoiAmountValid(!isNaN(amount) && amount > 0);
//   }, []);

//   const handleReservationAmountChange = useCallback((e) => {
//     const value = e.target.value.replace(/[^0-9.]/g, '');
//     setReservationAmount(value);
//     const amount = parseFloat(value);
//     setIsReservationAmountValid(!isNaN(amount) && amount > 0);
//   }, []);

//   const handleDateTimeChange = useCallback((newValue) => {
//     if (newValue) {
//       setValueDate(newValue);

//       const formattedDateTime = moment(newValue.toDate()).format("MMMM Do YYYY, h:mm A");
//       const currentSecondComment = secondcomment || '';

//       const commentWithoutDate = currentSecondComment
//         .replace(/ - Follow up on .*$/, '')
//         .replace(/ - Scheduled for .*$/, '')
//         .replace(/ - Next action on .*$/, '');

//       const newComment = commentWithoutDate
//         ? `${commentWithoutDate} - Follow up on ${formattedDateTime}`
//         : `Follow up on ${formattedDateTime}`;

//       setSecondComment(newComment);
//     }
//   }, [secondcomment]);

//   const onFirstCommentChange = useCallback((e) => {
//     const value = e.target.value;
//     setFirstComment(value);
//   }, []);

//   const onSecondCommentChange = useCallback((e) => {
//     const value = e.target.value;
//     setSecondComment(value);
//   }, []);

//   // Bunt Scoring Handlers
//   const handleBudgetChange = useCallback((e) => {
//     const value = e.target.value;
//     // Allow only numbers and one decimal point
//     const validatedValue = value.replace(/[^0-9.]/g, '');
//     setBudget(validatedValue);
//   }, []);

//   const handleAuthorityChange = useCallback((e) => {
//     setAuthority(e.target.checked);
//   }, []);

//   const handleSignInterestedChange = useCallback((e) => {
//     setSignInterested(e.target.checked);
//   }, []);

//   const handleNeedChange = useCallback((selectedNeed) => {
//     setNeed(selectedNeed);
//   }, []);

//   const handleTypeChange = useCallback((selectedType) => {
//     setType(selectedType);
//   }, []);

//   // إضافة handler للـ Timeline
//   const handleTimelineChange = useCallback((selectedTimeline) => {
//     setTimeline(selectedTimeline);
//   }, []);

//   // Calculate commission
//   useEffect(() => {
//     const price = parseFloat(unitPrice);
//     const ratio = parseFloat(commissionRatio);

//     if (!isNaN(price) && !isNaN(ratio) && price > 0 && ratio > 0) {
//       const commission = (price * ratio) / 100;
//       setTotalCommission(commission.toFixed(2));
//     } else {
//       setTotalCommission('');
//     }
//   }, [unitPrice, commissionRatio]);

//   // Calculate cashback
//   useEffect(() => {
//     const price = parseFloat(unitPrice);
//     const ratio = parseFloat(cashbackratio);
//     const commission = parseFloat(totalCommission);

//     if (!isNaN(ratio)) {
//       if (ratio === 0) {
//         setCashbackMoney('0');
//       } else if (!isNaN(commission) && commission > 0 && ratio > 0) {
//         const cashback = (commission * ratio) / 100;
//         setCashbackMoney(cashback.toFixed(2));
//       } else {
//         setCashbackMoney('');
//       }
//     } else {
//       setCashbackMoney('');
//     }
//   }, [cashbackratio, totalCommission, unitPrice]);

//   // Confetti function for Done Deal
//   const DoneDealFun = useCallback(() => {
//     const jsConfetti = new JSConfetti();
//     jsConfetti.addConfetti({
//       confettiColors: [
//         "#ff0a54", "#ff477e", "#ff7096",
//         "#ff85a1", "#fbb1bd", "#f9bec7",
//       ],
//     });
//   }, []);

//   // Submit data - FIXED VERSION with Bunt Scoring
//   const onsubmitdata = async (e) => {
//     e.preventDefault();

//     // ✅ Check required fields
//     if (!firstcomment.trim()) {
//       return Notify('error', 'Please enter first comment', 'error');
//     }
//     if (!secondcomment.trim()) {
//       return Notify('error', 'Please enter second comment', 'error');
//     }

//     // ✅ If stage needs DateTimePicker, check date
//     if (showDateTimePicker && !valuedate) {
//       return Notify('error', 'Please select date & time', 'error');
//     }

//     // ✅ For other stages, use current time
//     if (!showDateTimePicker && !valuedate) {
//       setValueDate(dayjs()); // Set to current time
//     }

//     // ✅ If Add Action is enabled, validate stage requirements
//     if (addActionEnabled && selectedStageId) {
//       // التحقق من صحة المبالغ في EOI و Reservation
//       if (selectedStageName === "EOI" && (!isEoiAmountValid || eoiAmount === '')) {
//         return Notify("error", "Please enter a valid EOI amount", "error");
//       }

//       if (selectedStageName === "Reservation" && (!isReservationAmountValid || reservationAmount === '')) {
//         return Notify("error", "Please enter a valid Reservation amount", "error");
//       }

//       if (selectedStageName === "Done Deal") {
//         const price = parseFloat(unitPrice);
//         if (isNaN(price) || price <= 0) {
//           return Notify("error", "Please enter a valid unit price (greater than zero)", "error");
//         }
//         if (!unitnumber.trim()) {
//           return Notify("error", "Please enter unit number", "error");
//         }
//         if (!commissionRatio || parseFloat(commissionRatio) <= 0) {
//           return Notify("error", "Please enter a valid commission ratio", "error");
//         }
//         if (!cashbackratio || cashbackratio < 0) {
//           return Notify("error", "Please enter a valid cashback ratio", "error");
//         }
//       }
//     }

//     setLoading(true);
//     setSendLoading(true);

//     try {
//       // Determine which stage to use
//       const stageIdToUse = addActionEnabled && selectedStage ? selectedStage._id : user?.stage?._id;

//       console.log("Add Action Enabled:", addActionEnabled);
//       console.log("Selected Stage:", selectedStage);
//       console.log("Stage ID to Use:", stageIdToUse);
//       console.log("Current User Stage:", user?.stage?._id);

//       const finalStageDate = valuedate ? valuedate : dayjs();

//       // Calculate lead status based on Bunt score
//      const leadStatus =
//   buntScore >= 8 ? "Hot" :
//   buntScore >= 5 ? "Warm" :
//   buntScore >= 2 ? "Cold" : "Not Qualified";

//       // إذا كان الـ Add Action مفعل، قم بتحديث الـ stage أولاً
//       if (addActionEnabled) {
//         console.log("🔄 Updating stage to:", selectedStageName);

//         const updateData = {
//           stage: selectedStageId,
//           stagedateupdated: finalStageDate,
//           last_stage_date_updated: moment().format('YYYY-MM-DD'),
//           // Add Bunt scoring data to lead update
//           ...(budget && { budget: parseFloat(budget) }),
//           ...(authority !== undefined && { authority: authority }),
//           ...(signInterested !== undefined && { signInterested: signInterested }),
//           ...(need && {
//             investor: need === "investor",
//             residential: need === "residential",
//             noneed: need === "none"
//           }),
//           ...(type && {
//             studio: type === "studio",
//             roomandlivingroom: type === "1Bhk",
//             tworoomsandlivingroom: type === "2Bhk",
//             threeroomsandlivingroom: type === "3Bhk",
//             villa: type === "villa",
//             selectedtype: type === "4Bhk",
//             notype: type === "none"
//           }),
//           ...(timeline && {
//             timeline: timeline,
//             timelineScore: timeline === "within_week_to_month" ? 2 :
//                           timeline === "within_1_to_3_months" ? 1 : 0
//           }),
//           // Done deal specific fields
//           ...(selectedStageName === "Done Deal" && {
//             unit_price: parseFloat(unitPrice),
//             review: false,
//             unitnumber: unitnumber,
//             commissionratio: parseFloat(commissionRatio),
//             commissionmoney: totalCommission,
//             cashbackratio: parseFloat(cashbackratio),
//             cashbackmoney: cashbackMoney,
//           }),
//           ...(selectedStageName === "EOI" && {
//             Eoi: parseFloat(eoiAmount),
//           }),
//           ...(selectedStageName === "Reservation" && {
//             Reservation: parseFloat(reservationAmount)
//           }),
//         };

//         console.log("📤 Update Data:", updateData);

//         // انتظر اكتمال تحديث الـ stage أولاً
//         const updateStageResult = await dispatch(UpdateStageToLeed(user._id, updateData));

//         console.log("✅ Stage Update Result:", updateStageResult);

//         // إضافة سجل في Lead Stages
//         const leadStageData = {
//           LeadId: user._id,
//           date: moment().format('YYYY-MM-DD'),
//           stage: selectedStageId,
//           sales: userlogin.data._id,
//           dateselectedforstage: finalStageDate,
//           // Add Bunt score to lead stages
//           buntScore: buntScore,
//           timeline: timeline,
//           ...(selectedStageName === "Done Deal" && {
//             unitPrice: parseFloat(unitPrice),
//           }),
//         };

//         console.log("📝 Lead Stage Data:", leadStageData);

//         await dispatch(Insert_Lead_Stages_Data_Action(leadStageData));

//         // إذا كانت Done Deal، شغل الكونفيتي
//         if (selectedStageName === "Done Deal") {
//           DoneDealFun();
//         }
//       }

//       // إضافة الكومنت مع الـ Bunt scoring data
//       console.log("💬 Adding comment with Bunt scoring:", buntScore);

//       const actionResponse = await dispatch(
//         InsertNewAction_action({
//           sales: userlogin.data._id,
//           text1: firstcomment,
//           text2: secondcomment,
//           date: finalStageDate,
//           leed: user._id,
//           username: userlogin.data._id,
//           commentbysales: userlogin.data.name,
//           stage: user?.stage?._id,
//           // Add Bunt scoring to comment
//           buntScoring: {
//             budget: budget ? parseFloat(budget) : null,
//             authority: authority,
//             signInterested: signInterested,
//             need: need,
//             type: type,
//             timeline: timeline,
//             timelineScore: timeline === "within_week_to_month" ? 2 :
//                           timeline === "within_1_to_3_months" ? 1 : 0,
//             meetingBonus: selectedStageName === "Meeting",
//             totalScore: buntScore,
//             leadStatus: leadStatus
//           }
//         })
//       );

//       console.log("✅ Comment Response:", actionResponse);

//     } catch (error) {
//       console.error("❌ Error submitting data:", error);
//       Notify('error', 'Error sending data, please try again.', 'error');
//     } finally {
//       setLoading(false);
//       setSendLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (!loading) {
//       if (resaddcomment && resaddcomment?.status === 200) {

//         Notify('success', 'Comment & Bunt Scoring added successfully!', 'success');
//         // Reset form
//         setFirstComment('');
//         setSecondComment('');
//         setBudget('');
//         setAuthority(false);
//         setSignInterested(false);
//         setNeed('');
//         setType('');
//         setTimeline('');

//         // Reset stage form إذا كان Add Action مفعل
//         if (addActionEnabled) {
//           resetStageForm();
//         }

//         // Refresh comments after adding new one
//         if (tabValue === 2) {
//           refreshComments();
//         }
//       } else {
//         Notify('error', 'Error adding comment', 'error');
//       }

//     }
//   }, [loading]);

//   // Handle tab change
//   const handleTabChange = useCallback((event, newValue) => {
//     setTabValue(newValue);

//     // Auto load comments when switching to All Comments tab
//     if (newValue === 2) {
//       console.log('Switching to All Comments tab');

//       if (leadid && userloginrealy.current?.data?._id) {
//         getallactiondata(1);
//       } else {
//         console.error('Cannot load comments: missing leadid or userId');
//         Notify('error', 'Cannot load comments: missing data', 'error');
//       }
//     }
//   }, [leadid, getallactiondata]);

//   useEffect(() => {
//     setOpen(true);
//   }, []);

//   const handleClose = useCallback(() => {
//     if (onClose) {
//       onClose();
//     } else {
//       setOpen(false);
//       setAddActionEnabled(false);
//       resetStageForm();
//       // Reset Bunt Scoring
//       setBudget('');
//       setAuthority(false);
//       setSignInterested(false);
//       setNeed('');
//       setType('');
//       setTimeline('');
//     }
//   }, [onClose, resetStageForm]);

//   return (
// <Dialog
//   open={open}
//   onClose={handleClose}
//   maxWidth="xl"
//   fullWidth
//   TransitionComponent={Transition}
//   PaperProps={{
//     sx: {
//       borderRadius: 4,
//       height: '95vh',
//       maxHeight: '95vh',
//       width: '95vw',
//       maxWidth: '95vw',
//       display: 'flex',
//       flexDirection: 'column',
//       // ✅ إضافة هذه الخصائص
//       position: 'relative',
//       overflow: 'visible !important',
//       zIndex: 50000,
//     }
//   }}
//   // ✅ إضافة sx جديد
//   sx={{
//     zIndex: 50000,
//     '& .MuiDialog-container': {
//       overflow: 'visible',
//       zIndex: 50000,
//       position: 'relative',
//     },
//     '& .MuiBackdrop-root': {
//       zIndex: 49999,
//     },
//     // ✅ هذا هو المفتاح لحل مشكلة الـ Picker
//     '& .MuiModal-root': {
//       zIndex: '50001 !important',
//     },
//     '& .MuiPickersPopper-root': {
//       zIndex: '50001 !important',
//       '& .MuiPaper-root': {
//         zIndex: '50001 !important',
//       }
//     },
//   }}
//   disablePortal={false}
//   keepMounted={true}
// >
//       {/* Header */}
//       <AppBar position="static" elevation={0} sx={{ borderTopLeftRadius: 4, borderTopRightRadius: 4, flexShrink: 0 }}>
//         <Toolbar>
//           <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
//             <Avatar
//               sx={{
//                 bgcolor: getStageColor(selectedStageName || user?.stage?.name),
//                 mr: 2,
//                 fontWeight: 'bold'
//               }}
//             >
//               {user?.name?.charAt(0)}
//             </Avatar>
//             <Box>
//               <Typography variant="h6" fontWeight={600} sx={{ color: '#fff' }}>
//                 {user?.name}
//               </Typography>
//               <Typography variant="body2" sx={{ color: '#fff' }}>
//                 {user?.sales?.name} •
//                 <StatusChip
//                   label={selectedStageName || user?.stage?.name}
//                   status={selectedStageName || user?.stage?.name}
//                   size="small"
//                   sx={{ ml: 1, color: "#fff" }}
//                 />
//               </Typography>
//             </Box>
//           </Box>
//           <IconButton edge="end" color="inherit" onClick={handleClose}>
//             <CloseIcon />
//           </IconButton>
//         </Toolbar>
//       </AppBar>

//       {/* Tabs Header - Fixed */}
//       <Box sx={{ borderBottom: 1, borderColor: 'divider', px: 3, flexShrink: 0 }}>
//         <Tabs
//           value={tabValue}
//           onChange={handleTabChange}
//           variant="fullWidth"
//           textColor="primary"
//           indicatorColor="primary"
//         >
//           <Tab
//             icon={<InfoIcon />}
//             iconPosition="start"
//             label="Information"
//             id="action-tab-0"
//             aria-controls="action-tabpanel-0"
//           />
//           <Tab
//             icon={<AddCommentIcon />}
//             iconPosition="start"
//             label="Add Comment"
//             id="action-tab-1"
//             aria-controls="action-tabpanel-1"
//           />
//           <Tab
//             icon={<CommentIcon />}
//             iconPosition="start"
//             label={`All Comments`}
//             id="action-tab-2"
//             aria-controls="action-tabpanel-2"
//           />
//         </Tabs>
//       </Box>

//       {/* Tab Content - Scrollable */}
//       <DialogContent dividers sx={{
//         p: 0,
//         flex: 1,
//         overflow: 'hidden',
//         display: 'flex',
//         flexDirection: 'column'
//       }}>
//         <Container maxWidth={false} sx={{
//           p: 0,
//           height: '100%',
//           display: 'flex',
//           flexDirection: 'column'
//         }}>
//           {/* Tab 1: Information */}
//           <TabPanel value={tabValue} index={0}>
//             <StyledCard>
//               <CardHeader
//                 avatar={
//                   <Avatar sx={{ bgcolor: 'primary.main' }}>
//                     <PersonIcon />
//                   </Avatar>
//                 }
//                 title="Lead Information"
//                 titleTypographyProps={{ variant: 'h6', fontWeight: 600 }}
//                 action={
//                   <Box display="flex" gap={1}>
//                     <Tooltip title="Lead Preview">
//                       <IconButton onClick={() => setOpenLeadPreview(true)} size="small">
//                         <VisibilityIcon />
//                       </IconButton>
//                     </Tooltip>
//                     {(userlogin?.data?.role === "Sales" || userlogin?.data?.role === "Team Leader") ? null : (
//                       <Tooltip title="Edit Lead">
//                         <IconButton component={Link} to={`/updateclient/${user._id}`} size="small">
//                           <EditIcon />
//                         </IconButton>
//                       </Tooltip>
//                     )}
//                   </Box>
//                 }
//               />
//               <CardContent>
//                 <Grid container spacing={2}>
//                   <Grid item xs={12}>
//                     <Box display="flex" alignItems="center" gap={1} mb={1}>
//                       <PersonIcon fontSize="small" color="primary" />
//                       <Typography variant="body2" color="textSecondary">
//                         Lead Name:
//                       </Typography>
//                       <Typography variant="body1" fontWeight={500}>
//                         {user?.name}
//                       </Typography>
//                     </Box>
//                   </Grid>

//                   <Grid item xs={12}>
//                     <Box display="flex" alignItems="center" gap={1} mb={1}>
//                       <WorkIcon fontSize="small" color="primary" />
//                       <Typography variant="body2" color="textSecondary">
//                         Sales Person:
//                       </Typography>
//                       <Typography variant="body1" fontWeight={500}>
//                         {user?.sales?.name}
//                       </Typography>
//                     </Box>
//                   </Grid>

//                   <Grid item xs={12}>
//                     <Box display="flex" alignItems="center" gap={1} mb={1}>
//                       <PhoneIcon fontSize="small" color="primary" />
//                       <Typography variant="body2" color="textSecondary">
//                         Phone 1:
//                       </Typography>
//                       <IconButton
//                         size="small"
//                         onClick={() => window.open(`https://wa.me/${user?.phone}`, '_blank')}
//                         sx={{ p: 0, ml: 1 }}
//                       >
//                         <WhatsAppIcon fontSize="small" color="success" />
//                       </IconButton>
//                       <Typography variant="body1" fontWeight={500}>
//                         {user?.phone}
//                       </Typography>
//                     </Box>
//                   </Grid>

//                   <Grid item xs={12}>
//                     <Box display="flex" alignItems="center" gap={1} mb={1}>
//                       <PhoneIcon fontSize="small" color="primary" />
//                       <Typography variant="body2" color="textSecondary">
//                         Phone 2:
//                       </Typography>
//                       <IconButton
//                         size="small"
//                         onClick={() => window.open(`https://wa.me/${user?.phonenumber2}`, '_blank')}
//                         sx={{ p: 0, ml: 1 }}
//                       >
//                         <WhatsAppIcon fontSize="small" color="success" />
//                       </IconButton>
//                       <Typography variant="body1" fontWeight={500}>
//                         {user?.phonenumber2 || 'Not Exist'}
//                       </Typography>
//                     </Box>
//                   </Grid>

//                   <Grid item xs={12}>
//                     <Box display="flex" alignItems="center" gap={1}>
//                       <WhatsAppIcon fontSize="small" color="primary" />
//                       <Typography variant="body2" color="textSecondary">
//                         WhatsApp:
//                       </Typography>
//                       <Typography variant="body1" fontWeight={500}>
//                         {user?.whatsappnumber ? user?.whatsappnumber : user?.phone || 'Not Exist'}
//                       </Typography>
//                     </Box>
//                   </Grid>

//                   <Grid item xs={12}>
//                     <Box display="flex" alignItems="center" gap={1}>
//                       <EmailIcon fontSize="small" color="primary" />
//                       <Typography variant="body2" color="textSecondary">
//                         Email:
//                       </Typography>
//                       <Typography variant="body1" fontWeight={500}>
//                         {user?.email || 'N/A'}
//                       </Typography>
//                     </Box>
//                   </Grid>

//                   <Grid item xs={12} sx={{ mt: 2 }}>
//                     <Divider />
//                   </Grid>

//                   <Grid item xs={12}>
//                     <Box display="flex" justifyContent="space-between" alignItems="center">
//                       <Typography variant="body2" color="textSecondary">
//                         Current Stage:
//                       </Typography>
//                       <StageChip
//                         label={user?.stage?.name}
//                         size="small"
//                       />
//                     </Box>
//                   </Grid>

//                   <Grid item xs={12}>
//                     <Box display="flex" justifyContent="space-between" alignItems="center">
//                       <Typography variant="body2" color="textSecondary">
//                         Developer:
//                       </Typography>
//                       <Typography variant="body1" fontWeight={500}>
//                         {user?.project?.developer?.name}
//                       </Typography>
//                     </Box>
//                   </Grid>

//                   <Grid item xs={12}>
//                     <Box display="flex" justifyContent="space-between" alignItems="center">
//                       <Typography variant="body2" color="textSecondary">
//                         Project:
//                       </Typography>
//                       <Typography variant="body1" fontWeight={500}>
//                         {user?.project?.name}
//                       </Typography>
//                     </Box>
//                   </Grid>

//                   <Grid item xs={12}>
//                     <Box display="flex" justifyContent="space-between" alignItems="center">
//                       <Typography variant="body2" color="textSecondary">
//                         Channal:
//                       </Typography>
//                       <Typography variant="body1" fontWeight={500}>
//                         {user?.chanel?.name}
//                       </Typography>
//                     </Box>
//                   </Grid>

//                   <Grid item xs={12}>
//                     <Box display="flex" justifyContent="space-between" alignItems="center">
//                       <Typography variant="body2" color="textSecondary">
//                         Created Date:
//                       </Typography>
//                       <Typography variant="body1" fontWeight={500}>
//                         {moment(user?.createdAt).format('DD/MM/YYYY')}
//                       </Typography>
//                     </Box>
//                   </Grid>

//                   <Grid item xs={12}>
//                     <Box display="flex" justifyContent="space-between" alignItems="center">
//                       <Typography variant="body2" color="textSecondary">
//                         Job Description:
//                       </Typography>
//                       <Typography variant="body1" fontWeight={500}>
//                        {user?.jobdescription}
//                       </Typography>
//                     </Box>
//                   </Grid>

//                   <Grid item xs={12}>
//                     <Box display="flex" justifyContent="space-between" alignItems="center">
//                       <Typography variant="body2" color="textSecondary">
//                         Notes:
//                       </Typography>
//                       <Typography variant="body1" fontWeight={500}>
//                        {user?.notes}
//                       </Typography>
//                     </Box>
//                   </Grid>

//                   {/* Project Price Information */}
//                   {user?.project?.startprice && (
//                     <Grid item xs={12}>
//                       <Box display="flex" justifyContent="space-between" alignItems="center">
//                         <Typography variant="body2" color="textSecondary">
//                           Project Starting Price:
//                         </Typography>
//                         <Chip
//                           label={`${parseFloat(user.project.startprice).toLocaleString()} AED`}
//                           size="small"
//                           color="info"
//                           variant="outlined"
//                         />
//                       </Box>
//                     </Grid>
//                   )}
//                 </Grid>
//               </CardContent>
//             </StyledCard>
//           </TabPanel>

//           {/* Tab 2: Add Comment */}
//           <TabPanel value={tabValue} index={1}>
//             <Grid container spacing={3} sx={{ height: '100%' }}>
//               {/* Left Column - Bunt Scoring */}
//               <Grid item xs={12} md={5} sx={{ height: '100%' }}>
//                 <Box sx={{ height: '100%', overflow: 'auto' }}>
//                   <BuntScoringForm
//                     disabled={
//                       selectedStageName === "Not interested" ||
//                       selectedStageName === "Transfere" ||
//                       selectedStageName === "No Answer" ||
//                       selectedStageName === "No Stage"
//                     }
//                     onBudgetChange={handleBudgetChange}
//                     onAuthorityChange={handleAuthorityChange}
//                     onSignInterestedChange={handleSignInterestedChange}
//                     onNeedChange={handleNeedChange}
//                     onTypeChange={handleTypeChange}
//                     onTimelineChange={handleTimelineChange}
//                     budget={budget}
//                     authority={authority}
//                     signInterested={signInterested}
//                     need={need}
//                     type={type}
//                     timeline={timeline}
//                     totalScore={buntScore}
//                     isMeetingStage={selectedStageName === "Meeting"||selectedStageName==="Follow After Meeting"}
//                     user={user}
//                   />
//                 </Box>
//               </Grid>

//               {/* Right Column - Comment Form */}
//               <Grid item xs={12} md={7} sx={{ height: '100%' }}>
//                 <Box sx={{ height: '100%', overflow: 'auto' }}>
//                   <StyledCard sx={{ mb: 3 }}>
//                     <CardContent>
//                       {/* Answer/No Answer Buttons */}
//                       <Box sx={{ display: 'flex', gap: 1, mb: 3, justifyContent: 'center' }}>
//                         <Tooltip title="Answer">
//                           <Button
//                             variant={!isNoAnswer ? "contained" : "outlined"}
//                             color="success"
//                             onClick={() => {
//                               setIsNoAnswer(false);
//                               setFirstComment('رد عليا');
//                               setSecondComment('هكتب اللي قاله وهشوف هعمل ايه بعد كده');
//                             }}
//                             startIcon={<PhoneInTalkIcon />}
//                             sx={{ flex: 1 }}
//                           >
//                             Answer
//                           </Button>
//                         </Tooltip>
//                         <Tooltip title="No Answer">
//                           <Button
//                             variant={isNoAnswer ? "contained" : "outlined"}
//                             color="error"
//                             onClick={() => {
//                               setIsNoAnswer(true);
//                               setFirstComment('اتصلت ومفيش رد');
//                               setSecondComment('هحاول تاني في وقت تاني');
//                             }}
//                             startIcon={<CancelIcon />}
//                             sx={{ flex: 1 }}
//                           >
//                             No Answer
//                           </Button>
//                         </Tooltip>
//                       </Box>

//                       {/* Enable Action Switch */}
//                       <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                         <Typography variant="h6" color="primary" fontWeight={600}>
//                           Stage Management
//                         </Typography>
//                         <FormControlLabel
//                           control={
//                             <Switch
//                               checked={addActionEnabled}
//                               onChange={(e) => handleEnableActionToggle(e.target.checked)}
//                               color="primary"
//                               size="medium"
//                             />
//                           }
//                           label={
//                             <Typography variant="body1" fontWeight={500}>
//                               {addActionEnabled ? "✓ Action Enabled" : "Enable Action to change stage"}
//                             </Typography>
//                           }
//                         />
//                       </Box>

//                       {/* Current Stage Display */}
//                       <CurrentStageComponent user={user} addActionEnabled={addActionEnabled} />

//                       {/* Stage Management Sections */}
//                       <Collapse in={addActionEnabled} timeout={500}>
//                         <Box>
//                           {/* Change Stage Section */}
//                           <Box mb={3}>
//                             <Paper elevation={0} sx={{
//                               p: 2.5,
//                               border: '2px solid',
//                               borderColor: 'primary.light',
//                               borderRadius: 2,
//                               bgcolor: 'primary.lighter'
//                             }}>
//                               <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
//                                 <ChangeCircleIcon color="primary" sx={{ mr: 1.5 }} />
//                                 <Typography variant="h6" color="primary" fontWeight={600}>
//                                   Change Stage To
//                                 </Typography>
//                               </Box>

//                               <Autocomplete
//                                 disablePortal
//                                 options={allstagesshow}
//                                 getOptionLabel={(option) => option.name || ""}
//                                 value={selectedStage}
//                                 onChange={handleStageChange}
//                                 isOptionEqualToValue={(option, value) => option?._id === value?._id}
//                                 size="medium"
//                                 fullWidth
//                                 // إضافة PopperProps لحل مشكلة z-index
//                                 PopperProps={{
//                                   style: {
//                                     zIndex: 9999,
//                                     position: 'fixed'
//                                   }
//                                 }}
//                                 renderInput={(params) => (
//                                   <TextField
//                                     {...params}
//                                     label="Choose New Stage"
//                                     variant="outlined"
//                                     helperText="Select the stage you want to move this lead to"
//                                   />
//                                 )}
//                               />

//                               {/* Display selected stage */}
//                               {selectedStage && (
//                                 <Box sx={{
//                                   mt: 2,
//                                   p: 1.5,
//                                   bgcolor: 'primary.main',
//                                   borderRadius: 1,
//                                   textAlign: 'center',
//                                   display: 'flex',
//                                   alignItems: 'center',
//                                   justifyContent: 'center',
//                                   gap: 1
//                                 }}>
//                                   <CheckCircleIcon sx={{ color: 'white' }} />
//                                   <Typography variant="body1" fontWeight={600} color="white">
//                                     Selected: {selectedStage.name}
//                                   </Typography>
//                                 </Box>
//                               )}
//                             </Paper>
//                           </Box>

//                           {/* Date Time Picker */}
//                       {showDateTimePicker && (
//   <Box mb={3}>
//     <Paper elevation={0} sx={{
//       p: 2.5,
//       border: '2px solid',
//       borderColor: 'warning.light',
//       borderRadius: 2,
//       bgcolor: 'warning.lighter',
//     }}>
//       <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
//         <ScheduleIcon color="warning" sx={{ mr: 1.5 }} />
//         <Typography variant="h6" color="warning.dark" fontWeight={600}>
//           Schedule Next Action
//         </Typography>
//       </Box>

//       <LocalizationProvider dateAdapter={AdapterDayjs}>
//         <DesktopDateTimePicker
//           label="Select Next Action Date & Time"
//           value={valuedate}
//           onChange={handleDateTimeChange}
//           ampm={true}
//           PopperProps={{
//             disablePortal: false,
//             sx: {
//               zIndex: 50001,
//             }
//           }}
//           slotProps={{
//             popper: {
//               sx: {
//                 zIndex: 50001,
//               }
//             },
//             desktopPaper: {
//               sx: {
//                 zIndex: 50001,
//               }
//             }
//           }}
//           renderInput={(params) => (
//             <TextField
//               {...params}
//               fullWidth
//               helperText="Set the date and time for the next follow-up action"
//             />
//           )}
//         />
//       </LocalizationProvider>
//     </Paper>
//   </Box>
// )}
//                           {/* Stage Specific Fields */}
//                           <StageSpecificForm
//                             selectedStageName={selectedStageName}
//                             eoiAmount={eoiAmount}
//                             reservationAmount={reservationAmount}
//                             onEoiAmountChange={handleEoiAmountChange}
//                             onReservationAmountChange={handleReservationAmountChange}
//                             unitPrice={unitPrice}
//                             unitnumber={unitnumber}
//                             commissionRatio={commissionRatio}
//                             cashbackratio={cashbackratio}
//                             totalCommission={totalCommission}
//                             cashbackMoney={cashbackMoney}
//                             onPriceChange={handlePriceChange}
//                             onUnitNumberChange={handleUnitNumber}
//                             onCommissionRatioChange={handleCommissionRatioChange}
//                             onCashbackRatioChange={handleCashbackRatioChange}
//                           />
//                         </Box>
//                       </Collapse>

//                       {/* Comment Inputs */}
//                       <Box mt={addActionEnabled ? 3 : 0}>
//                         <CommentInputs
//                           firstcomment={firstcomment}
//                           secondcomment={secondcomment}
//                           onFirstCommentChange={onFirstCommentChange}
//                           onSecondCommentChange={onSecondCommentChange}
//                         />
//                       </Box>

//                       {/* Validation Summary */}
//                       {(!firstcomment.trim() || !secondcomment.trim()) && (
//                         <Alert
//                           severity="error"
//                           sx={{ mt: 2, py: 1, mb: 2 }}
//                           icon={<WarningIcon />}
//                         >
//                           ⚠️ Please fill in both comment fields before submitting
//                         </Alert>
//                       )}

//                       {selectedStageName === "Done Deal" && (!unitPrice || !unitnumber || !commissionRatio) && (
//                         <Alert
//                           severity="warning"
//                           sx={{ mt: 2, py: 1, mb: 2 }}
//                           icon={<WarningIcon />}
//                         >
//                           ⚠️ Please fill all required Done Deal fields (Unit Price, Unit Number, Commission Ratio)
//                         </Alert>
//                       )}
//                     </CardContent>
//                   </StyledCard>

//                   {/* Submit Button Card */}
//                   <StyledCard>
//                     <CardContent>
//                       <Box sx={{ display: 'flex', justifyContent: 'center' }}>
//                         <GradientButton
//                           type="submit"
//                           disabled={sendloading}
//                           startIcon={sendloading ? null : selectedStageName === "Done Deal" ? <CheckCircleIcon /> : <SendIcon />}
//                           endIcon={sendloading ? <CircularProgress size={20} color="inherit" /> : null}
//                           size="large"
//                           sx={{
//                             minWidth: 250,
//                             bgcolor: selectedStageName === "Done Deal" ? 'success.main' : 'primary.main',
//                             '&:hover': {
//                               bgcolor: selectedStageName === "Done Deal" ? 'success.dark' : 'primary.dark',
//                             },
//                           }}
//                           onClick={onsubmitdata}
//                         >
//                           {sendloading
//                             ? 'Adding...'
//                             : selectedStageName === "Done Deal"
//                               ? '🎉 Complete Deal & Add Comment'
//                               : 'Add New Comment'
//                           }
//                         </GradientButton>
//                       </Box>
//                     </CardContent>
//                   </StyledCard>
//                 </Box>
//               </Grid>
//             </Grid>
//           </TabPanel>

//           {/* Tab 3: All Comments - مع نظام الردود الجديد */}
//           <TabPanel value={tabValue} index={2}>
//             <Box ref={commentsContainerRef} sx={{ height: '100%', overflow: 'hidden' }}>
//               <StyledCard sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
//                 <CardHeader
//                   title="All Comments"
//                   subheader={`Total: ${totalCommentsCount} comments`}
//                   titleTypographyProps={{ variant: 'h6', fontWeight: 600 }}
//                   action={
//                     <Box display="flex" gap={1}>
//                       <Tooltip title="Refresh">
//                         <IconButton
//                           size="small"
//                           onClick={() => getallactiondata(1)}
//                           disabled={isCommentsLoading}
//                         >
//                           <RefreshIcon />
//                         </IconButton>
//                       </Tooltip>
//                       <Button
//                         variant="contained"
//                         size="small"
//                         startIcon={<AddIcon />}
//                         onClick={() => setTabValue(1)}
//                       >
//                         Add Comment
//                       </Button>
//                     </Box>
//                   }
//                 />
//                 <CardContent sx={{ flex: 1, overflow: 'hidden' }}>
//                   {isCommentsLoading ? (
//                     <Box display="flex" justifyContent="center" alignItems="center" height="300px">
//                       <CircularProgress />
//                     </Box>
//                   ) : (
//                     <>
//                       {/* Filter Info Alert */}
//                       {filterInfo?.applied === 'filtered_by_date' && (
//                         <Alert
//                           severity="info"
//                           sx={{ mb: 2 }}
//                           icon={<InfoIcon />}
//                         >
//                           <Typography variant="body2">
//                             Showing comments after assignment date: {moment(filterInfo.assignmentInfo?.assignDateTime).format('DD/MM/YYYY hh:mm A')}
//                           </Typography>
//                         </Alert>
//                       )}

//                       {/* Comments List */}
//                       {comments && comments.length > 0 ? (
//                         <Box sx={{ height: '100%', overflow: 'auto' }}>
//                           {/* Display Comments Count */}
//                           <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
//                             Showing {comments.length} of {totalCommentsCount} comments (Page {currentPage} of {totalPages})
//                           </Typography>

//                           <List disablePadding>
//                             {comments
//                               .sort((a, b) => new Date(b.stageDate) - new Date(a.stageDate))
//                               .map((comment, index) => (
//                                 <React.Fragment key={comment._id || index}>
//                                   <Box sx={{ mb: 3 }}>
//                                     <Card variant="outlined" sx={{ borderRadius: 2 }}>
//                                       <CardContent>
//                                         {/* معلومات الـ Sales */}
//                                         {comment.sales && (
//                                           <Box display="flex" alignItems="center" gap={1} mb={2}>
//                                             <Avatar
//                                               src={comment.sales.profileImg}
//                                               sx={{ width: 32, height: 32 }}
//                                             >
//                                               {comment.sales.name?.charAt(0)}
//                                             </Avatar>
//                                             <Box>
//                                               <Typography variant="subtitle2" fontWeight={600}>
//                                                 {comment.sales.name}
//                                               </Typography>
//                                               <Typography variant="caption" color="textSecondary">
//                                                 {moment(comment.stageDate).format('DD/MM/YYYY hh:mm A')}
//                                               </Typography>
//                                             </Box>
//                                           </Box>
//                                         )}

//                                         {/* First Comment */}
//                                         {comment.firstcomment?.text && (
//                                           <Box mb={2}>
//                                             <Typography variant="body2" color="textSecondary" gutterBottom>
//                                               First Comment:
//                                             </Typography>
//                                             <Typography variant="body1" paragraph sx={{ whiteSpace: 'pre-wrap' }}>
//                                               {comment.firstcomment.text}
//                                             </Typography>
//                                             {comment.firstcomment.date && (
//                                               <Typography variant="caption" color="textSecondary">
//                                                 Posted: {moment(comment.firstcomment.date).format('DD/MM/YYYY hh:mm A')}
//                                               </Typography>
//                                             )}
//                                           </Box>
//                                         )}

//                                         {/* Second Comment */}
//                                         {comment.secondcomment?.text && (
//                                           <Box mb={2}>
//                                             <Typography variant="body2" color="textSecondary" gutterBottom>
//                                               Second Comment:
//                                             </Typography>
//                                             <Typography variant="body1" paragraph sx={{ whiteSpace: 'pre-wrap' }}>
//                                               {comment.secondcomment.text}
//                                             </Typography>
//                                             {comment.secondcomment.date && (
//                                               <Typography variant="caption" color="textSecondary">
//                                                 Posted: {moment(comment.secondcomment.date).format('DD/MM/YYYY hh:mm A')}
//                                               </Typography>
//                                             )}
//                                           </Box>
//                                         )}

//                                         {/* الـ Stage */}
//                                         {comment.stage && (
//                                           <Box display="flex" alignItems="center" gap={1} mb={2}>
//                                             <StageChip
//                                               label={comment.stage.name}
//                                               size="small"
//                                               stagecolor={getStageColor(comment.stage.name)}
//                                             />
//                                           </Box>
//                                         )}

//                                         {/* نظام الردود الجديد */}
//                                         <CommentReplies
//                                           comment={comment}
//                                           currentUserId={userloginrealy.current?.data?._id}
//                                           onReplyAdded={refreshComments}
//                                           theme={theme}
//                                         />
//                                       </CardContent>
//                                     </Card>
//                                   </Box>

//                                   {index < comments.length - 1 && (
//                                     <Divider sx={{ my: 2 }} />
//                                   )}
//                                 </React.Fragment>
//                               ))}
//                           </List>

//                           {/* Pagination Controls */}
//                           {totalPages > 1 && (
//                             <Box display="flex" justifyContent="center" alignItems="center" gap={2} mt={3} py={2}>
//                               <Button
//                                 variant="outlined"
//                                 size="small"
//                                 disabled={!hasPrev || isCommentsLoading}
//                                 onClick={() => getallactiondata(currentPage - 1)}
//                                 startIcon={<KeyboardArrowUpIcon />}
//                               >
//                                 Previous
//                               </Button>

//                               <Typography variant="body2" color="textSecondary">
//                                 Page {currentPage} of {totalPages}
//                               </Typography>

//                               <Button
//                                 variant="outlined"
//                                 size="small"
//                                 disabled={!hasNext || isCommentsLoading}
//                                 onClick={() => getallactiondata(currentPage + 1)}
//                                 endIcon={<KeyboardArrowDownIcon />}
//                               >
//                                 Next
//                               </Button>
//                             </Box>
//                           )}

//                           {/* إذا كان totalPages = 1 أو ليس هناك صفحات أخرى */}
//                           {totalPages <= 1 && (
//                             <Box textAlign="center" py={2}>
//                               <Typography variant="body2" color="textSecondary">
//                                 {totalCommentsCount <= 20
//                                   ? "All comments shown"
//                                   : `Showing all ${totalCommentsCount} comments in one page`}
//                               </Typography>
//                             </Box>
//                           )}
//                         </Box>
//                       ) : (
//                         <Box textAlign="center" py={8}>
//                           <CommentIcon sx={{ fontSize: 80, color: 'text.disabled', mb: 2 }} />
//                           <Typography variant="h5" color="textSecondary" gutterBottom>
//                             No Comments Available
//                           </Typography>
//                           <Typography variant="body1" color="textSecondary" paragraph>
//                             {filterInfo?.applied === 'filtered_by_date'
//                               ? 'Only comments after assignment date are shown'
//                               : 'Start the conversation by adding the first comment'
//                             }
//                           </Typography>
//                           <Button
//                             variant="contained"
//                             startIcon={<AddIcon />}
//                             onClick={() => setTabValue(1)}
//                             sx={{ mt: 2 }}
//                           >
//                             Add First Comment
//                           </Button>
//                         </Box>
//                       )}
//                     </>
//                   )}
//                 </CardContent>
//               </StyledCard>
//             </Box>
//           </TabPanel>
//         </Container>
//       </DialogContent>

//       {/* Lead Preview Dialog */}
//       <Dialog
//         open={openLeadPreview}
//         onClose={() => setOpenLeadPreview(false)}
//         maxWidth="sm"
//         fullWidth
//         sx={{
//           zIndex: (theme) => theme.zIndex.modal + 60000, // أعلى من الديالوج الرئيسي
//         }}
//       >
//         <DialogTitle>
//           <Typography variant="h6" fontWeight={600}>
//             Lead Preview
//           </Typography>
//         </DialogTitle>
//         <DialogContent dividers>
//           <Grid container spacing={2}>
//             <Grid item xs={12}>
//               <Typography variant="h6" gutterBottom>{user?.name}</Typography>
//             </Grid>
//             <Grid item xs={6}>
//               <Typography variant="body2" color="textSecondary">Phone</Typography>
//               <Typography variant="body1">{user?.phone}</Typography>
//             </Grid>
//             <Grid item xs={6}>
//               <Typography variant="body2" color="textSecondary">Email</Typography>
//               <Typography variant="body1">{user?.email || 'N/A'}</Typography>
//             </Grid>
//             <Grid item xs={6}>
//               <Typography variant="body2" color="textSecondary">Stage</Typography>
//               <Typography variant="body1">{user?.stage?.name}</Typography>
//             </Grid>
//             <Grid item xs={6}>
//               <Typography variant="body2" color="textSecondary">Project</Typography>
//               <Typography variant="body1">{user?.project?.name}</Typography>
//             </Grid>
//               <Grid item xs={12}>
//                 <Typography variant="body2" color="textSecondary">Project Starting Price</Typography>
//                 <Typography variant="body1">{(user.project.startprice)} AED</Typography>
//               </Grid>

//           </Grid>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenLeadPreview(false)} variant="contained">
//             Close
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Dialog>
//   );
// };
